var equaloneV3dSdk =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.instance = undefined;
	
	var _EQCore = __webpack_require__(1);
	
	var _EQCore2 = _interopRequireDefault(_EQCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instance = exports.instance = new _EQCore2.default(); /**
	                                                           * Created by mmaillot on 7/20/16.
	                                                           */

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*eslint-disable no-underscore-dangle*/
	
	
	var _Core = __webpack_require__(2);
	
	var _Core2 = _interopRequireDefault(_Core);
	
	var _EQOnClickManager = __webpack_require__(141);
	
	var _EQOnClickManager2 = _interopRequireDefault(_EQOnClickManager);
	
	var _Constants = __webpack_require__(88);
	
	var Constants = _interopRequireWildcard(_Constants);
	
	var _VersionParser = __webpack_require__(90);
	
	var _VersionParser2 = _interopRequireDefault(_VersionParser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// https://curiosity-driven.org/private-properties-in-javascript
	// https://esdiscuss.org/topic/es6-problem-with-private-name-objects-syntax
	// https://leanpub.com/understandinges6/read
	
	var privateState = new WeakMap();
	function createPrivateState(o) {
	    privateState.set(o, {});
	}
	function _private(o) {
	    // "private" is a reserved keyword
	    return privateState.get(o);
	}
	
	/**
	 * EQualOne SDK Core public APIs
	 */
	
	var EQCore = function () {
	    function EQCore() {
	        var _this = this;
	
	        _classCallCheck(this, EQCore);
	
	        if (window["chrome"] && window["chrome"].runtime && window["chrome"].runtime.onConnect) {
	            window["chrome"].runtime.onConnect.addListener(function (externalPort) {
	                externalPort.onDisconnect.addListener(function () {
	                    _private(_this).core.disconnectFromBackgroundPage();
	                });
	            });
	        }
	
	        createPrivateState(this);
	    }
	
	    /**
	     * Init the SDK
	     *
	     * @param url The server URL
	     * @param folder The folder
	     * @param configurationCallback Optional A configuration callback with 2 parameters (status, error)
	     * @param routerCallback Optional A router callback with 1 parameter (error)
	     * @param routerIp The router IP address (if null, auto detect)
	     * @param routerUsername The router username (if null, default username)
	     * @param routerPassword The router password (if null, default password)
	     * @param discoverGateway Au to discover gateway. Default is false.
	     */
	
	
	    _createClass(EQCore, [{
	        key: "init",
	        value: function init(url, folder) {
	            var configurationCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var routerCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	            var routerIp = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	            var routerUsername = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	            var routerPassword = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
	            var discoverGateway = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
	
	            _private(this).core = new _Core2.default(url, folder);
	            this.onClickManager = new _EQOnClickManager2.default(_private(this).core);
	            _private(this).core.init(configurationCallback, routerCallback, routerIp, routerUsername, routerPassword, discoverGateway);
	        }
	
	        /**
	         * Force the configuration update from the server, or call a coupon
	         *
	         * @param callback Optional A configuration callback with 2 parameters (status, error)
	         * @param coupon Optional A coupon to get a specific scenario
	         */
	
	    }, {
	        key: "updateConfig",
	        value: function updateConfig() {
	            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var coupon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (!_private(this).core) throw Error('Call init method first');
	            _private(this).core.updateConfig(callback, coupon);
	        }
	
	        /**
	         * Set a reverse geocoding function to enrich GPS data from client side
	         * The callback should get 3 parameters
	         * The 3rd parameter (callback) should have 1 parameter : the reverse geocoding data, under the following format :
	         * {city: "City", country: "Country", countryCode: "CO", postalCode: "12345", streetNumber: "1", streetName: "Quality street"}
	         *
	         * @param reverseGeocodingFunction A function with 3 parameters (latitude, longitude, another callback to alert SDK when enrichment is successfully done)
	         */
	
	    }, {
	        key: "setReverseGeocodingFunction",
	        value: function setReverseGeocodingFunction(reverseGeocodingFunction) {
	            if (!_private(this).core) throw Error('Call init method first');
	            _private(this).core.setReverseGeocodingFunction(reverseGeocodingFunction);
	        }
	
	        /**
	         * Add a custom field
	         *
	         * @param key
	         * @param value
	         */
	
	    }, {
	        key: "addCustomField",
	        value: function addCustomField(key, value) {
	            if (!_private(this).core) throw Error('Call init method first');
	            _private(this).core.addCustomField(key, value);
	        }
	
	        /**
	         * Remove a custom field
	         *
	         * @param key
	         */
	
	    }, {
	        key: "deleteCustomField",
	        value: function deleteCustomField(key) {
	            if (!_private(this).core) throw Error('Call init method first');
	            _private(this).core.deleteCustomField(key);
	        }
	
	        /*
	         * Returns the SDK version object
	         *
	         * @return SDK version (object)
	         */
	
	    }, {
	        key: "getVersion",
	        value: function getVersion() {
	            var version = {
	                "version": Constants.AGENT_VERSION,
	                "build": _VersionParser2.default.parseVersion(Constants.AGENT_VERSION)
	            };
	            return version;
	        }
	
	        /**
	         * Enable logs for SDK
	         *
	         * @param status
	         */
	
	    }, {
	        key: "enableLogs",
	        value: function enableLogs() {
	            var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	            window.equaloneLoggerEnabled = status;
	        }
	
	        /**
	         * Set the router informations
	         *
	         * @param callback a callback with an error
	         * @param ip An ip address
	         * @param username A router's username
	         * @param password A router's password
	         */
	
	    }, {
	        key: "setRouterAccessInformations",
	        value: function setRouterAccessInformations() {
	            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var ip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var username = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var password = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	            _private(this).core.setGatewayAccessInformations(callback, ip, username, password);
	        }
	    }]);
	
	    return EQCore;
	}();
	
	exports.default = EQCore;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SDK_MODE_CHROME_EXTENSION = exports.SDK_MODE_STANDARD = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Configuration
	
	
	var _ConfigService = __webpack_require__(3);
	
	var ConfigConst = _interopRequireWildcard(_ConfigService);
	
	var _ConfigWebService = __webpack_require__(12);
	
	var _ConfigWebService2 = _interopRequireDefault(_ConfigWebService);
	
	var _ConfigConverter = __webpack_require__(68);
	
	var _ConfigConverter2 = _interopRequireDefault(_ConfigConverter);
	
	var _ConfigParser = __webpack_require__(69);
	
	var _ConfigParser2 = _interopRequireDefault(_ConfigParser);
	
	var _ConfigPersist = __webpack_require__(75);
	
	var _ConfigPersist2 = _interopRequireDefault(_ConfigPersist);
	
	var _UIDGeneratorPersist = __webpack_require__(76);
	
	var _UIDGeneratorPersist2 = _interopRequireDefault(_UIDGeneratorPersist);
	
	var _UIDGenerator = __webpack_require__(77);
	
	var _UIDGenerator2 = _interopRequireDefault(_UIDGenerator);
	
	var _Security = __webpack_require__(11);
	
	var _Security2 = _interopRequireDefault(_Security);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _ScriptService = __webpack_require__(78);
	
	var _ScriptService2 = _interopRequireDefault(_ScriptService);
	
	var _GpsService = __webpack_require__(115);
	
	var _GpsService2 = _interopRequireDefault(_GpsService);
	
	var _DeviceService = __webpack_require__(118);
	
	var _DeviceService2 = _interopRequireDefault(_DeviceService);
	
	var _CustomFieldsManager = __webpack_require__(120);
	
	var _CustomFieldsManager2 = _interopRequireDefault(_CustomFieldsManager);
	
	var _EQError = __webpack_require__(6);
	
	var _EQError2 = _interopRequireDefault(_EQError);
	
	var _GatewayService = __webpack_require__(121);
	
	var _GatewayService2 = _interopRequireDefault(_GatewayService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*eslint-disable no-undef*/
	var es6polyfill = __webpack_require__(140);
	es6polyfill.polyfill();
	
	var SDK_MODE_STANDARD = exports.SDK_MODE_STANDARD = 0;
	var SDK_MODE_CHROME_EXTENSION = exports.SDK_MODE_CHROME_EXTENSION = 1;
	
	/**
	 * EQualOne SDK Core
	 */
	
	var Core = function () {
	    function Core(url, folder) {
	        _classCallCheck(this, Core);
	
	        _Logger2.default.log('Core init');
	
	        // Check if run in a background container
	        // eslint-disable-line
	        if (window && window.chrome && chrome.runtime && chrome.runtime.id && chrome.extension.getBackgroundPage && chrome.extension.getBackgroundPage() === window) {
	            this.sdkMode = SDK_MODE_CHROME_EXTENSION;
	        } else {
	            this.sdkMode = SDK_MODE_STANDARD;
	        }
	
	        // UID Generator
	        this.uidGenerator = new _UIDGenerator2.default(new _UIDGeneratorPersist2.default(), new _Security2.default());
	
	        // Custom fields manager
	        this.customFieldsManager = new _CustomFieldsManager2.default();
	
	        // Create configuration service
	        this.configService = new ConfigConst.default(new _ConfigWebService2.default(url, folder), new _ConfigConverter2.default(), new _ConfigParser2.default(), new _ConfigPersist2.default());
	
	        // Create gateway service
	        this.gatewayService = new _GatewayService2.default();
	
	        // Reload service with loaded configuration
	        this.reloadServices(this.configService.currentConfig);
	    }
	
	    /**
	     * Init the SDK
	     *
	     * @param configurationCallback A callback for update configuration
	     * @param gatewayCallback A callback for gateway / router detection
	     * @param gatewayIp The gateway IP address (if null, auto detect)
	     * @param gatewayUsername The gateway username (if null, default username)
	     * @param gatewayPassword The gateway password (if null, default password)
	     * @param discoverGateway Au to discover gateway. Default is false.
	     */
	
	
	    _createClass(Core, [{
	        key: "init",
	        value: function init(configurationCallback) {
	            var gatewayCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var gatewayIp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var gatewayUsername = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	            var _this = this;
	
	            var gatewayPassword = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	            var discoverGateway = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	            this.configService.init(function (status, error) {
	                _this.onConfigurationUpdate(status, error, configurationCallback);
	            }, null);
	
	            if (discoverGateway) {
	                this.gatewayService.init(gatewayCallback, gatewayIp, gatewayUsername, gatewayPassword);
	            }
	
	            _Logger2.default.log("SDK Mode : " + (this.sdkMode === SDK_MODE_CHROME_EXTENSION ? "Chrome extension (background)" : "Browser"));
	        }
	
	        /**
	         * Set the router gateway informations
	         *
	         * @param callback
	         * @param ip
	         * @param username
	         * @param password
	         */
	
	    }, {
	        key: "setGatewayAccessInformations",
	        value: function setGatewayAccessInformations() {
	            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var ip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var username = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var password = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	            this.gatewayService.init(callback, ip, username, password);
	        }
	
	        /**
	         * This method proxied the update config callback to reload services if necessary
	         * Once services are restarted, the method will alert client by calling callback with status and error
	         *
	         * @param status
	         * @param error
	         * @param callback
	         */
	
	    }, {
	        key: "onConfigurationUpdate",
	        value: function onConfigurationUpdate(status, error, callback) {
	            if (status == ConfigConst.CONFIG_SUCCESS) {
	                this.reloadServices(this.configService.currentConfig);
	            }
	            callback(status, error);
	        }
	
	        /**
	         * Update the configuration without checking last configuration update date (nextCheckDate)
	         *
	         * @param callback A callback with 2 parameters (status, error)
	         * @param coupon Optional parameter
	         */
	
	    }, {
	        key: "updateConfig",
	        value: function updateConfig(callback) {
	            var _this2 = this;
	
	            var coupon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            this.configService.update(function (status, error) {
	                _this2.onConfigurationUpdate(status, error, callback);
	            }, coupon);
	        }
	
	        /**
	         * This method will reload all services if a configuration is set as parameter
	         *
	         * @param configuration
	         */
	
	    }, {
	        key: "reloadServices",
	        value: function reloadServices(configuration) {
	            if (configuration) {
	                this.gpsService = new _GpsService2.default(configuration.gpsConfig);
	                this.gpsService.start();
	                this.deviceService = new _DeviceService2.default();
	                this.scriptService = new _ScriptService2.default(this.uidGenerator.getUID(), this.configService.currentConfig, this.gpsService, this.deviceService, this.gatewayService);
	            }
	        }
	
	        /**
	         * Set a reverse geocoding function to enrich GPS data from client side
	         * The callback should get 3 parameters
	         * The 3rd parameter (callback) should have 1 parameter : the reverse geocoding data, under the following format :
	         * {city: "City", country: "Country", countryCode: "CO", postalCode: "12345", streetNumber: "1", streetName: "Quality street"}
	         * WARNING : This method should be called only once you have configuration retrieved
	         *
	         * @param reverseGeocodingFunction A function with 3 parameters (latitude, longitude, another callback to alert SDK when enrichment is successfully done)
	         */
	
	    }, {
	        key: "setReverseGeocodingFunction",
	        value: function setReverseGeocodingFunction(reverseGeocodingFunction) {
	            if (this.gpsService) {
	                this.gpsService.setReverseGeocodingFunction(reverseGeocodingFunction);
	                this.gpsService.restart();
	            } else {
	                throw new _EQError2.default('Reverse geocoding function must be set when configuration has been retrieved', 6872);
	            }
	        }
	
	        /**
	         * Add a custom field
	         *
	         * @param key
	         * @param value
	         */
	
	    }, {
	        key: "addCustomField",
	        value: function addCustomField(key, value) {
	            this.customFieldsManager.add(key, value);
	        }
	
	        /**
	         * Delete a custom field
	         *
	         * @param key
	         */
	
	    }, {
	        key: "deleteCustomField",
	        value: function deleteCustomField(key) {
	            this.customFieldsManager.delete(key);
	        }
	
	        /**
	         * Called when popup chrome agent disconnect
	         */
	
	    }, {
	        key: "disconnectFromBackgroundPage",
	        value: function disconnectFromBackgroundPage() {
	            if (this.sdkMode === SDK_MODE_CHROME_EXTENSION) {
	                _Logger2.default.log("Front page disconnect");
	                this.scriptService.stopAll();
	            }
	        }
	    }]);
	
	    return Core;
	}();
	
	exports.default = Core;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CONFIG_FAILED = exports.CONFIG_UPTODATE = exports.CONFIG_SUCCESS = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Service2 = __webpack_require__(4);
	
	var _Service3 = _interopRequireDefault(_Service2);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _EQError = __webpack_require__(6);
	
	var _EQError2 = _interopRequireDefault(_EQError);
	
	var _DateUtil = __webpack_require__(8);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _MscoreStepPersist = __webpack_require__(9);
	
	var _MscoreStepPersist2 = _interopRequireDefault(_MscoreStepPersist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by mmaillot on 7/21/16.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CONFIG_SUCCESS = exports.CONFIG_SUCCESS = 0;
	var CONFIG_UPTODATE = exports.CONFIG_UPTODATE = 1;
	var CONFIG_FAILED = exports.CONFIG_FAILED = 2;
	
	var ConfigService = function (_Service) {
	    _inherits(ConfigService, _Service);
	
	    /**
	     *
	     * @param {ConfigWebService} webservice
	     * @param {ConfigConverter} converter
	     * @param {ConfigParser} parser
	     * @param {ConfigPersist} persistence
	     */
	    function ConfigService(webservice, converter, parser, persistence) {
	        _classCallCheck(this, ConfigService);
	
	        _Logger2.default.log('Configuration init');
	
	        var _this = _possibleConstructorReturn(this, (ConfigService.__proto__ || Object.getPrototypeOf(ConfigService)).call(this));
	
	        _this.webservice = webservice;
	        _this.converter = converter;
	        _this.parser = parser;
	        _this.persistence = persistence;
	
	        _this.migration();
	
	        _this.currentConfig = _this.persistence.loadConfig();
	        _this.nextCheckDate = _this.persistence.loadNextCheckDate() || _DateUtil2.default.getCurrentTimestamp();
	
	        // mScore best server
	        _this.mscoreStepPersist = new _MscoreStepPersist2.default();
	        return _this;
	    }
	
	    /**
	     * Init the service with a callback and a coupon.
	     *
	     * @param callback
	     * @param coupon
	     */
	
	
	    _createClass(ConfigService, [{
	        key: "init",
	        value: function init() {
	            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var coupon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (_DateUtil2.default.getCurrentTimestamp() >= this.nextCheckDate) {
	                this.update(callback, coupon);
	            } else {
	                // Config cache:
	                callback(CONFIG_UPTODATE, null);
	            }
	        }
	
	        /**
	         * Update the configuration with parameters
	         * No check on date is done on this method.
	         *
	         * @param callback
	         * @param coupon
	         * @returns {Promise} A promise
	         */
	
	    }, {
	        key: "update",
	        value: function update() {
	            var _this2 = this;
	
	            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var coupon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            _Logger2.default.log("Updating config");
	            // Fix EWA-38 Load the last coupon used from storage if no coupon set
	            return this.webservice.get(this.currentConfig, this.getOrUpdateCoupon(coupon)).then(this.converter.convert).then(this.parser.parse).then(function (config) {
	                if (_this2.currentConfig && _this2.currentConfig.confVersion == config.confVersion && _this2.currentConfig.groupId == config.groupId && _this2.currentConfig.campaignId == config.campaignId) {
	                    if (callback) callback(CONFIG_UPTODATE, null);
	                } else {
	
	                    _Logger2.default.log('New config');
	                    _this2.saveConfig(config);
	                    _this2.saveNextCheckDate(config);
	
	                    _this2.configurationUpdated();
	
	                    // Config successfully updated
	                    if (callback) callback(CONFIG_SUCCESS, null);
	                }
	            }).catch(function (error) {
	                // If 304 error (server not modified), set up to date callback
	                if (error instanceof _EQError2.default && error.httpError && error.code == 304) {
	                    // Config up to date
	                    if (callback) callback(CONFIG_UPTODATE, null);
	                } else {
	                    _Logger2.default.log(error);
	                    // Config failed
	                    if (callback) callback(CONFIG_FAILED, error);
	                }
	            });
	        }
	
	        /**
	         * This method is used to set (and store) the configuration
	         *
	         * @param {Config} config
	         * @returns {Promise}
	         */
	
	    }, {
	        key: "saveConfig",
	        value: function saveConfig(config) {
	            this.currentConfig = config;
	            _Logger2.default.log(this.currentConfig);
	            this.persistence.saveConfig(config, this.webservice.getWebserviceVersion());
	        }
	
	        /**
	         * This method is used to set (and store) the next configuration check timestamp
	         * depending on the configuration
	         *
	         * @param config
	         */
	
	    }, {
	        key: "saveNextCheckDate",
	        value: function saveNextCheckDate(config) {
	            _Logger2.default.log('Saving next check date');
	            var nextCheckTimestamp = void 0;
	            if (config.refreshConfigInterval) {
	                nextCheckTimestamp = _DateUtil2.default.getCurrentTimestamp() + config.refreshConfigInterval;
	            } else {
	                nextCheckTimestamp = _DateUtil2.default.getCurrentTimestamp();
	                _Logger2.default.log('Refresh config interval not set');
	            }
	            _Logger2.default.log(nextCheckTimestamp);
	            this.nextCheckDate = nextCheckTimestamp;
	            this.persistence.saveNextCheckDate(nextCheckTimestamp);
	        }
	
	        /**
	         * This method is used to set (and store) the current coupon used to retrieve config from server
	         *
	         * @param {string|null} coupon
	         *
	         * @return {string|null} coupon to used to update config
	         */
	
	    }, {
	        key: "getOrUpdateCoupon",
	        value: function getOrUpdateCoupon() {
	            var coupon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            _Logger2.default.log('Saving current coupon');
	            if (coupon != null) {
	                // Update the current coupon
	                this.coupon = coupon;
	                this.persistence.saveCoupon(coupon);
	                return coupon;
	            }
	            // If no coupon provided, get with the last coupon
	            return this.persistence.loadCoupon();
	        }
	
	        /**
	         * Check if web service version has been upgraded
	         *
	         * @return {boolean} true if configuration should be re-downloaded, else false
	         */
	
	    }, {
	        key: "isConfigurationOutdated",
	        value: function isConfigurationOutdated() {
	            var cacheVersion = this.persistence.loadVersion();
	            var appVersion = this.webservice.getWebserviceVersion();
	            return cacheVersion != appVersion ? true : false;
	        }
	
	        /**
	         * Do some configuration migration tasks
	         */
	
	    }, {
	        key: "migration",
	        value: function migration() {
	            // In this case, configuration version has changed, and cache need to be cleared to re-download valid configuration
	            if (this.isConfigurationOutdated()) {
	                _Logger2.default.log('Configuration outdated, cleaning configuration stuff');
	                this.persistence.clearConfigurationData();
	            }
	        }
	
	        /**
	         * Called when configuration is updated
	         */
	
	    }, {
	        key: "configurationUpdated",
	        value: function configurationUpdated() {
	            // Clean best mScore servers
	            _Logger2.default.log('Cleaning mScore best servers');
	            new this.mscoreStepPersist.clean();
	        }
	    }]);
	
	    return ConfigService;
	}(_Service3.default);
	
	exports.default = ConfigService;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by smizrahi on 7/27/16.
	 * From : http://www.datchley.name/es6-eventemitter/
	 */
	
	var Service = function Service() {
	  _classCallCheck(this, Service);
	};
	
	exports.default = Service;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Logger = function () {
	    function Logger() {
	        _classCallCheck(this, Logger);
	    }
	
	    _createClass(Logger, null, [{
	        key: 'log',
	        value: function log(message) {
	            if (typeof window !== 'undefined') {
	                if (window.equaloneLoggerEnabled) {
	                    if (message instanceof Error) {
	                        console.error(message.message + '(#' + message.code + ')');
	                        console.error(message);
	                    } else {
	                        console.log(message);
	                    }
	                }
	            }
	        }
	    }]);
	
	    return Logger;
	}();
	
	exports.default = Logger;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SCRIPT_STEP_MSCORE_PARSE_FAILED = exports.SCRIPT_STEP_CANCELLED = exports.SCRIPT_STEP_NOT_IMPLEMENTED = undefined;
	
	var _es6Error = __webpack_require__(7);
	
	var _es6Error2 = _interopRequireDefault(_es6Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCRIPT_STEP_NOT_IMPLEMENTED = exports.SCRIPT_STEP_NOT_IMPLEMENTED = 10000;
	var SCRIPT_STEP_CANCELLED = exports.SCRIPT_STEP_CANCELLED = 10001;
	var SCRIPT_STEP_MSCORE_PARSE_FAILED = exports.SCRIPT_STEP_MSCORE_PARSE_FAILED = 11001;
	
	var EQError = function (_ExtendableError) {
	    _inherits(EQError, _ExtendableError);
	
	    // constructor is optional; you should omit it if you just want a custom error
	    // type for inheritance and type checking
	    function EQError() {
	        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
	        var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	        var httpError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        _classCallCheck(this, EQError);
	
	        var _this = _possibleConstructorReturn(this, (EQError.__proto__ || Object.getPrototypeOf(EQError)).call(this, message));
	
	        _this.message = message;
	        _this.code = code;
	        _this.httpError = httpError;
	        return _this;
	    }
	
	    return EQError;
	}(_es6Error2.default);
	
	exports.default = EQError;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ExtendableError).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Class util for date
	 */
	var DateUtil = function () {
	  function DateUtil() {
	    _classCallCheck(this, DateUtil);
	  }
	
	  _createClass(DateUtil, null, [{
	    key: "getCurrentTimestamp",
	
	
	    /**
	     * Returns the current timestamp in s
	     *
	     * @returns {Number} Current timestamp in seconds
	     */
	    value: function getCurrentTimestamp() {
	      return Math.floor(Date.now() / 1000);
	    }
	
	    /**
	     * Returns the current timestamp in ms
	     *
	     * @returns {Number} Current timestamp in seconds
	     */
	
	  }, {
	    key: "getCurrentTimestampMs",
	    value: function getCurrentTimestampMs() {
	      return Date.now();
	    }
	  }]);
	
	  return DateUtil;
	}();
	
	exports.default = DateUtil;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Persistence2 = __webpack_require__(10);
	
	var _Persistence3 = _interopRequireDefault(_Persistence2);
	
	var _Security = __webpack_require__(11);
	
	var _Security2 = _interopRequireDefault(_Security);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by smizrahi on 4/25/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var BEST_MSCORE_SERVER_KEY = 'BEST_MSCORE_SERVER';
	
	var MscoreStepPersist = function (_Persistence) {
	    _inherits(MscoreStepPersist, _Persistence);
	
	    function MscoreStepPersist() {
	        _classCallCheck(this, MscoreStepPersist);
	
	        return _possibleConstructorReturn(this, (MscoreStepPersist.__proto__ || Object.getPrototypeOf(MscoreStepPersist)).apply(this, arguments));
	    }
	
	    _createClass(MscoreStepPersist, [{
	        key: "generateHash",
	
	
	        /**
	         * Generate a md5 hash from configuration
	         *
	         * @param {MScoreStepConfig} configuration
	         * @returns {string} MD5 hash
	         */
	        value: function generateHash(configuration) {
	            return new _Security2.default().md5(JSON.stringify(configuration));
	        }
	
	        /**
	         * Save an url for a specific configuration
	         *
	         * @param {string} url
	         * @param {MScoreStepConfig} configuration
	         */
	
	    }, {
	        key: "saveBestMscoreServer",
	        value: function saveBestMscoreServer(url, configuration) {
	            var hash = this.generateHash(configuration);
	            var mscoreBestServers = JSON.parse(this.get(BEST_MSCORE_SERVER_KEY));
	            if (!mscoreBestServers) {
	                mscoreBestServers = {};
	            }
	
	            mscoreBestServers[hash] = url;
	            _get(MscoreStepPersist.prototype.__proto__ || Object.getPrototypeOf(MscoreStepPersist.prototype), "set", this).call(this, BEST_MSCORE_SERVER_KEY, JSON.stringify(mscoreBestServers));
	        }
	
	        /**
	         * Return the best URL for the configuration, null if nothing found
	         *
	         * @param {MScoreStepConfig} configuration
	         * @returns {string,null} The URL
	         */
	
	    }, {
	        key: "getBestMscoreServer",
	        value: function getBestMscoreServer(configuration) {
	            var hash = this.generateHash(configuration);
	            var mscoreBestServers = JSON.parse(_get(MscoreStepPersist.prototype.__proto__ || Object.getPrototypeOf(MscoreStepPersist.prototype), "get", this).call(this, BEST_MSCORE_SERVER_KEY));
	            if (mscoreBestServers && mscoreBestServers[hash]) {
	                return mscoreBestServers[hash];
	            }
	
	            return null;
	        }
	
	        /**
	         * Clean the local storage stuff
	         */
	
	    }, {
	        key: "clean",
	        value: function clean() {
	            _get(MscoreStepPersist.prototype.__proto__ || Object.getPrototypeOf(MscoreStepPersist.prototype), "delete", this).call(this, BEST_MSCORE_SERVER_KEY);
	        }
	    }]);
	
	    return MscoreStepPersist;
	}(_Persistence3.default);
	
	exports.default = MscoreStepPersist;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by smizrahi on 7/27/16.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Persistence = function () {
	    function Persistence() {
	        var fallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        _classCallCheck(this, Persistence);
	
	        this.fallback = fallback;
	    }
	
	    _createClass(Persistence, [{
	        key: 'set',
	        value: function set(key, value) {
	            if (this.fallback) this.setCookie(key, value);
	            if ((typeof Storage === 'undefined' ? 'undefined' : _typeof(Storage)) !== undefined) {
	                try {
	                    localStorage.setItem(key, value);
	                } catch (e) {
	                    _Logger2.default.log('Local storage error : ');
	                    _Logger2.default.log(e);
	                }
	            } else {
	                _Logger2.default.log('Local storage unsupported');
	            }
	        }
	    }, {
	        key: 'get',
	        value: function get(key) {
	            if ((typeof Storage === 'undefined' ? 'undefined' : _typeof(Storage)) !== undefined) {
	                try {
	                    return localStorage.getItem(key);
	                } catch (e) {
	                    _Logger2.default.log('Local storage error : ');
	                    _Logger2.default.log(e);
	                    if (this.fallback) return this.getCookie(key);
	                }
	            } else {
	                _Logger2.default.log('Local storage unsupported');
	                if (this.fallback) return this.getCookie(key);
	            }
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(key) {
	            if ((typeof Storage === 'undefined' ? 'undefined' : _typeof(Storage)) !== undefined) {
	                return localStorage.removeItem(key);
	            } else {
	                _Logger2.default.log('Local storage unsupported');
	            }
	        }
	    }, {
	        key: 'setCookie',
	        value: function setCookie(key, value) {
	            var date = new Date();
	            date.setTime(date.getTime() + 20 * 360 * 24 * 60 * 60 * 1000);
	            var expires = '; expires=' + date.toGMTString();
	
	            document.cookie = key + '=' + value + expires + '; path=/';
	        }
	    }, {
	        key: 'getCookie',
	        value: function getCookie(key) {
	            var nameEQ = key + '=';
	            var ca = document.cookie.split(';');
	            for (var i = 0; i < ca.length; i++) {
	                var c = ca[i];
	                while (c.charAt(0) == ' ') {
	                    c = c.substring(1, c.length);
	                }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	            }
	            return null;
	        }
	    }]);
	
	    return Persistence;
	}();
	
	exports.default = Persistence;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by smizrahi on 8/17/16.
	 */
	
	var Security = function () {
	    function Security() {
	        _classCallCheck(this, Security);
	    }
	
	    /**
	     * This method generates a unique device ID based on browser's statistics (activex, user agent, displays, software)
	     * Source : https://gist.github.com/splosch/eaacc83f245372ae98fe
	     *
	     * @returns {*} A unique ID
	     */
	
	
	    _createClass(Security, [{
	        key: 'generateDeviceID',
	        value: function generateDeviceID() {
	            "use strict";
	
	            var SEP = '|',
	                opera,
	                ie;
	            /*
	             * Collect Browser & Device Data
	             */
	            var Collector = {
	                activeXDetect: function activeXDetect(componentClassID) {
	                    var componentVersion = document.body.getComponentVersion('{' + componentClassID + '}', 'ComponentID');
	                    return componentVersion !== null ? componentVersion : false;
	                },
	
	                stripIllegalChars: function stripIllegalChars(value) {
	                    var t = "",
	                        i;
	
	                    value = value.toLowerCase();
	                    for (i = 0; i < value.length; i++) {
	                        if (value.charAt(i) !== '\n' && value.charAt(i) !== '/' && value.charAt(i) !== "\\") {
	                            t += value.charAt(i);
	                        } else if (value.charAt(i) === '\n') {
	                            t += "n";
	                        }
	                    }
	                    return t;
	                },
	
	                stripFullPath: function stripFullPath(tempFileName, lastDir) {
	                    var fileName = tempFileName,
	                        filenameStart = fileName.lastIndexOf(lastDir),
	                        filenameFinish = fileName.length;
	
	                    if (filenameStart < 0) {
	                        filenameStart = 0;
	                    }
	
	                    fileName = fileName.substring(filenameStart + lastDir.length, filenameFinish);
	
	                    return fileName;
	                },
	
	                userAgent: function userAgent() {
	                    return window.navigator.userAgent || "unknown user agent";
	                },
	
	                display: function display() {
	                    var screen = window.screen || screen || {};
	                    return JSON.stringify(screen);
	                },
	
	                software: function software() {
	                    var i,
	                        t = "",
	                        isFirst = true,
	                        temp = "",
	                        lastDir = "Plugins",
	                        plugin,
	                        mimeType,
	                        components,
	                        ver;
	
	                    if (window.navigator.plugins.length > 0) {
	                        if (opera) {
	                            temp = "";
	                            lastDir = "Plugins";
	
	                            for (i = 0; i < window.navigator.plugins.length; i++) {
	                                plugin = window.navigator.plugins[i];
	                                if (isFirst === true) {
	                                    temp += this.stripFullPath(plugin.filename, lastDir);
	                                    isFirst = false;
	                                } else {
	                                    temp += SEP + this.stripFullPath(plugin.filename, lastDir);
	                                }
	                            }
	                            t = this.stripIllegalChars(temp);
	                        } else {
	                            for (i = 0; i < window.navigator.plugins.length; i++) {
	                                plugin = window.navigator.plugins[i];
	                                if (isFirst === true) {
	                                    t += plugin.filename;
	                                    isFirst = false;
	                                } else {
	                                    t += SEP + plugin.filename;
	                                }
	                            }
	                        }
	                    } else if (window.navigator.mimeTypes.length > 0) {
	                        for (i = 0; i < window.navigator.mimeTypes.length; i++) {
	                            mimeType = window.navigator.mimeTypes[i];
	                            if (isFirst === true) {
	                                t += mimeType.type;
	                                isFirst = false;
	                            } else {
	                                t += SEP + mimeType.type;
	                            }
	                        }
	                    } else if (ie) {
	                        components = new Array("7790769C-0471-11D2-AF11-00C04FA35D02", "89820200-ECBD-11CF-8B85-00AA005B4340", "283807B5-2C60-11D0-A31D-00AA00B92C03", "4F216970-C90C-11D1-B5C7-0000F8051515", "44BBA848-CC51-11CF-AAFA-00AA00B6015C", "9381D8F2-0288-11D0-9501-00AA00B911A5", "4F216970-C90C-11D1-B5C7-0000F8051515", "5A8D6EE0-3E18-11D0-821E-444553540000", "89820200-ECBD-11CF-8B85-00AA005B4383", "08B0E5C0-4FCB-11CF-AAA5-00401C608555", "45EA75A0-A269-11D1-B5BF-0000F8051515", "DE5AED00-A4BF-11D1-9948-00C04F98BBC9", "22D6F312-B0F6-11D0-94AB-0080C74C7E95", "44BBA842-CC51-11CF-AAFA-00AA00B6015B", "3AF36230-A269-11D1-B5BF-0000F8051515", "44BBA840-CC51-11CF-AAFA-00AA00B6015C", "CC2A9BA0-3BDD-11D0-821E-444553540000", "08B0E5C0-4FCB-11CF-AAA5-00401C608500", "D27CDB6E-AE6D-11CF-96B8-444553540000", "2A202491-F00D-11CF-87CC-0020AFEECF20");
	                        document.body.addBehavior("#default#clientCaps");
	                        for (i = 0; i < components.length; i++) {
	                            ver = this.activeXDetect(components[i]);
	                            if (ver) {
	                                if (isFirst === true) {
	                                    t += ver;
	                                    isFirst = false;
	                                } else {
	                                    t += SEP + ver;
	                                }
	                            } else {
	                                t += SEP + "null";
	                            }
	                        }
	                    }
	
	                    return t;
	                },
	
	                myDeviceHash: function myDeviceHash() {
	                    return this.userAgent() + this.display() + this.software();
	                }
	
	                // to be extended with canvas fingerprinting etc ...
	                // font lists etc ...
	            };
	
	            return this.md5(Collector.myDeviceHash());
	        }
	
	        /**
	         * Generates a md5 hash on the parameter
	         *
	         * @param s a string
	         */
	
	    }, {
	        key: 'md5',
	        value: function md5(s) {
	            var hexcase = 0,
	                chrsz = 8,
	                cmc5 = function cmc5(x, e) {
	                x[e >> 5] |= 0x80 << e % 32;x[(e + 64 >>> 9 << 4) + 14] = e;var a = 1732584193;var b = -271733879;var c = -1732584194;var d = 271733878;for (var i = 0; i < x.length; i += 16) {
	                    var f = a;var g = b;var h = c;var j = d;a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);a = safe_add(a, f);b = safe_add(b, g);c = safe_add(c, h);d = safe_add(d, j);
	                }return Array(a, b, c, d);
	            },
	                md5_cmn = function md5_cmn(q, a, b, x, s, t) {
	                return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
	            },
	                md5_ff = function md5_ff(a, b, c, d, x, s, t) {
	                return md5_cmn(b & c | ~b & d, a, b, x, s, t);
	            },
	                md5_gg = function md5_gg(a, b, c, d, x, s, t) {
	                return md5_cmn(b & d | c & ~d, a, b, x, s, t);
	            },
	                md5_hh = function md5_hh(a, b, c, d, x, s, t) {
	                return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	            },
	                md5_ii = function md5_ii(a, b, c, d, x, s, t) {
	                return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
	            },
	                safe_add = function safe_add(x, y) {
	                var a = (x & 0xFFFF) + (y & 0xFFFF);var b = (x >> 16) + (y >> 16) + (a >> 16);return b << 16 | a & 0xFFFF;
	            },
	                bit_rol = function bit_rol(a, b) {
	                return a << b | a >>> 32 - b;
	            },
	                s2b = function s2b(a) {
	                var b = Array();var c = (1 << chrsz) - 1;for (var i = 0; i < a.length * chrsz; i += chrsz) {
	                    b[i >> 5] |= (a.charCodeAt(i / chrsz) & c) << i % 32;
	                }return b;
	            },
	                b2h = function b2h(a) {
	                var b = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";var c = "";for (var i = 0; i < a.length * 4; i++) {
	                    c += b.charAt(a[i >> 2] >> i % 4 * 8 + 4 & 0xF) + b.charAt(a[i >> 2] >> i % 4 * 8 & 0xF);
	                }return c;
	            };return b2h(cmc5(s2b(s), s.length * chrsz));
	        }
	
	        /**
	         * Generates a random seed of X characters
	         *
	         * @param length
	         * @returns {string} The seed
	         */
	
	    }, {
	        key: 'generateSeed',
	        value: function generateSeed(length) {
	            var seed = '';
	            var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	
	            for (var i = 0; i < length; i++) {
	                seed += possible.charAt(Math.floor(Math.random() * possible.length));
	            }return seed;
	        }
	    }]);
	
	    return Security;
	}();
	
	exports.default = Security;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WEBSERVICE_EXT = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _WebService2 = __webpack_require__(13);
	
	var _WebService3 = _interopRequireDefault(_WebService2);
	
	var _EQError = __webpack_require__(6);
	
	var _EQError2 = _interopRequireDefault(_EQError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by smizrahi on 8/1/16.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var WEBSERVICE_EXT = exports.WEBSERVICE_EXT = '/ws/4';
	
	var ConfigWebService = function (_WebService) {
	    _inherits(ConfigWebService, _WebService);
	
	    function ConfigWebService(url, folder) {
	        _classCallCheck(this, ConfigWebService);
	
	        var _this = _possibleConstructorReturn(this, (ConfigWebService.__proto__ || Object.getPrototypeOf(ConfigWebService)).call(this));
	
	        if (!url || !folder) {
	            throw new _EQError2.default('Folder or url parameter missing', 1203);
	        } else {
	            _this.confVersion = 16;
	            _this.url = url + WEBSERVICE_EXT + '/mscoreconfiguration';
	            _this.folder = folder;
	        }
	        return _this;
	    }
	
	    /**
	     * Get the configuration from server
	     *
	     * @param config
	     * @param coupon
	     * @returns {Promise} XML Configuration
	     */
	
	
	    _createClass(ConfigWebService, [{
	        key: 'get',
	        value: function get(config) {
	            var coupon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            var parameters = {};
	            parameters.configurationVersion = this.confVersion;
	
	            if (config) {
	                parameters.scenarioVersion = config.confVersion;
	                parameters.groupId = config.groupId;
	            } else {
	                parameters.scenarioVersion = -1;
	                parameters.groupId = 0;
	            }
	
	            parameters.dqaInstallationDirectory = this.folder;
	            if (coupon) parameters.couponCode = coupon;
	
	            return this.post(this.url, parameters);
	        }
	
	        /**
	         * Return the configuration version from the server
	         *
	         * @returns {number} Configuration version
	         */
	
	    }, {
	        key: 'getWebserviceVersion',
	        value: function getWebserviceVersion() {
	            return this.confVersion;
	        }
	    }]);
	
	    return ConfigWebService;
	}(_WebService3.default);
	
	exports.default = ConfigWebService;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by smizrahi on 8/1/16.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _EQError = __webpack_require__(6);
	
	var _EQError2 = _interopRequireDefault(_EQError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*eslint-disable no-undef*/
	var WebService = function () {
	    function WebService() {
	        _classCallCheck(this, WebService);
	    }
	
	    /**
	     * Execute a POST query
	     *
	     * @param url
	     * @param parameters with key / value
	     * @returns {Promise}
	     */
	
	
	    _createClass(WebService, [{
	        key: 'post',
	        value: function post(url, parameters) {
	            return new Promise(function (resolve, reject) {
	                var parametersQueryArray = [];
	
	                for (var key in parameters) {
	                    parametersQueryArray.push(key + '=' + encodeURIComponent(parameters[key]));
	                }
	
	                var parametersQuery = parametersQueryArray.join('&');
	
	                var req = new XMLHttpRequest();
	                req.open('POST', url, true);
	                req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	
	                req.onload = function () {
	                    if (req.status == 200) {
	                        var response = req.responseText;
	                        resolve(response);
	                    } else {
	                        if (req.status == 500) {
	                            // Try to parse XML response
	                            var parseString = __webpack_require__(14).parseString;
	                            parseString(req.responseText, {
	                                attrkey: 'attr',
	                                childkey: 'child',
	                                charkey: 'val'
	                            }, function (err, result) {
	                                if (err) {
	                                    reject(new _EQError2.default(req.statusText, req.status, true));
	                                } else {
	                                    reject(new _EQError2.default(result.response.error[0].attr.message, parseInt(result.response.error[0].attr.code), false));
	                                }
	                            });
	                        } else {
	                            reject(new _EQError2.default(req.statusText, req.status, true));
	                        }
	                    }
	                };
	                req.onerror = function () {
	                    reject(new _EQError2.default('Network Error', 1200, true));
	                };
	                req.send(parametersQuery);
	            });
	        }
	
	        /**
	         * Execute a GET query
	         *
	         * @param url
	         * @param parameters a map key/value
	         * @returns {Promise}
	         */
	
	    }, {
	        key: 'get',
	        value: function get(url) {
	            var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            return new Promise(function (resolve, reject) {
	                var parametersQuery = null;
	                if (parameters) {
	                    var parametersQueryArray = [];
	
	                    parameters.forEach(function (value, key) {
	                        parametersQueryArray.push(key + '=' + encodeURIComponent(parameters[key]));
	                    });
	
	                    parametersQuery = parametersQueryArray.join('&');
	                }
	                var req = new XMLHttpRequest();
	                if (parametersQuery) {
	                    req.open('GET', url + '?' + parametersQuery, true);
	                } else {
	                    req.open('GET', url, true);
	                }
	
	                req.onload = function () {
	                    if (req.status == 200) {
	                        var response = req.responseText;
	                        resolve(response);
	                    } else {
	                        reject(new _EQError2.default(req.statusText, req.status, true));
	                    }
	                };
	                req.onerror = function () {
	                    reject(new _EQError2.default('Network Error', 1200, true));
	                };
	                req.send(parametersQuery);
	            });
	        }
	
	        /**
	         * Execute a POST query
	         *
	         * @param {string} url
	         * @param {string} raw data to post
	         * @returns {Promise}
	         */
	
	    }, {
	        key: 'postRaw',
	        value: function postRaw(url, raw) {
	            return new Promise(function (resolve, reject) {
	                var req = new XMLHttpRequest();
	                req.open('POST', url, true);
	                req.onload = function () {
	                    if (req.status == 200) {
	                        var response = req.responseText;
	                        resolve(response);
	                    } else {
	                        if (req.status == 500) {
	                            reject(new _EQError2.default(req.statusText, req.status, true));
	                        } else {
	                            reject(new _EQError2.default(req.statusText, req.status, true));
	                        }
	                    }
	                };
	                req.onabort = function () {
	                    reject(new _EQError2.default('Network Error', 1201, true));
	                };
	                req.onerror = function () {
	                    reject(new _EQError2.default('Network Error', 1200, true));
	                };
	                req.send(raw);
	            });
	        }
	    }]);
	
	    return WebService;
	}();
	
	exports.default = WebService;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.7
	(function () {
	  "use strict";
	
	  var builder,
	      defaults,
	      parser,
	      processors,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  defaults = __webpack_require__(15);
	
	  builder = __webpack_require__(16);
	
	  parser = __webpack_require__(39);
	
	  processors = __webpack_require__(67);
	
	  exports.defaults = defaults.defaults;
	
	  exports.processors = processors;
	
	  exports.ValidationError = function (superClass) {
	    extend(ValidationError, superClass);
	
	    function ValidationError(message) {
	      this.message = message;
	    }
	
	    return ValidationError;
	  }(Error);
	
	  exports.Builder = builder.Builder;
	
	  exports.Parser = parser.Parser;
	
	  exports.parseString = parser.parseString;
	}).call(undefined);

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	
	// Generated by CoffeeScript 1.12.7
	(function () {
	  exports.defaults = {
	    "0.1": {
	      explicitCharkey: false,
	      trim: true,
	      normalize: true,
	      normalizeTags: false,
	      attrkey: "@",
	      charkey: "#",
	      explicitArray: false,
	      ignoreAttrs: false,
	      mergeAttrs: false,
	      explicitRoot: false,
	      validator: null,
	      xmlns: false,
	      explicitChildren: false,
	      childkey: '@@',
	      charsAsChildren: false,
	      includeWhiteChars: false,
	      async: false,
	      strict: true,
	      attrNameProcessors: null,
	      attrValueProcessors: null,
	      tagNameProcessors: null,
	      valueProcessors: null,
	      emptyTag: ''
	    },
	    "0.2": {
	      explicitCharkey: false,
	      trim: false,
	      normalize: false,
	      normalizeTags: false,
	      attrkey: "$",
	      charkey: "_",
	      explicitArray: true,
	      ignoreAttrs: false,
	      mergeAttrs: false,
	      explicitRoot: true,
	      validator: null,
	      xmlns: false,
	      explicitChildren: false,
	      preserveChildrenOrder: false,
	      childkey: '$$',
	      charsAsChildren: false,
	      includeWhiteChars: false,
	      async: false,
	      strict: true,
	      attrNameProcessors: null,
	      attrValueProcessors: null,
	      tagNameProcessors: null,
	      valueProcessors: null,
	      rootName: 'root',
	      xmldec: {
	        'version': '1.0',
	        'encoding': 'UTF-8',
	        'standalone': true
	      },
	      doctype: null,
	      renderOpts: {
	        'pretty': true,
	        'indent': '  ',
	        'newline': '\n'
	      },
	      headless: false,
	      chunkSize: 10000,
	      emptyTag: '',
	      cdata: false
	    }
	  };
	}).call(undefined);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Generated by CoffeeScript 1.12.7
	(function () {
	  "use strict";
	
	  var builder,
	      defaults,
	      escapeCDATA,
	      requiresCDATA,
	      wrapCDATA,
	      hasProp = {}.hasOwnProperty;
	
	  builder = __webpack_require__(17);
	
	  defaults = __webpack_require__(15).defaults;
	
	  requiresCDATA = function requiresCDATA(entry) {
	    return typeof entry === "string" && (entry.indexOf('&') >= 0 || entry.indexOf('>') >= 0 || entry.indexOf('<') >= 0);
	  };
	
	  wrapCDATA = function wrapCDATA(entry) {
	    return "<![CDATA[" + escapeCDATA(entry) + "]]>";
	  };
	
	  escapeCDATA = function escapeCDATA(entry) {
	    return entry.replace(']]>', ']]]]><![CDATA[>');
	  };
	
	  exports.Builder = function () {
	    function Builder(opts) {
	      var key, ref, value;
	      this.options = {};
	      ref = defaults["0.2"];
	      for (key in ref) {
	        if (!hasProp.call(ref, key)) continue;
	        value = ref[key];
	        this.options[key] = value;
	      }
	      for (key in opts) {
	        if (!hasProp.call(opts, key)) continue;
	        value = opts[key];
	        this.options[key] = value;
	      }
	    }
	
	    Builder.prototype.buildObject = function (rootObj) {
	      var attrkey, charkey, render, rootElement, rootName;
	      attrkey = this.options.attrkey;
	      charkey = this.options.charkey;
	      if (Object.keys(rootObj).length === 1 && this.options.rootName === defaults['0.2'].rootName) {
	        rootName = Object.keys(rootObj)[0];
	        rootObj = rootObj[rootName];
	      } else {
	        rootName = this.options.rootName;
	      }
	      render = function (_this) {
	        return function (element, obj) {
	          var attr, child, entry, index, key, value;
	          if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
	            if (_this.options.cdata && requiresCDATA(obj)) {
	              element.raw(wrapCDATA(obj));
	            } else {
	              element.txt(obj);
	            }
	          } else if (Array.isArray(obj)) {
	            for (index in obj) {
	              if (!hasProp.call(obj, index)) continue;
	              child = obj[index];
	              for (key in child) {
	                entry = child[key];
	                element = render(element.ele(key), entry).up();
	              }
	            }
	          } else {
	            for (key in obj) {
	              if (!hasProp.call(obj, key)) continue;
	              child = obj[key];
	              if (key === attrkey) {
	                if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === "object") {
	                  for (attr in child) {
	                    value = child[attr];
	                    element = element.att(attr, value);
	                  }
	                }
	              } else if (key === charkey) {
	                if (_this.options.cdata && requiresCDATA(child)) {
	                  element = element.raw(wrapCDATA(child));
	                } else {
	                  element = element.txt(child);
	                }
	              } else if (Array.isArray(child)) {
	                for (index in child) {
	                  if (!hasProp.call(child, index)) continue;
	                  entry = child[index];
	                  if (typeof entry === 'string') {
	                    if (_this.options.cdata && requiresCDATA(entry)) {
	                      element = element.ele(key).raw(wrapCDATA(entry)).up();
	                    } else {
	                      element = element.ele(key, entry).up();
	                    }
	                  } else {
	                    element = render(element.ele(key), entry).up();
	                  }
	                }
	              } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === "object") {
	                element = render(element.ele(key), child).up();
	              } else {
	                if (typeof child === 'string' && _this.options.cdata && requiresCDATA(child)) {
	                  element = element.ele(key).raw(wrapCDATA(child)).up();
	                } else {
	                  if (child == null) {
	                    child = '';
	                  }
	                  element = element.ele(key, child.toString()).up();
	                }
	              }
	            }
	          }
	          return element;
	        };
	      }(this);
	      rootElement = builder.create(rootName, this.options.xmldec, this.options.doctype, {
	        headless: this.options.headless,
	        allowSurrogateChars: this.options.allowSurrogateChars
	      });
	      return render(rootElement, rootObj).end(this.options.renderOpts);
	    };
	
	    return Builder;
	  }();
	}).call(undefined);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;
	
	  ref = __webpack_require__(18), assign = ref.assign, isFunction = ref.isFunction;
	
	  XMLDocument = __webpack_require__(19);
	
	  XMLDocumentCB = __webpack_require__(37);
	
	  XMLStringWriter = __webpack_require__(35);
	
	  XMLStreamWriter = __webpack_require__(38);
	
	  module.exports.create = function (name, xmldec, doctype, options) {
	    var doc, root;
	    if (name == null) {
	      throw new Error("Root element needs a name");
	    }
	    options = assign({}, xmldec, doctype, options);
	    doc = new XMLDocument(options);
	    root = doc.element(name);
	    if (!options.headless) {
	      doc.declaration(options);
	      if (options.pubID != null || options.sysID != null) {
	        doc.doctype(options);
	      }
	    }
	    return root;
	  };
	
	  module.exports.begin = function (options, onData, onEnd) {
	    var ref1;
	    if (isFunction(options)) {
	      ref1 = [options, onData], onData = ref1[0], onEnd = ref1[1];
	      options = {};
	    }
	    if (onData) {
	      return new XMLDocumentCB(options, onData, onEnd);
	    } else {
	      return new XMLDocument(options);
	    }
	  };
	
	  module.exports.stringWriter = function (options) {
	    return new XMLStringWriter(options);
	  };
	
	  module.exports.streamWriter = function (stream, options) {
	    return new XMLStreamWriter(stream, options);
	  };
	}).call(undefined);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var assign,
	      isArray,
	      isEmpty,
	      isFunction,
	      isObject,
	      isPlainObject,
	      slice = [].slice,
	      hasProp = {}.hasOwnProperty;
	
	  assign = function assign() {
	    var i, key, len, source, sources, target;
	    target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	    if (isFunction(Object.assign)) {
	      Object.assign.apply(null, arguments);
	    } else {
	      for (i = 0, len = sources.length; i < len; i++) {
	        source = sources[i];
	        if (source != null) {
	          for (key in source) {
	            if (!hasProp.call(source, key)) continue;
	            target[key] = source[key];
	          }
	        }
	      }
	    }
	    return target;
	  };
	
	  isFunction = function isFunction(val) {
	    return !!val && Object.prototype.toString.call(val) === '[object Function]';
	  };
	
	  isObject = function isObject(val) {
	    var ref;
	    return !!val && ((ref = typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'function' || ref === 'object');
	  };
	
	  isArray = function isArray(val) {
	    if (isFunction(Array.isArray)) {
	      return Array.isArray(val);
	    } else {
	      return Object.prototype.toString.call(val) === '[object Array]';
	    }
	  };
	
	  isEmpty = function isEmpty(val) {
	    var key;
	    if (isArray(val)) {
	      return !val.length;
	    } else {
	      for (key in val) {
	        if (!hasProp.call(val, key)) continue;
	        return false;
	      }
	      return true;
	    }
	  };
	
	  isPlainObject = function isPlainObject(val) {
	    var ctor, proto;
	    return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && typeof ctor === 'function' && ctor instanceof ctor && Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object);
	  };
	
	  module.exports.assign = assign;
	
	  module.exports.isFunction = isFunction;
	
	  module.exports.isObject = isObject;
	
	  module.exports.isArray = isArray;
	
	  module.exports.isEmpty = isEmpty;
	
	  module.exports.isPlainObject = isPlainObject;
	}).call(undefined);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLDocument,
	      XMLNode,
	      XMLStringWriter,
	      XMLStringifier,
	      isPlainObject,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  isPlainObject = __webpack_require__(18).isPlainObject;
	
	  XMLNode = __webpack_require__(20);
	
	  XMLStringifier = __webpack_require__(34);
	
	  XMLStringWriter = __webpack_require__(35);
	
	  module.exports = XMLDocument = function (superClass) {
	    extend(XMLDocument, superClass);
	
	    function XMLDocument(options) {
	      XMLDocument.__super__.constructor.call(this, null);
	      options || (options = {});
	      if (!options.writer) {
	        options.writer = new XMLStringWriter();
	      }
	      this.options = options;
	      this.stringify = new XMLStringifier(options);
	      this.isDocument = true;
	    }
	
	    XMLDocument.prototype.end = function (writer) {
	      var writerOptions;
	      if (!writer) {
	        writer = this.options.writer;
	      } else if (isPlainObject(writer)) {
	        writerOptions = writer;
	        writer = this.options.writer.set(writerOptions);
	      }
	      return writer.document(this);
	    };
	
	    XMLDocument.prototype.toString = function (options) {
	      return this.options.writer.set(options).document(this);
	    };
	
	    return XMLDocument;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLCData,
	      XMLComment,
	      XMLDeclaration,
	      XMLDocType,
	      XMLElement,
	      XMLNode,
	      XMLProcessingInstruction,
	      XMLRaw,
	      XMLText,
	      isEmpty,
	      isFunction,
	      isObject,
	      ref,
	      hasProp = {}.hasOwnProperty;
	
	  ref = __webpack_require__(18), isObject = ref.isObject, isFunction = ref.isFunction, isEmpty = ref.isEmpty;
	
	  XMLElement = null;
	
	  XMLCData = null;
	
	  XMLComment = null;
	
	  XMLDeclaration = null;
	
	  XMLDocType = null;
	
	  XMLRaw = null;
	
	  XMLText = null;
	
	  XMLProcessingInstruction = null;
	
	  module.exports = XMLNode = function () {
	    function XMLNode(parent) {
	      this.parent = parent;
	      if (this.parent) {
	        this.options = this.parent.options;
	        this.stringify = this.parent.stringify;
	      }
	      this.children = [];
	      if (!XMLElement) {
	        XMLElement = __webpack_require__(21);
	        XMLCData = __webpack_require__(23);
	        XMLComment = __webpack_require__(24);
	        XMLDeclaration = __webpack_require__(25);
	        XMLDocType = __webpack_require__(26);
	        XMLRaw = __webpack_require__(31);
	        XMLText = __webpack_require__(32);
	        XMLProcessingInstruction = __webpack_require__(33);
	      }
	    }
	
	    XMLNode.prototype.element = function (name, attributes, text) {
	      var childNode, item, j, k, key, lastChild, len, len1, ref1, val;
	      lastChild = null;
	      if (attributes == null) {
	        attributes = {};
	      }
	      attributes = attributes.valueOf();
	      if (!isObject(attributes)) {
	        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
	      }
	      if (name != null) {
	        name = name.valueOf();
	      }
	      if (Array.isArray(name)) {
	        for (j = 0, len = name.length; j < len; j++) {
	          item = name[j];
	          lastChild = this.element(item);
	        }
	      } else if (isFunction(name)) {
	        lastChild = this.element(name.apply());
	      } else if (isObject(name)) {
	        for (key in name) {
	          if (!hasProp.call(name, key)) continue;
	          val = name[key];
	          if (isFunction(val)) {
	            val = val.apply();
	          }
	          if (isObject(val) && isEmpty(val)) {
	            val = null;
	          }
	          if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
	            lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
	          } else if (!this.options.separateArrayItems && Array.isArray(val)) {
	            for (k = 0, len1 = val.length; k < len1; k++) {
	              item = val[k];
	              childNode = {};
	              childNode[key] = item;
	              lastChild = this.element(childNode);
	            }
	          } else if (isObject(val)) {
	            lastChild = this.element(key);
	            lastChild.element(val);
	          } else {
	            lastChild = this.element(key, val);
	          }
	        }
	      } else {
	        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
	          lastChild = this.text(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
	          lastChild = this.cdata(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
	          lastChild = this.comment(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
	          lastChild = this.raw(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) {
	          lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
	        } else {
	          lastChild = this.node(name, attributes, text);
	        }
	      }
	      if (lastChild == null) {
	        throw new Error("Could not create any elements with: " + name);
	      }
	      return lastChild;
	    };
	
	    XMLNode.prototype.insertBefore = function (name, attributes, text) {
	      var child, i, removed;
	      if (this.isRoot) {
	        throw new Error("Cannot insert elements at root level");
	      }
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i);
	      child = this.parent.element(name, attributes, text);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return child;
	    };
	
	    XMLNode.prototype.insertAfter = function (name, attributes, text) {
	      var child, i, removed;
	      if (this.isRoot) {
	        throw new Error("Cannot insert elements at root level");
	      }
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i + 1);
	      child = this.parent.element(name, attributes, text);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return child;
	    };
	
	    XMLNode.prototype.remove = function () {
	      var i, ref1;
	      if (this.isRoot) {
	        throw new Error("Cannot remove the root element");
	      }
	      i = this.parent.children.indexOf(this);
	      [].splice.apply(this.parent.children, [i, i - i + 1].concat(ref1 = [])), ref1;
	      return this.parent;
	    };
	
	    XMLNode.prototype.node = function (name, attributes, text) {
	      var child, ref1;
	      if (name != null) {
	        name = name.valueOf();
	      }
	      attributes || (attributes = {});
	      attributes = attributes.valueOf();
	      if (!isObject(attributes)) {
	        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
	      }
	      child = new XMLElement(this, name, attributes);
	      if (text != null) {
	        child.text(text);
	      }
	      this.children.push(child);
	      return child;
	    };
	
	    XMLNode.prototype.text = function (value) {
	      var child;
	      child = new XMLText(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.cdata = function (value) {
	      var child;
	      child = new XMLCData(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.comment = function (value) {
	      var child;
	      child = new XMLComment(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.commentBefore = function (value) {
	      var child, i, removed;
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i);
	      child = this.parent.comment(value);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return this;
	    };
	
	    XMLNode.prototype.commentAfter = function (value) {
	      var child, i, removed;
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i + 1);
	      child = this.parent.comment(value);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return this;
	    };
	
	    XMLNode.prototype.raw = function (value) {
	      var child;
	      child = new XMLRaw(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.instruction = function (target, value) {
	      var insTarget, insValue, instruction, j, len;
	      if (target != null) {
	        target = target.valueOf();
	      }
	      if (value != null) {
	        value = value.valueOf();
	      }
	      if (Array.isArray(target)) {
	        for (j = 0, len = target.length; j < len; j++) {
	          insTarget = target[j];
	          this.instruction(insTarget);
	        }
	      } else if (isObject(target)) {
	        for (insTarget in target) {
	          if (!hasProp.call(target, insTarget)) continue;
	          insValue = target[insTarget];
	          this.instruction(insTarget, insValue);
	        }
	      } else {
	        if (isFunction(value)) {
	          value = value.apply();
	        }
	        instruction = new XMLProcessingInstruction(this, target, value);
	        this.children.push(instruction);
	      }
	      return this;
	    };
	
	    XMLNode.prototype.instructionBefore = function (target, value) {
	      var child, i, removed;
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i);
	      child = this.parent.instruction(target, value);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return this;
	    };
	
	    XMLNode.prototype.instructionAfter = function (target, value) {
	      var child, i, removed;
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i + 1);
	      child = this.parent.instruction(target, value);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return this;
	    };
	
	    XMLNode.prototype.declaration = function (version, encoding, standalone) {
	      var doc, xmldec;
	      doc = this.document();
	      xmldec = new XMLDeclaration(doc, version, encoding, standalone);
	      if (doc.children[0] instanceof XMLDeclaration) {
	        doc.children[0] = xmldec;
	      } else {
	        doc.children.unshift(xmldec);
	      }
	      return doc.root() || doc;
	    };
	
	    XMLNode.prototype.doctype = function (pubID, sysID) {
	      var child, doc, doctype, i, j, k, len, len1, ref1, ref2;
	      doc = this.document();
	      doctype = new XMLDocType(doc, pubID, sysID);
	      ref1 = doc.children;
	      for (i = j = 0, len = ref1.length; j < len; i = ++j) {
	        child = ref1[i];
	        if (child instanceof XMLDocType) {
	          doc.children[i] = doctype;
	          return doctype;
	        }
	      }
	      ref2 = doc.children;
	      for (i = k = 0, len1 = ref2.length; k < len1; i = ++k) {
	        child = ref2[i];
	        if (child.isRoot) {
	          doc.children.splice(i, 0, doctype);
	          return doctype;
	        }
	      }
	      doc.children.push(doctype);
	      return doctype;
	    };
	
	    XMLNode.prototype.up = function () {
	      if (this.isRoot) {
	        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
	      }
	      return this.parent;
	    };
	
	    XMLNode.prototype.root = function () {
	      var node;
	      node = this;
	      while (node) {
	        if (node.isDocument) {
	          return node.rootObject;
	        } else if (node.isRoot) {
	          return node;
	        } else {
	          node = node.parent;
	        }
	      }
	    };
	
	    XMLNode.prototype.document = function () {
	      var node;
	      node = this;
	      while (node) {
	        if (node.isDocument) {
	          return node;
	        } else {
	          node = node.parent;
	        }
	      }
	    };
	
	    XMLNode.prototype.end = function (options) {
	      return this.document().end(options);
	    };
	
	    XMLNode.prototype.prev = function () {
	      var i;
	      i = this.parent.children.indexOf(this);
	      if (i < 1) {
	        throw new Error("Already at the first node");
	      }
	      return this.parent.children[i - 1];
	    };
	
	    XMLNode.prototype.next = function () {
	      var i;
	      i = this.parent.children.indexOf(this);
	      if (i === -1 || i === this.parent.children.length - 1) {
	        throw new Error("Already at the last node");
	      }
	      return this.parent.children[i + 1];
	    };
	
	    XMLNode.prototype.importDocument = function (doc) {
	      var clonedRoot;
	      clonedRoot = doc.root().clone();
	      clonedRoot.parent = this;
	      clonedRoot.isRoot = false;
	      this.children.push(clonedRoot);
	      return this;
	    };
	
	    XMLNode.prototype.ele = function (name, attributes, text) {
	      return this.element(name, attributes, text);
	    };
	
	    XMLNode.prototype.nod = function (name, attributes, text) {
	      return this.node(name, attributes, text);
	    };
	
	    XMLNode.prototype.txt = function (value) {
	      return this.text(value);
	    };
	
	    XMLNode.prototype.dat = function (value) {
	      return this.cdata(value);
	    };
	
	    XMLNode.prototype.com = function (value) {
	      return this.comment(value);
	    };
	
	    XMLNode.prototype.ins = function (target, value) {
	      return this.instruction(target, value);
	    };
	
	    XMLNode.prototype.doc = function () {
	      return this.document();
	    };
	
	    XMLNode.prototype.dec = function (version, encoding, standalone) {
	      return this.declaration(version, encoding, standalone);
	    };
	
	    XMLNode.prototype.dtd = function (pubID, sysID) {
	      return this.doctype(pubID, sysID);
	    };
	
	    XMLNode.prototype.e = function (name, attributes, text) {
	      return this.element(name, attributes, text);
	    };
	
	    XMLNode.prototype.n = function (name, attributes, text) {
	      return this.node(name, attributes, text);
	    };
	
	    XMLNode.prototype.t = function (value) {
	      return this.text(value);
	    };
	
	    XMLNode.prototype.d = function (value) {
	      return this.cdata(value);
	    };
	
	    XMLNode.prototype.c = function (value) {
	      return this.comment(value);
	    };
	
	    XMLNode.prototype.r = function (value) {
	      return this.raw(value);
	    };
	
	    XMLNode.prototype.i = function (target, value) {
	      return this.instruction(target, value);
	    };
	
	    XMLNode.prototype.u = function () {
	      return this.up();
	    };
	
	    XMLNode.prototype.importXMLBuilder = function (doc) {
	      return this.importDocument(doc);
	    };
	
	    return XMLNode;
	  }();
	}).call(undefined);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLAttribute,
	      XMLElement,
	      XMLNode,
	      isFunction,
	      isObject,
	      ref,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  ref = __webpack_require__(18), isObject = ref.isObject, isFunction = ref.isFunction;
	
	  XMLNode = __webpack_require__(20);
	
	  XMLAttribute = __webpack_require__(22);
	
	  module.exports = XMLElement = function (superClass) {
	    extend(XMLElement, superClass);
	
	    function XMLElement(parent, name, attributes) {
	      XMLElement.__super__.constructor.call(this, parent);
	      if (name == null) {
	        throw new Error("Missing element name");
	      }
	      this.name = this.stringify.eleName(name);
	      this.attributes = {};
	      if (attributes != null) {
	        this.attribute(attributes);
	      }
	      if (parent.isDocument) {
	        this.isRoot = true;
	        this.documentObject = parent;
	        parent.rootObject = this;
	      }
	    }
	
	    XMLElement.prototype.clone = function () {
	      var att, attName, clonedSelf, ref1;
	      clonedSelf = Object.create(this);
	      if (clonedSelf.isRoot) {
	        clonedSelf.documentObject = null;
	      }
	      clonedSelf.attributes = {};
	      ref1 = this.attributes;
	      for (attName in ref1) {
	        if (!hasProp.call(ref1, attName)) continue;
	        att = ref1[attName];
	        clonedSelf.attributes[attName] = att.clone();
	      }
	      clonedSelf.children = [];
	      this.children.forEach(function (child) {
	        var clonedChild;
	        clonedChild = child.clone();
	        clonedChild.parent = clonedSelf;
	        return clonedSelf.children.push(clonedChild);
	      });
	      return clonedSelf;
	    };
	
	    XMLElement.prototype.attribute = function (name, value) {
	      var attName, attValue;
	      if (name != null) {
	        name = name.valueOf();
	      }
	      if (isObject(name)) {
	        for (attName in name) {
	          if (!hasProp.call(name, attName)) continue;
	          attValue = name[attName];
	          this.attribute(attName, attValue);
	        }
	      } else {
	        if (isFunction(value)) {
	          value = value.apply();
	        }
	        if (!this.options.skipNullAttributes || value != null) {
	          this.attributes[name] = new XMLAttribute(this, name, value);
	        }
	      }
	      return this;
	    };
	
	    XMLElement.prototype.removeAttribute = function (name) {
	      var attName, i, len;
	      if (name == null) {
	        throw new Error("Missing attribute name");
	      }
	      name = name.valueOf();
	      if (Array.isArray(name)) {
	        for (i = 0, len = name.length; i < len; i++) {
	          attName = name[i];
	          delete this.attributes[attName];
	        }
	      } else {
	        delete this.attributes[name];
	      }
	      return this;
	    };
	
	    XMLElement.prototype.toString = function (options) {
	      return this.options.writer.set(options).element(this);
	    };
	
	    XMLElement.prototype.att = function (name, value) {
	      return this.attribute(name, value);
	    };
	
	    XMLElement.prototype.a = function (name, value) {
	      return this.attribute(name, value);
	    };
	
	    return XMLElement;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLAttribute;
	
	  module.exports = XMLAttribute = function () {
	    function XMLAttribute(parent, name, value) {
	      this.options = parent.options;
	      this.stringify = parent.stringify;
	      if (name == null) {
	        throw new Error("Missing attribute name of element " + parent.name);
	      }
	      if (value == null) {
	        throw new Error("Missing attribute value for attribute " + name + " of element " + parent.name);
	      }
	      this.name = this.stringify.attName(name);
	      this.value = this.stringify.attValue(value);
	    }
	
	    XMLAttribute.prototype.clone = function () {
	      return Object.create(this);
	    };
	
	    XMLAttribute.prototype.toString = function (options) {
	      return this.options.writer.set(options).attribute(this);
	    };
	
	    return XMLAttribute;
	  }();
	}).call(undefined);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLCData,
	      XMLNode,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(20);
	
	  module.exports = XMLCData = function (superClass) {
	    extend(XMLCData, superClass);
	
	    function XMLCData(parent, text) {
	      XMLCData.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing CDATA text");
	      }
	      this.text = this.stringify.cdata(text);
	    }
	
	    XMLCData.prototype.clone = function () {
	      return Object.create(this);
	    };
	
	    XMLCData.prototype.toString = function (options) {
	      return this.options.writer.set(options).cdata(this);
	    };
	
	    return XMLCData;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLComment,
	      XMLNode,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(20);
	
	  module.exports = XMLComment = function (superClass) {
	    extend(XMLComment, superClass);
	
	    function XMLComment(parent, text) {
	      XMLComment.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing comment text");
	      }
	      this.text = this.stringify.comment(text);
	    }
	
	    XMLComment.prototype.clone = function () {
	      return Object.create(this);
	    };
	
	    XMLComment.prototype.toString = function (options) {
	      return this.options.writer.set(options).comment(this);
	    };
	
	    return XMLComment;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLDeclaration,
	      XMLNode,
	      isObject,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  isObject = __webpack_require__(18).isObject;
	
	  XMLNode = __webpack_require__(20);
	
	  module.exports = XMLDeclaration = function (superClass) {
	    extend(XMLDeclaration, superClass);
	
	    function XMLDeclaration(parent, version, encoding, standalone) {
	      var ref;
	      XMLDeclaration.__super__.constructor.call(this, parent);
	      if (isObject(version)) {
	        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
	      }
	      if (!version) {
	        version = '1.0';
	      }
	      this.version = this.stringify.xmlVersion(version);
	      if (encoding != null) {
	        this.encoding = this.stringify.xmlEncoding(encoding);
	      }
	      if (standalone != null) {
	        this.standalone = this.stringify.xmlStandalone(standalone);
	      }
	    }
	
	    XMLDeclaration.prototype.toString = function (options) {
	      return this.options.writer.set(options).declaration(this);
	    };
	
	    return XMLDeclaration;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLDTDAttList,
	      XMLDTDElement,
	      XMLDTDEntity,
	      XMLDTDNotation,
	      XMLDocType,
	      XMLNode,
	      isObject,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  isObject = __webpack_require__(18).isObject;
	
	  XMLNode = __webpack_require__(20);
	
	  XMLDTDAttList = __webpack_require__(27);
	
	  XMLDTDEntity = __webpack_require__(28);
	
	  XMLDTDElement = __webpack_require__(29);
	
	  XMLDTDNotation = __webpack_require__(30);
	
	  module.exports = XMLDocType = function (superClass) {
	    extend(XMLDocType, superClass);
	
	    function XMLDocType(parent, pubID, sysID) {
	      var ref, ref1;
	      XMLDocType.__super__.constructor.call(this, parent);
	      this.documentObject = parent;
	      if (isObject(pubID)) {
	        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
	      }
	      if (sysID == null) {
	        ref1 = [pubID, sysID], sysID = ref1[0], pubID = ref1[1];
	      }
	      if (pubID != null) {
	        this.pubID = this.stringify.dtdPubID(pubID);
	      }
	      if (sysID != null) {
	        this.sysID = this.stringify.dtdSysID(sysID);
	      }
	    }
	
	    XMLDocType.prototype.element = function (name, value) {
	      var child;
	      child = new XMLDTDElement(this, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.attList = function (elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      var child;
	      child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.entity = function (name, value) {
	      var child;
	      child = new XMLDTDEntity(this, false, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.pEntity = function (name, value) {
	      var child;
	      child = new XMLDTDEntity(this, true, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.notation = function (name, value) {
	      var child;
	      child = new XMLDTDNotation(this, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.toString = function (options) {
	      return this.options.writer.set(options).docType(this);
	    };
	
	    XMLDocType.prototype.ele = function (name, value) {
	      return this.element(name, value);
	    };
	
	    XMLDocType.prototype.att = function (elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
	    };
	
	    XMLDocType.prototype.ent = function (name, value) {
	      return this.entity(name, value);
	    };
	
	    XMLDocType.prototype.pent = function (name, value) {
	      return this.pEntity(name, value);
	    };
	
	    XMLDocType.prototype.not = function (name, value) {
	      return this.notation(name, value);
	    };
	
	    XMLDocType.prototype.up = function () {
	      return this.root() || this.documentObject;
	    };
	
	    return XMLDocType;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLDTDAttList,
	      XMLNode,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(20);
	
	  module.exports = XMLDTDAttList = function (superClass) {
	    extend(XMLDTDAttList, superClass);
	
	    function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      XMLDTDAttList.__super__.constructor.call(this, parent);
	      if (elementName == null) {
	        throw new Error("Missing DTD element name");
	      }
	      if (attributeName == null) {
	        throw new Error("Missing DTD attribute name");
	      }
	      if (!attributeType) {
	        throw new Error("Missing DTD attribute type");
	      }
	      if (!defaultValueType) {
	        throw new Error("Missing DTD attribute default");
	      }
	      if (defaultValueType.indexOf('#') !== 0) {
	        defaultValueType = '#' + defaultValueType;
	      }
	      if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
	        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
	      }
	      if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
	        throw new Error("Default value only applies to #FIXED or #DEFAULT");
	      }
	      this.elementName = this.stringify.eleName(elementName);
	      this.attributeName = this.stringify.attName(attributeName);
	      this.attributeType = this.stringify.dtdAttType(attributeType);
	      this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
	      this.defaultValueType = defaultValueType;
	    }
	
	    XMLDTDAttList.prototype.toString = function (options) {
	      return this.options.writer.set(options).dtdAttList(this);
	    };
	
	    return XMLDTDAttList;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLDTDEntity,
	      XMLNode,
	      isObject,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  isObject = __webpack_require__(18).isObject;
	
	  XMLNode = __webpack_require__(20);
	
	  module.exports = XMLDTDEntity = function (superClass) {
	    extend(XMLDTDEntity, superClass);
	
	    function XMLDTDEntity(parent, pe, name, value) {
	      XMLDTDEntity.__super__.constructor.call(this, parent);
	      if (name == null) {
	        throw new Error("Missing entity name");
	      }
	      if (value == null) {
	        throw new Error("Missing entity value");
	      }
	      this.pe = !!pe;
	      this.name = this.stringify.eleName(name);
	      if (!isObject(value)) {
	        this.value = this.stringify.dtdEntityValue(value);
	      } else {
	        if (!value.pubID && !value.sysID) {
	          throw new Error("Public and/or system identifiers are required for an external entity");
	        }
	        if (value.pubID && !value.sysID) {
	          throw new Error("System identifier is required for a public external entity");
	        }
	        if (value.pubID != null) {
	          this.pubID = this.stringify.dtdPubID(value.pubID);
	        }
	        if (value.sysID != null) {
	          this.sysID = this.stringify.dtdSysID(value.sysID);
	        }
	        if (value.nData != null) {
	          this.nData = this.stringify.dtdNData(value.nData);
	        }
	        if (this.pe && this.nData) {
	          throw new Error("Notation declaration is not allowed in a parameter entity");
	        }
	      }
	    }
	
	    XMLDTDEntity.prototype.toString = function (options) {
	      return this.options.writer.set(options).dtdEntity(this);
	    };
	
	    return XMLDTDEntity;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLDTDElement,
	      XMLNode,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(20);
	
	  module.exports = XMLDTDElement = function (superClass) {
	    extend(XMLDTDElement, superClass);
	
	    function XMLDTDElement(parent, name, value) {
	      XMLDTDElement.__super__.constructor.call(this, parent);
	      if (name == null) {
	        throw new Error("Missing DTD element name");
	      }
	      if (!value) {
	        value = '(#PCDATA)';
	      }
	      if (Array.isArray(value)) {
	        value = '(' + value.join(',') + ')';
	      }
	      this.name = this.stringify.eleName(name);
	      this.value = this.stringify.dtdElementValue(value);
	    }
	
	    XMLDTDElement.prototype.toString = function (options) {
	      return this.options.writer.set(options).dtdElement(this);
	    };
	
	    return XMLDTDElement;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLDTDNotation,
	      XMLNode,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(20);
	
	  module.exports = XMLDTDNotation = function (superClass) {
	    extend(XMLDTDNotation, superClass);
	
	    function XMLDTDNotation(parent, name, value) {
	      XMLDTDNotation.__super__.constructor.call(this, parent);
	      if (name == null) {
	        throw new Error("Missing notation name");
	      }
	      if (!value.pubID && !value.sysID) {
	        throw new Error("Public or system identifiers are required for an external entity");
	      }
	      this.name = this.stringify.eleName(name);
	      if (value.pubID != null) {
	        this.pubID = this.stringify.dtdPubID(value.pubID);
	      }
	      if (value.sysID != null) {
	        this.sysID = this.stringify.dtdSysID(value.sysID);
	      }
	    }
	
	    XMLDTDNotation.prototype.toString = function (options) {
	      return this.options.writer.set(options).dtdNotation(this);
	    };
	
	    return XMLDTDNotation;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLNode,
	      XMLRaw,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(20);
	
	  module.exports = XMLRaw = function (superClass) {
	    extend(XMLRaw, superClass);
	
	    function XMLRaw(parent, text) {
	      XMLRaw.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing raw text");
	      }
	      this.value = this.stringify.raw(text);
	    }
	
	    XMLRaw.prototype.clone = function () {
	      return Object.create(this);
	    };
	
	    XMLRaw.prototype.toString = function (options) {
	      return this.options.writer.set(options).raw(this);
	    };
	
	    return XMLRaw;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLNode,
	      XMLText,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(20);
	
	  module.exports = XMLText = function (superClass) {
	    extend(XMLText, superClass);
	
	    function XMLText(parent, text) {
	      XMLText.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing element text");
	      }
	      this.value = this.stringify.eleText(text);
	    }
	
	    XMLText.prototype.clone = function () {
	      return Object.create(this);
	    };
	
	    XMLText.prototype.toString = function (options) {
	      return this.options.writer.set(options).text(this);
	    };
	
	    return XMLText;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLNode,
	      XMLProcessingInstruction,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(20);
	
	  module.exports = XMLProcessingInstruction = function (superClass) {
	    extend(XMLProcessingInstruction, superClass);
	
	    function XMLProcessingInstruction(parent, target, value) {
	      XMLProcessingInstruction.__super__.constructor.call(this, parent);
	      if (target == null) {
	        throw new Error("Missing instruction target");
	      }
	      this.target = this.stringify.insTarget(target);
	      if (value) {
	        this.value = this.stringify.insValue(value);
	      }
	    }
	
	    XMLProcessingInstruction.prototype.clone = function () {
	      return Object.create(this);
	    };
	
	    XMLProcessingInstruction.prototype.toString = function (options) {
	      return this.options.writer.set(options).processingInstruction(this);
	    };
	
	    return XMLProcessingInstruction;
	  }(XMLNode);
	}).call(undefined);

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLStringifier,
	      bind = function bind(fn, me) {
	    return function () {
	      return fn.apply(me, arguments);
	    };
	  },
	      hasProp = {}.hasOwnProperty;
	
	  module.exports = XMLStringifier = function () {
	    function XMLStringifier(options) {
	      this.assertLegalChar = bind(this.assertLegalChar, this);
	      var key, ref, value;
	      options || (options = {});
	      this.noDoubleEncoding = options.noDoubleEncoding;
	      ref = options.stringify || {};
	      for (key in ref) {
	        if (!hasProp.call(ref, key)) continue;
	        value = ref[key];
	        this[key] = value;
	      }
	    }
	
	    XMLStringifier.prototype.eleName = function (val) {
	      val = '' + val || '';
	      return this.assertLegalChar(val);
	    };
	
	    XMLStringifier.prototype.eleText = function (val) {
	      val = '' + val || '';
	      return this.assertLegalChar(this.elEscape(val));
	    };
	
	    XMLStringifier.prototype.cdata = function (val) {
	      val = '' + val || '';
	      val = val.replace(']]>', ']]]]><![CDATA[>');
	      return this.assertLegalChar(val);
	    };
	
	    XMLStringifier.prototype.comment = function (val) {
	      val = '' + val || '';
	      if (val.match(/--/)) {
	        throw new Error("Comment text cannot contain double-hypen: " + val);
	      }
	      return this.assertLegalChar(val);
	    };
	
	    XMLStringifier.prototype.raw = function (val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.attName = function (val) {
	      return val = '' + val || '';
	    };
	
	    XMLStringifier.prototype.attValue = function (val) {
	      val = '' + val || '';
	      return this.attEscape(val);
	    };
	
	    XMLStringifier.prototype.insTarget = function (val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.insValue = function (val) {
	      val = '' + val || '';
	      if (val.match(/\?>/)) {
	        throw new Error("Invalid processing instruction value: " + val);
	      }
	      return val;
	    };
	
	    XMLStringifier.prototype.xmlVersion = function (val) {
	      val = '' + val || '';
	      if (!val.match(/1\.[0-9]+/)) {
	        throw new Error("Invalid version number: " + val);
	      }
	      return val;
	    };
	
	    XMLStringifier.prototype.xmlEncoding = function (val) {
	      val = '' + val || '';
	      if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-]|-)*$/)) {
	        throw new Error("Invalid encoding: " + val);
	      }
	      return val;
	    };
	
	    XMLStringifier.prototype.xmlStandalone = function (val) {
	      if (val) {
	        return "yes";
	      } else {
	        return "no";
	      }
	    };
	
	    XMLStringifier.prototype.dtdPubID = function (val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdSysID = function (val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdElementValue = function (val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdAttType = function (val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdAttDefault = function (val) {
	      if (val != null) {
	        return '' + val || '';
	      } else {
	        return val;
	      }
	    };
	
	    XMLStringifier.prototype.dtdEntityValue = function (val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdNData = function (val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.convertAttKey = '@';
	
	    XMLStringifier.prototype.convertPIKey = '?';
	
	    XMLStringifier.prototype.convertTextKey = '#text';
	
	    XMLStringifier.prototype.convertCDataKey = '#cdata';
	
	    XMLStringifier.prototype.convertCommentKey = '#comment';
	
	    XMLStringifier.prototype.convertRawKey = '#raw';
	
	    XMLStringifier.prototype.assertLegalChar = function (str) {
	      var res;
	      res = str.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/);
	      if (res) {
	        throw new Error("Invalid character in string: " + str + " at index " + res.index);
	      }
	      return str;
	    };
	
	    XMLStringifier.prototype.elEscape = function (str) {
	      var ampregex;
	      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
	      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
	    };
	
	    XMLStringifier.prototype.attEscape = function (str) {
	      var ampregex;
	      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
	      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
	    };
	
	    return XMLStringifier;
	  }();
	}).call(undefined);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLCData,
	      XMLComment,
	      XMLDTDAttList,
	      XMLDTDElement,
	      XMLDTDEntity,
	      XMLDTDNotation,
	      XMLDeclaration,
	      XMLDocType,
	      XMLElement,
	      XMLProcessingInstruction,
	      XMLRaw,
	      XMLStringWriter,
	      XMLText,
	      XMLWriterBase,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  XMLDeclaration = __webpack_require__(25);
	
	  XMLDocType = __webpack_require__(26);
	
	  XMLCData = __webpack_require__(23);
	
	  XMLComment = __webpack_require__(24);
	
	  XMLElement = __webpack_require__(21);
	
	  XMLRaw = __webpack_require__(31);
	
	  XMLText = __webpack_require__(32);
	
	  XMLProcessingInstruction = __webpack_require__(33);
	
	  XMLDTDAttList = __webpack_require__(27);
	
	  XMLDTDElement = __webpack_require__(29);
	
	  XMLDTDEntity = __webpack_require__(28);
	
	  XMLDTDNotation = __webpack_require__(30);
	
	  XMLWriterBase = __webpack_require__(36);
	
	  module.exports = XMLStringWriter = function (superClass) {
	    extend(XMLStringWriter, superClass);
	
	    function XMLStringWriter(options) {
	      XMLStringWriter.__super__.constructor.call(this, options);
	    }
	
	    XMLStringWriter.prototype.document = function (doc) {
	      var child, i, len, r, ref;
	      this.textispresent = false;
	      r = '';
	      ref = doc.children;
	      for (i = 0, len = ref.length; i < len; i++) {
	        child = ref[i];
	        r += function () {
	          switch (false) {
	            case !(child instanceof XMLDeclaration):
	              return this.declaration(child);
	            case !(child instanceof XMLDocType):
	              return this.docType(child);
	            case !(child instanceof XMLComment):
	              return this.comment(child);
	            case !(child instanceof XMLProcessingInstruction):
	              return this.processingInstruction(child);
	            default:
	              return this.element(child, 0);
	          }
	        }.call(this);
	      }
	      if (this.pretty && r.slice(-this.newline.length) === this.newline) {
	        r = r.slice(0, -this.newline.length);
	      }
	      return r;
	    };
	
	    XMLStringWriter.prototype.attribute = function (att) {
	      return ' ' + att.name + '="' + att.value + '"';
	    };
	
	    XMLStringWriter.prototype.cdata = function (node, level) {
	      return this.space(level) + '<![CDATA[' + node.text + ']]>' + this.newline;
	    };
	
	    XMLStringWriter.prototype.comment = function (node, level) {
	      return this.space(level) + '<!-- ' + node.text + ' -->' + this.newline;
	    };
	
	    XMLStringWriter.prototype.declaration = function (node, level) {
	      var r;
	      r = this.space(level);
	      r += '<?xml version="' + node.version + '"';
	      if (node.encoding != null) {
	        r += ' encoding="' + node.encoding + '"';
	      }
	      if (node.standalone != null) {
	        r += ' standalone="' + node.standalone + '"';
	      }
	      r += this.spacebeforeslash + '?>';
	      r += this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.docType = function (node, level) {
	      var child, i, len, r, ref;
	      level || (level = 0);
	      r = this.space(level);
	      r += '<!DOCTYPE ' + node.root().name;
	      if (node.pubID && node.sysID) {
	        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
	      } else if (node.sysID) {
	        r += ' SYSTEM "' + node.sysID + '"';
	      }
	      if (node.children.length > 0) {
	        r += ' [';
	        r += this.newline;
	        ref = node.children;
	        for (i = 0, len = ref.length; i < len; i++) {
	          child = ref[i];
	          r += function () {
	            switch (false) {
	              case !(child instanceof XMLDTDAttList):
	                return this.dtdAttList(child, level + 1);
	              case !(child instanceof XMLDTDElement):
	                return this.dtdElement(child, level + 1);
	              case !(child instanceof XMLDTDEntity):
	                return this.dtdEntity(child, level + 1);
	              case !(child instanceof XMLDTDNotation):
	                return this.dtdNotation(child, level + 1);
	              case !(child instanceof XMLCData):
	                return this.cdata(child, level + 1);
	              case !(child instanceof XMLComment):
	                return this.comment(child, level + 1);
	              case !(child instanceof XMLProcessingInstruction):
	                return this.processingInstruction(child, level + 1);
	              default:
	                throw new Error("Unknown DTD node type: " + child.constructor.name);
	            }
	          }.call(this);
	        }
	        r += ']';
	      }
	      r += this.spacebeforeslash + '>';
	      r += this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.element = function (node, level) {
	      var att, child, i, j, len, len1, name, r, ref, ref1, ref2, space, textispresentwasset;
	      level || (level = 0);
	      textispresentwasset = false;
	      if (this.textispresent) {
	        this.newline = '';
	        this.pretty = false;
	      } else {
	        this.newline = this.newlinedefault;
	        this.pretty = this.prettydefault;
	      }
	      space = this.space(level);
	      r = '';
	      r += space + '<' + node.name;
	      ref = node.attributes;
	      for (name in ref) {
	        if (!hasProp.call(ref, name)) continue;
	        att = ref[name];
	        r += this.attribute(att);
	      }
	      if (node.children.length === 0 || node.children.every(function (e) {
	        return e.value === '';
	      })) {
	        if (this.allowEmpty) {
	          r += '></' + node.name + '>' + this.newline;
	        } else {
	          r += this.spacebeforeslash + '/>' + this.newline;
	        }
	      } else if (this.pretty && node.children.length === 1 && node.children[0].value != null) {
	        r += '>';
	        r += node.children[0].value;
	        r += '</' + node.name + '>' + this.newline;
	      } else {
	        if (this.dontprettytextnodes) {
	          ref1 = node.children;
	          for (i = 0, len = ref1.length; i < len; i++) {
	            child = ref1[i];
	            if (child.value != null) {
	              this.textispresent++;
	              textispresentwasset = true;
	              break;
	            }
	          }
	        }
	        if (this.textispresent) {
	          this.newline = '';
	          this.pretty = false;
	          space = this.space(level);
	        }
	        r += '>' + this.newline;
	        ref2 = node.children;
	        for (j = 0, len1 = ref2.length; j < len1; j++) {
	          child = ref2[j];
	          r += function () {
	            switch (false) {
	              case !(child instanceof XMLCData):
	                return this.cdata(child, level + 1);
	              case !(child instanceof XMLComment):
	                return this.comment(child, level + 1);
	              case !(child instanceof XMLElement):
	                return this.element(child, level + 1);
	              case !(child instanceof XMLRaw):
	                return this.raw(child, level + 1);
	              case !(child instanceof XMLText):
	                return this.text(child, level + 1);
	              case !(child instanceof XMLProcessingInstruction):
	                return this.processingInstruction(child, level + 1);
	              default:
	                throw new Error("Unknown XML node type: " + child.constructor.name);
	            }
	          }.call(this);
	        }
	        if (textispresentwasset) {
	          this.textispresent--;
	        }
	        if (!this.textispresent) {
	          this.newline = this.newlinedefault;
	          this.pretty = this.prettydefault;
	        }
	        r += space + '</' + node.name + '>' + this.newline;
	      }
	      return r;
	    };
	
	    XMLStringWriter.prototype.processingInstruction = function (node, level) {
	      var r;
	      r = this.space(level) + '<?' + node.target;
	      if (node.value) {
	        r += ' ' + node.value;
	      }
	      r += this.spacebeforeslash + '?>' + this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.raw = function (node, level) {
	      return this.space(level) + node.value + this.newline;
	    };
	
	    XMLStringWriter.prototype.text = function (node, level) {
	      return this.space(level) + node.value + this.newline;
	    };
	
	    XMLStringWriter.prototype.dtdAttList = function (node, level) {
	      var r;
	      r = this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType;
	      if (node.defaultValueType !== '#DEFAULT') {
	        r += ' ' + node.defaultValueType;
	      }
	      if (node.defaultValue) {
	        r += ' "' + node.defaultValue + '"';
	      }
	      r += this.spacebeforeslash + '>' + this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.dtdElement = function (node, level) {
	      return this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value + this.spacebeforeslash + '>' + this.newline;
	    };
	
	    XMLStringWriter.prototype.dtdEntity = function (node, level) {
	      var r;
	      r = this.space(level) + '<!ENTITY';
	      if (node.pe) {
	        r += ' %';
	      }
	      r += ' ' + node.name;
	      if (node.value) {
	        r += ' "' + node.value + '"';
	      } else {
	        if (node.pubID && node.sysID) {
	          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
	        } else if (node.sysID) {
	          r += ' SYSTEM "' + node.sysID + '"';
	        }
	        if (node.nData) {
	          r += ' NDATA ' + node.nData;
	        }
	      }
	      r += this.spacebeforeslash + '>' + this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.dtdNotation = function (node, level) {
	      var r;
	      r = this.space(level) + '<!NOTATION ' + node.name;
	      if (node.pubID && node.sysID) {
	        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
	      } else if (node.pubID) {
	        r += ' PUBLIC "' + node.pubID + '"';
	      } else if (node.sysID) {
	        r += ' SYSTEM "' + node.sysID + '"';
	      }
	      r += this.spacebeforeslash + '>' + this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.openNode = function (node, level) {
	      var att, name, r, ref;
	      level || (level = 0);
	      if (node instanceof XMLElement) {
	        r = this.space(level) + '<' + node.name;
	        ref = node.attributes;
	        for (name in ref) {
	          if (!hasProp.call(ref, name)) continue;
	          att = ref[name];
	          r += this.attribute(att);
	        }
	        r += (node.children ? '>' : '/>') + this.newline;
	        return r;
	      } else {
	        r = this.space(level) + '<!DOCTYPE ' + node.rootNodeName;
	        if (node.pubID && node.sysID) {
	          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
	        } else if (node.sysID) {
	          r += ' SYSTEM "' + node.sysID + '"';
	        }
	        r += (node.children ? ' [' : '>') + this.newline;
	        return r;
	      }
	    };
	
	    XMLStringWriter.prototype.closeNode = function (node, level) {
	      level || (level = 0);
	      switch (false) {
	        case !(node instanceof XMLElement):
	          return this.space(level) + '</' + node.name + '>' + this.newline;
	        case !(node instanceof XMLDocType):
	          return this.space(level) + ']>' + this.newline;
	      }
	    };
	
	    return XMLStringWriter;
	  }(XMLWriterBase);
	}).call(undefined);

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLWriterBase,
	      hasProp = {}.hasOwnProperty;
	
	  module.exports = XMLWriterBase = function () {
	    function XMLWriterBase(options) {
	      var key, ref, ref1, ref2, ref3, ref4, ref5, ref6, value;
	      options || (options = {});
	      this.pretty = options.pretty || false;
	      this.allowEmpty = (ref = options.allowEmpty) != null ? ref : false;
	      if (this.pretty) {
	        this.indent = (ref1 = options.indent) != null ? ref1 : '  ';
	        this.newline = (ref2 = options.newline) != null ? ref2 : '\n';
	        this.offset = (ref3 = options.offset) != null ? ref3 : 0;
	        this.dontprettytextnodes = (ref4 = options.dontprettytextnodes) != null ? ref4 : 0;
	      } else {
	        this.indent = '';
	        this.newline = '';
	        this.offset = 0;
	        this.dontprettytextnodes = 0;
	      }
	      this.spacebeforeslash = (ref5 = options.spacebeforeslash) != null ? ref5 : '';
	      if (this.spacebeforeslash === true) {
	        this.spacebeforeslash = ' ';
	      }
	      this.newlinedefault = this.newline;
	      this.prettydefault = this.pretty;
	      ref6 = options.writer || {};
	      for (key in ref6) {
	        if (!hasProp.call(ref6, key)) continue;
	        value = ref6[key];
	        this[key] = value;
	      }
	    }
	
	    XMLWriterBase.prototype.set = function (options) {
	      var key, ref, value;
	      options || (options = {});
	      if ("pretty" in options) {
	        this.pretty = options.pretty;
	      }
	      if ("allowEmpty" in options) {
	        this.allowEmpty = options.allowEmpty;
	      }
	      if (this.pretty) {
	        this.indent = "indent" in options ? options.indent : '  ';
	        this.newline = "newline" in options ? options.newline : '\n';
	        this.offset = "offset" in options ? options.offset : 0;
	        this.dontprettytextnodes = "dontprettytextnodes" in options ? options.dontprettytextnodes : 0;
	      } else {
	        this.indent = '';
	        this.newline = '';
	        this.offset = 0;
	        this.dontprettytextnodes = 0;
	      }
	      this.spacebeforeslash = "spacebeforeslash" in options ? options.spacebeforeslash : '';
	      if (this.spacebeforeslash === true) {
	        this.spacebeforeslash = ' ';
	      }
	      this.newlinedefault = this.newline;
	      this.prettydefault = this.pretty;
	      ref = options.writer || {};
	      for (key in ref) {
	        if (!hasProp.call(ref, key)) continue;
	        value = ref[key];
	        this[key] = value;
	      }
	      return this;
	    };
	
	    XMLWriterBase.prototype.space = function (level) {
	      var indent;
	      if (this.pretty) {
	        indent = (level || 0) + this.offset + 1;
	        if (indent > 0) {
	          return new Array(indent).join(this.indent);
	        } else {
	          return '';
	        }
	      } else {
	        return '';
	      }
	    };
	
	    return XMLWriterBase;
	  }();
	}).call(undefined);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLAttribute,
	      XMLCData,
	      XMLComment,
	      XMLDTDAttList,
	      XMLDTDElement,
	      XMLDTDEntity,
	      XMLDTDNotation,
	      XMLDeclaration,
	      XMLDocType,
	      XMLDocumentCB,
	      XMLElement,
	      XMLProcessingInstruction,
	      XMLRaw,
	      XMLStringWriter,
	      XMLStringifier,
	      XMLText,
	      isFunction,
	      isObject,
	      isPlainObject,
	      ref,
	      hasProp = {}.hasOwnProperty;
	
	  ref = __webpack_require__(18), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject;
	
	  XMLElement = __webpack_require__(21);
	
	  XMLCData = __webpack_require__(23);
	
	  XMLComment = __webpack_require__(24);
	
	  XMLRaw = __webpack_require__(31);
	
	  XMLText = __webpack_require__(32);
	
	  XMLProcessingInstruction = __webpack_require__(33);
	
	  XMLDeclaration = __webpack_require__(25);
	
	  XMLDocType = __webpack_require__(26);
	
	  XMLDTDAttList = __webpack_require__(27);
	
	  XMLDTDEntity = __webpack_require__(28);
	
	  XMLDTDElement = __webpack_require__(29);
	
	  XMLDTDNotation = __webpack_require__(30);
	
	  XMLAttribute = __webpack_require__(22);
	
	  XMLStringifier = __webpack_require__(34);
	
	  XMLStringWriter = __webpack_require__(35);
	
	  module.exports = XMLDocumentCB = function () {
	    function XMLDocumentCB(options, onData, onEnd) {
	      var writerOptions;
	      options || (options = {});
	      if (!options.writer) {
	        options.writer = new XMLStringWriter(options);
	      } else if (isPlainObject(options.writer)) {
	        writerOptions = options.writer;
	        options.writer = new XMLStringWriter(writerOptions);
	      }
	      this.options = options;
	      this.writer = options.writer;
	      this.stringify = new XMLStringifier(options);
	      this.onDataCallback = onData || function () {};
	      this.onEndCallback = onEnd || function () {};
	      this.currentNode = null;
	      this.currentLevel = -1;
	      this.openTags = {};
	      this.documentStarted = false;
	      this.documentCompleted = false;
	      this.root = null;
	    }
	
	    XMLDocumentCB.prototype.node = function (name, attributes, text) {
	      var ref1;
	      if (name == null) {
	        throw new Error("Missing node name");
	      }
	      if (this.root && this.currentLevel === -1) {
	        throw new Error("Document can only have one root node");
	      }
	      this.openCurrent();
	      name = name.valueOf();
	      if (attributes == null) {
	        attributes = {};
	      }
	      attributes = attributes.valueOf();
	      if (!isObject(attributes)) {
	        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
	      }
	      this.currentNode = new XMLElement(this, name, attributes);
	      this.currentNode.children = false;
	      this.currentLevel++;
	      this.openTags[this.currentLevel] = this.currentNode;
	      if (text != null) {
	        this.text(text);
	      }
	      return this;
	    };
	
	    XMLDocumentCB.prototype.element = function (name, attributes, text) {
	      if (this.currentNode && this.currentNode instanceof XMLDocType) {
	        return this.dtdElement.apply(this, arguments);
	      } else {
	        return this.node(name, attributes, text);
	      }
	    };
	
	    XMLDocumentCB.prototype.attribute = function (name, value) {
	      var attName, attValue;
	      if (!this.currentNode || this.currentNode.children) {
	        throw new Error("att() can only be used immediately after an ele() call in callback mode");
	      }
	      if (name != null) {
	        name = name.valueOf();
	      }
	      if (isObject(name)) {
	        for (attName in name) {
	          if (!hasProp.call(name, attName)) continue;
	          attValue = name[attName];
	          this.attribute(attName, attValue);
	        }
	      } else {
	        if (isFunction(value)) {
	          value = value.apply();
	        }
	        if (!this.options.skipNullAttributes || value != null) {
	          this.currentNode.attributes[name] = new XMLAttribute(this, name, value);
	        }
	      }
	      return this;
	    };
	
	    XMLDocumentCB.prototype.text = function (value) {
	      var node;
	      this.openCurrent();
	      node = new XMLText(this, value);
	      this.onData(this.writer.text(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.cdata = function (value) {
	      var node;
	      this.openCurrent();
	      node = new XMLCData(this, value);
	      this.onData(this.writer.cdata(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.comment = function (value) {
	      var node;
	      this.openCurrent();
	      node = new XMLComment(this, value);
	      this.onData(this.writer.comment(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.raw = function (value) {
	      var node;
	      this.openCurrent();
	      node = new XMLRaw(this, value);
	      this.onData(this.writer.raw(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.instruction = function (target, value) {
	      var i, insTarget, insValue, len, node;
	      this.openCurrent();
	      if (target != null) {
	        target = target.valueOf();
	      }
	      if (value != null) {
	        value = value.valueOf();
	      }
	      if (Array.isArray(target)) {
	        for (i = 0, len = target.length; i < len; i++) {
	          insTarget = target[i];
	          this.instruction(insTarget);
	        }
	      } else if (isObject(target)) {
	        for (insTarget in target) {
	          if (!hasProp.call(target, insTarget)) continue;
	          insValue = target[insTarget];
	          this.instruction(insTarget, insValue);
	        }
	      } else {
	        if (isFunction(value)) {
	          value = value.apply();
	        }
	        node = new XMLProcessingInstruction(this, target, value);
	        this.onData(this.writer.processingInstruction(node, this.currentLevel + 1));
	      }
	      return this;
	    };
	
	    XMLDocumentCB.prototype.declaration = function (version, encoding, standalone) {
	      var node;
	      this.openCurrent();
	      if (this.documentStarted) {
	        throw new Error("declaration() must be the first node");
	      }
	      node = new XMLDeclaration(this, version, encoding, standalone);
	      this.onData(this.writer.declaration(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.doctype = function (root, pubID, sysID) {
	      this.openCurrent();
	      if (root == null) {
	        throw new Error("Missing root node name");
	      }
	      if (this.root) {
	        throw new Error("dtd() must come before the root node");
	      }
	      this.currentNode = new XMLDocType(this, pubID, sysID);
	      this.currentNode.rootNodeName = root;
	      this.currentNode.children = false;
	      this.currentLevel++;
	      this.openTags[this.currentLevel] = this.currentNode;
	      return this;
	    };
	
	    XMLDocumentCB.prototype.dtdElement = function (name, value) {
	      var node;
	      this.openCurrent();
	      node = new XMLDTDElement(this, name, value);
	      this.onData(this.writer.dtdElement(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.attList = function (elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      var node;
	      this.openCurrent();
	      node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
	      this.onData(this.writer.dtdAttList(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.entity = function (name, value) {
	      var node;
	      this.openCurrent();
	      node = new XMLDTDEntity(this, false, name, value);
	      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.pEntity = function (name, value) {
	      var node;
	      this.openCurrent();
	      node = new XMLDTDEntity(this, true, name, value);
	      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.notation = function (name, value) {
	      var node;
	      this.openCurrent();
	      node = new XMLDTDNotation(this, name, value);
	      this.onData(this.writer.dtdNotation(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.up = function () {
	      if (this.currentLevel < 0) {
	        throw new Error("The document node has no parent");
	      }
	      if (this.currentNode) {
	        if (this.currentNode.children) {
	          this.closeNode(this.currentNode);
	        } else {
	          this.openNode(this.currentNode);
	        }
	        this.currentNode = null;
	      } else {
	        this.closeNode(this.openTags[this.currentLevel]);
	      }
	      delete this.openTags[this.currentLevel];
	      this.currentLevel--;
	      return this;
	    };
	
	    XMLDocumentCB.prototype.end = function () {
	      while (this.currentLevel >= 0) {
	        this.up();
	      }
	      return this.onEnd();
	    };
	
	    XMLDocumentCB.prototype.openCurrent = function () {
	      if (this.currentNode) {
	        this.currentNode.children = true;
	        return this.openNode(this.currentNode);
	      }
	    };
	
	    XMLDocumentCB.prototype.openNode = function (node) {
	      if (!node.isOpen) {
	        if (!this.root && this.currentLevel === 0 && node instanceof XMLElement) {
	          this.root = node;
	        }
	        this.onData(this.writer.openNode(node, this.currentLevel));
	        return node.isOpen = true;
	      }
	    };
	
	    XMLDocumentCB.prototype.closeNode = function (node) {
	      if (!node.isClosed) {
	        this.onData(this.writer.closeNode(node, this.currentLevel));
	        return node.isClosed = true;
	      }
	    };
	
	    XMLDocumentCB.prototype.onData = function (chunk) {
	      this.documentStarted = true;
	      return this.onDataCallback(chunk);
	    };
	
	    XMLDocumentCB.prototype.onEnd = function () {
	      this.documentCompleted = true;
	      return this.onEndCallback();
	    };
	
	    XMLDocumentCB.prototype.ele = function () {
	      return this.element.apply(this, arguments);
	    };
	
	    XMLDocumentCB.prototype.nod = function (name, attributes, text) {
	      return this.node(name, attributes, text);
	    };
	
	    XMLDocumentCB.prototype.txt = function (value) {
	      return this.text(value);
	    };
	
	    XMLDocumentCB.prototype.dat = function (value) {
	      return this.cdata(value);
	    };
	
	    XMLDocumentCB.prototype.com = function (value) {
	      return this.comment(value);
	    };
	
	    XMLDocumentCB.prototype.ins = function (target, value) {
	      return this.instruction(target, value);
	    };
	
	    XMLDocumentCB.prototype.dec = function (version, encoding, standalone) {
	      return this.declaration(version, encoding, standalone);
	    };
	
	    XMLDocumentCB.prototype.dtd = function (root, pubID, sysID) {
	      return this.doctype(root, pubID, sysID);
	    };
	
	    XMLDocumentCB.prototype.e = function (name, attributes, text) {
	      return this.element(name, attributes, text);
	    };
	
	    XMLDocumentCB.prototype.n = function (name, attributes, text) {
	      return this.node(name, attributes, text);
	    };
	
	    XMLDocumentCB.prototype.t = function (value) {
	      return this.text(value);
	    };
	
	    XMLDocumentCB.prototype.d = function (value) {
	      return this.cdata(value);
	    };
	
	    XMLDocumentCB.prototype.c = function (value) {
	      return this.comment(value);
	    };
	
	    XMLDocumentCB.prototype.r = function (value) {
	      return this.raw(value);
	    };
	
	    XMLDocumentCB.prototype.i = function (target, value) {
	      return this.instruction(target, value);
	    };
	
	    XMLDocumentCB.prototype.att = function () {
	      if (this.currentNode && this.currentNode instanceof XMLDocType) {
	        return this.attList.apply(this, arguments);
	      } else {
	        return this.attribute.apply(this, arguments);
	      }
	    };
	
	    XMLDocumentCB.prototype.a = function () {
	      if (this.currentNode && this.currentNode instanceof XMLDocType) {
	        return this.attList.apply(this, arguments);
	      } else {
	        return this.attribute.apply(this, arguments);
	      }
	    };
	
	    XMLDocumentCB.prototype.ent = function (name, value) {
	      return this.entity(name, value);
	    };
	
	    XMLDocumentCB.prototype.pent = function (name, value) {
	      return this.pEntity(name, value);
	    };
	
	    XMLDocumentCB.prototype.not = function (name, value) {
	      return this.notation(name, value);
	    };
	
	    return XMLDocumentCB;
	  }();
	}).call(undefined);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.6
	(function () {
	  var XMLCData,
	      XMLComment,
	      XMLDTDAttList,
	      XMLDTDElement,
	      XMLDTDEntity,
	      XMLDTDNotation,
	      XMLDeclaration,
	      XMLDocType,
	      XMLElement,
	      XMLProcessingInstruction,
	      XMLRaw,
	      XMLStreamWriter,
	      XMLText,
	      XMLWriterBase,
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  XMLDeclaration = __webpack_require__(25);
	
	  XMLDocType = __webpack_require__(26);
	
	  XMLCData = __webpack_require__(23);
	
	  XMLComment = __webpack_require__(24);
	
	  XMLElement = __webpack_require__(21);
	
	  XMLRaw = __webpack_require__(31);
	
	  XMLText = __webpack_require__(32);
	
	  XMLProcessingInstruction = __webpack_require__(33);
	
	  XMLDTDAttList = __webpack_require__(27);
	
	  XMLDTDElement = __webpack_require__(29);
	
	  XMLDTDEntity = __webpack_require__(28);
	
	  XMLDTDNotation = __webpack_require__(30);
	
	  XMLWriterBase = __webpack_require__(36);
	
	  module.exports = XMLStreamWriter = function (superClass) {
	    extend(XMLStreamWriter, superClass);
	
	    function XMLStreamWriter(stream, options) {
	      this.stream = stream;
	      XMLStreamWriter.__super__.constructor.call(this, options);
	    }
	
	    XMLStreamWriter.prototype.document = function (doc) {
	      var child, i, j, len, len1, ref, ref1, results;
	      ref = doc.children;
	      for (i = 0, len = ref.length; i < len; i++) {
	        child = ref[i];
	        child.isLastRootNode = false;
	      }
	      doc.children[doc.children.length - 1].isLastRootNode = true;
	      ref1 = doc.children;
	      results = [];
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        child = ref1[j];
	        switch (false) {
	          case !(child instanceof XMLDeclaration):
	            results.push(this.declaration(child));
	            break;
	          case !(child instanceof XMLDocType):
	            results.push(this.docType(child));
	            break;
	          case !(child instanceof XMLComment):
	            results.push(this.comment(child));
	            break;
	          case !(child instanceof XMLProcessingInstruction):
	            results.push(this.processingInstruction(child));
	            break;
	          default:
	            results.push(this.element(child));
	        }
	      }
	      return results;
	    };
	
	    XMLStreamWriter.prototype.attribute = function (att) {
	      return this.stream.write(' ' + att.name + '="' + att.value + '"');
	    };
	
	    XMLStreamWriter.prototype.cdata = function (node, level) {
	      return this.stream.write(this.space(level) + '<![CDATA[' + node.text + ']]>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.comment = function (node, level) {
	      return this.stream.write(this.space(level) + '<!-- ' + node.text + ' -->' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.declaration = function (node, level) {
	      this.stream.write(this.space(level));
	      this.stream.write('<?xml version="' + node.version + '"');
	      if (node.encoding != null) {
	        this.stream.write(' encoding="' + node.encoding + '"');
	      }
	      if (node.standalone != null) {
	        this.stream.write(' standalone="' + node.standalone + '"');
	      }
	      this.stream.write(this.spacebeforeslash + '?>');
	      return this.stream.write(this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.docType = function (node, level) {
	      var child, i, len, ref;
	      level || (level = 0);
	      this.stream.write(this.space(level));
	      this.stream.write('<!DOCTYPE ' + node.root().name);
	      if (node.pubID && node.sysID) {
	        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
	      } else if (node.sysID) {
	        this.stream.write(' SYSTEM "' + node.sysID + '"');
	      }
	      if (node.children.length > 0) {
	        this.stream.write(' [');
	        this.stream.write(this.endline(node));
	        ref = node.children;
	        for (i = 0, len = ref.length; i < len; i++) {
	          child = ref[i];
	          switch (false) {
	            case !(child instanceof XMLDTDAttList):
	              this.dtdAttList(child, level + 1);
	              break;
	            case !(child instanceof XMLDTDElement):
	              this.dtdElement(child, level + 1);
	              break;
	            case !(child instanceof XMLDTDEntity):
	              this.dtdEntity(child, level + 1);
	              break;
	            case !(child instanceof XMLDTDNotation):
	              this.dtdNotation(child, level + 1);
	              break;
	            case !(child instanceof XMLCData):
	              this.cdata(child, level + 1);
	              break;
	            case !(child instanceof XMLComment):
	              this.comment(child, level + 1);
	              break;
	            case !(child instanceof XMLProcessingInstruction):
	              this.processingInstruction(child, level + 1);
	              break;
	            default:
	              throw new Error("Unknown DTD node type: " + child.constructor.name);
	          }
	        }
	        this.stream.write(']');
	      }
	      this.stream.write(this.spacebeforeslash + '>');
	      return this.stream.write(this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.element = function (node, level) {
	      var att, child, i, len, name, ref, ref1, space;
	      level || (level = 0);
	      space = this.space(level);
	      this.stream.write(space + '<' + node.name);
	      ref = node.attributes;
	      for (name in ref) {
	        if (!hasProp.call(ref, name)) continue;
	        att = ref[name];
	        this.attribute(att);
	      }
	      if (node.children.length === 0 || node.children.every(function (e) {
	        return e.value === '';
	      })) {
	        if (this.allowEmpty) {
	          this.stream.write('></' + node.name + '>');
	        } else {
	          this.stream.write(this.spacebeforeslash + '/>');
	        }
	      } else if (this.pretty && node.children.length === 1 && node.children[0].value != null) {
	        this.stream.write('>');
	        this.stream.write(node.children[0].value);
	        this.stream.write('</' + node.name + '>');
	      } else {
	        this.stream.write('>' + this.newline);
	        ref1 = node.children;
	        for (i = 0, len = ref1.length; i < len; i++) {
	          child = ref1[i];
	          switch (false) {
	            case !(child instanceof XMLCData):
	              this.cdata(child, level + 1);
	              break;
	            case !(child instanceof XMLComment):
	              this.comment(child, level + 1);
	              break;
	            case !(child instanceof XMLElement):
	              this.element(child, level + 1);
	              break;
	            case !(child instanceof XMLRaw):
	              this.raw(child, level + 1);
	              break;
	            case !(child instanceof XMLText):
	              this.text(child, level + 1);
	              break;
	            case !(child instanceof XMLProcessingInstruction):
	              this.processingInstruction(child, level + 1);
	              break;
	            default:
	              throw new Error("Unknown XML node type: " + child.constructor.name);
	          }
	        }
	        this.stream.write(space + '</' + node.name + '>');
	      }
	      return this.stream.write(this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.processingInstruction = function (node, level) {
	      this.stream.write(this.space(level) + '<?' + node.target);
	      if (node.value) {
	        this.stream.write(' ' + node.value);
	      }
	      return this.stream.write(this.spacebeforeslash + '?>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.raw = function (node, level) {
	      return this.stream.write(this.space(level) + node.value + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.text = function (node, level) {
	      return this.stream.write(this.space(level) + node.value + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.dtdAttList = function (node, level) {
	      this.stream.write(this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType);
	      if (node.defaultValueType !== '#DEFAULT') {
	        this.stream.write(' ' + node.defaultValueType);
	      }
	      if (node.defaultValue) {
	        this.stream.write(' "' + node.defaultValue + '"');
	      }
	      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.dtdElement = function (node, level) {
	      this.stream.write(this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value);
	      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.dtdEntity = function (node, level) {
	      this.stream.write(this.space(level) + '<!ENTITY');
	      if (node.pe) {
	        this.stream.write(' %');
	      }
	      this.stream.write(' ' + node.name);
	      if (node.value) {
	        this.stream.write(' "' + node.value + '"');
	      } else {
	        if (node.pubID && node.sysID) {
	          this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
	        } else if (node.sysID) {
	          this.stream.write(' SYSTEM "' + node.sysID + '"');
	        }
	        if (node.nData) {
	          this.stream.write(' NDATA ' + node.nData);
	        }
	      }
	      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.dtdNotation = function (node, level) {
	      this.stream.write(this.space(level) + '<!NOTATION ' + node.name);
	      if (node.pubID && node.sysID) {
	        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
	      } else if (node.pubID) {
	        this.stream.write(' PUBLIC "' + node.pubID + '"');
	      } else if (node.sysID) {
	        this.stream.write(' SYSTEM "' + node.sysID + '"');
	      }
	      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.endline = function (node) {
	      if (!node.isLastRootNode) {
	        return this.newline;
	      } else {
	        return '';
	      }
	    };
	
	    return XMLStreamWriter;
	  }(XMLWriterBase);
	}).call(undefined);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Generated by CoffeeScript 1.12.7
	(function () {
	  "use strict";
	
	  var bom,
	      defaults,
	      events,
	      isEmpty,
	      processItem,
	      processors,
	      sax,
	      setImmediate,
	      bind = function bind(fn, me) {
	    return function () {
	      return fn.apply(me, arguments);
	    };
	  },
	      extend = function extend(child, parent) {
	    for (var key in parent) {
	      if (hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  },
	      hasProp = {}.hasOwnProperty;
	
	  sax = __webpack_require__(40);
	
	  events = __webpack_require__(46);
	
	  bom = __webpack_require__(66);
	
	  processors = __webpack_require__(67);
	
	  setImmediate = __webpack_require__(56).setImmediate;
	
	  defaults = __webpack_require__(15).defaults;
	
	  isEmpty = function isEmpty(thing) {
	    return (typeof thing === 'undefined' ? 'undefined' : _typeof(thing)) === "object" && thing != null && Object.keys(thing).length === 0;
	  };
	
	  processItem = function processItem(processors, item, key) {
	    var i, len, process;
	    for (i = 0, len = processors.length; i < len; i++) {
	      process = processors[i];
	      item = process(item, key);
	    }
	    return item;
	  };
	
	  exports.Parser = function (superClass) {
	    extend(Parser, superClass);
	
	    function Parser(opts) {
	      this.parseString = bind(this.parseString, this);
	      this.reset = bind(this.reset, this);
	      this.assignOrPush = bind(this.assignOrPush, this);
	      this.processAsync = bind(this.processAsync, this);
	      var key, ref, value;
	      if (!(this instanceof exports.Parser)) {
	        return new exports.Parser(opts);
	      }
	      this.options = {};
	      ref = defaults["0.2"];
	      for (key in ref) {
	        if (!hasProp.call(ref, key)) continue;
	        value = ref[key];
	        this.options[key] = value;
	      }
	      for (key in opts) {
	        if (!hasProp.call(opts, key)) continue;
	        value = opts[key];
	        this.options[key] = value;
	      }
	      if (this.options.xmlns) {
	        this.options.xmlnskey = this.options.attrkey + "ns";
	      }
	      if (this.options.normalizeTags) {
	        if (!this.options.tagNameProcessors) {
	          this.options.tagNameProcessors = [];
	        }
	        this.options.tagNameProcessors.unshift(processors.normalize);
	      }
	      this.reset();
	    }
	
	    Parser.prototype.processAsync = function () {
	      var chunk, err;
	      try {
	        if (this.remaining.length <= this.options.chunkSize) {
	          chunk = this.remaining;
	          this.remaining = '';
	          this.saxParser = this.saxParser.write(chunk);
	          return this.saxParser.close();
	        } else {
	          chunk = this.remaining.substr(0, this.options.chunkSize);
	          this.remaining = this.remaining.substr(this.options.chunkSize, this.remaining.length);
	          this.saxParser = this.saxParser.write(chunk);
	          return setImmediate(this.processAsync);
	        }
	      } catch (error1) {
	        err = error1;
	        if (!this.saxParser.errThrown) {
	          this.saxParser.errThrown = true;
	          return this.emit(err);
	        }
	      }
	    };
	
	    Parser.prototype.assignOrPush = function (obj, key, newValue) {
	      if (!(key in obj)) {
	        if (!this.options.explicitArray) {
	          return obj[key] = newValue;
	        } else {
	          return obj[key] = [newValue];
	        }
	      } else {
	        if (!(obj[key] instanceof Array)) {
	          obj[key] = [obj[key]];
	        }
	        return obj[key].push(newValue);
	      }
	    };
	
	    Parser.prototype.reset = function () {
	      var attrkey, charkey, ontext, stack;
	      this.removeAllListeners();
	      this.saxParser = sax.parser(this.options.strict, {
	        trim: false,
	        normalize: false,
	        xmlns: this.options.xmlns
	      });
	      this.saxParser.errThrown = false;
	      this.saxParser.onerror = function (_this) {
	        return function (error) {
	          _this.saxParser.resume();
	          if (!_this.saxParser.errThrown) {
	            _this.saxParser.errThrown = true;
	            return _this.emit("error", error);
	          }
	        };
	      }(this);
	      this.saxParser.onend = function (_this) {
	        return function () {
	          if (!_this.saxParser.ended) {
	            _this.saxParser.ended = true;
	            return _this.emit("end", _this.resultObject);
	          }
	        };
	      }(this);
	      this.saxParser.ended = false;
	      this.EXPLICIT_CHARKEY = this.options.explicitCharkey;
	      this.resultObject = null;
	      stack = [];
	      attrkey = this.options.attrkey;
	      charkey = this.options.charkey;
	      this.saxParser.onopentag = function (_this) {
	        return function (node) {
	          var key, newValue, obj, processedKey, ref;
	          obj = {};
	          obj[charkey] = "";
	          if (!_this.options.ignoreAttrs) {
	            ref = node.attributes;
	            for (key in ref) {
	              if (!hasProp.call(ref, key)) continue;
	              if (!(attrkey in obj) && !_this.options.mergeAttrs) {
	                obj[attrkey] = {};
	              }
	              newValue = _this.options.attrValueProcessors ? processItem(_this.options.attrValueProcessors, node.attributes[key], key) : node.attributes[key];
	              processedKey = _this.options.attrNameProcessors ? processItem(_this.options.attrNameProcessors, key) : key;
	              if (_this.options.mergeAttrs) {
	                _this.assignOrPush(obj, processedKey, newValue);
	              } else {
	                obj[attrkey][processedKey] = newValue;
	              }
	            }
	          }
	          obj["#name"] = _this.options.tagNameProcessors ? processItem(_this.options.tagNameProcessors, node.name) : node.name;
	          if (_this.options.xmlns) {
	            obj[_this.options.xmlnskey] = {
	              uri: node.uri,
	              local: node.local
	            };
	          }
	          return stack.push(obj);
	        };
	      }(this);
	      this.saxParser.onclosetag = function (_this) {
	        return function () {
	          var cdata, emptyStr, key, node, nodeName, obj, objClone, old, s, xpath;
	          obj = stack.pop();
	          nodeName = obj["#name"];
	          if (!_this.options.explicitChildren || !_this.options.preserveChildrenOrder) {
	            delete obj["#name"];
	          }
	          if (obj.cdata === true) {
	            cdata = obj.cdata;
	            delete obj.cdata;
	          }
	          s = stack[stack.length - 1];
	          if (obj[charkey].match(/^\s*$/) && !cdata) {
	            emptyStr = obj[charkey];
	            delete obj[charkey];
	          } else {
	            if (_this.options.trim) {
	              obj[charkey] = obj[charkey].trim();
	            }
	            if (_this.options.normalize) {
	              obj[charkey] = obj[charkey].replace(/\s{2,}/g, " ").trim();
	            }
	            obj[charkey] = _this.options.valueProcessors ? processItem(_this.options.valueProcessors, obj[charkey], nodeName) : obj[charkey];
	            if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) {
	              obj = obj[charkey];
	            }
	          }
	          if (isEmpty(obj)) {
	            obj = _this.options.emptyTag !== '' ? _this.options.emptyTag : emptyStr;
	          }
	          if (_this.options.validator != null) {
	            xpath = "/" + function () {
	              var i, len, results;
	              results = [];
	              for (i = 0, len = stack.length; i < len; i++) {
	                node = stack[i];
	                results.push(node["#name"]);
	              }
	              return results;
	            }().concat(nodeName).join("/");
	            (function () {
	              var err;
	              try {
	                return obj = _this.options.validator(xpath, s && s[nodeName], obj);
	              } catch (error1) {
	                err = error1;
	                return _this.emit("error", err);
	              }
	            })();
	          }
	          if (_this.options.explicitChildren && !_this.options.mergeAttrs && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
	            if (!_this.options.preserveChildrenOrder) {
	              node = {};
	              if (_this.options.attrkey in obj) {
	                node[_this.options.attrkey] = obj[_this.options.attrkey];
	                delete obj[_this.options.attrkey];
	              }
	              if (!_this.options.charsAsChildren && _this.options.charkey in obj) {
	                node[_this.options.charkey] = obj[_this.options.charkey];
	                delete obj[_this.options.charkey];
	              }
	              if (Object.getOwnPropertyNames(obj).length > 0) {
	                node[_this.options.childkey] = obj;
	              }
	              obj = node;
	            } else if (s) {
	              s[_this.options.childkey] = s[_this.options.childkey] || [];
	              objClone = {};
	              for (key in obj) {
	                if (!hasProp.call(obj, key)) continue;
	                objClone[key] = obj[key];
	              }
	              s[_this.options.childkey].push(objClone);
	              delete obj["#name"];
	              if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) {
	                obj = obj[charkey];
	              }
	            }
	          }
	          if (stack.length > 0) {
	            return _this.assignOrPush(s, nodeName, obj);
	          } else {
	            if (_this.options.explicitRoot) {
	              old = obj;
	              obj = {};
	              obj[nodeName] = old;
	            }
	            _this.resultObject = obj;
	            _this.saxParser.ended = true;
	            return _this.emit("end", _this.resultObject);
	          }
	        };
	      }(this);
	      ontext = function (_this) {
	        return function (text) {
	          var charChild, s;
	          s = stack[stack.length - 1];
	          if (s) {
	            s[charkey] += text;
	            if (_this.options.explicitChildren && _this.options.preserveChildrenOrder && _this.options.charsAsChildren && (_this.options.includeWhiteChars || text.replace(/\\n/g, '').trim() !== '')) {
	              s[_this.options.childkey] = s[_this.options.childkey] || [];
	              charChild = {
	                '#name': '__text__'
	              };
	              charChild[charkey] = text;
	              if (_this.options.normalize) {
	                charChild[charkey] = charChild[charkey].replace(/\s{2,}/g, " ").trim();
	              }
	              s[_this.options.childkey].push(charChild);
	            }
	            return s;
	          }
	        };
	      }(this);
	      this.saxParser.ontext = ontext;
	      return this.saxParser.oncdata = function (_this) {
	        return function (text) {
	          var s;
	          s = ontext(text);
	          if (s) {
	            return s.cdata = true;
	          }
	        };
	      }(this);
	    };
	
	    Parser.prototype.parseString = function (str, cb) {
	      var err;
	      if (cb != null && typeof cb === "function") {
	        this.on("end", function (result) {
	          this.reset();
	          return cb(null, result);
	        });
	        this.on("error", function (err) {
	          this.reset();
	          return cb(err);
	        });
	      }
	      try {
	        str = str.toString();
	        if (str.trim() === '') {
	          this.emit("end", null);
	          return true;
	        }
	        str = bom.stripBOM(str);
	        if (this.options.async) {
	          this.remaining = str;
	          setImmediate(this.processAsync);
	          return this.saxParser;
	        }
	        return this.saxParser.write(str).close();
	      } catch (error1) {
	        err = error1;
	        if (!(this.saxParser.errThrown || this.saxParser.ended)) {
	          this.emit('error', err);
	          return this.saxParser.errThrown = true;
	        } else if (this.saxParser.ended) {
	          throw err;
	        }
	      }
	    };
	
	    return Parser;
	  }(events.EventEmitter);
	
	  exports.parseString = function (str, a, b) {
	    var cb, options, parser;
	    if (b != null) {
	      if (typeof b === 'function') {
	        cb = b;
	      }
	      if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	        options = a;
	      }
	    } else {
	      if (typeof a === 'function') {
	        cb = a;
	      }
	      options = {};
	    }
	    parser = new exports.Parser(options);
	    return parser.parseString(str, cb);
	  };
	}).call(undefined);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	;(function (sax) {
	  // wrapper for non-node envs
	  sax.parser = function (strict, opt) {
	    return new SAXParser(strict, opt);
	  };
	  sax.SAXParser = SAXParser;
	  sax.SAXStream = SAXStream;
	  sax.createStream = createStream;
	
	  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
	  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
	  // since that's the earliest that a buffer overrun could occur.  This way, checks are
	  // as rare as required, but as often as necessary to ensure never crossing this bound.
	  // Furthermore, buffers are only tested at most once per write(), so passing a very
	  // large string into write() might have undesirable effects, but this is manageable by
	  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
	  // edge case, result in creating at most one complete copy of the string passed in.
	  // Set to Infinity to have unlimited buffers.
	  sax.MAX_BUFFER_LENGTH = 64 * 1024;
	
	  var buffers = ['comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype', 'procInstName', 'procInstBody', 'entity', 'attribName', 'attribValue', 'cdata', 'script'];
	
	  sax.EVENTS = ['text', 'processinginstruction', 'sgmldeclaration', 'doctype', 'comment', 'opentagstart', 'attribute', 'opentag', 'closetag', 'opencdata', 'cdata', 'closecdata', 'error', 'end', 'ready', 'script', 'opennamespace', 'closenamespace'];
	
	  function SAXParser(strict, opt) {
	    if (!(this instanceof SAXParser)) {
	      return new SAXParser(strict, opt);
	    }
	
	    var parser = this;
	    clearBuffers(parser);
	    parser.q = parser.c = '';
	    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
	    parser.opt = opt || {};
	    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
	    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase';
	    parser.tags = [];
	    parser.closed = parser.closedRoot = parser.sawRoot = false;
	    parser.tag = parser.error = null;
	    parser.strict = !!strict;
	    parser.noscript = !!(strict || parser.opt.noscript);
	    parser.state = S.BEGIN;
	    parser.strictEntities = parser.opt.strictEntities;
	    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
	    parser.attribList = [];
	
	    // namespaces form a prototype chain.
	    // it always points at the current tag,
	    // which protos to its parent tag.
	    if (parser.opt.xmlns) {
	      parser.ns = Object.create(rootNS);
	    }
	
	    // mostly just for error reporting
	    parser.trackPosition = parser.opt.position !== false;
	    if (parser.trackPosition) {
	      parser.position = parser.line = parser.column = 0;
	    }
	    emit(parser, 'onready');
	  }
	
	  if (!Object.create) {
	    Object.create = function (o) {
	      function F() {}
	      F.prototype = o;
	      var newf = new F();
	      return newf;
	    };
	  }
	
	  if (!Object.keys) {
	    Object.keys = function (o) {
	      var a = [];
	      for (var i in o) {
	        if (o.hasOwnProperty(i)) a.push(i);
	      }return a;
	    };
	  }
	
	  function checkBufferLength(parser) {
	    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
	    var maxActual = 0;
	    for (var i = 0, l = buffers.length; i < l; i++) {
	      var len = parser[buffers[i]].length;
	      if (len > maxAllowed) {
	        // Text/cdata nodes can get big, and since they're buffered,
	        // we can get here under normal conditions.
	        // Avoid issues by emitting the text node now,
	        // so at least it won't get any bigger.
	        switch (buffers[i]) {
	          case 'textNode':
	            closeText(parser);
	            break;
	
	          case 'cdata':
	            emitNode(parser, 'oncdata', parser.cdata);
	            parser.cdata = '';
	            break;
	
	          case 'script':
	            emitNode(parser, 'onscript', parser.script);
	            parser.script = '';
	            break;
	
	          default:
	            error(parser, 'Max buffer length exceeded: ' + buffers[i]);
	        }
	      }
	      maxActual = Math.max(maxActual, len);
	    }
	    // schedule the next check for the earliest possible buffer overrun.
	    var m = sax.MAX_BUFFER_LENGTH - maxActual;
	    parser.bufferCheckPosition = m + parser.position;
	  }
	
	  function clearBuffers(parser) {
	    for (var i = 0, l = buffers.length; i < l; i++) {
	      parser[buffers[i]] = '';
	    }
	  }
	
	  function flushBuffers(parser) {
	    closeText(parser);
	    if (parser.cdata !== '') {
	      emitNode(parser, 'oncdata', parser.cdata);
	      parser.cdata = '';
	    }
	    if (parser.script !== '') {
	      emitNode(parser, 'onscript', parser.script);
	      parser.script = '';
	    }
	  }
	
	  SAXParser.prototype = {
	    end: function end() {
	      _end(this);
	    },
	    write: write,
	    resume: function resume() {
	      this.error = null;return this;
	    },
	    close: function close() {
	      return this.write(null);
	    },
	    flush: function flush() {
	      flushBuffers(this);
	    }
	  };
	
	  var Stream;
	  try {
	    Stream = __webpack_require__(45).Stream;
	  } catch (ex) {
	    Stream = function Stream() {};
	  }
	
	  var streamWraps = sax.EVENTS.filter(function (ev) {
	    return ev !== 'error' && ev !== 'end';
	  });
	
	  function createStream(strict, opt) {
	    return new SAXStream(strict, opt);
	  }
	
	  function SAXStream(strict, opt) {
	    if (!(this instanceof SAXStream)) {
	      return new SAXStream(strict, opt);
	    }
	
	    Stream.apply(this);
	
	    this._parser = new SAXParser(strict, opt);
	    this.writable = true;
	    this.readable = true;
	
	    var me = this;
	
	    this._parser.onend = function () {
	      me.emit('end');
	    };
	
	    this._parser.onerror = function (er) {
	      me.emit('error', er);
	
	      // if didn't throw, then means error was handled.
	      // go ahead and clear error, so we can write again.
	      me._parser.error = null;
	    };
	
	    this._decoder = null;
	
	    streamWraps.forEach(function (ev) {
	      Object.defineProperty(me, 'on' + ev, {
	        get: function get() {
	          return me._parser['on' + ev];
	        },
	        set: function set(h) {
	          if (!h) {
	            me.removeAllListeners(ev);
	            me._parser['on' + ev] = h;
	            return h;
	          }
	          me.on(ev, h);
	        },
	        enumerable: true,
	        configurable: false
	      });
	    });
	  }
	
	  SAXStream.prototype = Object.create(Stream.prototype, {
	    constructor: {
	      value: SAXStream
	    }
	  });
	
	  SAXStream.prototype.write = function (data) {
	    if (typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function' && Buffer.isBuffer(data)) {
	      if (!this._decoder) {
	        var SD = __webpack_require__(59).StringDecoder;
	        this._decoder = new SD('utf8');
	      }
	      data = this._decoder.write(data);
	    }
	
	    this._parser.write(data.toString());
	    this.emit('data', data);
	    return true;
	  };
	
	  SAXStream.prototype.end = function (chunk) {
	    if (chunk && chunk.length) {
	      this.write(chunk);
	    }
	    this._parser.end();
	    return true;
	  };
	
	  SAXStream.prototype.on = function (ev, handler) {
	    var me = this;
	    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
	      me._parser['on' + ev] = function () {
	        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
	        args.splice(0, 0, ev);
	        me.emit.apply(me, args);
	      };
	    }
	
	    return Stream.prototype.on.call(me, ev, handler);
	  };
	
	  // character classes and tokens
	  var whitespace = '\r\n\t ';
	
	  // this really needs to be replaced with character classes.
	  // XML allows all manner of ridiculous numbers and digits.
	  var number = '0124356789';
	  var letter = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	
	  // (Letter | "_" | ":")
	  var quote = '\'"';
	  var attribEnd = whitespace + '>';
	  var CDATA = '[CDATA[';
	  var DOCTYPE = 'DOCTYPE';
	  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
	  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/';
	  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE
	
	    // turn all the string character sets into character class objects.
	  };whitespace = charClass(whitespace);
	  number = charClass(number);
	  letter = charClass(letter);
	
	  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
	  // This implementation works on strings, a single character at a time
	  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
	  // without a significant breaking change to either this  parser, or the
	  // JavaScript language.  Implementation of an emoji-capable xml parser
	  // is left as an exercise for the reader.
	  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
	
	  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/;
	
	  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
	  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/;
	
	  quote = charClass(quote);
	  attribEnd = charClass(attribEnd);
	
	  function charClass(str) {
	    return str.split('').reduce(function (s, c) {
	      s[c] = true;
	      return s;
	    }, {});
	  }
	
	  function isRegExp(c) {
	    return Object.prototype.toString.call(c) === '[object RegExp]';
	  }
	
	  function is(charclass, c) {
	    return isRegExp(charclass) ? !!c.match(charclass) : charclass[c];
	  }
	
	  function not(charclass, c) {
	    return !is(charclass, c);
	  }
	
	  var S = 0;
	  sax.STATE = {
	    BEGIN: S++, // leading byte order mark or whitespace
	    BEGIN_WHITESPACE: S++, // leading whitespace
	    TEXT: S++, // general stuff
	    TEXT_ENTITY: S++, // &amp and such.
	    OPEN_WAKA: S++, // <
	    SGML_DECL: S++, // <!BLARG
	    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
	    DOCTYPE: S++, // <!DOCTYPE
	    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
	    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
	    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
	    COMMENT_STARTING: S++, // <!-
	    COMMENT: S++, // <!--
	    COMMENT_ENDING: S++, // <!-- blah -
	    COMMENT_ENDED: S++, // <!-- blah --
	    CDATA: S++, // <![CDATA[ something
	    CDATA_ENDING: S++, // ]
	    CDATA_ENDING_2: S++, // ]]
	    PROC_INST: S++, // <?hi
	    PROC_INST_BODY: S++, // <?hi there
	    PROC_INST_ENDING: S++, // <?hi "there" ?
	    OPEN_TAG: S++, // <strong
	    OPEN_TAG_SLASH: S++, // <strong /
	    ATTRIB: S++, // <a
	    ATTRIB_NAME: S++, // <a foo
	    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
	    ATTRIB_VALUE: S++, // <a foo=
	    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
	    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
	    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
	    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
	    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
	    CLOSE_TAG: S++, // </a
	    CLOSE_TAG_SAW_WHITE: S++, // </a   >
	    SCRIPT: S++, // <script> ...
	    SCRIPT_ENDING: S++ // <script> ... <
	  };
	
	  sax.XML_ENTITIES = {
	    'amp': '&',
	    'gt': '>',
	    'lt': '<',
	    'quot': '"',
	    'apos': "'"
	  };
	
	  sax.ENTITIES = {
	    'amp': '&',
	    'gt': '>',
	    'lt': '<',
	    'quot': '"',
	    'apos': "'",
	    'AElig': 198,
	    'Aacute': 193,
	    'Acirc': 194,
	    'Agrave': 192,
	    'Aring': 197,
	    'Atilde': 195,
	    'Auml': 196,
	    'Ccedil': 199,
	    'ETH': 208,
	    'Eacute': 201,
	    'Ecirc': 202,
	    'Egrave': 200,
	    'Euml': 203,
	    'Iacute': 205,
	    'Icirc': 206,
	    'Igrave': 204,
	    'Iuml': 207,
	    'Ntilde': 209,
	    'Oacute': 211,
	    'Ocirc': 212,
	    'Ograve': 210,
	    'Oslash': 216,
	    'Otilde': 213,
	    'Ouml': 214,
	    'THORN': 222,
	    'Uacute': 218,
	    'Ucirc': 219,
	    'Ugrave': 217,
	    'Uuml': 220,
	    'Yacute': 221,
	    'aacute': 225,
	    'acirc': 226,
	    'aelig': 230,
	    'agrave': 224,
	    'aring': 229,
	    'atilde': 227,
	    'auml': 228,
	    'ccedil': 231,
	    'eacute': 233,
	    'ecirc': 234,
	    'egrave': 232,
	    'eth': 240,
	    'euml': 235,
	    'iacute': 237,
	    'icirc': 238,
	    'igrave': 236,
	    'iuml': 239,
	    'ntilde': 241,
	    'oacute': 243,
	    'ocirc': 244,
	    'ograve': 242,
	    'oslash': 248,
	    'otilde': 245,
	    'ouml': 246,
	    'szlig': 223,
	    'thorn': 254,
	    'uacute': 250,
	    'ucirc': 251,
	    'ugrave': 249,
	    'uuml': 252,
	    'yacute': 253,
	    'yuml': 255,
	    'copy': 169,
	    'reg': 174,
	    'nbsp': 160,
	    'iexcl': 161,
	    'cent': 162,
	    'pound': 163,
	    'curren': 164,
	    'yen': 165,
	    'brvbar': 166,
	    'sect': 167,
	    'uml': 168,
	    'ordf': 170,
	    'laquo': 171,
	    'not': 172,
	    'shy': 173,
	    'macr': 175,
	    'deg': 176,
	    'plusmn': 177,
	    'sup1': 185,
	    'sup2': 178,
	    'sup3': 179,
	    'acute': 180,
	    'micro': 181,
	    'para': 182,
	    'middot': 183,
	    'cedil': 184,
	    'ordm': 186,
	    'raquo': 187,
	    'frac14': 188,
	    'frac12': 189,
	    'frac34': 190,
	    'iquest': 191,
	    'times': 215,
	    'divide': 247,
	    'OElig': 338,
	    'oelig': 339,
	    'Scaron': 352,
	    'scaron': 353,
	    'Yuml': 376,
	    'fnof': 402,
	    'circ': 710,
	    'tilde': 732,
	    'Alpha': 913,
	    'Beta': 914,
	    'Gamma': 915,
	    'Delta': 916,
	    'Epsilon': 917,
	    'Zeta': 918,
	    'Eta': 919,
	    'Theta': 920,
	    'Iota': 921,
	    'Kappa': 922,
	    'Lambda': 923,
	    'Mu': 924,
	    'Nu': 925,
	    'Xi': 926,
	    'Omicron': 927,
	    'Pi': 928,
	    'Rho': 929,
	    'Sigma': 931,
	    'Tau': 932,
	    'Upsilon': 933,
	    'Phi': 934,
	    'Chi': 935,
	    'Psi': 936,
	    'Omega': 937,
	    'alpha': 945,
	    'beta': 946,
	    'gamma': 947,
	    'delta': 948,
	    'epsilon': 949,
	    'zeta': 950,
	    'eta': 951,
	    'theta': 952,
	    'iota': 953,
	    'kappa': 954,
	    'lambda': 955,
	    'mu': 956,
	    'nu': 957,
	    'xi': 958,
	    'omicron': 959,
	    'pi': 960,
	    'rho': 961,
	    'sigmaf': 962,
	    'sigma': 963,
	    'tau': 964,
	    'upsilon': 965,
	    'phi': 966,
	    'chi': 967,
	    'psi': 968,
	    'omega': 969,
	    'thetasym': 977,
	    'upsih': 978,
	    'piv': 982,
	    'ensp': 8194,
	    'emsp': 8195,
	    'thinsp': 8201,
	    'zwnj': 8204,
	    'zwj': 8205,
	    'lrm': 8206,
	    'rlm': 8207,
	    'ndash': 8211,
	    'mdash': 8212,
	    'lsquo': 8216,
	    'rsquo': 8217,
	    'sbquo': 8218,
	    'ldquo': 8220,
	    'rdquo': 8221,
	    'bdquo': 8222,
	    'dagger': 8224,
	    'Dagger': 8225,
	    'bull': 8226,
	    'hellip': 8230,
	    'permil': 8240,
	    'prime': 8242,
	    'Prime': 8243,
	    'lsaquo': 8249,
	    'rsaquo': 8250,
	    'oline': 8254,
	    'frasl': 8260,
	    'euro': 8364,
	    'image': 8465,
	    'weierp': 8472,
	    'real': 8476,
	    'trade': 8482,
	    'alefsym': 8501,
	    'larr': 8592,
	    'uarr': 8593,
	    'rarr': 8594,
	    'darr': 8595,
	    'harr': 8596,
	    'crarr': 8629,
	    'lArr': 8656,
	    'uArr': 8657,
	    'rArr': 8658,
	    'dArr': 8659,
	    'hArr': 8660,
	    'forall': 8704,
	    'part': 8706,
	    'exist': 8707,
	    'empty': 8709,
	    'nabla': 8711,
	    'isin': 8712,
	    'notin': 8713,
	    'ni': 8715,
	    'prod': 8719,
	    'sum': 8721,
	    'minus': 8722,
	    'lowast': 8727,
	    'radic': 8730,
	    'prop': 8733,
	    'infin': 8734,
	    'ang': 8736,
	    'and': 8743,
	    'or': 8744,
	    'cap': 8745,
	    'cup': 8746,
	    'int': 8747,
	    'there4': 8756,
	    'sim': 8764,
	    'cong': 8773,
	    'asymp': 8776,
	    'ne': 8800,
	    'equiv': 8801,
	    'le': 8804,
	    'ge': 8805,
	    'sub': 8834,
	    'sup': 8835,
	    'nsub': 8836,
	    'sube': 8838,
	    'supe': 8839,
	    'oplus': 8853,
	    'otimes': 8855,
	    'perp': 8869,
	    'sdot': 8901,
	    'lceil': 8968,
	    'rceil': 8969,
	    'lfloor': 8970,
	    'rfloor': 8971,
	    'lang': 9001,
	    'rang': 9002,
	    'loz': 9674,
	    'spades': 9824,
	    'clubs': 9827,
	    'hearts': 9829,
	    'diams': 9830
	  };
	
	  Object.keys(sax.ENTITIES).forEach(function (key) {
	    var e = sax.ENTITIES[key];
	    var s = typeof e === 'number' ? String.fromCharCode(e) : e;
	    sax.ENTITIES[key] = s;
	  });
	
	  for (var s in sax.STATE) {
	    sax.STATE[sax.STATE[s]] = s;
	  }
	
	  // shorthand
	  S = sax.STATE;
	
	  function emit(parser, event, data) {
	    parser[event] && parser[event](data);
	  }
	
	  function emitNode(parser, nodeType, data) {
	    if (parser.textNode) closeText(parser);
	    emit(parser, nodeType, data);
	  }
	
	  function closeText(parser) {
	    parser.textNode = textopts(parser.opt, parser.textNode);
	    if (parser.textNode) emit(parser, 'ontext', parser.textNode);
	    parser.textNode = '';
	  }
	
	  function textopts(opt, text) {
	    if (opt.trim) text = text.trim();
	    if (opt.normalize) text = text.replace(/\s+/g, ' ');
	    return text;
	  }
	
	  function error(parser, er) {
	    closeText(parser);
	    if (parser.trackPosition) {
	      er += '\nLine: ' + parser.line + '\nColumn: ' + parser.column + '\nChar: ' + parser.c;
	    }
	    er = new Error(er);
	    parser.error = er;
	    emit(parser, 'onerror', er);
	    return parser;
	  }
	
	  function _end(parser) {
	    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag');
	    if (parser.state !== S.BEGIN && parser.state !== S.BEGIN_WHITESPACE && parser.state !== S.TEXT) {
	      error(parser, 'Unexpected end');
	    }
	    closeText(parser);
	    parser.c = '';
	    parser.closed = true;
	    emit(parser, 'onend');
	    SAXParser.call(parser, parser.strict, parser.opt);
	    return parser;
	  }
	
	  function strictFail(parser, message) {
	    if ((typeof parser === 'undefined' ? 'undefined' : _typeof(parser)) !== 'object' || !(parser instanceof SAXParser)) {
	      throw new Error('bad call to strictFail');
	    }
	    if (parser.strict) {
	      error(parser, message);
	    }
	  }
	
	  function newTag(parser) {
	    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
	    var parent = parser.tags[parser.tags.length - 1] || parser;
	    var tag = parser.tag = { name: parser.tagName, attributes: {}
	
	      // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
	    };if (parser.opt.xmlns) {
	      tag.ns = parent.ns;
	    }
	    parser.attribList.length = 0;
	    emitNode(parser, 'onopentagstart', tag);
	  }
	
	  function qname(name, attribute) {
	    var i = name.indexOf(':');
	    var qualName = i < 0 ? ['', name] : name.split(':');
	    var prefix = qualName[0];
	    var local = qualName[1];
	
	    // <x "xmlns"="http://foo">
	    if (attribute && name === 'xmlns') {
	      prefix = 'xmlns';
	      local = '';
	    }
	
	    return { prefix: prefix, local: local };
	  }
	
	  function attrib(parser) {
	    if (!parser.strict) {
	      parser.attribName = parser.attribName[parser.looseCase]();
	    }
	
	    if (parser.attribList.indexOf(parser.attribName) !== -1 || parser.tag.attributes.hasOwnProperty(parser.attribName)) {
	      parser.attribName = parser.attribValue = '';
	      return;
	    }
	
	    if (parser.opt.xmlns) {
	      var qn = qname(parser.attribName, true);
	      var prefix = qn.prefix;
	      var local = qn.local;
	
	      if (prefix === 'xmlns') {
	        // namespace binding attribute. push the binding into scope
	        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
	          strictFail(parser, 'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' + 'Actual: ' + parser.attribValue);
	        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
	          strictFail(parser, 'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' + 'Actual: ' + parser.attribValue);
	        } else {
	          var tag = parser.tag;
	          var parent = parser.tags[parser.tags.length - 1] || parser;
	          if (tag.ns === parent.ns) {
	            tag.ns = Object.create(parent.ns);
	          }
	          tag.ns[local] = parser.attribValue;
	        }
	      }
	
	      // defer onattribute events until all attributes have been seen
	      // so any new bindings can take effect. preserve attribute order
	      // so deferred events can be emitted in document order
	      parser.attribList.push([parser.attribName, parser.attribValue]);
	    } else {
	      // in non-xmlns mode, we can emit the event right away
	      parser.tag.attributes[parser.attribName] = parser.attribValue;
	      emitNode(parser, 'onattribute', {
	        name: parser.attribName,
	        value: parser.attribValue
	      });
	    }
	
	    parser.attribName = parser.attribValue = '';
	  }
	
	  function openTag(parser, selfClosing) {
	    if (parser.opt.xmlns) {
	      // emit namespace binding events
	      var tag = parser.tag;
	
	      // add namespace info to tag
	      var qn = qname(parser.tagName);
	      tag.prefix = qn.prefix;
	      tag.local = qn.local;
	      tag.uri = tag.ns[qn.prefix] || '';
	
	      if (tag.prefix && !tag.uri) {
	        strictFail(parser, 'Unbound namespace prefix: ' + JSON.stringify(parser.tagName));
	        tag.uri = qn.prefix;
	      }
	
	      var parent = parser.tags[parser.tags.length - 1] || parser;
	      if (tag.ns && parent.ns !== tag.ns) {
	        Object.keys(tag.ns).forEach(function (p) {
	          emitNode(parser, 'onopennamespace', {
	            prefix: p,
	            uri: tag.ns[p]
	          });
	        });
	      }
	
	      // handle deferred onattribute events
	      // Note: do not apply default ns to attributes:
	      //   http://www.w3.org/TR/REC-xml-names/#defaulting
	      for (var i = 0, l = parser.attribList.length; i < l; i++) {
	        var nv = parser.attribList[i];
	        var name = nv[0];
	        var value = nv[1];
	        var qualName = qname(name, true);
	        var prefix = qualName.prefix;
	        var local = qualName.local;
	        var uri = prefix === '' ? '' : tag.ns[prefix] || '';
	        var a = {
	          name: name,
	          value: value,
	          prefix: prefix,
	          local: local,
	          uri: uri
	
	          // if there's any attributes with an undefined namespace,
	          // then fail on them now.
	        };if (prefix && prefix !== 'xmlns' && !uri) {
	          strictFail(parser, 'Unbound namespace prefix: ' + JSON.stringify(prefix));
	          a.uri = prefix;
	        }
	        parser.tag.attributes[name] = a;
	        emitNode(parser, 'onattribute', a);
	      }
	      parser.attribList.length = 0;
	    }
	
	    parser.tag.isSelfClosing = !!selfClosing;
	
	    // process the tag
	    parser.sawRoot = true;
	    parser.tags.push(parser.tag);
	    emitNode(parser, 'onopentag', parser.tag);
	    if (!selfClosing) {
	      // special case for <script> in non-strict mode.
	      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
	        parser.state = S.SCRIPT;
	      } else {
	        parser.state = S.TEXT;
	      }
	      parser.tag = null;
	      parser.tagName = '';
	    }
	    parser.attribName = parser.attribValue = '';
	    parser.attribList.length = 0;
	  }
	
	  function closeTag(parser) {
	    if (!parser.tagName) {
	      strictFail(parser, 'Weird empty close tag.');
	      parser.textNode += '</>';
	      parser.state = S.TEXT;
	      return;
	    }
	
	    if (parser.script) {
	      if (parser.tagName !== 'script') {
	        parser.script += '</' + parser.tagName + '>';
	        parser.tagName = '';
	        parser.state = S.SCRIPT;
	        return;
	      }
	      emitNode(parser, 'onscript', parser.script);
	      parser.script = '';
	    }
	
	    // first make sure that the closing tag actually exists.
	    // <a><b></c></b></a> will close everything, otherwise.
	    var t = parser.tags.length;
	    var tagName = parser.tagName;
	    if (!parser.strict) {
	      tagName = tagName[parser.looseCase]();
	    }
	    var closeTo = tagName;
	    while (t--) {
	      var close = parser.tags[t];
	      if (close.name !== closeTo) {
	        // fail the first time in strict mode
	        strictFail(parser, 'Unexpected close tag');
	      } else {
	        break;
	      }
	    }
	
	    // didn't find it.  we already failed for strict, so just abort.
	    if (t < 0) {
	      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName);
	      parser.textNode += '</' + parser.tagName + '>';
	      parser.state = S.TEXT;
	      return;
	    }
	    parser.tagName = tagName;
	    var s = parser.tags.length;
	    while (s-- > t) {
	      var tag = parser.tag = parser.tags.pop();
	      parser.tagName = parser.tag.name;
	      emitNode(parser, 'onclosetag', parser.tagName);
	
	      var x = {};
	      for (var i in tag.ns) {
	        x[i] = tag.ns[i];
	      }
	
	      var parent = parser.tags[parser.tags.length - 1] || parser;
	      if (parser.opt.xmlns && tag.ns !== parent.ns) {
	        // remove namespace bindings introduced by tag
	        Object.keys(tag.ns).forEach(function (p) {
	          var n = tag.ns[p];
	          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n });
	        });
	      }
	    }
	    if (t === 0) parser.closedRoot = true;
	    parser.tagName = parser.attribValue = parser.attribName = '';
	    parser.attribList.length = 0;
	    parser.state = S.TEXT;
	  }
	
	  function parseEntity(parser) {
	    var entity = parser.entity;
	    var entityLC = entity.toLowerCase();
	    var num;
	    var numStr = '';
	
	    if (parser.ENTITIES[entity]) {
	      return parser.ENTITIES[entity];
	    }
	    if (parser.ENTITIES[entityLC]) {
	      return parser.ENTITIES[entityLC];
	    }
	    entity = entityLC;
	    if (entity.charAt(0) === '#') {
	      if (entity.charAt(1) === 'x') {
	        entity = entity.slice(2);
	        num = parseInt(entity, 16);
	        numStr = num.toString(16);
	      } else {
	        entity = entity.slice(1);
	        num = parseInt(entity, 10);
	        numStr = num.toString(10);
	      }
	    }
	    entity = entity.replace(/^0+/, '');
	    if (numStr.toLowerCase() !== entity) {
	      strictFail(parser, 'Invalid character entity');
	      return '&' + parser.entity + ';';
	    }
	
	    return String.fromCodePoint(num);
	  }
	
	  function beginWhiteSpace(parser, c) {
	    if (c === '<') {
	      parser.state = S.OPEN_WAKA;
	      parser.startTagPosition = parser.position;
	    } else if (not(whitespace, c)) {
	      // have to process this as a text node.
	      // weird, but happens.
	      strictFail(parser, 'Non-whitespace before first tag.');
	      parser.textNode = c;
	      parser.state = S.TEXT;
	    }
	  }
	
	  function charAt(chunk, i) {
	    var result = '';
	    if (i < chunk.length) {
	      result = chunk.charAt(i);
	    }
	    return result;
	  }
	
	  function write(chunk) {
	    var parser = this;
	    if (this.error) {
	      throw this.error;
	    }
	    if (parser.closed) {
	      return error(parser, 'Cannot write after close. Assign an onready handler.');
	    }
	    if (chunk === null) {
	      return _end(parser);
	    }
	    if ((typeof chunk === 'undefined' ? 'undefined' : _typeof(chunk)) === 'object') {
	      chunk = chunk.toString();
	    }
	    var i = 0;
	    var c = '';
	    while (true) {
	      c = charAt(chunk, i++);
	      parser.c = c;
	      if (!c) {
	        break;
	      }
	      if (parser.trackPosition) {
	        parser.position++;
	        if (c === '\n') {
	          parser.line++;
	          parser.column = 0;
	        } else {
	          parser.column++;
	        }
	      }
	      switch (parser.state) {
	        case S.BEGIN:
	          parser.state = S.BEGIN_WHITESPACE;
	          if (c === '\uFEFF') {
	            continue;
	          }
	          beginWhiteSpace(parser, c);
	          continue;
	
	        case S.BEGIN_WHITESPACE:
	          beginWhiteSpace(parser, c);
	          continue;
	
	        case S.TEXT:
	          if (parser.sawRoot && !parser.closedRoot) {
	            var starti = i - 1;
	            while (c && c !== '<' && c !== '&') {
	              c = charAt(chunk, i++);
	              if (c && parser.trackPosition) {
	                parser.position++;
	                if (c === '\n') {
	                  parser.line++;
	                  parser.column = 0;
	                } else {
	                  parser.column++;
	                }
	              }
	            }
	            parser.textNode += chunk.substring(starti, i - 1);
	          }
	          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
	            parser.state = S.OPEN_WAKA;
	            parser.startTagPosition = parser.position;
	          } else {
	            if (not(whitespace, c) && (!parser.sawRoot || parser.closedRoot)) {
	              strictFail(parser, 'Text data outside of root node.');
	            }
	            if (c === '&') {
	              parser.state = S.TEXT_ENTITY;
	            } else {
	              parser.textNode += c;
	            }
	          }
	          continue;
	
	        case S.SCRIPT:
	          // only non-strict
	          if (c === '<') {
	            parser.state = S.SCRIPT_ENDING;
	          } else {
	            parser.script += c;
	          }
	          continue;
	
	        case S.SCRIPT_ENDING:
	          if (c === '/') {
	            parser.state = S.CLOSE_TAG;
	          } else {
	            parser.script += '<' + c;
	            parser.state = S.SCRIPT;
	          }
	          continue;
	
	        case S.OPEN_WAKA:
	          // either a /, ?, !, or text is coming next.
	          if (c === '!') {
	            parser.state = S.SGML_DECL;
	            parser.sgmlDecl = '';
	          } else if (is(whitespace, c)) {
	            // wait for it...
	          } else if (is(nameStart, c)) {
	            parser.state = S.OPEN_TAG;
	            parser.tagName = c;
	          } else if (c === '/') {
	            parser.state = S.CLOSE_TAG;
	            parser.tagName = '';
	          } else if (c === '?') {
	            parser.state = S.PROC_INST;
	            parser.procInstName = parser.procInstBody = '';
	          } else {
	            strictFail(parser, 'Unencoded <');
	            // if there was some whitespace, then add that in.
	            if (parser.startTagPosition + 1 < parser.position) {
	              var pad = parser.position - parser.startTagPosition;
	              c = new Array(pad).join(' ') + c;
	            }
	            parser.textNode += '<' + c;
	            parser.state = S.TEXT;
	          }
	          continue;
	
	        case S.SGML_DECL:
	          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
	            emitNode(parser, 'onopencdata');
	            parser.state = S.CDATA;
	            parser.sgmlDecl = '';
	            parser.cdata = '';
	          } else if (parser.sgmlDecl + c === '--') {
	            parser.state = S.COMMENT;
	            parser.comment = '';
	            parser.sgmlDecl = '';
	          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
	            parser.state = S.DOCTYPE;
	            if (parser.doctype || parser.sawRoot) {
	              strictFail(parser, 'Inappropriately located doctype declaration');
	            }
	            parser.doctype = '';
	            parser.sgmlDecl = '';
	          } else if (c === '>') {
	            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl);
	            parser.sgmlDecl = '';
	            parser.state = S.TEXT;
	          } else if (is(quote, c)) {
	            parser.state = S.SGML_DECL_QUOTED;
	            parser.sgmlDecl += c;
	          } else {
	            parser.sgmlDecl += c;
	          }
	          continue;
	
	        case S.SGML_DECL_QUOTED:
	          if (c === parser.q) {
	            parser.state = S.SGML_DECL;
	            parser.q = '';
	          }
	          parser.sgmlDecl += c;
	          continue;
	
	        case S.DOCTYPE:
	          if (c === '>') {
	            parser.state = S.TEXT;
	            emitNode(parser, 'ondoctype', parser.doctype);
	            parser.doctype = true; // just remember that we saw it.
	          } else {
	            parser.doctype += c;
	            if (c === '[') {
	              parser.state = S.DOCTYPE_DTD;
	            } else if (is(quote, c)) {
	              parser.state = S.DOCTYPE_QUOTED;
	              parser.q = c;
	            }
	          }
	          continue;
	
	        case S.DOCTYPE_QUOTED:
	          parser.doctype += c;
	          if (c === parser.q) {
	            parser.q = '';
	            parser.state = S.DOCTYPE;
	          }
	          continue;
	
	        case S.DOCTYPE_DTD:
	          parser.doctype += c;
	          if (c === ']') {
	            parser.state = S.DOCTYPE;
	          } else if (is(quote, c)) {
	            parser.state = S.DOCTYPE_DTD_QUOTED;
	            parser.q = c;
	          }
	          continue;
	
	        case S.DOCTYPE_DTD_QUOTED:
	          parser.doctype += c;
	          if (c === parser.q) {
	            parser.state = S.DOCTYPE_DTD;
	            parser.q = '';
	          }
	          continue;
	
	        case S.COMMENT:
	          if (c === '-') {
	            parser.state = S.COMMENT_ENDING;
	          } else {
	            parser.comment += c;
	          }
	          continue;
	
	        case S.COMMENT_ENDING:
	          if (c === '-') {
	            parser.state = S.COMMENT_ENDED;
	            parser.comment = textopts(parser.opt, parser.comment);
	            if (parser.comment) {
	              emitNode(parser, 'oncomment', parser.comment);
	            }
	            parser.comment = '';
	          } else {
	            parser.comment += '-' + c;
	            parser.state = S.COMMENT;
	          }
	          continue;
	
	        case S.COMMENT_ENDED:
	          if (c !== '>') {
	            strictFail(parser, 'Malformed comment');
	            // allow <!-- blah -- bloo --> in non-strict mode,
	            // which is a comment of " blah -- bloo "
	            parser.comment += '--' + c;
	            parser.state = S.COMMENT;
	          } else {
	            parser.state = S.TEXT;
	          }
	          continue;
	
	        case S.CDATA:
	          if (c === ']') {
	            parser.state = S.CDATA_ENDING;
	          } else {
	            parser.cdata += c;
	          }
	          continue;
	
	        case S.CDATA_ENDING:
	          if (c === ']') {
	            parser.state = S.CDATA_ENDING_2;
	          } else {
	            parser.cdata += ']' + c;
	            parser.state = S.CDATA;
	          }
	          continue;
	
	        case S.CDATA_ENDING_2:
	          if (c === '>') {
	            if (parser.cdata) {
	              emitNode(parser, 'oncdata', parser.cdata);
	            }
	            emitNode(parser, 'onclosecdata');
	            parser.cdata = '';
	            parser.state = S.TEXT;
	          } else if (c === ']') {
	            parser.cdata += ']';
	          } else {
	            parser.cdata += ']]' + c;
	            parser.state = S.CDATA;
	          }
	          continue;
	
	        case S.PROC_INST:
	          if (c === '?') {
	            parser.state = S.PROC_INST_ENDING;
	          } else if (is(whitespace, c)) {
	            parser.state = S.PROC_INST_BODY;
	          } else {
	            parser.procInstName += c;
	          }
	          continue;
	
	        case S.PROC_INST_BODY:
	          if (!parser.procInstBody && is(whitespace, c)) {
	            continue;
	          } else if (c === '?') {
	            parser.state = S.PROC_INST_ENDING;
	          } else {
	            parser.procInstBody += c;
	          }
	          continue;
	
	        case S.PROC_INST_ENDING:
	          if (c === '>') {
	            emitNode(parser, 'onprocessinginstruction', {
	              name: parser.procInstName,
	              body: parser.procInstBody
	            });
	            parser.procInstName = parser.procInstBody = '';
	            parser.state = S.TEXT;
	          } else {
	            parser.procInstBody += '?' + c;
	            parser.state = S.PROC_INST_BODY;
	          }
	          continue;
	
	        case S.OPEN_TAG:
	          if (is(nameBody, c)) {
	            parser.tagName += c;
	          } else {
	            newTag(parser);
	            if (c === '>') {
	              openTag(parser);
	            } else if (c === '/') {
	              parser.state = S.OPEN_TAG_SLASH;
	            } else {
	              if (not(whitespace, c)) {
	                strictFail(parser, 'Invalid character in tag name');
	              }
	              parser.state = S.ATTRIB;
	            }
	          }
	          continue;
	
	        case S.OPEN_TAG_SLASH:
	          if (c === '>') {
	            openTag(parser, true);
	            closeTag(parser);
	          } else {
	            strictFail(parser, 'Forward-slash in opening tag not followed by >');
	            parser.state = S.ATTRIB;
	          }
	          continue;
	
	        case S.ATTRIB:
	          // haven't read the attribute name yet.
	          if (is(whitespace, c)) {
	            continue;
	          } else if (c === '>') {
	            openTag(parser);
	          } else if (c === '/') {
	            parser.state = S.OPEN_TAG_SLASH;
	          } else if (is(nameStart, c)) {
	            parser.attribName = c;
	            parser.attribValue = '';
	            parser.state = S.ATTRIB_NAME;
	          } else {
	            strictFail(parser, 'Invalid attribute name');
	          }
	          continue;
	
	        case S.ATTRIB_NAME:
	          if (c === '=') {
	            parser.state = S.ATTRIB_VALUE;
	          } else if (c === '>') {
	            strictFail(parser, 'Attribute without value');
	            parser.attribValue = parser.attribName;
	            attrib(parser);
	            openTag(parser);
	          } else if (is(whitespace, c)) {
	            parser.state = S.ATTRIB_NAME_SAW_WHITE;
	          } else if (is(nameBody, c)) {
	            parser.attribName += c;
	          } else {
	            strictFail(parser, 'Invalid attribute name');
	          }
	          continue;
	
	        case S.ATTRIB_NAME_SAW_WHITE:
	          if (c === '=') {
	            parser.state = S.ATTRIB_VALUE;
	          } else if (is(whitespace, c)) {
	            continue;
	          } else {
	            strictFail(parser, 'Attribute without value');
	            parser.tag.attributes[parser.attribName] = '';
	            parser.attribValue = '';
	            emitNode(parser, 'onattribute', {
	              name: parser.attribName,
	              value: ''
	            });
	            parser.attribName = '';
	            if (c === '>') {
	              openTag(parser);
	            } else if (is(nameStart, c)) {
	              parser.attribName = c;
	              parser.state = S.ATTRIB_NAME;
	            } else {
	              strictFail(parser, 'Invalid attribute name');
	              parser.state = S.ATTRIB;
	            }
	          }
	          continue;
	
	        case S.ATTRIB_VALUE:
	          if (is(whitespace, c)) {
	            continue;
	          } else if (is(quote, c)) {
	            parser.q = c;
	            parser.state = S.ATTRIB_VALUE_QUOTED;
	          } else {
	            strictFail(parser, 'Unquoted attribute value');
	            parser.state = S.ATTRIB_VALUE_UNQUOTED;
	            parser.attribValue = c;
	          }
	          continue;
	
	        case S.ATTRIB_VALUE_QUOTED:
	          if (c !== parser.q) {
	            if (c === '&') {
	              parser.state = S.ATTRIB_VALUE_ENTITY_Q;
	            } else {
	              parser.attribValue += c;
	            }
	            continue;
	          }
	          attrib(parser);
	          parser.q = '';
	          parser.state = S.ATTRIB_VALUE_CLOSED;
	          continue;
	
	        case S.ATTRIB_VALUE_CLOSED:
	          if (is(whitespace, c)) {
	            parser.state = S.ATTRIB;
	          } else if (c === '>') {
	            openTag(parser);
	          } else if (c === '/') {
	            parser.state = S.OPEN_TAG_SLASH;
	          } else if (is(nameStart, c)) {
	            strictFail(parser, 'No whitespace between attributes');
	            parser.attribName = c;
	            parser.attribValue = '';
	            parser.state = S.ATTRIB_NAME;
	          } else {
	            strictFail(parser, 'Invalid attribute name');
	          }
	          continue;
	
	        case S.ATTRIB_VALUE_UNQUOTED:
	          if (not(attribEnd, c)) {
	            if (c === '&') {
	              parser.state = S.ATTRIB_VALUE_ENTITY_U;
	            } else {
	              parser.attribValue += c;
	            }
	            continue;
	          }
	          attrib(parser);
	          if (c === '>') {
	            openTag(parser);
	          } else {
	            parser.state = S.ATTRIB;
	          }
	          continue;
	
	        case S.CLOSE_TAG:
	          if (!parser.tagName) {
	            if (is(whitespace, c)) {
	              continue;
	            } else if (not(nameStart, c)) {
	              if (parser.script) {
	                parser.script += '</' + c;
	                parser.state = S.SCRIPT;
	              } else {
	                strictFail(parser, 'Invalid tagname in closing tag.');
	              }
	            } else {
	              parser.tagName = c;
	            }
	          } else if (c === '>') {
	            closeTag(parser);
	          } else if (is(nameBody, c)) {
	            parser.tagName += c;
	          } else if (parser.script) {
	            parser.script += '</' + parser.tagName;
	            parser.tagName = '';
	            parser.state = S.SCRIPT;
	          } else {
	            if (not(whitespace, c)) {
	              strictFail(parser, 'Invalid tagname in closing tag');
	            }
	            parser.state = S.CLOSE_TAG_SAW_WHITE;
	          }
	          continue;
	
	        case S.CLOSE_TAG_SAW_WHITE:
	          if (is(whitespace, c)) {
	            continue;
	          }
	          if (c === '>') {
	            closeTag(parser);
	          } else {
	            strictFail(parser, 'Invalid characters in closing tag');
	          }
	          continue;
	
	        case S.TEXT_ENTITY:
	        case S.ATTRIB_VALUE_ENTITY_Q:
	        case S.ATTRIB_VALUE_ENTITY_U:
	          var returnState;
	          var buffer;
	          switch (parser.state) {
	            case S.TEXT_ENTITY:
	              returnState = S.TEXT;
	              buffer = 'textNode';
	              break;
	
	            case S.ATTRIB_VALUE_ENTITY_Q:
	              returnState = S.ATTRIB_VALUE_QUOTED;
	              buffer = 'attribValue';
	              break;
	
	            case S.ATTRIB_VALUE_ENTITY_U:
	              returnState = S.ATTRIB_VALUE_UNQUOTED;
	              buffer = 'attribValue';
	              break;
	          }
	
	          if (c === ';') {
	            parser[buffer] += parseEntity(parser);
	            parser.entity = '';
	            parser.state = returnState;
	          } else if (is(parser.entity.length ? entityBody : entityStart, c)) {
	            parser.entity += c;
	          } else {
	            strictFail(parser, 'Invalid character in entity name');
	            parser[buffer] += '&' + parser.entity + c;
	            parser.entity = '';
	            parser.state = returnState;
	          }
	
	          continue;
	
	        default:
	          throw new Error(parser, 'Unknown state: ' + parser.state);
	      }
	    } // while
	
	    if (parser.position >= parser.bufferCheckPosition) {
	      checkBufferLength(parser);
	    }
	    return parser;
	  }
	
	  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
	  if (!String.fromCodePoint) {
	    (function () {
	      var stringFromCharCode = String.fromCharCode;
	      var floor = Math.floor;
	      var fromCodePoint = function fromCodePoint() {
	        var MAX_SIZE = 0x4000;
	        var codeUnits = [];
	        var highSurrogate;
	        var lowSurrogate;
	        var index = -1;
	        var length = arguments.length;
	        if (!length) {
	          return '';
	        }
	        var result = '';
	        while (++index < length) {
	          var codePoint = Number(arguments[index]);
	          if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
	          codePoint < 0 || // not a valid Unicode code point
	          codePoint > 0x10FFFF || // not a valid Unicode code point
	          floor(codePoint) !== codePoint // not an integer
	          ) {
	              throw RangeError('Invalid code point: ' + codePoint);
	            }
	          if (codePoint <= 0xFFFF) {
	            // BMP code point
	            codeUnits.push(codePoint);
	          } else {
	            // Astral code point; split in surrogate halves
	            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	            codePoint -= 0x10000;
	            highSurrogate = (codePoint >> 10) + 0xD800;
	            lowSurrogate = codePoint % 0x400 + 0xDC00;
	            codeUnits.push(highSurrogate, lowSurrogate);
	          }
	          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
	            result += stringFromCharCode.apply(null, codeUnits);
	            codeUnits.length = 0;
	          }
	        }
	        return result;
	      };
	      if (Object.defineProperty) {
	        Object.defineProperty(String, 'fromCodePoint', {
	          value: fromCodePoint,
	          configurable: true,
	          writable: true
	        });
	      } else {
	        String.fromCodePoint = fromCodePoint;
	      }
	    })();
	  }
	})( false ? undefined.sax = {} : exports);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41).Buffer))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict';
	
	var base64 = __webpack_require__(42);
	var ieee754 = __webpack_require__(43);
	var isArray = __webpack_require__(44);
	
	exports.Buffer = Buffer;
	exports.SlowBuffer = SlowBuffer;
	exports.INSPECT_MAX_BYTES = 50;
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength();
	
	function typedArraySupport() {
	  try {
	    var arr = new Uint8Array(1);
	    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
	        return 42;
	      } };
	    return arr.foo() === 42 && // typed array instances can be augmented
	    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
	  } catch (e) {
	    return false;
	  }
	}
	
	function kMaxLength() {
	  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
	}
	
	function createBuffer(that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length');
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length);
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length);
	    }
	    that.length = length;
	  }
	
	  return that;
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer(arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length);
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error('If encoding is specified then the first argument must be a string');
	    }
	    return allocUnsafe(this, arg);
	  }
	  return from(this, arg, encodingOrOffset, length);
	}
	
	Buffer.poolSize = 8192; // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype;
	  return arr;
	};
	
	function from(that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number');
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length);
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset);
	  }
	
	  return fromObject(that, value);
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length);
	};
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype;
	  Buffer.__proto__ = Uint8Array;
	  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    });
	  }
	}
	
	function assertSize(size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number');
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative');
	  }
	}
	
	function alloc(that, size, fill, encoding) {
	  assertSize(size);
	  if (size <= 0) {
	    return createBuffer(that, size);
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
	  }
	  return createBuffer(that, size);
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding);
	};
	
	function allocUnsafe(that, size) {
	  assertSize(size);
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0;
	    }
	  }
	  return that;
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size);
	};
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size);
	};
	
	function fromString(that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8';
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding');
	  }
	
	  var length = byteLength(string, encoding) | 0;
	  that = createBuffer(that, length);
	
	  var actual = that.write(string, encoding);
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual);
	  }
	
	  return that;
	}
	
	function fromArrayLike(that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0;
	  that = createBuffer(that, length);
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255;
	  }
	  return that;
	}
	
	function fromArrayBuffer(that, array, byteOffset, length) {
	  array.byteLength; // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds');
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds');
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array);
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset);
	  } else {
	    array = new Uint8Array(array, byteOffset, length);
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array;
	    that.__proto__ = Buffer.prototype;
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array);
	  }
	  return that;
	}
	
	function fromObject(that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0;
	    that = createBuffer(that, len);
	
	    if (that.length === 0) {
	      return that;
	    }
	
	    obj.copy(that, 0, 0, len);
	    return that;
	  }
	
	  if (obj) {
	    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0);
	      }
	      return fromArrayLike(that, obj);
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data);
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
	}
	
	function checked(length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
	  }
	  return length | 0;
	}
	
	function SlowBuffer(length) {
	  if (+length != length) {
	    // eslint-disable-line eqeqeq
	    length = 0;
	  }
	  return Buffer.alloc(+length);
	}
	
	Buffer.isBuffer = function isBuffer(b) {
	  return !!(b != null && b._isBuffer);
	};
	
	Buffer.compare = function compare(a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers');
	  }
	
	  if (a === b) return 0;
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	Buffer.isEncoding = function isEncoding(encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true;
	    default:
	      return false;
	  }
	};
	
	Buffer.concat = function concat(list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers');
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0);
	  }
	
	  var i;
	  if (length === undefined) {
	    length = 0;
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length;
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length);
	  var pos = 0;
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i];
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers');
	    }
	    buf.copy(buffer, pos);
	    pos += buf.length;
	  }
	  return buffer;
	};
	
	function byteLength(string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length;
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength;
	  }
	  if (typeof string !== 'string') {
	    string = '' + string;
	  }
	
	  var len = string.length;
	  if (len === 0) return 0;
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len;
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length;
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2;
	      case 'hex':
	        return len >>> 1;
	      case 'base64':
	        return base64ToBytes(string).length;
	      default:
	        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	Buffer.byteLength = byteLength;
	
	function slowToString(encoding, start, end) {
	  var loweredCase = false;
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0;
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return '';
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length;
	  }
	
	  if (end <= 0) {
	    return '';
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0;
	  start >>>= 0;
	
	  if (end <= start) {
	    return '';
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end);
	
	      case 'ascii':
	        return asciiSlice(this, start, end);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end);
	
	      case 'base64':
	        return base64Slice(this, start, end);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = (encoding + '').toLowerCase();
	        loweredCase = true;
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true;
	
	function swap(b, n, m) {
	  var i = b[n];
	  b[n] = b[m];
	  b[m] = i;
	}
	
	Buffer.prototype.swap16 = function swap16() {
	  var len = this.length;
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits');
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1);
	  }
	  return this;
	};
	
	Buffer.prototype.swap32 = function swap32() {
	  var len = this.length;
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits');
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3);
	    swap(this, i + 1, i + 2);
	  }
	  return this;
	};
	
	Buffer.prototype.swap64 = function swap64() {
	  var len = this.length;
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits');
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7);
	    swap(this, i + 1, i + 6);
	    swap(this, i + 2, i + 5);
	    swap(this, i + 3, i + 4);
	  }
	  return this;
	};
	
	Buffer.prototype.toString = function toString() {
	  var length = this.length | 0;
	  if (length === 0) return '';
	  if (arguments.length === 0) return utf8Slice(this, 0, length);
	  return slowToString.apply(this, arguments);
	};
	
	Buffer.prototype.equals = function equals(b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
	  if (this === b) return true;
	  return Buffer.compare(this, b) === 0;
	};
	
	Buffer.prototype.inspect = function inspect() {
	  var str = '';
	  var max = exports.INSPECT_MAX_BYTES;
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
	    if (this.length > max) str += ' ... ';
	  }
	  return '<Buffer ' + str + '>';
	};
	
	Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer');
	  }
	
	  if (start === undefined) {
	    start = 0;
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0;
	  }
	  if (thisStart === undefined) {
	    thisStart = 0;
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length;
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index');
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0;
	  }
	  if (thisStart >= thisEnd) {
	    return -1;
	  }
	  if (start >= end) {
	    return 1;
	  }
	
	  start >>>= 0;
	  end >>>= 0;
	  thisStart >>>= 0;
	  thisEnd >>>= 0;
	
	  if (this === target) return 0;
	
	  var x = thisEnd - thisStart;
	  var y = end - start;
	  var len = Math.min(x, y);
	
	  var thisCopy = this.slice(thisStart, thisEnd);
	  var targetCopy = target.slice(start, end);
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i];
	      y = targetCopy[i];
	      break;
	    }
	  }
	
	  if (x < y) return -1;
	  if (y < x) return 1;
	  return 0;
	};
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1;
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset;
	    byteOffset = 0;
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff;
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000;
	  }
	  byteOffset = +byteOffset; // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : buffer.length - 1;
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1;else byteOffset = buffer.length - 1;
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0;else return -1;
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding);
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1;
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
	  } else if (typeof val === 'number') {
	    val = val & 0xFF; // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
	      }
	    }
	    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
	  }
	
	  throw new TypeError('val must be string, number or Buffer');
	}
	
	function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1;
	  var arrLength = arr.length;
	  var valLength = val.length;
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase();
	    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1;
	      }
	      indexSize = 2;
	      arrLength /= 2;
	      valLength /= 2;
	      byteOffset /= 2;
	    }
	  }
	
	  function read(buf, i) {
	    if (indexSize === 1) {
	      return buf[i];
	    } else {
	      return buf.readUInt16BE(i * indexSize);
	    }
	  }
	
	  var i;
	  if (dir) {
	    var foundIndex = -1;
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i;
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex;
	        foundIndex = -1;
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true;
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false;
	          break;
	        }
	      }
	      if (found) return i;
	    }
	  }
	
	  return -1;
	}
	
	Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1;
	};
	
	Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
	};
	
	Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
	};
	
	function hexWrite(buf, string, offset, length) {
	  offset = Number(offset) || 0;
	  var remaining = buf.length - offset;
	  if (!length) {
	    length = remaining;
	  } else {
	    length = Number(length);
	    if (length > remaining) {
	      length = remaining;
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length;
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');
	
	  if (length > strLen / 2) {
	    length = strLen / 2;
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16);
	    if (isNaN(parsed)) return i;
	    buf[offset + i] = parsed;
	  }
	  return i;
	}
	
	function utf8Write(buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	function asciiWrite(buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length);
	}
	
	function latin1Write(buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length);
	}
	
	function base64Write(buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length);
	}
	
	function ucs2Write(buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
	}
	
	Buffer.prototype.write = function write(string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8';
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset;
	    length = this.length;
	    offset = 0;
	    // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0;
	    if (isFinite(length)) {
	      length = length | 0;
	      if (encoding === undefined) encoding = 'utf8';
	    } else {
	      encoding = length;
	      length = undefined;
	    }
	    // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
	  }
	
	  var remaining = this.length - offset;
	  if (length === undefined || length > remaining) length = remaining;
	
	  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds');
	  }
	
	  if (!encoding) encoding = 'utf8';
	
	  var loweredCase = false;
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length);
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length);
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length);
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length);
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length);
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length);
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
	        encoding = ('' + encoding).toLowerCase();
	        loweredCase = true;
	    }
	  }
	};
	
	Buffer.prototype.toJSON = function toJSON() {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  };
	};
	
	function base64Slice(buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf);
	  } else {
	    return base64.fromByteArray(buf.slice(start, end));
	  }
	}
	
	function utf8Slice(buf, start, end) {
	  end = Math.min(buf.length, end);
	  var res = [];
	
	  var i = start;
	  while (i < end) {
	    var firstByte = buf[i];
	    var codePoint = null;
	    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint;
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte;
	          }
	          break;
	        case 2:
	          secondByte = buf[i + 1];
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 3:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint;
	            }
	          }
	          break;
	        case 4:
	          secondByte = buf[i + 1];
	          thirdByte = buf[i + 2];
	          fourthByte = buf[i + 3];
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint;
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD;
	      bytesPerSequence = 1;
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000;
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
	      codePoint = 0xDC00 | codePoint & 0x3FF;
	    }
	
	    res.push(codePoint);
	    i += bytesPerSequence;
	  }
	
	  return decodeCodePointsArray(res);
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000;
	
	function decodeCodePointsArray(codePoints) {
	  var len = codePoints.length;
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = '';
	  var i = 0;
	  while (i < len) {
	    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
	  }
	  return res;
	}
	
	function asciiSlice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F);
	  }
	  return ret;
	}
	
	function latin1Slice(buf, start, end) {
	  var ret = '';
	  end = Math.min(buf.length, end);
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i]);
	  }
	  return ret;
	}
	
	function hexSlice(buf, start, end) {
	  var len = buf.length;
	
	  if (!start || start < 0) start = 0;
	  if (!end || end < 0 || end > len) end = len;
	
	  var out = '';
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i]);
	  }
	  return out;
	}
	
	function utf16leSlice(buf, start, end) {
	  var bytes = buf.slice(start, end);
	  var res = '';
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
	  }
	  return res;
	}
	
	Buffer.prototype.slice = function slice(start, end) {
	  var len = this.length;
	  start = ~~start;
	  end = end === undefined ? len : ~~end;
	
	  if (start < 0) {
	    start += len;
	    if (start < 0) start = 0;
	  } else if (start > len) {
	    start = len;
	  }
	
	  if (end < 0) {
	    end += len;
	    if (end < 0) end = 0;
	  } else if (end > len) {
	    end = len;
	  }
	
	  if (end < start) end = start;
	
	  var newBuf;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end);
	    newBuf.__proto__ = Buffer.prototype;
	  } else {
	    var sliceLen = end - start;
	    newBuf = new Buffer(sliceLen, undefined);
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start];
	    }
	  }
	
	  return newBuf;
	};
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset(offset, ext, length) {
	  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length);
	  }
	
	  var val = this[offset + --byteLength];
	  var mul = 1;
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul;
	  }
	
	  return val;
	};
	
	Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  return this[offset];
	};
	
	Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] | this[offset + 1] << 8;
	};
	
	Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  return this[offset] << 8 | this[offset + 1];
	};
	
	Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
	};
	
	Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
	};
	
	Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var val = this[offset];
	  var mul = 1;
	  var i = 0;
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) checkOffset(offset, byteLength, this.length);
	
	  var i = byteLength;
	  var mul = 1;
	  var val = this[offset + --i];
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul;
	  }
	  mul *= 0x80;
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
	
	  return val;
	};
	
	Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length);
	  if (!(this[offset] & 0x80)) return this[offset];
	  return (0xff - this[offset] + 1) * -1;
	};
	
	Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset] | this[offset + 1] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length);
	  var val = this[offset + 1] | this[offset] << 8;
	  return val & 0x8000 ? val | 0xFFFF0000 : val;
	};
	
	Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
	};
	
	Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	
	  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
	};
	
	Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, true, 23, 4);
	};
	
	Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length);
	  return ieee754.read(this, offset, false, 23, 4);
	};
	
	Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, true, 52, 8);
	};
	
	Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length);
	  return ieee754.read(this, offset, false, 52, 8);
	};
	
	function checkInt(buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var mul = 1;
	  var i = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  byteLength = byteLength | 0;
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
	    checkInt(this, value, offset, byteLength, maxBytes, 0);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = value / mul & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	function objectWriteUInt16(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	function objectWriteUInt32(buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1;
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = value >>> 24;
	    this[offset + 2] = value >>> 16;
	    this[offset + 1] = value >>> 8;
	    this[offset] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = 0;
	  var mul = 1;
	  var sub = 0;
	  this[offset] = value & 0xFF;
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1);
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit);
	  }
	
	  var i = byteLength - 1;
	  var mul = 1;
	  var sub = 0;
	  this[offset + i] = value & 0xFF;
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1;
	    }
	    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
	  }
	
	  return offset + byteLength;
	};
	
	Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
	  if (value < 0) value = 0xff + value + 1;
	  this[offset] = value & 0xff;
	  return offset + 1;
	};
	
	Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	  } else {
	    objectWriteUInt16(this, value, offset, true);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 8;
	    this[offset + 1] = value & 0xff;
	  } else {
	    objectWriteUInt16(this, value, offset, false);
	  }
	  return offset + 2;
	};
	
	Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value & 0xff;
	    this[offset + 1] = value >>> 8;
	    this[offset + 2] = value >>> 16;
	    this[offset + 3] = value >>> 24;
	  } else {
	    objectWriteUInt32(this, value, offset, true);
	  }
	  return offset + 4;
	};
	
	Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
	  value = +value;
	  offset = offset | 0;
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
	  if (value < 0) value = 0xffffffff + value + 1;
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = value >>> 24;
	    this[offset + 1] = value >>> 16;
	    this[offset + 2] = value >>> 8;
	    this[offset + 3] = value & 0xff;
	  } else {
	    objectWriteUInt32(this, value, offset, false);
	  }
	  return offset + 4;
	};
	
	function checkIEEE754(buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range');
	  if (offset < 0) throw new RangeError('Index out of range');
	}
	
	function writeFloat(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4);
	  return offset + 4;
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert);
	};
	
	function writeDouble(buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8);
	  return offset + 8;
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert);
	};
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert);
	};
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy(target, targetStart, start, end) {
	  if (!start) start = 0;
	  if (!end && end !== 0) end = this.length;
	  if (targetStart >= target.length) targetStart = target.length;
	  if (!targetStart) targetStart = 0;
	  if (end > 0 && end < start) end = start;
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0;
	  if (target.length === 0 || this.length === 0) return 0;
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds');
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
	  if (end < 0) throw new RangeError('sourceEnd out of bounds');
	
	  // Are we oob?
	  if (end > this.length) end = this.length;
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start;
	  }
	
	  var len = end - start;
	  var i;
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start];
	    }
	  } else {
	    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
	  }
	
	  return len;
	};
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill(val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start;
	      start = 0;
	      end = this.length;
	    } else if (typeof end === 'string') {
	      encoding = end;
	      end = this.length;
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0);
	      if (code < 256) {
	        val = code;
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string');
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding);
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255;
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index');
	  }
	
	  if (end <= start) {
	    return this;
	  }
	
	  start = start >>> 0;
	  end = end === undefined ? this.length : end >>> 0;
	
	  if (!val) val = 0;
	
	  var i;
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val;
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
	    var len = bytes.length;
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len];
	    }
	  }
	
	  return this;
	};
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
	
	function base64clean(str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return '';
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '=';
	  }
	  return str;
	}
	
	function stringtrim(str) {
	  if (str.trim) return str.trim();
	  return str.replace(/^\s+|\s+$/g, '');
	}
	
	function toHex(n) {
	  if (n < 16) return '0' + n.toString(16);
	  return n.toString(16);
	}
	
	function utf8ToBytes(string, units) {
	  units = units || Infinity;
	  var codePoint;
	  var length = string.length;
	  var leadSurrogate = null;
	  var bytes = [];
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i);
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	          continue;
	        }
	
	        // valid lead
	        leadSurrogate = codePoint;
	
	        continue;
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	        leadSurrogate = codePoint;
	        continue;
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
	    }
	
	    leadSurrogate = null;
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break;
	      bytes.push(codePoint);
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break;
	      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break;
	      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break;
	      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
	    } else {
	      throw new Error('Invalid code point');
	    }
	  }
	
	  return bytes;
	}
	
	function asciiToBytes(str) {
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF);
	  }
	  return byteArray;
	}
	
	function utf16leToBytes(str, units) {
	  var c, hi, lo;
	  var byteArray = [];
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break;
	
	    c = str.charCodeAt(i);
	    hi = c >> 8;
	    lo = c % 256;
	    byteArray.push(lo);
	    byteArray.push(hi);
	  }
	
	  return byteArray;
	}
	
	function base64ToBytes(str) {
	  return base64.toByteArray(base64clean(str));
	}
	
	function blitBuffer(src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if (i + offset >= dst.length || i >= src.length) break;
	    dst[i + offset] = src[i];
	  }
	  return i;
	}
	
	function isnan(val) {
	  return val !== val; // eslint-disable-line no-self-compare
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.byteLength = byteLength;
	exports.toByteArray = toByteArray;
	exports.fromByteArray = fromByteArray;
	
	var lookup = [];
	var revLookup = [];
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i];
	  revLookup[code.charCodeAt(i)] = i;
	}
	
	revLookup['-'.charCodeAt(0)] = 62;
	revLookup['_'.charCodeAt(0)] = 63;
	
	function placeHoldersCount(b64) {
	  var len = b64.length;
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4');
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
	}
	
	function byteLength(b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64);
	}
	
	function toByteArray(b64) {
	  var i, j, l, tmp, placeHolders, arr;
	  var len = b64.length;
	  placeHolders = placeHoldersCount(b64);
	
	  arr = new Arr(len * 3 / 4 - placeHolders);
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len;
	
	  var L = 0;
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
	    arr[L++] = tmp >> 16 & 0xFF;
	    arr[L++] = tmp >> 8 & 0xFF;
	    arr[L++] = tmp & 0xFF;
	  }
	
	  if (placeHolders === 2) {
	    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
	    arr[L++] = tmp & 0xFF;
	  } else if (placeHolders === 1) {
	    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
	    arr[L++] = tmp >> 8 & 0xFF;
	    arr[L++] = tmp & 0xFF;
	  }
	
	  return arr;
	}
	
	function tripletToBase64(num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
	}
	
	function encodeChunk(uint8, start, end) {
	  var tmp;
	  var output = [];
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
	    output.push(tripletToBase64(tmp));
	  }
	  return output.join('');
	}
	
	function fromByteArray(uint8) {
	  var tmp;
	  var len = uint8.length;
	  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
	  var output = '';
	  var parts = [];
	  var maxChunkLength = 16383; // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1];
	    output += lookup[tmp >> 2];
	    output += lookup[tmp << 4 & 0x3F];
	    output += '==';
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
	    output += lookup[tmp >> 10];
	    output += lookup[tmp >> 4 & 0x3F];
	    output += lookup[tmp << 2 & 0x3F];
	    output += '=';
	  }
	
	  parts.push(output);
	
	  return parts.join('');
	}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? nBytes - 1 : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];
	
	  i += d;
	
	  e = s & (1 << -nBits) - 1;
	  s >>= -nBits;
	  nBits += eLen;
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : (s ? -1 : 1) * Infinity;
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
	};
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
	  var i = isLE ? 0 : nBytes - 1;
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	
	  value = Math.abs(value);
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128;
	};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(46).EventEmitter;
	var inherits = __webpack_require__(47);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(48);
	Stream.Writable = __webpack_require__(62);
	Stream.Duplex = __webpack_require__(63);
	Stream.Transform = __webpack_require__(64);
	Stream.PassThrough = __webpack_require__(65);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function (dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function (n) {
	  if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function (type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events) this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler)) return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++) {
	      listeners[i].apply(this, args);
	    }
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function (type, listener) {
	  var m;
	
	  if (!isFunction(listener)) throw TypeError('listener must be a function');
	
	  if (!this._events) this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener) this.emit('newListener', type, isFunction(listener.listener) ? listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' + 'leak detected. %d listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.', this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function (type, listener) {
	  if (!isFunction(listener)) throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function (type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener)) throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type]) return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener || isFunction(list.listener) && list.listener === listener) {
	    delete this._events[type];
	    if (this._events.removeListener) this.emit('removeListener', type, listener);
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0) return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener) this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function (type) {
	  var key, listeners;
	
	  if (!this._events) return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0) this._events = {};else if (this._events[type]) delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length) {
	      this.removeListener(type, listeners[listeners.length - 1]);
	    }
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function (type) {
	  var ret;
	  if (!this._events || !this._events[type]) ret = [];else if (isFunction(this._events[type])) ret = [this._events[type]];else ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function (type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener)) return 1;else if (evlistener) return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function (emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    var TempCtor = function TempCtor() {};
	    TempCtor.prototype = superCtor.prototype;
	    ctor.prototype = new TempCtor();
	    ctor.prototype.constructor = ctor;
	  };
	}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Stream = function () {
	  try {
	    return __webpack_require__(45); // hack to fix a circular dependency issue when used with browserify
	  } catch (_) {}
	}();
	exports = module.exports = __webpack_require__(49);
	exports.Stream = Stream || exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(55);
	exports.Duplex = __webpack_require__(54);
	exports.Transform = __webpack_require__(60);
	exports.PassThrough = __webpack_require__(61);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	module.exports = Readable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(51);
	/*</replacement>*/
	
	/*<replacement>*/
	var isArray = __webpack_require__(44);
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(41).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(46);
	
	/*<replacement>*/
	var EElistenerCount = function EElistenerCount(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream;
	(function () {
	  try {
	    Stream = __webpack_require__(45);
	  } catch (_) {} finally {
	    if (!Stream) Stream = __webpack_require__(46).EventEmitter;
	  }
	})();
	/*</replacement>*/
	
	var Buffer = __webpack_require__(41).Buffer;
	
	/*<replacement>*/
	var util = __webpack_require__(52);
	util.inherits = __webpack_require__(47);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(53);
	var debug = undefined;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function debug() {};
	}
	/*</replacement>*/
	
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var Duplex;
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(54);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(59).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	var Duplex;
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(54);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options && typeof options.read === 'function') this._read = options.read;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	
	  if (!state.objectMode && typeof chunk === 'string') {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      var skipAdd;
	      if (state.decoder && !addToFront && !encoding) {
	        chunk = state.decoder.write(chunk);
	        skipAdd = !state.objectMode && chunk.length === 0;
	      }
	
	      if (!addToFront) state.reading = false;
	
	      // Don't add to the buffer if we've decoded to an empty string chunk and
	      // we're not in object mode
	      if (!skipAdd) {
	        // if we want the data now, just emit it.
	        if (state.flowing && state.length === 0 && !state.sync) {
	          stream.emit('data', chunk);
	          stream.read(0);
	        } else {
	          // update the buffer info.
	          state.length += state.objectMode ? 1 : chunk.length;
	          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	          if (state.needReadable) emitReadable(stream);
	        }
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(59).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended) return 0;
	
	  if (state.objectMode) return n === 0 ? 0 : 1;
	
	  if (n === null || isNaN(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length) return state.buffer[0].length;else return state.length;
	  }
	
	  if (n <= 0) return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else {
	      return state.length;
	    }
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (typeof n !== 'number' || n > 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading) n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended) state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0) endReadable(this);
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      if (state.pipesCount === 1 && state.pipes[0] === dest && src.listenerCount('data') === 1 && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error) dest.on('error', onerror);else if (isArray(dest._events.error)) dest._events.error.unshift(onerror);else dest._events.error = [onerror, dest._events.error];
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var _i = 0; _i < len; _i++) {
	      dests[_i].emit('unpipe', this);
	    }return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1) return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && !this._readableState.endEmitted) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function (ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0) return null;
	
	  if (length === 0) ret = null;else if (objectMode) ret = list.shift();else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode) ret = list.join('');else if (list.length === 1) ret = list[0];else ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode) ret = '';else ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode) ret += buf.slice(0, cpy);else buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length) list[0] = buf.slice(cpy);else list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version || process.version.indexOf('v0.') === 0 || process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	    case 0:
	    case 1:
	      return process.nextTick(fn);
	    case 2:
	      return process.nextTick(function afterTickOne() {
	        fn.call(null, arg1);
	      });
	    case 3:
	      return process.nextTick(function afterTickTwo() {
	        fn.call(null, arg1, arg2);
	      });
	    case 4:
	      return process.nextTick(function afterTickThree() {
	        fn.call(null, arg1, arg2, arg3);
	      });
	    default:
	      args = new Array(len - 1);
	      i = 0;
	      while (i < args.length) {
	        args[i++] = arguments[i];
	      }
	      return process.nextTick(function afterTick() {
	        fn.apply(null, args);
	      });
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return objectToString(e) === '[object Error]' || e instanceof Error;
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol' || // ES6 symbol
	  typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41).Buffer))

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(51);
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(52);
	util.inherits = __webpack_require__(47);
	/*</replacement>*/
	
	var Readable = __webpack_require__(49);
	var Writable = __webpack_require__(55);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	module.exports = Writable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(51);
	/*</replacement>*/
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(41).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(52);
	util.inherits = __webpack_require__(47);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(58)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream;
	(function () {
	  try {
	    Stream = __webpack_require__(45);
	  } catch (_) {} finally {
	    if (!Stream) Stream = __webpack_require__(46).EventEmitter;
	  }
	})();
	/*</replacement>*/
	
	var Buffer = __webpack_require__(41).Buffer;
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	var Duplex;
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(54);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // create the two objects needed to store the corked requests
	  // they are not a linked list, as no new elements are inserted in there
	  this.corkedRequestsFree = new CorkedRequest(this);
	  this.corkedRequestsFree.next = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function writableStateGetBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
	    });
	  } catch (_) {}
	})();
	
	var Duplex;
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(54);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	
	  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	
	  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	  if (sync) processNextTick(cb, er);else cb(er);
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    while (entry) {
	      buffer[count] = entry;
	      entry = entry.next;
	      count += 1;
	    }
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    state.corkedRequestsFree = holder.next;
	    holder.next = null;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else {
	      prefinish(stream, state);
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	
	  this.finish = function (err) {
	    var entry = _this.entry;
	    _this.entry = null;
	    while (entry) {
	      var cb = entry.callback;
	      state.pendingcb--;
	      cb(err);
	      entry = entry.next;
	    }
	    if (state.corkedRequestsFree) {
	      state.corkedRequestsFree.next = _this;
	    } else {
	      state.corkedRequestsFree = _this;
	    }
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), __webpack_require__(56).setImmediate))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function () {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function () {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout = exports.clearInterval = function (timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function () {};
	Timeout.prototype.close = function () {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function (item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function (item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function (item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout) item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(57);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	
	(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	        // Callback can either be a function or a string
	        if (typeof callback !== "function") {
	            callback = new Function("" + callback);
	        }
	        // Copy function arguments
	        var args = new Array(arguments.length - 1);
	        for (var i = 0; i < args.length; i++) {
	            args[i] = arguments[i + 1];
	        }
	        // Store and register the task
	        var task = { callback: callback, args: args };
	        tasksByHandle[nextHandle] = task;
	        registerImmediate(nextHandle);
	        return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	            case 0:
	                callback();
	                break;
	            case 1:
	                callback(args[0]);
	                break;
	            case 2:
	                callback(args[0], args[1]);
	                break;
	            case 3:
	                callback(args[0], args[1], args[2]);
	                break;
	            default:
	                callback.apply(undefined, args);
	                break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function registerImmediate(handle) {
	            process.nextTick(function () {
	                runIfPresent(handle);
	            });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function () {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function onGlobalMessage(event) {
	            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function registerImmediate(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function (event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function registerImmediate(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function registerImmediate(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function registerImmediate(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(50)))

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate(fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config(name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(41).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding || function (encoding) {
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function (encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function (buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = buffer.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function (buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = buffer.length >= 3 ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function (buffer) {
	  var res = '';
	  if (buffer && buffer.length) res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(54);
	
	/*<replacement>*/
	var util = __webpack_require__(52);
	util.inherits = __webpack_require__(47);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er) {
	      done(stream, er);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	function done(stream, er) {
	  if (er) return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(60);
	
	/*<replacement>*/
	var util = __webpack_require__(52);
	util.inherits = __webpack_require__(47);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(55);

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(54);

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(60);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(61);

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	"use strict";
	
	// Generated by CoffeeScript 1.12.7
	(function () {
	  "use strict";
	
	  exports.stripBOM = function (str) {
	    if (str[0] === "\uFEFF") {
	      return str.substring(1);
	    } else {
	      return str;
	    }
	  };
	}).call(undefined);

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	// Generated by CoffeeScript 1.12.7
	(function () {
	  "use strict";
	
	  var prefixMatch;
	
	  prefixMatch = new RegExp(/(?!xmlns)^.*:/);
	
	  exports.normalize = function (str) {
	    return str.toLowerCase();
	  };
	
	  exports.firstCharLowerCase = function (str) {
	    return str.charAt(0).toLowerCase() + str.slice(1);
	  };
	
	  exports.stripPrefix = function (str) {
	    return str.replace(prefixMatch, '');
	  };
	
	  exports.parseNumbers = function (str) {
	    if (!isNaN(str)) {
	      str = str % 1 === 0 ? parseInt(str, 10) : parseFloat(str);
	    }
	    return str;
	  };
	
	  exports.parseBooleans = function (str) {
	    if (/^(?:true|false)$/i.test(str)) {
	      str = str.toLowerCase() === 'true';
	    }
	    return str;
	  };
	}).call(undefined);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by smizrahi on 7/26/16.
	 */
	/*eslint-disable no-undef*/
	var ConfigConverter = function () {
	    function ConfigConverter() {
	        _classCallCheck(this, ConfigConverter);
	    }
	
	    /**
	     * Convert the configuration from XML to JS using xml2js
	     *
	     * @param configurationRaw
	     * @returns {Promise} An array of parameters if success, an error if failed
	     */
	
	
	    _createClass(ConfigConverter, [{
	        key: 'convert',
	        value: function convert(configurationRaw) {
	            return new Promise(function (resolve, reject) {
	                if (configurationRaw && configurationRaw != '') {
	                    var parseString = __webpack_require__(14).parseString;
	                    // The option explicitChildren is used to avoid merging sub properties
	                    // Take a tour on https://github.com/Leonidas-from-XIV/node-xml2js documentation
	                    parseString(configurationRaw, {
	                        explicitChildren: true,
	                        preserveChildrenOrder: true,
	                        attrkey: 'attr',
	                        childkey: 'child',
	                        charkey: 'val',
	                        trim: true
	                    }, function (err, result) {
	                        if (err) {
	                            reject(Error(err.message, 1001));
	                        } else {
	                            resolve(result);
	                        }
	                    });
	                } else {
	                    reject(Error('Empty configuration downloaded', 1000));
	                }
	            });
	        }
	    }]);
	
	    return ConfigConverter;
	}();
	
	exports.default = ConfigConverter;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by smizrahi on 7/26/16.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _EQError = __webpack_require__(6);
	
	var _EQError2 = _interopRequireDefault(_EQError);
	
	var _Config = __webpack_require__(70);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _ConfigGps = __webpack_require__(72);
	
	var _ConfigGps2 = _interopRequireDefault(_ConfigGps);
	
	var _ConfigScenario = __webpack_require__(71);
	
	var _ConfigScenario2 = _interopRequireDefault(_ConfigScenario);
	
	var _ConfigStepPause = __webpack_require__(73);
	
	var ConfigStepPauseConst = _interopRequireWildcard(_ConfigStepPause);
	
	var _ConfigStepMscore = __webpack_require__(74);
	
	var _ConfigStepMscore2 = _interopRequireDefault(_ConfigStepMscore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Global config
	var CAMPAIGN_ID = 'campaignid';
	var PORTAL_URL = 'portalurl';
	var GROUP_ID = 'groupid';
	var CONF_VERSION = 'version';
	var REFRESH_INTERVAL = 'interval';
	var GLOBAL_GPS = 'gps';
	var GLOBAL_GPS_ENABLED = 'enable';
	var GLOBAL_GPS_GEOCODING = 'geocoding';
	var GLOBAL_GPS_GEOCODING_ENABLED = 'enable';
	
	// Chained test
	var CHAINED_TESTS = 'chainedtests';
	var CHAINED_TESTS_OCM = 'ocm';
	var CHAINED_TESTS_OCM_ITEM = 'chainedtest';
	var CHAINED_TESTS_OCM_ITEM_ITERATION = 'iteration';
	var CHAINED_TESTS_OCM_ITEM_LABEL = 'label';
	var CHAINED_TESTS_OCM_ITEM_GPS = 'gps';
	var CHAINED_TESTS_OCM_ITEM_GPS_ENABLED = 'enable';
	var CHAINED_TESTS_OCM_ITEM_GPS_SEARCHTIME = 'searchtime';
	var CHAINED_TESTS_OCM_ITEM_GPS_ACCURACY = 'accuracy';
	var CHAINED_TESTS_OCM_ITEM_STEPS = 'steps';
	
	// Pause step
	var SCENARIO_STEP_PAUSE = 'pause';
	var SCENARIO_STEP_PAUSE_PERIOD = 'period';
	
	// mScore step
	var SCENARIO_STEP_SHOOTER = 'shooterstep';
	var SCENARIO_STEP_SCORING = 'scoringstep';
	var SCENARIO_STEP_MSCORE_INFO_URL = 'url';
	var SCENARIO_STEP_MSCORE_INFO_MODULE = 'module';
	var SCENARIO_STEP_MSCORE_PARAMS_KEY = 'key';
	
	var ConfigParser = function () {
	    function ConfigParser() {
	        _classCallCheck(this, ConfigParser);
	    }
	
	    /**
	     * Parse the configuration from JS object
	     *
	     * @param configurationJs
	     * @returns {Promise} An array of parameters if success, an error if failed
	     */
	
	
	    _createClass(ConfigParser, [{
	        key: 'parse',
	        value: function parse(configurationJs) {
	            return new Promise(function (resolve, reject) {
	                if (configurationJs && configurationJs != '') {
	                    _Logger2.default.log('Parsing configuration');
	
	                    var configParsed = configurationJs.response.configuration[0];
	
	                    // Campaign Id
	                    var campaignId = configParsed.attr[CAMPAIGN_ID];
	
	                    // Group id
	                    var groupId = configParsed.attr[GROUP_ID];
	
	                    // Conf version
	                    var confVersion = configParsed.attr[CONF_VERSION];
	
	                    // Refresh config interval
	                    var refreshConfigInterval = configParsed.attr[REFRESH_INTERVAL];
	
	                    // Portal url
	                    var portalUrl = configParsed.attr[PORTAL_URL];
	
	                    // Global GPS
	                    var globalGpsConfig = null;
	                    if (configParsed[GLOBAL_GPS]) {
	                        var globalGpsEnabled = configParsed[GLOBAL_GPS][0].attr[GLOBAL_GPS_ENABLED];
	                        // Reverse geocoding
	                        var globalGeocodingEnabled = null;
	                        if (configParsed[GLOBAL_GPS][0][GLOBAL_GPS_GEOCODING]) {
	                            globalGeocodingEnabled = configParsed[GLOBAL_GPS][0][GLOBAL_GPS_GEOCODING][0].attr[GLOBAL_GPS_GEOCODING_ENABLED];
	                        }
	
	                        globalGpsConfig = new _ConfigGps2.default(globalGpsEnabled, globalGeocodingEnabled);
	                    }
	
	                    // Picking needed scenarios depending on chained test configuration
	                    var chainedTestsScenarios = new Array();
	                    if (configParsed[CHAINED_TESTS]) {
	                        if (configParsed[CHAINED_TESTS][0][CHAINED_TESTS_OCM]) {
	                            var rootChainedTest = configParsed[CHAINED_TESTS][0][CHAINED_TESTS_OCM][0];
	
	                            if (rootChainedTest) {
	                                var chainedTestId = 0;
	                                rootChainedTest.child.forEach(function (chainedTestItem) {
	                                    if (chainedTestItem['#name'] == CHAINED_TESTS_OCM_ITEM) {
	                                        var chainedTestIterations = chainedTestItem.attr[CHAINED_TESTS_OCM_ITEM_ITERATION];
	
	                                        // EWA-30 : Aggregate GPS Configuration enabled
	                                        var scenarioGpsConfigEnabled = false;
	                                        if (globalGpsConfig.enabled) {
	                                            var scenarioGpsConfigEnabledItem = chainedTestItem[CHAINED_TESTS_OCM_ITEM_GPS][0].attr[CHAINED_TESTS_OCM_ITEM_GPS_ENABLED];
	                                            if (typeof scenarioGpsConfigEnabledItem !== "boolean") {
	                                                // Convert as boolean
	                                                scenarioGpsConfigEnabledItem = scenarioGpsConfigEnabledItem === 'true';
	                                            }
	                                            if (scenarioGpsConfigEnabledItem) scenarioGpsConfigEnabled = true;
	                                        }
	
	                                        var chainedTestGpsConfig = new _ConfigGps2.default(scenarioGpsConfigEnabled, globalGpsConfig.geocodingEnabled, chainedTestItem[CHAINED_TESTS_OCM_ITEM_GPS][0].attr[CHAINED_TESTS_OCM_ITEM_GPS_SEARCHTIME], chainedTestItem[CHAINED_TESTS_OCM_ITEM_GPS][0].attr[CHAINED_TESTS_OCM_ITEM_GPS_ACCURACY]);
	
	                                        var chainedTestLabel = null;
	                                        if (chainedTestItem[CHAINED_TESTS_OCM_ITEM_LABEL][0]) {
	                                            chainedTestLabel = chainedTestItem[CHAINED_TESTS_OCM_ITEM_LABEL][0];
	                                        }
	
	                                        // Steps
	                                        var steps = new Array();
	                                        var skipNextStep = false;
	                                        var chainedTest = chainedTestItem[CHAINED_TESTS_OCM_ITEM_STEPS][0];
	                                        if (chainedTest) {
	                                            chainedTest.child.forEach(function (step) {
	                                                var supportedStep = false;
	
	                                                // Pause step
	                                                // BR : Iteration pause is put at the end and should never been skipped !
	                                                if (step['#name'] == SCENARIO_STEP_PAUSE && (!skipNextStep || step == chainedTest.child[chainedTest.child.length - 1])) {
	                                                    steps.push(new ConfigStepPauseConst.default(step.attr[SCENARIO_STEP_PAUSE_PERIOD]));
	                                                    supportedStep = true;
	                                                }
	
	                                                // mScore step
	                                                if (step['#name'] === SCENARIO_STEP_SHOOTER || step['#name'] === SCENARIO_STEP_SCORING) {
	                                                    var mScoreModule = null;
	
	                                                    if (step.attr && step.attr[SCENARIO_STEP_MSCORE_INFO_MODULE]) {
	                                                        mScoreModule = step.attr[SCENARIO_STEP_MSCORE_INFO_MODULE];
	                                                    }
	
	                                                    // Parsing mScore urls
	                                                    var servers = [];
	
	                                                    step.mscoreservers[0].mscoreserver.forEach(function (mScoreServer) {
	                                                        servers.push(mScoreServer.attr[SCENARIO_STEP_MSCORE_INFO_URL]);
	                                                    });
	
	                                                    var params = {};
	                                                    // Parsing mScore parameters
	                                                    step.parameter.forEach(function (mScoreParam) {
	                                                        params[mScoreParam.attr[SCENARIO_STEP_MSCORE_PARAMS_KEY]] = mScoreParam.val;
	                                                    });
	
	                                                    steps.push(new _ConfigStepMscore2.default(servers, params, mScoreModule, portalUrl));
	                                                    supportedStep = true;
	                                                }
	
	                                                // BR : If step is not supported or not the last step, we have to remove the next pause step
	                                                skipNextStep = !supportedStep ? true : false;
	                                            });
	                                        }
	
	                                        // BR : If the last step and step just before are a pause, delete this step
	                                        if (steps.length > 1) {
	                                            var lastStep = steps[steps.length - 1];
	                                            if (lastStep.type == ConfigStepPauseConst.STEP_PAUSE_TYPE && steps[steps.length - 2].type == ConfigStepPauseConst.STEP_PAUSE_TYPE) {
	                                                steps.splice(steps.length - 2, 1);
	                                            }
	
	                                            // BR : If only one iteration and last step is a pause, delete the last step
	                                            if (chainedTestIterations == 1 && lastStep.type == ConfigStepPauseConst.STEP_PAUSE_TYPE) {
	                                                steps.pop();
	                                            }
	                                        }
	
	                                        // BR : If the first step is a pause, removed it
	                                        if (steps.length > 0) {
	                                            if (steps[0].type == ConfigStepPauseConst.STEP_PAUSE_TYPE) {
	                                                steps.splice(0, 1);
	                                            }
	                                        }
	
	                                        // BR : If no steps in the script, don't add the scenario
	                                        if (steps.length > 0) {
	                                            chainedTestsScenarios.push(new _ConfigScenario2.default(steps, chainedTestGpsConfig, chainedTestId, chainedTestLabel, chainedTestIterations));
	                                        }
	                                    }
	                                    chainedTestId++;
	                                });
	                            }
	                        }
	                    }
	
	                    var config = new _Config2.default(campaignId, confVersion, refreshConfigInterval, globalGpsConfig, chainedTestsScenarios, groupId);
	                    resolve(config);
	                } else {
	                    reject(new _EQError2.default('Empty configuration downloaded', 1100));
	                }
	            });
	        }
	    }]);
	
	    return ConfigParser;
	}();
	
	exports.default = ConfigParser;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by mmaillot on 7/21/16.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _ConfigScenario = __webpack_require__(71);
	
	var _ConfigScenario2 = _interopRequireDefault(_ConfigScenario);
	
	var _ConfigGps = __webpack_require__(72);
	
	var _ConfigGps2 = _interopRequireDefault(_ConfigGps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Config = function () {
	    function Config(campaignId, confVersion) {
	        var refreshConfigInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3600;
	        var gpsConfig = arguments[3];
	        var scenarios = arguments[4];
	        var groupId = arguments[5];
	
	        _classCallCheck(this, Config);
	
	        this.campaignId = campaignId;
	        this.confVersion = parseInt(confVersion);
	        this.refreshConfigInterval = parseInt(refreshConfigInterval);
	        this.gpsConfig = gpsConfig;
	        this.scenarios = scenarios;
	        if (groupId) {
	            this.groupId = groupId;
	        } else {
	            this.groupId = 0;
	        }
	        Object.freeze(this);
	    }
	
	    _createClass(Config, null, [{
	        key: 'restore',
	        value: function restore(obj) {
	            var scenarios = [];
	            obj.scenarios.forEach(function (s) {
	                scenarios.push(_ConfigScenario2.default.restore(s));
	            });
	
	            return new Config(obj.campaignId, obj.confVersion, obj.refreshConfigInterval, _ConfigGps2.default.restore(obj.gpsConfig), scenarios, obj.groupId);
	        }
	    }]);
	
	    return Config;
	}();
	
	exports.default = Config;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by smizrahi on 7/27/16.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	// Class
	
	
	// Const
	
	
	var _ConfigGps = __webpack_require__(72);
	
	var _ConfigGps2 = _interopRequireDefault(_ConfigGps);
	
	var _ConfigStepPause = __webpack_require__(73);
	
	var StepPause = _interopRequireWildcard(_ConfigStepPause);
	
	var _ConfigStepMscore = __webpack_require__(74);
	
	var StepMscore = _interopRequireWildcard(_ConfigStepMscore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConfigScenario = function () {
	    function ConfigScenario(steps, gpsConfig, chainedTestId, label, iterations) {
	        _classCallCheck(this, ConfigScenario);
	
	        this.steps = steps;
	        this.gpsConfig = gpsConfig;
	        this.chainedTestId = parseInt(chainedTestId);
	        this.iterations = parseInt(iterations);
	        this.label = label;
	        Object.freeze(this);
	    }
	
	    _createClass(ConfigScenario, null, [{
	        key: 'restore',
	        value: function restore(obj) {
	            var steps = new Array();
	            obj.steps.forEach(function (s) {
	                if (s.type == StepPause.STEP_PAUSE_TYPE) steps.push(StepPause.default.restore(s));
	                if (s.type == StepMscore.STEP_MSCORE_TYPE) steps.push(StepMscore.default.restore(s));
	            });
	
	            return new ConfigScenario(steps, _ConfigGps2.default.restore(obj.gpsConfig), obj.chainedTestId, obj.label, obj.iterations);
	        }
	    }]);
	
	    return ConfigScenario;
	}();
	
	exports.default = ConfigScenario;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by smizrahi on 7/29/16.
	 */
	
	var ConfigGps = function () {
	    function ConfigGps() {
	        var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var geocodingEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var searchTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
	        var accuracy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
	
	        _classCallCheck(this, ConfigGps);
	
	        if (typeof enabled === "boolean") {
	            this.enabled = enabled;
	        } else {
	            this.enabled = enabled === 'true';
	        }
	
	        if (typeof geocodingEnabled === "boolean") {
	            this.geocodingEnabled = geocodingEnabled;
	        } else {
	            this.geocodingEnabled = geocodingEnabled === 'true';
	        }
	
	        this.searchTime = parseInt(searchTime);
	        this.accuracy = parseInt(accuracy);
	        Object.freeze(this);
	    }
	
	    _createClass(ConfigGps, null, [{
	        key: "restore",
	        value: function restore(obj) {
	            return new ConfigGps(obj.enabled, obj.geocodingEnabled, obj.searchTime, obj.accuracy);
	        }
	    }]);
	
	    return ConfigGps;
	}();
	
	exports.default = ConfigGps;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by smizrahi on 7/27/16.
	 */
	
	var STEP_PAUSE_TYPE = exports.STEP_PAUSE_TYPE = 'pause';
	
	var ConfigStepPause = function () {
	    function ConfigStepPause(pause) {
	        _classCallCheck(this, ConfigStepPause);
	
	        this.type = STEP_PAUSE_TYPE;
	        this.pause = parseInt(pause);
	        Object.freeze(this);
	    }
	
	    _createClass(ConfigStepPause, null, [{
	        key: 'restore',
	        value: function restore(obj) {
	            return new ConfigStepPause(obj.pause);
	        }
	    }]);
	
	    return ConfigStepPause;
	}();
	
	exports.default = ConfigStepPause;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by smizrahi on 7/27/16.
	 */
	
	var STEP_MSCORE_TYPE = exports.STEP_MSCORE_TYPE = 'mscore';
	
	var STEP_DIRECTION_DL = exports.STEP_DIRECTION_DL = 'download';
	var STEP_DIRECTION_UP = exports.STEP_DIRECTION_UP = 'upload';
	
	var ConfigStepMscore = function () {
	    function ConfigStepMscore(servers, params, module, portalUrl) {
	        _classCallCheck(this, ConfigStepMscore);
	
	        this.type = STEP_MSCORE_TYPE;
	        this.params = params;
	        /**
	         * @type {string}
	         */
	        this.portalUrl = portalUrl;
	        /**
	         * @type {array}
	         */
	        this.servers = servers;
	        if (module) {
	            this.module = parseInt(module);
	        } else {
	            this.module = null;
	        }
	
	        Object.freeze(params);
	        Object.freeze(this);
	    }
	
	    /**
	     * @return {string} the direction
	     */
	
	
	    _createClass(ConfigStepMscore, [{
	        key: 'getDirection',
	        value: function getDirection() {
	            if (parseInt(this.params.da_direction) === 1) {
	                return STEP_DIRECTION_UP;
	            }
	            return STEP_DIRECTION_DL;
	        }
	
	        /**
	         * @return {Number} the service id
	         */
	
	    }, {
	        key: 'getService',
	        value: function getService() {
	            return parseInt(this.params.da_service);
	        }
	
	        /**
	         * @return {number} the socket count
	         */
	
	    }, {
	        key: 'getSocketCount',
	        value: function getSocketCount() {
	            if (this.params.nbsocket) {
	                var nbSocket = parseInt(this.params.nbsocket);
	                if (nbSocket > 5) nbSocket = 5; // Fix max socket to 5
	                return nbSocket;
	            }
	            return 1;
	        }
	
	        /**
	         *
	         * @return {number} the volume in bytes
	         */
	
	    }, {
	        key: 'getVolume',
	        value: function getVolume() {
	            return parseInt(this.params.volume);
	        }
	
	        /**
	         * @return {number} the timeout in ms
	         */
	
	    }, {
	        key: 'getTimeout',
	        value: function getTimeout() {
	
	            if (this.params.da_service == 4) {
	                // Scoring
	                return parseInt(this.params.emodel_duration) + (this.params.logsextratime ? parseInt(this.params.logsextratime) : 0);
	            } else {
	                // Other
	                return parseInt(this.params.timeout) + (this.params.logsextratime ? parseInt(this.params.logsextratime) : 0);
	            }
	        }
	
	        /**
	         * @return {int} the port
	         */
	
	    }, {
	        key: 'getPort',
	        value: function getPort() {
	            return parseInt(this.params.port);
	        }
	
	        /**
	         * @return {Boolean} true if logs are enabled
	         */
	
	    }, {
	        key: 'isLogEnabled',
	        value: function isLogEnabled() {
	            return this.params.logs === 'yes';
	        }
	
	        /**
	         * @return {int} the module
	         */
	
	    }, {
	        key: 'getModule',
	        value: function getModule() {
	            return parseInt(this.module);
	        }
	
	        /**
	         * @return {string} the portal URL
	         */
	
	    }, {
	        key: 'getPortalUrl',
	        value: function getPortalUrl() {
	            return this.portalUrl;
	        }
	
	        /**
	         * @return {array} the params
	         */
	
	    }, {
	        key: 'getParams',
	        value: function getParams() {
	            return this.params;
	        }
	    }], [{
	        key: 'restore',
	        value: function restore(obj) {
	
	            return new ConfigStepMscore(obj.servers, obj.params, obj.module, obj.portalUrl);
	        }
	    }]);
	
	    return ConfigStepMscore;
	}();
	
	exports.default = ConfigStepMscore;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _Persistence2 = __webpack_require__(10);
	
	var _Persistence3 = _interopRequireDefault(_Persistence2);
	
	var _Config = __webpack_require__(70);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by smizrahi on 8/1/16.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CONFIG_KEY = 'EQCONFIG';
	var CONFIG_NEXT_CHECK_KEY = 'EQCONFIG_NEXT_CHECK';
	var CONFIG_COUPON = 'EQCONFIG_COUPON';
	var CONFIG_VERSION = 'EQCONFIG_VERSION';
	
	var ConfigPersist = function (_Persistence) {
	    _inherits(ConfigPersist, _Persistence);
	
	    function ConfigPersist() {
	        _classCallCheck(this, ConfigPersist);
	
	        return _possibleConstructorReturn(this, (ConfigPersist.__proto__ || Object.getPrototypeOf(ConfigPersist)).call(this));
	    }
	
	    /**
	     * Save a configuration into local storage
	     *
	     * @param config
	     */
	
	
	    _createClass(ConfigPersist, [{
	        key: "saveConfig",
	        value: function saveConfig(config, version) {
	            this.set(CONFIG_KEY, JSON.stringify(config));
	            this.set(CONFIG_VERSION, version);
	        }
	
	        /**
	         * Get the configuration from local storage
	         *
	         * @returns {*} A configuration
	         */
	
	    }, {
	        key: "loadConfig",
	        value: function loadConfig() {
	            _Logger2.default.log("Loading config from cache :");
	            var c = this.get(CONFIG_KEY);
	            if (c) {
	                var config = _Config2.default.restore(JSON.parse(c));
	                _Logger2.default.log(config);
	                return config;
	            } else {
	                _Logger2.default.log("No config in cache");
	            }
	        }
	
	        /**
	         * Get the configuration web service version of persisted config
	         *
	         * @returns {Number} The configuration web service version
	         */
	
	    }, {
	        key: "loadVersion",
	        value: function loadVersion() {
	            var v = this.get(CONFIG_VERSION);
	            if (v) {
	                return parseInt(v);
	            }
	
	            return null;
	        }
	
	        /**
	         * Save the timestamp where configuration should be next checked into local storage
	         *
	         * @param timestamp
	         */
	
	    }, {
	        key: "saveNextCheckDate",
	        value: function saveNextCheckDate(timestamp) {
	            this.set(CONFIG_NEXT_CHECK_KEY, timestamp);
	        }
	
	        /**
	         * Get the timestamp where configuration should be next checked
	         *
	         * @returns {Number} The next check config timestamp
	         */
	
	    }, {
	        key: "loadNextCheckDate",
	        value: function loadNextCheckDate() {
	            var c = this.get(CONFIG_NEXT_CHECK_KEY);
	            if (c) {
	                return parseInt(JSON.parse(c));
	            } else {
	                _Logger2.default.log("No config next check date in cache");
	            }
	        }
	
	        /**
	         * Save the last coupon used to update config (can be null)
	         *
	         * @param {string|null} coupon the coupon to save
	         */
	
	    }, {
	        key: "saveCoupon",
	        value: function saveCoupon(coupon) {
	            this.set(CONFIG_COUPON, coupon);
	        }
	
	        /**
	         * Get the last coupon used to update config
	         *
	         * @returns {string|null} the last coupon used, can be null
	         */
	
	    }, {
	        key: "loadCoupon",
	        value: function loadCoupon() {
	            var c = this.get(CONFIG_COUPON);
	            if (c) {
	                return c;
	            } else {
	                _Logger2.default.log("No coupon in cache");
	            }
	        }
	
	        /**
	         * Delete configuration informations
	         */
	
	    }, {
	        key: "clearConfigurationData",
	        value: function clearConfigurationData() {
	            this.delete(CONFIG_KEY);
	            this.delete(CONFIG_NEXT_CHECK_KEY);
	            this.delete(CONFIG_VERSION);
	        }
	    }]);
	
	    return ConfigPersist;
	}(_Persistence3.default);
	
	exports.default = ConfigPersist;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _Persistence2 = __webpack_require__(10);
	
	var _Persistence3 = _interopRequireDefault(_Persistence2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by smizrahi on 8/17/16.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var UID_KEY = 'UID';
	
	var UIDGeneratorPersist = function (_Persistence) {
	    _inherits(UIDGeneratorPersist, _Persistence);
	
	    function UIDGeneratorPersist() {
	        _classCallCheck(this, UIDGeneratorPersist);
	
	        return _possibleConstructorReturn(this, (UIDGeneratorPersist.__proto__ || Object.getPrototypeOf(UIDGeneratorPersist)).call(this, true)); // True is set to enable cookies fallback
	    }
	
	    /**
	     * Save the UID into local storage or cookie
	     *
	     * @param uid
	     */
	
	
	    _createClass(UIDGeneratorPersist, [{
	        key: "saveUID",
	        value: function saveUID(uid) {
	            this.set(UID_KEY, uid);
	        }
	
	        /**
	         * Load the UID from local storage or cookie
	         *
	         * @returns {*} The UID
	         */
	
	    }, {
	        key: "loadUID",
	        value: function loadUID() {
	            var uid = this.get(UID_KEY);
	            _Logger2.default.log("Loading UID from cache : " + uid);
	            return uid;
	        }
	    }]);
	
	    return UIDGeneratorPersist;
	}(_Persistence3.default);
	
	exports.default = UIDGeneratorPersist;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by smizrahi on 8/17/16.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SEED_LENGTH = 256;
	var SEED_SHORT_LENGTH = 128;
	
	var UIDGenerator = function () {
	    function UIDGenerator(persistence, security) {
	        _classCallCheck(this, UIDGenerator);
	
	        _Logger2.default.log('UID Generator init');
	        this.persistence = persistence;
	        this.security = security;
	
	        var uid = this.persistence.loadUID();
	        if (uid) {
	            this.uid = uid;
	        } else {
	            // Generates an UID
	            var deviceID = this.security.generateDeviceID();
	            if (!deviceID) {
	                // If no device ID, generates a random seed
	                deviceID = this.security.md5(this.security.generateSeed(SEED_LENGTH));
	            }
	            // UID is a md5 combination of device ID and a short random seed
	            this.uid = this.security.md5(deviceID + this.security.generateSeed(SEED_SHORT_LENGTH));
	            // Saves the UID into local storage or cookie
	            this.persistence.saveUID(this.uid);
	        }
	        _Logger2.default.log('UID : ' + this.uid);
	    }
	
	    /**
	     * Gives the UID of client
	     *
	     * @returns {*}
	     */
	
	
	    _createClass(UIDGenerator, [{
	        key: 'getUID',
	        value: function getUID() {
	            return this.uid;
	        }
	
	        /**
	         * Generates a session ID (SID)
	         * A SID is the UID appending current timestamp in milliseconds
	         *
	         * @returns {string}
	         */
	
	    }, {
	        key: 'getSID',
	        value: function getSID() {
	            return this.uid + '-' + Math.round(new Date().getTime());
	        }
	    }]);
	
	    return UIDGenerator;
	}();
	
	exports.default = UIDGenerator;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Service2 = __webpack_require__(4);
	
	var _Service3 = _interopRequireDefault(_Service2);
	
	var _ScriptEngine = __webpack_require__(79);
	
	var ScriptConst = _interopRequireWildcard(_ScriptEngine);
	
	var _EQScript = __webpack_require__(114);
	
	var _EQScript2 = _interopRequireDefault(_EQScript);
	
	var _StepConfigFactory = __webpack_require__(109);
	
	var _StepConfigFactory2 = _interopRequireDefault(_StepConfigFactory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Manage scripts
	 */
	var ScriptService = function (_Service) {
	    _inherits(ScriptService, _Service);
	
	    /**
	     * Default constructor
	     *
	     * @param {number} uid
	     * @param {Config} configuration
	     * @param {GpsService} gpsService
	     * @param {DeviceService} deviceService
	     * @param {GatewayService} gatewayService
	     */
	    function ScriptService(uid, configuration, gpsService, deviceService, gatewayService) {
	        _classCallCheck(this, ScriptService);
	
	        var _this = _possibleConstructorReturn(this, (ScriptService.__proto__ || Object.getPrototypeOf(ScriptService)).call(this));
	
	        _this.uid = uid;
	        _this.configuration = configuration;
	        _this.scripts = new Map();
	        _this.gpsService = gpsService;
	        _this.deviceService = deviceService;
	        _this.gatewayService = gatewayService;
	        return _this;
	    }
	
	    /**
	     * Public API to get all scripts available
	     *
	     * @return {Array} list of scripts from the config (with less information for UI)
	     */
	
	
	    _createClass(ScriptService, [{
	        key: "getScripts",
	        value: function getScripts() {
	            var scripts = [];
	            if (this.configuration.scenarios) {
	                this.configuration.scenarios.forEach(function (scenario) {
	
	                    // Fix EWA-31
	                    var steps = new Array();
	                    if (scenario.steps) {
	                        scenario.steps.forEach(function (step) {
	                            var s = _StepConfigFactory2.default.getStepPublicConfig(step);
	                            steps.push(s);
	                        });
	                    }
	
	                    // Fix EWA-30
	                    var gpsEnabled = false;
	                    if (scenario.gpsConfig) {
	                        gpsEnabled = scenario.gpsConfig.enabled;
	                    }
	
	                    scripts.push(new _EQScript2.default(scenario.chainedTestId, scenario.label, scenario.iterations, steps, gpsEnabled));
	                });
	            }
	            return scripts;
	        }
	
	        /**
	         * Public API to start a new script
	         *
	         * @param {number} key the script key from config
	         * @param {function} callback the callback for progression
	         * @param {Map<string,string>} customFields A map of custom fields
	         */
	
	    }, {
	        key: "startScript",
	        value: function startScript(key, callback, customFields) {
	            var scriptEngine = this.scripts.get(key);
	            if (scriptEngine && scriptEngine.running) {
	                callback(ScriptConst.SCRIPT_FAILED, ScriptConst.NOT_AVAILABLE, "Script is already running");
	            } else {
	                var scenario = this.foundScenario(this.configuration, key);
	                if (scenario) {
	                    var deviceManager = this.deviceService.manager;
	
	                    // Refresh IP
	                    deviceManager.retrievePrivateIpAddress();
	
	                    scriptEngine = new ScriptConst.default(this.uid, this.configuration.campaignId, scenario, this.gpsService.gpsManager, deviceManager, callback, customFields, this.configuration.groupId, this.gatewayService);
	
	                    this.scripts.set(key, scriptEngine);
	                    scriptEngine.start();
	                } else {
	                    callback(ScriptConst.SCRIPT_FAILED, ScriptConst.NOT_AVAILABLE, "Scenario not found, the configuration has changed, reload it");
	                }
	            }
	        }
	
	        /**
	         * Public API to stop a running script
	         *
	         * @param {number} key the script key from config
	         * @return {boolean} if test will stop, false otherwise
	         */
	
	    }, {
	        key: "stopScript",
	        value: function stopScript(key) {
	            var scriptEngine = this.scripts.get(key);
	            if (!scriptEngine || !scriptEngine.running) {
	                return false;
	            }
	            return scriptEngine.stop();
	        }
	
	        /**
	         * Stop all scripts
	         */
	
	    }, {
	        key: "stopAll",
	        value: function stopAll() {
	            var _this2 = this;
	
	            this.scripts.forEach(function (value, key) {
	                _this2.stopScript(key);
	            });
	        }
	
	        /**
	         * Search the scenario from config with the key
	         *
	         * @param {Config} configuration the server config
	         * @param {number} key the scenario key
	         * @return {ConfigScenario} the scenario if found, null otherwise
	         */
	
	    }, {
	        key: "foundScenario",
	        value: function foundScenario(configuration, key) {
	            var tmp = null;
	            configuration.scenarios.forEach(function (scenario) {
	                if (scenario.chainedTestId === key) {
	                    tmp = scenario;
	                }
	            });
	            return tmp;
	        }
	    }]);
	
	    return ScriptService;
	}(_Service3.default);
	
	exports.default = ScriptService;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NOT_AVAILABLE = exports.SCRIPT_DONE = exports.ITERATION_DONE = exports.STEP_DONE = exports.STEP_PROGRESS = exports.STEP_STARTED = exports.ITERATION_STARTED = exports.SCRIPT_STARTED = exports.SCRIPT_FAILED = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StepExecutorFactory = __webpack_require__(80);
	
	var _StepExecutorFactory2 = _interopRequireDefault(_StepExecutorFactory);
	
	var _StepConfigFactory = __webpack_require__(109);
	
	var _StepConfigFactory2 = _interopRequireDefault(_StepConfigFactory);
	
	var _DateUtil = __webpack_require__(8);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _GpsManagerWrapper = __webpack_require__(112);
	
	var _GpsManagerWrapper2 = _interopRequireDefault(_GpsManagerWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SCRIPT_FAILED = exports.SCRIPT_FAILED = 'SCRIPT_FAILED';
	var SCRIPT_STARTED = exports.SCRIPT_STARTED = 'SCRIPT_STARTED';
	var ITERATION_STARTED = exports.ITERATION_STARTED = 'ITERATION_STARTED';
	var STEP_STARTED = exports.STEP_STARTED = 'STEP_STARTED';
	var STEP_PROGRESS = exports.STEP_PROGRESS = 'STEP_PROGRESS';
	var STEP_DONE = exports.STEP_DONE = 'STEP_DONE';
	var ITERATION_DONE = exports.ITERATION_DONE = 'ITERATION_DONE';
	var SCRIPT_DONE = exports.SCRIPT_DONE = 'SCRIPT_DONE';
	
	var NOT_AVAILABLE = exports.NOT_AVAILABLE = -1;
	
	/**
	 * Run a specific script
	 */
	
	var ScriptEngine = function () {
	
	    /**
	     *
	     * @param {string} uid the unique id
	     * @param {number} campaignId from config
	     * @param {ConfigScenario} scenario the scenario config
	     * @param {GpsManager} gpsManager the GPS manager to collect location
	     * @param {DeviceManager} deviceManager the device manager to collect device informations
	     * @param {function} callback the callback
	     * @param {Map<string,string>} customFields A map of custom fields
	     * @param {number} group identifier
	     * @param {GatewayService} gateway service
	     */
	    function ScriptEngine(uid, campaignId, scenario, gpsManager, deviceManager, callback, customFields, groupId, gatewayService) {
	        _classCallCheck(this, ScriptEngine);
	
	        this.uid = uid;
	        this.campaignId = campaignId;
	        this.scenario = scenario;
	        this.scenarioId = _DateUtil2.default.getCurrentTimestamp();
	        this.running = false;
	        this.cancelled = false;
	        this.gpsManager = gpsManager;
	        this.deviceManager = deviceManager;
	        this.gatewayService = gatewayService;
	
	        if (callback) {
	            this.callback = callback;
	        } else {
	            this.callback = function () {};
	        }
	        this.stepExecutor = null;
	        this.customFields = customFields;
	        this.groupId = groupId;
	    }
	
	    /**
	     * Start the script
	     */
	
	
	    _createClass(ScriptEngine, [{
	        key: "start",
	        value: function start() {
	            if (this.running) {
	                this.callback(SCRIPT_FAILED, NOT_AVAILABLE, "Script already started");
	                return;
	            }
	            if (this.scenario.steps.length === 0) {
	                this.callback(SCRIPT_FAILED, NOT_AVAILABLE, "No step to run");
	                return;
	            }
	            this.running = true;
	            this.callback(SCRIPT_STARTED);
	            this.runIteration(this.scenario);
	        }
	
	        /**
	         * Run a new iteration
	         * @param {ConfigScenario} scenario the scenario config
	         * @param {number} iteration the iteration index
	         */
	
	    }, {
	        key: "runIteration",
	        value: function runIteration(scenario) {
	            var iteration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	            if (this.cancelled) {
	                this.testDone();
	                return;
	            }
	            if (scenario.iterations > 0 && iteration >= scenario.iterations) {
	                // No more iteration, script is done
	                this.testDone();
	                return;
	            }
	            this.callback(ITERATION_STARTED, iteration);
	            this.runStep(scenario, iteration);
	        }
	
	        /**
	         * Run a new step
	         * @param {ConfigScenario} scenario the scenario config
	         * @param {number} iteration the iteration index
	         * @param {number} step the step index
	         */
	
	    }, {
	        key: "runStep",
	        value: function runStep(scenario, iteration) {
	            var _this = this;
	
	            var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	            if (this.cancelled) {
	                this.testDone();
	                return;
	            }
	            if (step > scenario.steps.length) {
	                // Start the next iteration
	                this.callback(ITERATION_DONE, iteration);
	                this.runIteration(scenario, iteration + 1);
	                return;
	            }
	            this.stepExecutor = this.getStepExecutor(scenario, step);
	            if (!this.stepExecutor) {
	                this.runStep(scenario, iteration, step + 1);
	                return;
	            }
	            this.callback(STEP_STARTED, step, _StepConfigFactory2.default.getStepPublicConfig(scenario.steps[step]));
	            this.stepExecutor.start(function (data) {
	                _this.callback(STEP_PROGRESS, step, data);
	            }).then(function (result) {
	                _this.stepExecutor = null;
	                _this.callback(STEP_DONE, step, result);
	                _this.runStep(scenario, iteration, step + 1);
	            }).catch(function (error) {
	                _this.stepExecutor = null;
	                _this.callback(STEP_DONE, step, error);
	                _this.runStep(scenario, iteration, step + 1);
	            });
	        }
	    }, {
	        key: "testDone",
	        value: function testDone() {
	            this.running = false;
	            this.callback(SCRIPT_DONE);
	        }
	
	        /**
	         * Method only for unit test
	         *
	         * @param {ConfigScenario} scenario
	         * @param {number} stepIndex
	         */
	
	    }, {
	        key: "getStepExecutor",
	        value: function getStepExecutor(scenario, stepIndex) {
	            var stepConfig = scenario.steps[stepIndex];
	            return _StepExecutorFactory2.default.getStepExecutor(new _GpsManagerWrapper2.default(this.gpsManager, scenario.gpsConfig), this.deviceManager, stepConfig, this.uid, this.campaignId, this.scenarioId, this.customFields, this.groupId, this.gatewayService);
	        }
	
	        /**
	         * Stop the test
	         * @return {boolean} true if the test will be stopped, false if doesn't running or already cancelled
	         */
	
	    }, {
	        key: "stop",
	        value: function stop() {
	            if (this.running && !this.cancelled && this.stepExecutor.stop && this.stepExecutor.stop()) {
	                this.cancelled = true;
	                return true;
	            }
	            return false;
	        }
	    }]);
	
	    return ScriptEngine;
	}();
	
	exports.default = ScriptEngine;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfigStepPause = __webpack_require__(73);
	
	var _ConfigStepPause2 = _interopRequireDefault(_ConfigStepPause);
	
	var _ConfigStepMscore = __webpack_require__(74);
	
	var _ConfigStepMscore2 = _interopRequireDefault(_ConfigStepMscore);
	
	var _PauseStepExecutor = __webpack_require__(81);
	
	var _PauseStepExecutor2 = _interopRequireDefault(_PauseStepExecutor);
	
	var _MscoreStepExecutor = __webpack_require__(85);
	
	var _MscoreStepExecutor2 = _interopRequireDefault(_MscoreStepExecutor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Create step executor from config
	 */
	var StepExecutorFactory = function () {
	    function StepExecutorFactory() {
	        _classCallCheck(this, StepExecutorFactory);
	    }
	
	    _createClass(StepExecutorFactory, null, [{
	        key: "getStepExecutor",
	
	
	        /**
	         * @param {GpsManager} gpsManager
	         * @param {DeviceManager} deviceManager
	         * @param {ConfigStepPause | ConfigStepMscore} stepConfig
	         * @param {string} uid
	         * @param {number} campaignId from configuration
	         * @param {number} scenarioId identifier (should be the same for all step in a script)
	         * @param {Map<string,string>} customFields A map of custom fields
	         * @param {number} group identifier
	         * @param {GatewayService} gateway service
	         *
	         * @return {PauseStepExecutor | MscoreStepExecutor | null} null if no step executor available
	         */
	        value: function getStepExecutor(gpsManager, deviceManager, stepConfig, uid, campaignId, scenarioId, customFields, groupId, gatewayService) {
	            if (stepConfig instanceof _ConfigStepPause2.default) {
	                return new _PauseStepExecutor2.default(stepConfig);
	            } else if (stepConfig instanceof _ConfigStepMscore2.default) {
	                return new _MscoreStepExecutor2.default(gpsManager, deviceManager, stepConfig, uid, campaignId, scenarioId, customFields, groupId, gatewayService);
	            }
	
	            return null;
	        }
	    }]);
	
	    return StepExecutorFactory;
	}();
	
	exports.default = StepExecutorFactory;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StepExecutor2 = __webpack_require__(82);
	
	var _StepExecutor3 = _interopRequireDefault(_StepExecutor2);
	
	var _EQError = __webpack_require__(6);
	
	var Error = _interopRequireWildcard(_EQError);
	
	var _EQPauseStepProgress = __webpack_require__(83);
	
	var _EQPauseStepProgress2 = _interopRequireDefault(_EQPauseStepProgress);
	
	var _EQPauseStepDone = __webpack_require__(84);
	
	var _EQPauseStepDone2 = _interopRequireDefault(_EQPauseStepDone);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Represent a pause between two steps
	 */
	var PauseStepExecutor = function (_StepExecutor) {
	    _inherits(PauseStepExecutor, _StepExecutor);
	
	    /**
	     * @param {ConfigStepPause} configuration a {@link ConfigStepPause}
	     */
	    function PauseStepExecutor(configuration) {
	        _classCallCheck(this, PauseStepExecutor);
	
	        var _this = _possibleConstructorReturn(this, (PauseStepExecutor.__proto__ || Object.getPrototypeOf(PauseStepExecutor)).call(this, configuration));
	
	        _this.waitingTime = configuration.pause; // Use the config value
	        return _this;
	    }
	
	    _createClass(PauseStepExecutor, [{
	        key: "startInternal",
	        value: function startInternal(resolve, reject, progress) {
	            this.runSleep(resolve, reject, progress, this.waitingTime, this.waitingTime);
	        }
	
	        /**
	         * Run a sleep iteration
	         * @param {function} resolve resolver callback for a promise
	         * @param {function} reject rejected callback for a promise
	         * @param {function} progress alert each seconds with the current second
	         * @param {number} remainingTime in seconds
	         * @param {number} maxTime the maximum seconds to sleep
	         */
	
	    }, {
	        key: "runSleep",
	        value: function runSleep(resolve, reject, progress, remainingTime, maxTime) {
	            var _this2 = this;
	
	            if (this.isCancelled()) {
	                reject(new Error.default('Step is cancelled', Error.SCRIPT_STEP_CANCELLED));
	                return;
	            }
	            if (remainingTime == 0) {
	                // Pause is over
	                resolve(new _EQPauseStepDone2.default(maxTime));
	            } else {
	                // Alert progress with remainingTime
	                progress(new _EQPauseStepProgress2.default(maxTime, remainingTime));
	                this.sleep1second(remainingTime).then(function (result) {
	                    _this2.runSleep(resolve, reject, progress, result, maxTime);
	                });
	            }
	        }
	
	        /**
	         * Sleep during 1 seconds and resolve the promise with the arg - 1
	         * @param {number} arg the argument to decrease
	         * @returns {Promise} with the arg decrease by one when resolved
	         */
	
	    }, {
	        key: "sleep1second",
	        value: function sleep1second(arg) {
	            return new Promise(function (resolve) {
	                return setTimeout(function () {
	                    resolve(arg - 1);
	                }, 1000);
	            });
	        }
	    }, {
	        key: "stopInternal",
	        value: function stopInternal() {
	            // Manage from the runSleep method with the isStopped method
	            return true;
	        }
	    }]);
	
	    return PauseStepExecutor;
	}(_StepExecutor3.default);
	
	exports.default = PauseStepExecutor;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STEP_MSCORE = exports.STEP_PAUSE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _EQError = __webpack_require__(6);
	
	var EQError = _interopRequireWildcard(_EQError);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var STEP_PAUSE = exports.STEP_PAUSE = 'pause';
	var STEP_MSCORE = exports.STEP_MSCORE = 'mscore';
	
	/**
	 * Base class for each step executor.
	 * It uses promise to run the test on the start method.
	 *
	 * <b>/*\ SUBCLASS MUSTN'T OVERRIDE {@link StepExecutor#start} and {@link StepExecutor#stop} METHODS</b>
	 */
	
	var StepExecutor = function () {
	    function StepExecutor(configuration) {
	        _classCallCheck(this, StepExecutor);
	
	        this.configuration = configuration;
	        this.cancelled = false;
	        this.running = false;
	    }
	
	    /**
	     * Start the step
	     *
	     * /*\ DON'T OVERRIDE THIS METHOD, OVERRIDE {@link startInternal}
	     *
	     * @param {function} progress callback on step progress
	     *
	     * @return {Promise}
	     */
	
	
	    _createClass(StepExecutor, [{
	        key: 'start',
	        value: function start(progress) {
	            var _this = this;
	
	            return new Promise(function (resolve, reject) {
	                _this.running = true;
	                _this.startInternal(function (result) {
	                    _this.running = false;
	                    resolve(result);
	                }, function (rejectCause) {
	                    _this.running = false;
	                    reject(rejectCause);
	                }, progress);
	            });
	        }
	
	        /**
	         * Subclass should start the test
	         * @param {function} resolve callback will be called with object contains data computed
	         * @param {function} reject callback will be called with a EQError (see {@link EQError} constants)
	         * @param {function} progress callback called with an id, the progress in percent and information contains in an object (progress(1, 90, {th:'123.2'})
	         */
	        /*eslint-disable no-unused-vars*/
	
	    }, {
	        key: 'startInternal',
	        value: function startInternal(resolve, reject, progress) {
	            reject(new EQError(EQError.SCRIPT_STEP_NOT_IMPLEMENTED));
	        }
	
	        /**
	         * @return {boolean} true if the step has been cancelled
	         */
	
	    }, {
	        key: 'isCancelled',
	        value: function isCancelled() {
	            return this.cancelled;
	        }
	
	        /**
	         * Stop the step
	         * /*\ DON'T OVERRIDE THIS METHOD, OVERRIDE {@link stopInternal}
	         * @return {boolean} true if the test has stopped (or will stop), false otherwise. The promise from the start will be rejected.
	         */
	
	    }, {
	        key: 'stop',
	        value: function stop() {
	            if (this.running && !this.cancelled) {
	                this.cancelled = true;
	                return this.stopInternal();
	            }
	            return false;
	        }
	    }, {
	        key: 'stopInternal',
	        value: function stopInternal() {
	            return false;
	        }
	    }]);
	
	    return StepExecutor;
	}();
	
	exports.default = StepExecutor;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StepExecutor = __webpack_require__(82);
	
	var Step = _interopRequireWildcard(_StepExecutor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Call used to alert UI on progress
	 */
	var EQPauseStepProgress = function EQPauseStepProgress(pause, remaining) {
	    _classCallCheck(this, EQPauseStepProgress);
	
	    this.type = Step.STEP_PAUSE;
	    this.pause = pause;
	    this.remaining = remaining;
	};
	
	exports.default = EQPauseStepProgress;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StepExecutor = __webpack_require__(82);
	
	var Step = _interopRequireWildcard(_StepExecutor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Class used to alert UI when done
	 */
	var ConfigDone = function ConfigDone(pause) {
	    _classCallCheck(this, ConfigDone);
	
	    this.type = Step.STEP_PAUSE;
	    this.pause = pause;
	};
	
	exports.default = ConfigDone;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.STATUS_DROP = exports.STATUS_CANCEL = exports.STATUS_FAILED = exports.STATUS_SUCCESS = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StepExecutor2 = __webpack_require__(82);
	
	var _StepExecutor3 = _interopRequireDefault(_StepExecutor2);
	
	var _UrlBuilder = __webpack_require__(86);
	
	var _UrlBuilder2 = _interopRequireDefault(_UrlBuilder);
	
	var _SocketManager = __webpack_require__(95);
	
	var _SocketManager2 = _interopRequireDefault(_SocketManager);
	
	var _ResultManager = __webpack_require__(103);
	
	var _ResultManager2 = _interopRequireDefault(_ResultManager);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _EQmScoreStepDone = __webpack_require__(107);
	
	var _EQmScoreStepDone2 = _interopRequireDefault(_EQmScoreStepDone);
	
	var _MscoreBestServer = __webpack_require__(108);
	
	var _MscoreBestServer2 = _interopRequireDefault(_MscoreBestServer);
	
	var _KpiMapper = __webpack_require__(100);
	
	var KpiMapper = _interopRequireWildcard(_KpiMapper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_SUCCESS = exports.STATUS_SUCCESS = 'success';
	var STATUS_FAILED = exports.STATUS_FAILED = 'failed';
	var STATUS_CANCEL = exports.STATUS_CANCEL = 'canceled';
	var STATUS_DROP = exports.STATUS_DROP = 'drop';
	
	/**
	 * Represent a mScore step
	 */
	
	var MscoreStepExecutor = function (_StepExecutor) {
	    _inherits(MscoreStepExecutor, _StepExecutor);
	
	    /**
	     * @param {GpsManager} gpsManager GPS Manager to collect GPS info
	     * @param {DeviceManager} deviceManager The device manager
	     * @param {ConfigStepMscore} configuration server
	     * @param {string} uid Unique id
	     * @param {number} campaignId from configuration
	     * @param {number} scenarioId identifier (should be the same for all step in a script)
	     * @param {Map<string,string>} customFields A map of custom fields
	     * @param {number} group identifier
	     * @param {GatewayService} gatewayService gateway service
	     */
	    function MscoreStepExecutor(gpsManager, deviceManager, configuration, uid, campaignId, scenarioId, customFields, groupId, gatewayService) {
	        _classCallCheck(this, MscoreStepExecutor);
	
	        var _this = _possibleConstructorReturn(this, (MscoreStepExecutor.__proto__ || Object.getPrototypeOf(MscoreStepExecutor)).call(this, configuration));
	
	        _this.gpsManager = gpsManager;
	        _this.uid = uid;
	        _this.urlBuilder = new _UrlBuilder2.default(uid, configuration, campaignId, scenarioId, customFields, groupId, deviceManager);
	        _this.direction = configuration.getDirection();
	        _this.volume = configuration.getVolume();
	        _this.log = configuration.isLogEnabled();
	        _this.socketManager = new _SocketManager2.default(gpsManager, _this.urlBuilder, configuration.getSocketCount(), configuration.getDirection(), configuration.getTimeout(), gatewayService);
	        _this.resultManager = new _ResultManager2.default(_this.urlBuilder);
	        _this.mscoreBestServer = new _MscoreBestServer2.default(_this.configuration, _this.urlBuilder);
	        _this.gatewayService = gatewayService;
	        return _this;
	    }
	
	    /**
	     *
	     * @param {function} resolve
	     * @param {function} reject
	     * @param {function} progress
	     */
	
	
	    _createClass(MscoreStepExecutor, [{
	        key: "startInternal",
	        value: function startInternal(resolve, reject, progress) {
	            var _this2 = this;
	
	            var gatewayInfos = {};
	            var gatewayInfosCache = this.gatewayService.getCacheInfos();
	            if (gatewayInfosCache) {
	                gatewayInfos = Object.assign(gatewayInfos, gatewayInfosCache[KpiMapper.COMMON]);
	                gatewayInfos = Object.assign(gatewayInfos, gatewayInfosCache[KpiMapper.BEGIN]);
	                gatewayInfos = Object.assign(gatewayInfos, gatewayInfosCache[KpiMapper.END]);
	                this.socketManager.gatewayInfos = gatewayInfosCache[KpiMapper.RAW];
	            }
	
	            var gatewayRetrieval = new Promise(function (resolve) {
	                // Create new promise because success is not mandatory to call operation
	                _this2.gatewayService.getInfos().then(function (infos) {
	                    gatewayInfos = Object.assign(gatewayInfos, infos[KpiMapper.COMMON]);
	                    gatewayInfos = Object.assign(gatewayInfos, infos[KpiMapper.BEGIN]);
	                    gatewayInfos = Object.assign(gatewayInfos, infos[KpiMapper.END]);
	                    _this2.socketManager.gatewayInfos = infos[KpiMapper.RAW];
	                    resolve();
	                }).catch(function (e) {
	                    _Logger2.default.log(e);
	                    resolve();
	                });
	            });
	
	            gatewayRetrieval.then(function () {
	                return _this2.mscoreBestServer.bestServer();
	            }).then(function (mScoreServerUrl) {
	                return _this2.socketManager.start(progress, _this2.urlBuilder.buildTestUrl(mScoreServerUrl, _this2.gpsManager.get(), gatewayInfos), _this2.volume, mScoreServerUrl).then(function (result) {
	                    return _this2.resultManager.getResult(_this2.urlBuilder.buildResultUrl(result.mScoreServerUrl), result.results, result.mScoreServerUrl, _this2.configuration);
	                }).then(function (result) {
	                    if (_this2.isCancelled()) result.status = STATUS_CANCEL;
	                    if (_this2.isDropped()) result.status = STATUS_DROP;
	                    if (_this2.isFailed()) result.status = STATUS_FAILED;
	                    resolve(result);
	                });
	            }).catch(function (error) {
	                _Logger2.default.log(error);
	                resolve(new _EQmScoreStepDone2.default(STATUS_FAILED, _this2.direction, _this2.configuration.getService(), _this2.configuration.getModule()));
	            });
	        }
	    }, {
	        key: "stopInternal",
	        value: function stopInternal() {
	            return this.socketManager.stop();
	        }
	    }, {
	        key: "isDropped",
	        value: function isDropped() {
	            // EWA-48
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this.socketManager.sockets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var socket = _step.value;
	
	                    if (socket.httpStatus < 500 || socket.httpStatus > 599) {
	                        return false;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return true;
	        }
	    }, {
	        key: "isFailed",
	        value: function isFailed() {
	            // EWA-59
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = this.socketManager.sockets[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var socket = _step2.value;
	
	                    if (!socket.hasFailed || socket.volume > 0) {
	                        return false;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            return true;
	        }
	    }]);
	
	    return MscoreStepExecutor;
	}(_StepExecutor3.default);
	
	exports.default = MscoreStepExecutor;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DA_DIRECTION_MAPPER = exports.DA_DIRECTION = exports.DA_SERVICE = exports.MSCORE_DA_FIELDS = exports.MSCORE_DA_IP = exports.MSCORE_DA_CELL = exports.MSCORE_UID = exports.SERVICE_SCORING = exports.SERVICE_PACKETLOSS = exports.SERVICE_FLASHTEST = exports.SERVICE_SHOOTER = exports.PORT = exports.LOGS = exports.VOLUME = exports.NB_SOCKETS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MapUtil = __webpack_require__(87);
	
	var _MapUtil2 = _interopRequireDefault(_MapUtil);
	
	var _ConfigStepMscore = __webpack_require__(74);
	
	var ConfigStepEnum = _interopRequireWildcard(_ConfigStepMscore);
	
	var _Constants = __webpack_require__(88);
	
	var Constants = _interopRequireWildcard(_Constants);
	
	var _DateUtil = __webpack_require__(8);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _TimeZoneUtils = __webpack_require__(89);
	
	var _TimeZoneUtils2 = _interopRequireDefault(_TimeZoneUtils);
	
	var _VersionParser = __webpack_require__(90);
	
	var _VersionParser2 = _interopRequireDefault(_VersionParser);
	
	var _uaParserJs = __webpack_require__(91);
	
	var _uaParserJs2 = _interopRequireDefault(_uaParserJs);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Specials parameters, must be transformed for mScore
	 * @type {string}
	 */
	var NB_SOCKETS = exports.NB_SOCKETS = "nbsocket";
	
	/**
	 * Specials parameters, must be transformed for mScore
	 * @type {string}
	 */
	var VOLUME = exports.VOLUME = "volume";
	
	/**
	 * Specials parameters, must be transformed for mScore
	 * @type {string}
	 */
	var LOGS = exports.LOGS = "logs";
	
	/**
	 * Specials parameters, must be transformed for mScore
	 * @type {string}
	 */
	var PORT = exports.PORT = "port";
	
	/**
	 * Constants for all services
	 * @type {number}
	 */
	var SERVICE_SHOOTER = exports.SERVICE_SHOOTER = 1;
	var SERVICE_FLASHTEST = exports.SERVICE_FLASHTEST = 2;
	var SERVICE_PACKETLOSS = exports.SERVICE_PACKETLOSS = 3;
	var SERVICE_SCORING = exports.SERVICE_SCORING = 4;
	
	/**
	 * gps_lat parameter is used to store GPS latitude
	 * @type {string} contains float WGS84
	 */
	var MSCORE_GPS_LAT = "gps_lat";
	
	/**
	 * gps_long parameter is used to store GPS longitude
	 * @type {string} contains float WGS84
	 */
	var MSCORE_GPS_LONG = "gps_lon";
	
	/**
	 * gps_radius parameter is used to store GPS precision
	 * @type {string} contains int meters
	 */
	var MSCORE_GPS_RADIUS = "gps_radius";
	
	/**
	 * Timestamp of the GPS location (in seconds)
	 * @type {string} contains long
	 */
	var MSCORE_GPS_TIMESTAMP = "gps_tm";
	
	/**
	 * Status of the GPS
	 * @type {string} contains integer
	 */
	var MSCORE_GPS_STATUS = "gps_state";
	
	/**
	 * gps_city parameter is used to store reverse GPS geocoder information
	 * @type {string} zip-code city country
	 */
	var MSCORE_GPS_CITY = "city";
	
	/**
	 * da_gps_address parameter is used to store reverse GPS geocoder information
	 * @type {string}
	 */
	var MSCORE_GPS_ADDRESS = "address";
	
	/**
	 * da_gps_zip_code parameter is used to store reverse GPS geocoder information
	 * @type {string}
	 */
	var MSCORE_GPS_ZIP_CODE = "zip_code";
	
	/**
	 * da_gps_country_code parameter is used to store reverse GPS geocoder information
	 * @type {string}
	 */
	var MSCORE_GPS_COUNTRY_CODE = "country_code";
	
	/**
	 * campaign id for the current scenario
	
	 ▪ @type {string}
	 */
	var MSCORE_CAMPAIGN_ID = "campaign_id";
	
	/**
	 * group id
	
	 ▪ @type {number}
	 */
	var MSCORE_GROUP_ID = "DA_GROUP_ID";
	
	/**
	 * group parameter is used to store/retrieve results (per groupname)
	
	 ▪ @type {string}
	 */
	var MSCORE_GROUP = "group";
	
	/**
	 * multithreading parameter is used to configure the mScore server to accept multiple sockets for a single test session. By default, every new incoming socket will be considered by the mScore server as a new single test. multithreading parameter must be used with tmpid parameter
	 * @type {string} yes/no
	 */
	var MSCORE_MULTISOCKET = "multithreading";
	
	/**
	 * sid parameter is used to select session to be downloaded/updated (raw data per session)
	 * @type {string}
	 */
	var MSCORE_SID = "da_sid";
	
	/**
	 * tmpid parameter is used to identify multiple threads belonging to the same multithreading test. tmpid parameter must be used with multithreading parameter
	 * @type {string} contains long
	 */
	var MSCORE_SOCKET_ID = "tmpid";
	
	/**
	 * uid parameter is used to store/retrieve results (per uid). uid must be unique, minimum length must be 20 chars
	 * @type {string}
	 */
	var MSCORE_UID = exports.MSCORE_UID = "uid";
	
	/**
	 * Allow mScore to push KPI to EQualOne server
	 *
	 * @type {string} Should be always to yes
	 */
	var MSCORE_NBI = "nbi";
	
	/**
	 * Timestamp of the test (in milliseconds)
	 * @type {string}
	 */
	var MSCORE_DA_TIMESTAMP = "timestamp_agent";
	var MSCORE_DA_TIMESTAMP_MS = "created_at_agent_ms";
	
	/**
	 * Timezone of the test
	 * @type {string}
	 */
	var MSCORE_DA_TIMEZONE = "timezone_agent";
	
	/**
	 * Mode of the test (slm/ssm/ocm)
	 * @type {string} always set to 3 (OCM). Web Agent doesn't support SLM & SSM
	 */
	var MSCORE_DA_MODE_ID = "mode_id";
	
	/**
	 * Scenario ID: timestamp in seconds shared by each step in a script
	 * @type {string}
	 */
	var MSCORE_DA_ITERATION_ID = "scenario_id";
	
	/**
	 * Version of the agent in String format X.Y.Z.H
	 * @type {string}
	 */
	var MSCORE_DA_DQA_NAME = "dqa_name";
	/**
	 * Version of the agent in integer format
	 * @type {string}
	 */
	var MSCORE_DA_DQA_VERSION = "dqa_version";
	/**
	 * Browser name
	 * @type {string}
	 */
	var MSCORE_DA_BROWSER_NAME = "browser_name";
	var MSCORE_DA_BROWSER_NAME_CHROME_AGENT = "ChromeAgent";
	var MSCORE_DA_OS_NAME = "os_name";
	
	/**
	 * Browser version
	 * @type {string}
	 */
	var MSCORE_DA_BROWSER_VERSION = "browser_version";
	/**
	 * Platform
	 * @type {string}
	 */
	var MSCORE_DA_PLATFORM = "platform";
	/**
	 * Firmware
	 * @type {string}
	 */
	var MSCORE_DA_FIRMWARE = "firmware";
	
	/**
	 * Test to start by mScore
	 * @type {string} shooterDL/shooterUL
	 */
	var MSCORE_TEST = "test";
	
	/**
	 * Test to start by mScore
	 * @type {string} shooterDL/shooterUL
	 */
	var MSCORE_URL = "mscore_server";
	
	/**
	 * Module for mScore test
	 * @type {number} For score
	 */
	var MSCORE_DA_MODULE = "mscore_module";
	
	/**
	 * mScore best server URL check
	 * @type {number} For da_cell
	 */
	var MSCORE_DA_CELL = exports.MSCORE_DA_CELL = "da_cell";
	
	/**
	 * mScore private IP
	 * @type {string} For da_ip
	 */
	var MSCORE_DA_IP = exports.MSCORE_DA_IP = "private_ip";
	
	/**
	 * mScore DA fields
	 * @type {string} For da fields
	 */
	var MSCORE_DA_FIELDS = exports.MSCORE_DA_FIELDS = "da_fields";
	
	/**
	 * DA service
	 * @type {string} For da service
	 */
	var DA_SERVICE = exports.DA_SERVICE = "da_service";
	
	/**
	 * DA direction
	 * @type {string} For da direction
	 */
	var DA_DIRECTION = exports.DA_DIRECTION = "da_direction";
	
	/**
	 * DA direction proto mapping
	 * @type {string} For da direction
	 */
	var DA_DIRECTION_MAPPER = exports.DA_DIRECTION_MAPPER = "th_type_id";
	
	/**
	 * Build mScore URL for test
	 */
	
	var UrlBuilder = function () {
	
	  /**
	   * Default constructor
	   *
	   * @param {string} uid the unique id of the agent
	   * @param {ConfigStepMscore} configuration the server configuration
	   * @param {number} campaignId the current campaign id
	   * @param {number} iterationId identifier (should be the same for all step in a script)
	   * @param {Map<string,string>} customFields A map of custom fields
	   * @param {number} group identifier
	   * @param {DeviceManager} device manager
	   */
	  function UrlBuilder(uid, configuration, campaignId, iterationId, customFields, groupId, deviceManager) {
	    _classCallCheck(this, UrlBuilder);
	
	    this.uid = uid;
	    this.port = configuration.getPort();
	    this.direction = configuration.getDirection();
	    this.service = configuration.getService();
	    this.serverParams = _MapUtil2.default.objectToMap(configuration.params);
	    this.campaignId = campaignId;
	    this.iterationId = iterationId;
	    this.sid = uid + '-' + Math.round(new Date().getTime());
	    this.socketId = this.randomLong();
	    this.date = new Date().toISOString();
	    this.customFields = customFields;
	    this.groupId = groupId;
	    this.module = configuration.getModule();
	    this.portalUrl = configuration.getPortalUrl();
	    this.deviceManager = deviceManager;
	  }
	
	  /**
	   * Build the mScore test URL
	   *
	   * @param {String} The mScore server URL
	   * @param {GpsInfos} gpsInfos the current agent location
	   * @param {Object} gatewayInfos the gateway informations
	   * @return {string}
	   */
	
	
	  _createClass(UrlBuilder, [{
	    key: "buildTestUrl",
	    value: function buildTestUrl(mScoreServerUrl) {
	      var gpsInfos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var gatewayInfos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      return mScoreServerUrl + ':' + this.port + '/' + "operation?" + this.buildUrlParams(this.buildMainParams(mScoreServerUrl, this.serverParams, gpsInfos, gatewayInfos));
	    }
	
	    /**
	     * Build the base test URL
	     *
	     * @param {String} The mScore server URL
	     * @return {string}
	     */
	
	  }, {
	    key: "buildBaseUrl",
	    value: function buildBaseUrl(mScoreServerUrl) {
	      return mScoreServerUrl + ':' + this.port;
	    }
	
	    /**
	     * @return {Array} excluded keys from request
	     */
	
	  }, {
	    key: "getExcludedKeys",
	    value: function getExcludedKeys() {
	      var excludedKeys = [];
	      excludedKeys.push(NB_SOCKETS);
	      excludedKeys.push(LOGS);
	      excludedKeys.push(PORT);
	      excludedKeys.push(DA_SERVICE);
	      // Remove the volume from parameters if upload test (content-length will be used)
	      if (this.direction == ConfigStepEnum.STEP_DIRECTION_UP) {
	        excludedKeys.push(VOLUME);
	      }
	      return excludedKeys;
	    }
	
	    /**
	     * Build the mScore result URL
	     *
	     * @param {String} The mScore server URL
	     * @param {String} The optional mScore server URL
	     * @return {string}
	     */
	
	  }, {
	    key: "buildResultUrl",
	    value: function buildResultUrl(mScoreServerUrl) {
	      var param = new Map();
	      param.set(MSCORE_UID, this.uid);
	      if (this.serverParams.get(NB_SOCKETS) > 1) {
	        param.set(MSCORE_MULTISOCKET, "yes");
	        param.set(MSCORE_SOCKET_ID, this.socketId);
	      }
	
	      return mScoreServerUrl + ':' + this.port + '/' + "update_result?" + this.buildUrlParams(param);
	    }
	
	    /**
	     * Build input parameters for mScore
	     *
	     * @param {string} mScoreServerUrl
	     * @param {map} configParametersMap
	     * @param {GpsInfos} gpsInfos
	     * @param {Object} gatewayInfos the gateway informations
	     * @return {Map.<string, string>}
	     */
	
	  }, {
	    key: "buildMainParams",
	    value: function buildMainParams(mScoreServerUrl, configParametersMap) {
	      var gpsInfos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	      var gatewayInfos = arguments[3];
	
	      var mainParams = new Map();
	      var daFields = new Map();
	
	      daFields.set(MSCORE_DA_DQA_NAME, Constants.AGENT_VERSION);
	      daFields.set(MSCORE_DA_DQA_VERSION, _VersionParser2.default.parseVersion(Constants.AGENT_VERSION));
	      mainParams.set(MSCORE_UID, this.uid);
	      daFields.set(MSCORE_CAMPAIGN_ID, this.campaignId);
	      daFields.set(MSCORE_GROUP_ID, this.groupId);
	      mainParams.set(MSCORE_GROUP, this.campaignId);
	      if (this.module) {
	        daFields.set(MSCORE_DA_MODULE, this.module);
	      }
	      mainParams.set(MSCORE_TEST, this.getTestServiceLabel(this.direction, this.service));
	      var sockets = this.serverParams.get(NB_SOCKETS);
	
	      if (sockets > 1) {
	        mainParams.set(MSCORE_MULTISOCKET, "yes");
	        mainParams.set(MSCORE_SOCKET_ID, this.socketId);
	      } else {
	        mainParams.set(MSCORE_MULTISOCKET, "no");
	      }
	      mainParams.set(MSCORE_SID, this.sid);
	      daFields.set(MSCORE_DA_TIMESTAMP, _DateUtil2.default.getCurrentTimestamp());
	      daFields.set(MSCORE_DA_TIMESTAMP_MS, _DateUtil2.default.getCurrentTimestamp() * 1000);
	      daFields.set(MSCORE_DA_TIMEZONE, _TimeZoneUtils2.default.getJstz().determine().name());
	      daFields.set(MSCORE_DA_MODE_ID, 3);
	      daFields.set(MSCORE_DA_ITERATION_ID, this.iterationId);
	
	      mainParams.set(MSCORE_DA_CELL, this.deviceManager.getTechnology() + "::");
	
	      var ip = this.deviceManager.getPrivateIpAddress();
	
	      if (ip) {
	        daFields.set(MSCORE_DA_IP, ip);
	      }
	
	      // Force NBI to yes to spool KPI to EQualOne server
	      mainParams.set(MSCORE_NBI, "yes");
	      if (gpsInfos) {
	        if (gpsInfos.timestamp) daFields.set(MSCORE_GPS_TIMESTAMP, gpsInfos.timestamp);
	        if (gpsInfos.status) daFields.set(MSCORE_GPS_STATUS, gpsInfos.status);
	        if (gpsInfos.lat) daFields.set(MSCORE_GPS_LAT, gpsInfos.lat);
	        if (gpsInfos.long) daFields.set(MSCORE_GPS_LONG, gpsInfos.long);
	        if (gpsInfos.radius) daFields.set(MSCORE_GPS_RADIUS, gpsInfos.radius);
	        if (gpsInfos.city) daFields.set(MSCORE_GPS_CITY, gpsInfos.city);
	        if (gpsInfos.streetName) daFields.set(MSCORE_GPS_ADDRESS, gpsInfos.streetName);
	        if (gpsInfos.postalCode) daFields.set(MSCORE_GPS_ZIP_CODE, gpsInfos.postalCode);
	        if (gpsInfos.countryCode) daFields.set(MSCORE_GPS_COUNTRY_CODE, gpsInfos.countryCode);
	      }
	
	      this.customFields.forEach(function (value, key) {
	        daFields.set(key, value);
	      });
	
	      if (typeof navigator != 'undefined') {
	        var uaParserJs = new _uaParserJs2.default();
	
	        var browserName = uaParserJs.getBrowser().name;
	        var browserVersion = uaParserJs.getBrowser().version;
	        var platform = uaParserJs.getOS().name;
	
	        if (location.protocol === "chrome-extension:") {
	          daFields.set(MSCORE_DA_OS_NAME, 10);
	          daFields.set(MSCORE_DA_BROWSER_NAME, MSCORE_DA_BROWSER_NAME_CHROME_AGENT);
	        } else {
	          daFields.set(MSCORE_DA_OS_NAME, 8);
	          daFields.set(MSCORE_DA_BROWSER_NAME, browserName);
	        }
	        daFields.set(MSCORE_DA_BROWSER_VERSION, browserVersion);
	        daFields.set(MSCORE_DA_PLATFORM, platform);
	        daFields.set(MSCORE_DA_FIRMWARE, navigator.userAgent);
	      }
	
	      // Adding configuration parameters, filtered with useless elements
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = _MapUtil2.default.excludeKeys(configParametersMap, this.getExcludedKeys())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 2),
	              configParametersMapKey = _step$value[0],
	              configParametersMapValue = _step$value[1];
	
	          // For DA Direction, put in da_fields with real protobuf name
	          if (configParametersMapKey.toLowerCase() === DA_DIRECTION.toLowerCase()) {
	            daFields.set(DA_DIRECTION_MAPPER, configParametersMapValue);
	          } else {
	            // For others, => main params
	            mainParams.set(configParametersMapKey, configParametersMapValue);
	          }
	        }
	
	        // EWA-64 Add mscore_url
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      daFields.set(MSCORE_URL, mScoreServerUrl + ":" + this.port);
	
	      // EWA-108 Add gateway informations
	      if (gatewayInfos) {
	        Object.keys(gatewayInfos).forEach(function (kpiKey) {
	          daFields.set(kpiKey, gatewayInfos[kpiKey]);
	        });
	      }
	
	      // Added technology on end kpi part (EWA-108)
	      // The goal here is to know if customer is connected through Ethernet or Wifi
	      // TODO: Put in specific field
	      daFields.set("agg_bearer", this.deviceManager.getTechnology());
	
	      // Transform DA_FIELDS
	      var daFieldsArray = [];
	      daFields.forEach(function (daFieldValue, daFieldKey) {
	        daFieldsArray.push(daFieldKey + "=" + daFieldValue);
	      });
	
	      // Add DA_Fields to main stream
	      mainParams.set(MSCORE_DA_FIELDS, daFieldsArray.join(";"));
	      return mainParams;
	    }
	
	    /**
	     * @param {number} da_direction
	     * @param {number} da_service
	     * @return {string}
	     */
	
	  }, {
	    key: "getTestServiceLabel",
	    value: function getTestServiceLabel(da_direction, da_service) {
	      var direction = da_direction == ConfigStepEnum.STEP_DIRECTION_UP ? "UL" : "DL";
	      switch (da_service) {
	        case SERVICE_SHOOTER:
	          return "shooter" + direction;
	        case SERVICE_FLASHTEST:
	          return "flashtest" + direction;
	        case SERVICE_PACKETLOSS:
	          return "packetloss" + direction;
	        case SERVICE_SCORING:
	          return "score";
	      }
	      return "unknown" + direction;
	    }
	
	    /**
	     * Build parameter to format GET call
	     * @param {Map.<string, string>} parameters
	     * @return {string}
	     */
	
	  }, {
	    key: "buildUrlParams",
	    value: function buildUrlParams(parameters) {
	      var tmp = "";
	      parameters.forEach(function (value, key) {
	        if (tmp) {
	          tmp = tmp + "&" + key + "=" + encodeURIComponent(value);
	        } else {
	          tmp = key + "=" + encodeURIComponent(value);
	        }
	      });
	
	      return tmp;
	    }
	
	    /**
	     * Create 64bit random number
	     */
	
	  }, {
	    key: "randomLong",
	    value: function randomLong() {
	      var currentRandom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (currentRandom >= 1024) {
	        return currentRandom;
	      }
	      return this.randomLong(parseInt(Math.random() * 10000000));
	    }
	  }, {
	    key: "buildCheckServerUrl",
	    value: function buildCheckServerUrl(url) {
	      var param = new Map();
	      param.set(MSCORE_UID, this.uid);
	      param.set(MSCORE_DA_CELL, this.deviceManager.getTechnology());
	
	      return url + ':' + this.port + '/' + "check?" + this.buildUrlParams(param);
	    }
	  }]);
	
	  return UrlBuilder;
	}();
	
	exports.default = UrlBuilder;

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Class util for Map
	 */
	var MapUtil = function () {
	    function MapUtil() {
	        _classCallCheck(this, MapUtil);
	    }
	
	    _createClass(MapUtil, null, [{
	        key: "objectToMap",
	
	
	        /**
	         * Transform an object to a map
	         * @param obj the object
	         * @return {Map} the map with all properties object as key
	         */
	        value: function objectToMap(obj) {
	            var tmp = new Map();
	            for (var property in obj) {
	                if (obj.hasOwnProperty(property)) {
	                    tmp.set(property, obj[property]);
	                }
	            }
	            return tmp;
	        }
	
	        /**
	         * Delete a list of keys from a map
	         * @param {Map} map the input map
	         * @param {Array} keys the keys to delete
	         * @return {Map} the map with keys deleted (be careful, the input map is also changed)
	         */
	
	    }, {
	        key: "excludeKeys",
	        value: function excludeKeys(map, keys) {
	            keys.forEach(function (value) {
	                map.delete(value);
	            });
	            return map;
	        }
	    }]);
	
	    return MapUtil;
	}();
	
	exports.default = MapUtil;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*eslint-disable no-undef*/
	var isInTest = typeof global.it === 'function';
	
	var AGENT_VERSION_VAR = "";
	
	if (!isInTest) {
	    AGENT_VERSION_VAR = "" + ("1.2.17.0");
	}
	
	var AGENT_VERSION = exports.AGENT_VERSION = AGENT_VERSION_VAR;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * This script gives you the zone info key representing your device's time zone setting.
	 *
	 * @name jsTimezoneDetect
	 * @version 1.0.6
	 * @author Jon Nylander
	 * @license MIT License - https://bitbucket.org/pellepim/jstimezonedetect/src/default/LICENCE.txt
	 *
	 * For usage and examples, visit:
	 * http://pellepim.bitbucket.org/jstz/
	 *
	 * Copyright (c) Jon Nylander
	 */
	
	/**
	 * The keys in this dictionary are comma separated as such:
	 *
	 * First the offset compared to UTC time in minutes.
	 *
	 * Then a flag which is 0 if the timezone does not take daylight savings into account and 1 if it
	 * does.
	 *
	 * Thirdly an optional 's' signifies that the timezone is in the southern hemisphere,
	 * only interesting for timezones with DST.
	 *
	 * The mapped arrays is used for constructing the jstz.TimeZone object from within
	 * jstz.determine();
	 */
	var TIMEZONES = {
	    '-720,0': 'Etc/GMT+12',
	    '-660,0': 'Pacific/Pago_Pago',
	    '-660,1,s': 'Pacific/Apia', // Why? Because windows... cry!
	    '-600,1': 'America/Adak',
	    '-600,0': 'Pacific/Honolulu',
	    '-570,0': 'Pacific/Marquesas',
	    '-540,0': 'Pacific/Gambier',
	    '-540,1': 'America/Anchorage',
	    '-480,1': 'America/Los_Angeles',
	    '-480,0': 'Pacific/Pitcairn',
	    '-420,0': 'America/Phoenix',
	    '-420,1': 'America/Denver',
	    '-360,0': 'America/Guatemala',
	    '-360,1': 'America/Chicago',
	    '-360,1,s': 'Pacific/Easter',
	    '-300,0': 'America/Bogota',
	    '-300,1': 'America/New_York',
	    '-270,0': 'America/Caracas',
	    '-240,1': 'America/Halifax',
	    '-240,0': 'America/Santo_Domingo',
	    '-240,1,s': 'America/Asuncion',
	    '-210,1': 'America/St_Johns',
	    '-180,1': 'America/Godthab',
	    '-180,0': 'America/Argentina/Buenos_Aires',
	    '-180,1,s': 'America/Montevideo',
	    '-120,0': 'America/Noronha',
	    '-120,1': 'America/Noronha',
	    '-60,1': 'Atlantic/Azores',
	    '-60,0': 'Atlantic/Cape_Verde',
	    '0,0': 'UTC',
	    '0,1': 'Europe/London',
	    '60,1': 'Europe/Berlin',
	    '60,0': 'Africa/Lagos',
	    '60,1,s': 'Africa/Windhoek',
	    '120,1': 'Asia/Beirut',
	    '120,0': 'Africa/Johannesburg',
	    '180,0': 'Asia/Baghdad',
	    '180,1': 'Europe/Moscow',
	    '210,1': 'Asia/Tehran',
	    '240,0': 'Asia/Dubai',
	    '240,1': 'Asia/Baku',
	    '270,0': 'Asia/Kabul',
	    '300,1': 'Asia/Yekaterinburg',
	    '300,0': 'Asia/Karachi',
	    '330,0': 'Asia/Kolkata',
	    '345,0': 'Asia/Kathmandu',
	    '360,0': 'Asia/Dhaka',
	    '360,1': 'Asia/Omsk',
	    '390,0': 'Asia/Rangoon',
	    '420,1': 'Asia/Krasnoyarsk',
	    '420,0': 'Asia/Jakarta',
	    '480,0': 'Asia/Shanghai',
	    '480,1': 'Asia/Irkutsk',
	    '525,0': 'Australia/Eucla',
	    '525,1,s': 'Australia/Eucla',
	    '540,1': 'Asia/Yakutsk',
	    '540,0': 'Asia/Tokyo',
	    '570,0': 'Australia/Darwin',
	    '570,1,s': 'Australia/Adelaide',
	    '600,0': 'Australia/Brisbane',
	    '600,1': 'Asia/Vladivostok',
	    '600,1,s': 'Australia/Sydney',
	    '630,1,s': 'Australia/Lord_Howe',
	    '660,1': 'Asia/Kamchatka',
	    '660,0': 'Pacific/Noumea',
	    '690,0': 'Pacific/Norfolk',
	    '720,1,s': 'Pacific/Auckland',
	    '720,0': 'Pacific/Majuro',
	    '765,1,s': 'Pacific/Chatham',
	    '780,0': 'Pacific/Tongatapu',
	    '780,1,s': 'Pacific/Apia',
	    '840,0': 'Pacific/Kiritimati'
	};
	
	/* Build time: 2015-11-02 13:01:00Z Build by invoking python utilities/dst.py generate */
	var DST_RULES = {
	    "years": [2008, 2009, 2010, 2011, 2012, 2013, 2014],
	    "zones": [{
	        "name": "Africa/Cairo",
	        "rules": [{
	            "e": 1219957200000,
	            "s": 1209074400000
	        }, {
	            "e": 1250802000000,
	            "s": 1240524000000
	        }, {
	            "e": 1285880400000,
	            "s": 1284069600000
	        }, false, false, false, {
	            "e": 1411678800000,
	            "s": 1406844000000
	        }]
	    }, {
	        "name": "Africa/Casablanca",
	        "rules": [{
	            "e": 1220223600000,
	            "s": 1212278400000
	        }, {
	            "e": 1250809200000,
	            "s": 1243814400000
	        }, {
	            "e": 1281222000000,
	            "s": 1272758400000
	        }, {
	            "e": 1312066800000,
	            "s": 1301788800000
	        }, {
	            "e": 1348970400000,
	            "s": 1345428000000
	        }, {
	            "e": 1382839200000,
	            "s": 1376100000000
	        }, {
	            "e": 1414288800000,
	            "s": 1406944800000
	        }]
	    }, {
	        "name": "America/Asuncion",
	        "rules": [{
	            "e": 1205031600000,
	            "s": 1224388800000
	        }, {
	            "e": 1236481200000,
	            "s": 1255838400000
	        }, {
	            "e": 1270954800000,
	            "s": 1286078400000
	        }, {
	            "e": 1302404400000,
	            "s": 1317528000000
	        }, {
	            "e": 1333854000000,
	            "s": 1349582400000
	        }, {
	            "e": 1364094000000,
	            "s": 1381032000000
	        }, {
	            "e": 1395543600000,
	            "s": 1412481600000
	        }]
	    }, {
	        "name": "America/Campo_Grande",
	        "rules": [{
	            "e": 1203217200000,
	            "s": 1224388800000
	        }, {
	            "e": 1234666800000,
	            "s": 1255838400000
	        }, {
	            "e": 1266721200000,
	            "s": 1287288000000
	        }, {
	            "e": 1298170800000,
	            "s": 1318737600000
	        }, {
	            "e": 1330225200000,
	            "s": 1350792000000
	        }, {
	            "e": 1361070000000,
	            "s": 1382241600000
	        }, {
	            "e": 1392519600000,
	            "s": 1413691200000
	        }]
	    }, {
	        "name": "America/Goose_Bay",
	        "rules": [{
	            "e": 1225594860000,
	            "s": 1205035260000
	        }, {
	            "e": 1257044460000,
	            "s": 1236484860000
	        }, {
	            "e": 1289098860000,
	            "s": 1268539260000
	        }, {
	            "e": 1320555600000,
	            "s": 1299988860000
	        }, {
	            "e": 1352005200000,
	            "s": 1331445600000
	        }, {
	            "e": 1383454800000,
	            "s": 1362895200000
	        }, {
	            "e": 1414904400000,
	            "s": 1394344800000
	        }]
	    }, {
	        "name": "America/Havana",
	        "rules": [{
	            "e": 1224997200000,
	            "s": 1205643600000
	        }, {
	            "e": 1256446800000,
	            "s": 1236488400000
	        }, {
	            "e": 1288501200000,
	            "s": 1268542800000
	        }, {
	            "e": 1321160400000,
	            "s": 1300597200000
	        }, {
	            "e": 1352005200000,
	            "s": 1333256400000
	        }, {
	            "e": 1383454800000,
	            "s": 1362891600000
	        }, {
	            "e": 1414904400000,
	            "s": 1394341200000
	        }]
	    }, {
	        "name": "America/Mazatlan",
	        "rules": [{
	            "e": 1225008000000,
	            "s": 1207472400000
	        }, {
	            "e": 1256457600000,
	            "s": 1238922000000
	        }, {
	            "e": 1288512000000,
	            "s": 1270371600000
	        }, {
	            "e": 1319961600000,
	            "s": 1301821200000
	        }, {
	            "e": 1351411200000,
	            "s": 1333270800000
	        }, {
	            "e": 1382860800000,
	            "s": 1365325200000
	        }, {
	            "e": 1414310400000,
	            "s": 1396774800000
	        }]
	    }, {
	        "name": "America/Mexico_City",
	        "rules": [{
	            "e": 1225004400000,
	            "s": 1207468800000
	        }, {
	            "e": 1256454000000,
	            "s": 1238918400000
	        }, {
	            "e": 1288508400000,
	            "s": 1270368000000
	        }, {
	            "e": 1319958000000,
	            "s": 1301817600000
	        }, {
	            "e": 1351407600000,
	            "s": 1333267200000
	        }, {
	            "e": 1382857200000,
	            "s": 1365321600000
	        }, {
	            "e": 1414306800000,
	            "s": 1396771200000
	        }]
	    }, {
	        "name": "America/Miquelon",
	        "rules": [{
	            "e": 1225598400000,
	            "s": 1205038800000
	        }, {
	            "e": 1257048000000,
	            "s": 1236488400000
	        }, {
	            "e": 1289102400000,
	            "s": 1268542800000
	        }, {
	            "e": 1320552000000,
	            "s": 1299992400000
	        }, {
	            "e": 1352001600000,
	            "s": 1331442000000
	        }, {
	            "e": 1383451200000,
	            "s": 1362891600000
	        }, {
	            "e": 1414900800000,
	            "s": 1394341200000
	        }]
	    }, {
	        "name": "America/Santa_Isabel",
	        "rules": [{
	            "e": 1225011600000,
	            "s": 1207476000000
	        }, {
	            "e": 1256461200000,
	            "s": 1238925600000
	        }, {
	            "e": 1288515600000,
	            "s": 1270375200000
	        }, {
	            "e": 1319965200000,
	            "s": 1301824800000
	        }, {
	            "e": 1351414800000,
	            "s": 1333274400000
	        }, {
	            "e": 1382864400000,
	            "s": 1365328800000
	        }, {
	            "e": 1414314000000,
	            "s": 1396778400000
	        }]
	    }, {
	        "name": "America/Santiago",
	        "rules": [{
	            "e": 1206846000000,
	            "s": 1223784000000
	        }, {
	            "e": 1237086000000,
	            "s": 1255233600000
	        }, {
	            "e": 1270350000000,
	            "s": 1286683200000
	        }, {
	            "e": 1304823600000,
	            "s": 1313899200000
	        }, {
	            "e": 1335668400000,
	            "s": 1346558400000
	        }, {
	            "e": 1367118000000,
	            "s": 1378612800000
	        }, {
	            "e": 1398567600000,
	            "s": 1410062400000
	        }]
	    }, {
	        "name": "America/Sao_Paulo",
	        "rules": [{
	            "e": 1203213600000,
	            "s": 1224385200000
	        }, {
	            "e": 1234663200000,
	            "s": 1255834800000
	        }, {
	            "e": 1266717600000,
	            "s": 1287284400000
	        }, {
	            "e": 1298167200000,
	            "s": 1318734000000
	        }, {
	            "e": 1330221600000,
	            "s": 1350788400000
	        }, {
	            "e": 1361066400000,
	            "s": 1382238000000
	        }, {
	            "e": 1392516000000,
	            "s": 1413687600000
	        }]
	    }, {
	        "name": "Asia/Amman",
	        "rules": [{
	            "e": 1225404000000,
	            "s": 1206655200000
	        }, {
	            "e": 1256853600000,
	            "s": 1238104800000
	        }, {
	            "e": 1288303200000,
	            "s": 1269554400000
	        }, {
	            "e": 1319752800000,
	            "s": 1301608800000
	        }, false, false, {
	            "e": 1414706400000,
	            "s": 1395957600000
	        }]
	    }, {
	        "name": "Asia/Damascus",
	        "rules": [{
	            "e": 1225486800000,
	            "s": 1207260000000
	        }, {
	            "e": 1256850000000,
	            "s": 1238104800000
	        }, {
	            "e": 1288299600000,
	            "s": 1270159200000
	        }, {
	            "e": 1319749200000,
	            "s": 1301608800000
	        }, {
	            "e": 1351198800000,
	            "s": 1333058400000
	        }, {
	            "e": 1382648400000,
	            "s": 1364508000000
	        }, {
	            "e": 1414702800000,
	            "s": 1395957600000
	        }]
	    }, {
	        "name": "Asia/Dubai",
	        "rules": [false, false, false, false, false, false, false]
	    }, {
	        "name": "Asia/Gaza",
	        "rules": [{
	            "e": 1219957200000,
	            "s": 1206655200000
	        }, {
	            "e": 1252015200000,
	            "s": 1238104800000
	        }, {
	            "e": 1281474000000,
	            "s": 1269640860000
	        }, {
	            "e": 1312146000000,
	            "s": 1301608860000
	        }, {
	            "e": 1348178400000,
	            "s": 1333058400000
	        }, {
	            "e": 1380229200000,
	            "s": 1364508000000
	        }, {
	            "e": 1414098000000,
	            "s": 1395957600000
	        }]
	    }, {
	        "name": "Asia/Irkutsk",
	        "rules": [{
	            "e": 1224957600000,
	            "s": 1206813600000
	        }, {
	            "e": 1256407200000,
	            "s": 1238263200000
	        }, {
	            "e": 1288461600000,
	            "s": 1269712800000
	        }, false, false, false, false]
	    }, {
	        "name": "Asia/Jerusalem",
	        "rules": [{
	            "e": 1223161200000,
	            "s": 1206662400000
	        }, {
	            "e": 1254006000000,
	            "s": 1238112000000
	        }, {
	            "e": 1284246000000,
	            "s": 1269561600000
	        }, {
	            "e": 1317510000000,
	            "s": 1301616000000
	        }, {
	            "e": 1348354800000,
	            "s": 1333065600000
	        }, {
	            "e": 1382828400000,
	            "s": 1364515200000
	        }, {
	            "e": 1414278000000,
	            "s": 1395964800000
	        }]
	    }, {
	        "name": "Asia/Kamchatka",
	        "rules": [{
	            "e": 1224943200000,
	            "s": 1206799200000
	        }, {
	            "e": 1256392800000,
	            "s": 1238248800000
	        }, {
	            "e": 1288450800000,
	            "s": 1269698400000
	        }, false, false, false, false]
	    }, {
	        "name": "Asia/Krasnoyarsk",
	        "rules": [{
	            "e": 1224961200000,
	            "s": 1206817200000
	        }, {
	            "e": 1256410800000,
	            "s": 1238266800000
	        }, {
	            "e": 1288465200000,
	            "s": 1269716400000
	        }, false, false, false, false]
	    }, {
	        "name": "Asia/Omsk",
	        "rules": [{
	            "e": 1224964800000,
	            "s": 1206820800000
	        }, {
	            "e": 1256414400000,
	            "s": 1238270400000
	        }, {
	            "e": 1288468800000,
	            "s": 1269720000000
	        }, false, false, false, false]
	    }, {
	        "name": "Asia/Vladivostok",
	        "rules": [{
	            "e": 1224950400000,
	            "s": 1206806400000
	        }, {
	            "e": 1256400000000,
	            "s": 1238256000000
	        }, {
	            "e": 1288454400000,
	            "s": 1269705600000
	        }, false, false, false, false]
	    }, {
	        "name": "Asia/Yakutsk",
	        "rules": [{
	            "e": 1224954000000,
	            "s": 1206810000000
	        }, {
	            "e": 1256403600000,
	            "s": 1238259600000
	        }, {
	            "e": 1288458000000,
	            "s": 1269709200000
	        }, false, false, false, false]
	    }, {
	        "name": "Asia/Yekaterinburg",
	        "rules": [{
	            "e": 1224968400000,
	            "s": 1206824400000
	        }, {
	            "e": 1256418000000,
	            "s": 1238274000000
	        }, {
	            "e": 1288472400000,
	            "s": 1269723600000
	        }, false, false, false, false]
	    }, {
	        "name": "Asia/Yerevan",
	        "rules": [{
	            "e": 1224972000000,
	            "s": 1206828000000
	        }, {
	            "e": 1256421600000,
	            "s": 1238277600000
	        }, {
	            "e": 1288476000000,
	            "s": 1269727200000
	        }, {
	            "e": 1319925600000,
	            "s": 1301176800000
	        }, false, false, false]
	    }, {
	        "name": "Australia/Lord_Howe",
	        "rules": [{
	            "e": 1207407600000,
	            "s": 1223134200000
	        }, {
	            "e": 1238857200000,
	            "s": 1254583800000
	        }, {
	            "e": 1270306800000,
	            "s": 1286033400000
	        }, {
	            "e": 1301756400000,
	            "s": 1317483000000
	        }, {
	            "e": 1333206000000,
	            "s": 1349537400000
	        }, {
	            "e": 1365260400000,
	            "s": 1380987000000
	        }, {
	            "e": 1396710000000,
	            "s": 1412436600000
	        }]
	    }, {
	        "name": "Australia/Perth",
	        "rules": [{
	            "e": 1206813600000,
	            "s": 1224957600000
	        }, false, false, false, false, false, false]
	    }, {
	        "name": "Europe/Helsinki",
	        "rules": [{
	            "e": 1224982800000,
	            "s": 1206838800000
	        }, {
	            "e": 1256432400000,
	            "s": 1238288400000
	        }, {
	            "e": 1288486800000,
	            "s": 1269738000000
	        }, {
	            "e": 1319936400000,
	            "s": 1301187600000
	        }, {
	            "e": 1351386000000,
	            "s": 1332637200000
	        }, {
	            "e": 1382835600000,
	            "s": 1364691600000
	        }, {
	            "e": 1414285200000,
	            "s": 1396141200000
	        }]
	    }, {
	        "name": "Europe/Minsk",
	        "rules": [{
	            "e": 1224979200000,
	            "s": 1206835200000
	        }, {
	            "e": 1256428800000,
	            "s": 1238284800000
	        }, {
	            "e": 1288483200000,
	            "s": 1269734400000
	        }, false, false, false, false]
	    }, {
	        "name": "Europe/Moscow",
	        "rules": [{
	            "e": 1224975600000,
	            "s": 1206831600000
	        }, {
	            "e": 1256425200000,
	            "s": 1238281200000
	        }, {
	            "e": 1288479600000,
	            "s": 1269730800000
	        }, false, false, false, false]
	    }, {
	        "name": "Pacific/Apia",
	        "rules": [false, false, false, {
	            "e": 1301752800000,
	            "s": 1316872800000
	        }, {
	            "e": 1333202400000,
	            "s": 1348927200000
	        }, {
	            "e": 1365256800000,
	            "s": 1380376800000
	        }, {
	            "e": 1396706400000,
	            "s": 1411826400000
	        }]
	    }, {
	        "name": "Pacific/Fiji",
	        "rules": [false, false, {
	            "e": 1269698400000,
	            "s": 1287842400000
	        }, {
	            "e": 1327154400000,
	            "s": 1319292000000
	        }, {
	            "e": 1358604000000,
	            "s": 1350741600000
	        }, {
	            "e": 1390050000000,
	            "s": 1382796000000
	        }, {
	            "e": 1421503200000,
	            "s": 1414850400000
	        }]
	    }, {
	        "name": "Europe/London",
	        "rules": [{
	            "e": 1224982800000,
	            "s": 1206838800000
	        }, {
	            "e": 1256432400000,
	            "s": 1238288400000
	        }, {
	            "e": 1288486800000,
	            "s": 1269738000000
	        }, {
	            "e": 1319936400000,
	            "s": 1301187600000
	        }, {
	            "e": 1351386000000,
	            "s": 1332637200000
	        }, {
	            "e": 1382835600000,
	            "s": 1364691600000
	        }, {
	            "e": 1414285200000,
	            "s": 1396141200000
	        }]
	    }]
	};
	
	var TimeZoneUtils = function () {
	    function TimeZoneUtils() {
	        _classCallCheck(this, TimeZoneUtils);
	    }
	
	    _createClass(TimeZoneUtils, null, [{
	        key: 'getJstz',
	
	
	        /**
	         * Namespace to hold all the code for timezone detection.
	         */
	        value: function getJstz() {
	            return function () {
	                'use strict';
	
	                var HEMISPHERE_SOUTH = 's',
	                    consts = {
	                    DAY: 86400000,
	                    HOUR: 3600000,
	                    MINUTE: 60000,
	                    SECOND: 1000,
	                    BASELINE_YEAR: 2014,
	                    MAX_SCORE: 864000000, // 10 days
	                    AMBIGUITIES: {
	                        'America/Denver': ['America/Mazatlan'],
	                        'Europe/London': ['Africa/Casablanca'],
	                        'America/Chicago': ['America/Mexico_City'],
	                        'America/Asuncion': ['America/Campo_Grande', 'America/Santiago'],
	                        'America/Montevideo': ['America/Sao_Paulo', 'America/Santiago'],
	                        // Europe/Minsk should not be in this list... but Windows.
	                        'Asia/Beirut': ['Asia/Amman', 'Asia/Jerusalem', 'Europe/Helsinki', 'Asia/Damascus', 'Africa/Cairo', 'Asia/Gaza', 'Europe/Minsk'],
	                        'Pacific/Auckland': ['Pacific/Fiji'],
	                        'America/Los_Angeles': ['America/Santa_Isabel'],
	                        'America/New_York': ['America/Havana'],
	                        'America/Halifax': ['America/Goose_Bay'],
	                        'America/Godthab': ['America/Miquelon'],
	                        'Asia/Dubai': ['Asia/Yerevan'],
	                        'Asia/Jakarta': ['Asia/Krasnoyarsk'],
	                        'Asia/Shanghai': ['Asia/Irkutsk', 'Australia/Perth'],
	                        'Australia/Sydney': ['Australia/Lord_Howe'],
	                        'Asia/Tokyo': ['Asia/Yakutsk'],
	                        'Asia/Dhaka': ['Asia/Omsk'],
	                        // In the real world Yerevan is not ambigous for Baku... but Windows.
	                        'Asia/Baku': ['Asia/Yerevan'],
	                        'Australia/Brisbane': ['Asia/Vladivostok'],
	                        'Pacific/Noumea': ['Asia/Vladivostok'],
	                        'Pacific/Majuro': ['Asia/Kamchatka', 'Pacific/Fiji'],
	                        'Pacific/Tongatapu': ['Pacific/Apia'],
	                        'Asia/Baghdad': ['Europe/Minsk', 'Europe/Moscow'],
	                        'Asia/Karachi': ['Asia/Yekaterinburg'],
	                        'Africa/Johannesburg': ['Asia/Gaza', 'Africa/Cairo']
	                    }
	                },
	
	
	                /**
	                 * Gets the offset in minutes from UTC for a certain date.
	                 * @param {Date} date
	                 * @returns {Number}
	                 */
	                get_date_offset = function get_date_offset(date) {
	                    var offset = -date.getTimezoneOffset();
	                    return offset !== null ? offset : 0;
	                },
	
	
	                /**
	                 * This function does some basic calculations to create information about
	                 * the user's timezone. It uses REFERENCE_YEAR as a solid year for which
	                 * the script has been tested rather than depend on the year set by the
	                 * client device.
	                 *
	                 * Returns a key that can be used to do lookups in TIMEZONES.
	                 * eg: "720,1,2".
	                 *
	                 * @returns {String}
	                 */
	                lookup_key = function lookup_key() {
	                    var january_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 0, 2)),
	                        june_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 5, 2)),
	                        diff = january_offset - june_offset;
	
	                    if (diff < 0) {
	                        return january_offset + ",1";
	                    } else if (diff > 0) {
	                        return june_offset + ",1," + HEMISPHERE_SOUTH;
	                    }
	
	                    return january_offset + ",0";
	                },
	
	
	                /**
	                 * Tries to get the time zone key directly from the operating system for those
	                 * environments that support the ECMAScript Internationalization API.
	                 */
	                get_from_internationalization_api = function get_from_internationalization_api() {
	                    var format, timezone;
	                    if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") {
	                        return;
	                    }
	
	                    format = Intl.DateTimeFormat();
	
	                    if (typeof format === "undefined" || typeof format.resolvedOptions === "undefined") {
	                        return;
	                    }
	
	                    timezone = format.resolvedOptions().timeZone;
	
	                    if (timezone && (timezone.indexOf("/") > -1 || timezone === 'UTC')) {
	                        return timezone;
	                    }
	                },
	
	
	                /**
	                 * Starting point for getting all the DST rules for a specific year
	                 * for the current timezone (as described by the client system).
	                 *
	                 * Returns an object with start and end attributes, or false if no
	                 * DST rules were found for the year.
	                 *
	                 * @param year
	                 * @returns {Object} || {Boolean}
	                 */
	                dst_dates = function dst_dates(year) {
	                    var yearstart = new Date(year, 0, 1, 0, 0, 1, 0).getTime();
	                    var yearend = new Date(year, 12, 31, 23, 59, 59).getTime();
	                    var current = yearstart;
	                    var offset = new Date(current).getTimezoneOffset();
	                    var dst_start = null;
	                    var dst_end = null;
	
	                    while (current < yearend - 86400000) {
	                        var dateToCheck = new Date(current);
	                        var dateToCheckOffset = dateToCheck.getTimezoneOffset();
	
	                        if (dateToCheckOffset !== offset) {
	                            if (dateToCheckOffset < offset) {
	                                dst_start = dateToCheck;
	                            }
	                            if (dateToCheckOffset > offset) {
	                                dst_end = dateToCheck;
	                            }
	                            offset = dateToCheckOffset;
	                        }
	
	                        current += 86400000;
	                    }
	
	                    if (dst_start && dst_end) {
	                        return {
	                            s: find_dst_fold(dst_start).getTime(),
	                            e: find_dst_fold(dst_end).getTime()
	                        };
	                    }
	
	                    return false;
	                },
	
	
	                /**
	                 * Probably completely unnecessary function that recursively finds the
	                 * exact (to the second) time when a DST rule was changed.
	                 *
	                 * @param a_date - The candidate Date.
	                 * @param padding - integer specifying the padding to allow around the candidate
	                 *                  date for finding the fold.
	                 * @param iterator - integer specifying how many milliseconds to iterate while
	                 *                   searching for the fold.
	                 *
	                 * @returns {Date}
	                 */
	                find_dst_fold = function find_dst_fold(a_date, padding, iterator) {
	                    if (typeof padding === 'undefined') {
	                        padding = consts.DAY;
	                        iterator = consts.HOUR;
	                    }
	
	                    var date_start = new Date(a_date.getTime() - padding).getTime();
	                    var date_end = a_date.getTime() + padding;
	                    var offset = new Date(date_start).getTimezoneOffset();
	
	                    var current = date_start;
	
	                    var dst_change = null;
	                    while (current < date_end - iterator) {
	                        var dateToCheck = new Date(current);
	                        var dateToCheckOffset = dateToCheck.getTimezoneOffset();
	
	                        if (dateToCheckOffset !== offset) {
	                            dst_change = dateToCheck;
	                            break;
	                        }
	                        current += iterator;
	                    }
	
	                    if (padding === consts.DAY) {
	                        return find_dst_fold(dst_change, consts.HOUR, consts.MINUTE);
	                    }
	
	                    if (padding === consts.HOUR) {
	                        return find_dst_fold(dst_change, consts.MINUTE, consts.SECOND);
	                    }
	
	                    return dst_change;
	                },
	                    windows7_adaptations = function windows7_adaptions(rule_list, preliminary_timezone, score, sample) {
	                    if (score !== 'N/A') {
	                        return score;
	                    }
	                    if (preliminary_timezone === 'Asia/Beirut') {
	                        if (sample.name === 'Africa/Cairo') {
	                            if (rule_list[6].s === 1398376800000 && rule_list[6].e === 1411678800000) {
	                                return 0;
	                            }
	                        }
	                        if (sample.name === 'Asia/Jerusalem') {
	                            if (rule_list[6].s === 1395964800000 && rule_list[6].e === 1411858800000) {
	                                return 0;
	                            }
	                        }
	                    } else if (preliminary_timezone === 'America/Santiago') {
	                        if (sample.name === 'America/Asuncion') {
	                            if (rule_list[6].s === 1412481600000 && rule_list[6].e === 1397358000000) {
	                                return 0;
	                            }
	                        }
	                        if (sample.name === 'America/Campo_Grande') {
	                            if (rule_list[6].s === 1413691200000 && rule_list[6].e === 1392519600000) {
	                                return 0;
	                            }
	                        }
	                    } else if (preliminary_timezone === 'America/Montevideo') {
	                        if (sample.name === 'America/Sao_Paulo') {
	                            if (rule_list[6].s === 1413687600000 && rule_list[6].e === 1392516000000) {
	                                return 0;
	                            }
	                        }
	                    } else if (preliminary_timezone === 'Pacific/Auckland') {
	                        if (sample.name === 'Pacific/Fiji') {
	                            if (rule_list[6].s === 1414245600000 && rule_list[6].e === 1396101600000) {
	                                return 0;
	                            }
	                        }
	                    }
	
	                    return score;
	                },
	
	
	                /**
	                 * Takes the DST rules for the current timezone, and proceeds to find matches
	                 * in the DST_RULES.zones array.
	                 *
	                 * Compares samples to the current timezone on a scoring basis.
	                 *
	                 * Candidates are ruled immediately if either the candidate or the current zone
	                 * has a DST rule where the other does not.
	                 *
	                 * Candidates are ruled out immediately if the current zone has a rule that is
	                 * outside the DST scope of the candidate.
	                 *
	                 * Candidates are included for scoring if the current zones rules fall within the
	                 * span of the samples rules.
	                 *
	                 * Low score is best, the score is calculated by summing up the differences in DST
	                 * rules and if the consts.MAX_SCORE is overreached the candidate is ruled out.
	                 *
	                 * Yah follow? :)
	                 *
	                 * @param rule_list
	                 * @param preliminary_timezone
	                 * @returns {*}
	                 */
	                best_dst_match = function best_dst_match(rule_list, preliminary_timezone) {
	                    var score_sample = function score_sample(sample) {
	                        var score = 0;
	
	                        for (var j = 0; j < rule_list.length; j++) {
	
	                            // Both sample and current time zone report DST during the year.
	                            if (!!sample.rules[j] && !!rule_list[j]) {
	
	                                // The current time zone's DST rules are inside the sample's. Include.
	                                if (rule_list[j].s >= sample.rules[j].s && rule_list[j].e <= sample.rules[j].e) {
	                                    score = 0;
	                                    score += Math.abs(rule_list[j].s - sample.rules[j].s);
	                                    score += Math.abs(sample.rules[j].e - rule_list[j].e);
	
	                                    // The current time zone's DST rules are outside the sample's. Discard.
	                                } else {
	                                    score = 'N/A';
	                                    break;
	                                }
	
	                                // The max score has been reached. Discard.
	                                if (score > consts.MAX_SCORE) {
	                                    score = 'N/A';
	                                    break;
	                                }
	                            }
	                        }
	
	                        score = windows7_adaptations(rule_list, preliminary_timezone, score, sample);
	
	                        return score;
	                    };
	                    var scoreboard = {};
	                    var dst_zones = DST_RULES.zones;
	                    var dst_zones_length = dst_zones.length;
	                    var ambiguities = consts.AMBIGUITIES[preliminary_timezone];
	
	                    for (var i = 0; i < dst_zones_length; i++) {
	                        var sample = dst_zones[i];
	                        var score = score_sample(dst_zones[i]);
	
	                        if (score !== 'N/A') {
	                            scoreboard[sample.name] = score;
	                        }
	                    }
	
	                    for (var tz in scoreboard) {
	                        if (scoreboard.hasOwnProperty(tz)) {
	                            for (var j = 0; j < ambiguities.length; j++) {
	                                if (ambiguities[j] === tz) {
	                                    return tz;
	                                }
	                            }
	                        }
	                    }
	
	                    return preliminary_timezone;
	                },
	
	
	                /**
	                 * Takes the preliminary_timezone as detected by lookup_key().
	                 *
	                 * Builds up the current timezones DST rules for the years defined
	                 * in the DST_RULES.years array.
	                 *
	                 * If there are no DST occurences for those years, immediately returns
	                 * the preliminary timezone. Otherwise proceeds and tries to solve
	                 * ambiguities.
	                 *
	                 * @param preliminary_timezone
	                 * @returns {String} timezone_name
	                 */
	                get_by_dst = function get_by_dst(preliminary_timezone) {
	                    var get_rules = function get_rules() {
	                        var rule_list = [];
	                        for (var i = 0; i < DST_RULES.years.length; i++) {
	                            var year_rules = dst_dates(DST_RULES.years[i]);
	                            rule_list.push(year_rules);
	                        }
	                        return rule_list;
	                    };
	                    var check_has_dst = function check_has_dst(rules) {
	                        for (var i = 0; i < rules.length; i++) {
	                            if (rules[i] !== false) {
	                                return true;
	                            }
	                        }
	                        return false;
	                    };
	                    var rules = get_rules();
	                    var has_dst = check_has_dst(rules);
	
	                    if (has_dst) {
	                        return best_dst_match(rules, preliminary_timezone);
	                    }
	
	                    return preliminary_timezone;
	                },
	
	
	                /**
	                 * Uses get_timezone_info() to formulate a key to use in the olson.timezones dictionary.
	                 *
	                 * Returns an object with one function ".name()"
	                 *
	                 * @returns Object
	                 */
	                determine = function determine() {
	                    var preliminary_tz = get_from_internationalization_api();
	
	                    if (!preliminary_tz) {
	                        preliminary_tz = TIMEZONES[lookup_key()];
	
	                        if (typeof consts.AMBIGUITIES[preliminary_tz] !== 'undefined') {
	                            preliminary_tz = get_by_dst(preliminary_tz);
	                        }
	                    }
	
	                    return {
	                        name: function name() {
	                            return preliminary_tz;
	                        }
	                    };
	                };
	
	                return {
	                    determine: determine
	                };
	            }();
	        }
	    }]);
	
	    return TimeZoneUtils;
	}();
	
	exports.default = TimeZoneUtils;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Class util for date
	 */
	var VersionParser = function () {
	    function VersionParser() {
	        _classCallCheck(this, VersionParser);
	    }
	
	    _createClass(VersionParser, null, [{
	        key: "parseVersion",
	
	
	        /**
	         * Parse the version name to version code (string to number)
	         *
	         * @param {String} versionName the version name of SDK
	         * @returns {Number} the version convert to number
	         */
	        value: function parseVersion(versionName) {
	            var versionNameParsed = versionName.split(".");
	            if (versionNameParsed.length != 4) {
	                return 0;
	            }
	            return this.parseVersionRec(versionNameParsed, versionNameParsed.length - 1, 1, 0);
	        }
	
	        /**
	         * Recursive method to parse version
	         *
	         * @param {Array} versionNameSplit array contains each digits of the version name
	         * @param {Number} index the index to start (from end of array)
	         * @param {Number} mult the current multiplicator
	         * @param {Number} result the result of previous iteration
	         */
	
	    }, {
	        key: "parseVersionRec",
	        value: function parseVersionRec(versionNameSplit, index, mult, result) {
	            if (index >= 0) {
	                return result + Number(this.parseVersionRec(versionNameSplit, index - 1, mult * 100, versionNameSplit[index] * mult));
	            }
	            return result;
	        }
	
	        /**
	         * Returns the current timestamp in ms
	         *
	         * @returns {Number} Current timestamp in seconds
	         */
	
	    }, {
	        key: "getCurrentTimestampMs",
	        value: function getCurrentTimestampMs() {
	            return Date.now();
	        }
	    }]);
	
	    return VersionParser;
	}();
	
	exports.default = VersionParser;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * UAParser.js v0.7.19
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 or MIT
	 */
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION = '0.7.19',
	        EMPTY = '',
	        UNKNOWN = '?',
	        FUNC_TYPE = 'function',
	        UNDEF_TYPE = 'undefined',
	        OBJ_TYPE = 'object',
	        STR_TYPE = 'string',
	        MAJOR = 'major',
	        // deprecated
	    MODEL = 'model',
	        NAME = 'name',
	        TYPE = 'type',
	        VENDOR = 'vendor',
	        VERSION = 'version',
	        ARCHITECTURE = 'architecture',
	        CONSOLE = 'console',
	        MOBILE = 'mobile',
	        TABLET = 'tablet',
	        SMARTTV = 'smarttv',
	        WEARABLE = 'wearable',
	        EMBEDDED = 'embedded';
	
	    ///////////
	    // Helper
	    //////////
	
	
	    var util = {
	        extend: function extend(regexes, extensions) {
	            var margedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    margedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    margedRegexes[i] = regexes[i];
	                }
	            }
	            return margedRegexes;
	        },
	        has: function has(str1, str2) {
	            if (typeof str1 === "string") {
	                return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	            } else {
	                return false;
	            }
	        },
	        lowerize: function lowerize(str) {
	            return str.toLowerCase();
	        },
	        major: function major(version) {
	            return (typeof version === 'undefined' ? 'undefined' : _typeof(version)) === STR_TYPE ? version.replace(/[^\d\.]/g, '').split(".")[0] : undefined;
	        },
	        trim: function trim(str) {
	            return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	        }
	    };
	
	    ///////////////
	    // Map helper
	    //////////////
	
	
	    var mapper = {
	
	        rgx: function rgx(ua, arrays) {
	
	            //var result = {},
	            var i = 0,
	                j,
	                k,
	                p,
	                q,
	                matches,
	                match; //, args = arguments;
	
	            /*// construct object barebones
	            for (p = 0; p < args[1].length; p++) {
	                q = args[1][p];
	                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
	            }*/
	
	            // loop through all regexes maps
	            while (i < arrays.length && !matches) {
	
	                var regex = arrays[i],
	                    // even sequence (0,2,4,..)
	                props = arrays[i + 1]; // odd sequence (1,3,5,..)
	                j = k = 0;
	
	                // try matching uastring with regexes
	                while (j < regex.length && !matches) {
	
	                    matches = regex[j++].exec(ua);
	
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if ((typeof q === 'undefined' ? 'undefined' : _typeof(q)) === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (_typeof(q[1]) == FUNC_TYPE) {
	                                        // assign modified match
	                                        this[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        this[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (_typeof(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length == 4) {
	                                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                this[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	            // console.log(this);
	            //return this;
	        },
	
	        str: function str(_str, map) {
	
	            for (var i in map) {
	                // check if array
	                if (_typeof(map[i]) === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], _str)) {
	                            return i === UNKNOWN ? undefined : i;
	                        }
	                    }
	                } else if (util.has(map[i], _str)) {
	                    return i === UNKNOWN ? undefined : i;
	                }
	            }
	            return _str;
	        }
	    };
	
	    ///////////////
	    // String map
	    //////////////
	
	
	    var maps = {
	
	        browser: {
	            oldsafari: {
	                version: {
	                    '1.0': '/8',
	                    '1.2': '/1',
	                    '1.3': '/3',
	                    '2.0': '/412',
	                    '2.0.2': '/416',
	                    '2.0.3': '/417',
	                    '2.0.4': '/419',
	                    '?': '/'
	                }
	            }
	        },
	
	        device: {
	            amazon: {
	                model: {
	                    'Fire Phone': ['SD', 'KF']
	                }
	            },
	            sprint: {
	                model: {
	                    'Evo Shift 4G': '7373KT'
	                },
	                vendor: {
	                    'HTC': 'APA',
	                    'Sprint': 'Sprint'
	                }
	            }
	        },
	
	        os: {
	            windows: {
	                version: {
	                    'ME': '4.90',
	                    'NT 3.11': 'NT3.51',
	                    'NT 4.0': 'NT4.0',
	                    '2000': 'NT 5.0',
	                    'XP': ['NT 5.1', 'NT 5.2'],
	                    'Vista': 'NT 6.0',
	                    '7': 'NT 6.1',
	                    '8': 'NT 6.2',
	                    '8.1': 'NT 6.3',
	                    '10': ['NT 6.4', 'NT 10.0'],
	                    'RT': 'ARM'
	                }
	            }
	        }
	    };
	
	    //////////////
	    // Regex map
	    /////////////
	
	
	    var regexes = {
	
	        browser: [[
	
	        // Presto based
	        /(opera\smini)\/([\w\.-]+)/i, // Opera Mini
	        /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, // Opera Mobi/Tablet
	        /(opera).+version\/([\w\.]+)/i, // Opera > 9.80
	        /(opera)[\/\s]+([\w\.]+)/i // Opera < 9.80
	        ], [NAME, VERSION], [/(opios)[\/\s]+([\w\.]+)/i // Opera mini on iphone >= 8.0
	        ], [[NAME, 'Opera Mini'], VERSION], [/\s(opr)\/([\w\.]+)/i // Opera Webkit
	        ], [[NAME, 'Opera'], VERSION], [
	
	        // Mixed
	        /(kindle)\/([\w\.]+)/i, // Kindle
	        /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
	        // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	
	        // Trident based
	        /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
	        // Avant/IEMobile/SlimBrowser/Baidu
	        /(?:ms|\()(ie)\s([\w\.]+)/i, // Internet Explorer
	
	        // Webkit/KHTML based
	        /(rekonq)\/([\w\.]*)/i, // Rekonq
	        /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i
	        // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
	        ], [NAME, VERSION], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i // IE11
	        ], [[NAME, 'IE'], VERSION], [/(edge|edgios|edga)\/((\d+)?[\w\.]+)/i // Microsoft Edge
	        ], [[NAME, 'Edge'], VERSION], [/(yabrowser)\/([\w\.]+)/i // Yandex
	        ], [[NAME, 'Yandex'], VERSION], [/(puffin)\/([\w\.]+)/i // Puffin
	        ], [[NAME, 'Puffin'], VERSION], [/(focus)\/([\w\.]+)/i // Firefox Focus
	        ], [[NAME, 'Firefox Focus'], VERSION], [/(opt)\/([\w\.]+)/i // Opera Touch
	        ], [[NAME, 'Opera Touch'], VERSION], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i // UCBrowser
	        ], [[NAME, 'UCBrowser'], VERSION], [/(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
	        ], [[NAME, /_/g, ' '], VERSION], [/(micromessenger)\/([\w\.]+)/i // WeChat
	        ], [[NAME, 'WeChat'], VERSION], [/(brave)\/([\w\.]+)/i // Brave browser
	        ], [[NAME, 'Brave'], VERSION], [/(qqbrowserlite)\/([\w\.]+)/i // QQBrowserLite
	        ], [NAME, VERSION], [/(QQ)\/([\d\.]+)/i // QQ, aka ShouQ
	        ], [NAME, VERSION], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i // QQBrowser
	        ], [NAME, VERSION], [/(BIDUBrowser)[\/\s]?([\w\.]+)/i // Baidu Browser
	        ], [NAME, VERSION], [/(2345Explorer)[\/\s]?([\w\.]+)/i // 2345 Browser
	        ], [NAME, VERSION], [/(MetaSr)[\/\s]?([\w\.]+)/i // SouGouBrowser
	        ], [NAME], [/(LBBROWSER)/i // LieBao Browser
	        ], [NAME], [/xiaomi\/miuibrowser\/([\w\.]+)/i // MIUI Browser
	        ], [VERSION, [NAME, 'MIUI Browser']], [/;fbav\/([\w\.]+);/i // Facebook App for iOS & Android
	        ], [VERSION, [NAME, 'Facebook']], [/safari\s(line)\/([\w\.]+)/i, // Line App for iOS
	        /android.+(line)\/([\w\.]+)\/iab/i // Line App for Android
	        ], [NAME, VERSION], [/headlesschrome(?:\/([\w\.]+)|\s)/i // Chrome Headless
	        ], [VERSION, [NAME, 'Chrome Headless']], [/\swv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
	        ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [// Oculus / Samsung Browser
	
	        /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i // Android Browser
	        ], [VERSION, [NAME, 'Android Browser']], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
	        // Chrome/OmniWeb/Arora/Tizen/Nokia
	        ], [NAME, VERSION], [/(dolfin)\/([\w\.]+)/i // Dolphin
	        ], [[NAME, 'Dolphin'], VERSION], [/((?:android.+)crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
	        ], [[NAME, 'Chrome'], VERSION], [/(coast)\/([\w\.]+)/i // Opera Coast
	        ], [[NAME, 'Opera Coast'], VERSION], [/fxios\/([\w\.-]+)/i // Firefox for iOS
	        ], [VERSION, [NAME, 'Firefox']], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i // Mobile Safari
	        ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i // Safari & Safari Mobile
	        ], [VERSION, NAME], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Google Search Appliance on iOS
	        ], [[NAME, 'GSA'], VERSION], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
	        ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [/(konqueror)\/([\w\.]+)/i, // Konqueror
	        /(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [
	
	        // Gecko based
	        /(navigator|netscape)\/([\w\.-]+)/i // Netscape
	        ], [[NAME, 'Netscape'], VERSION], [/(swiftfox)/i, // Swiftfox
	        /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	        // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	        /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,
	
	        // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	        /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, // Mozilla
	
	        // Other
	        /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	        // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	        /(links)\s\(([\w\.]+)/i, // Links
	        /(gobrowser)\/?([\w\.]*)/i, // GoBrowser
	        /(ice\s?browser)\/v?([\w\._]+)/i, // ICE Browser
	        /(mosaic)[\/\s]([\w\.]+)/i // Mosaic
	        ], [NAME, VERSION]
	
	        /* /////////////////////
	        // Media players BEGIN
	        ////////////////////////
	         , [
	         /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
	        /(coremedia) v((\d+)[\w\._]+)/i
	        ], [NAME, VERSION], [
	         /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
	        ], [NAME, VERSION], [
	         /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
	        ], [NAME, VERSION], [
	         /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
	                                                                            // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
	                                                                            // NSPlayer/PSP-InternetRadioPlayer/Videos
	        /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
	        /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
	        /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
	        ], [NAME, VERSION], [
	        /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
	        ], [NAME, VERSION], [
	         /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
	        ], [[NAME, 'Flip Player'], VERSION], [
	         /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
	                                                                            // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
	        ], [NAME], [
	         /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
	                                                                            // Gstreamer
	        ], [NAME, VERSION], [
	         /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
	        /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
	                                                                            // Java/urllib/requests/wget/cURL
	        /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
	        ], [NAME, VERSION], [
	         /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
	        ], [[NAME, /_/g, ' '], VERSION], [
	         /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
	                                                                            // MPlayer SVN
	        ], [NAME, VERSION], [
	         /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
	        ], [NAME, VERSION], [
	         /(mplayer)/i,                                                       // MPlayer (no other info)
	        /(yourmuze)/i,                                                      // YourMuze
	        /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
	        ], [NAME], [
	         /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
	        ], [NAME, VERSION], [
	         /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
	        ], [NAME, VERSION], [
	         /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
	        ], [NAME, VERSION], [
	         /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
	        /(winamp)\s((\d+)[\w\.-]+)/i,
	        /(winamp)mpeg\/((\d+)[\w\.-]+)/i
	        ], [NAME, VERSION], [
	         /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
	                                                                            // inlight radio
	        ], [NAME], [
	         /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
	                                                                            // QuickTime/RealMedia/RadioApp/RadioClientApplication/
	                                                                            // SoundTap/Totem/Stagefright/Streamium
	        ], [NAME, VERSION], [
	         /(smp)((\d+)[\d\.]+)/i                                              // SMP
	        ], [NAME, VERSION], [
	         /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
	        /(vlc)\/((\d+)[\w\.-]+)/i,
	        /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
	        /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
	        /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
	        ], [NAME, VERSION], [
	         /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
	        /(windows-media-player)\/((\d+)[\w\.-]+)/i
	        ], [[NAME, /-/g, ' '], VERSION], [
	         /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
	                                                                            // Windows Media Server
	        ], [VERSION, [NAME, 'Windows']], [
	         /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
	        ], [NAME, VERSION], [
	         /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
	        /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
	        ], [[NAME, 'rad.io'], VERSION]
	         //////////////////////
	        // Media players END
	        ////////////////////*/
	
	        ],
	
	        cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i // AMD64
	        ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
	        ], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32
	        ], [[ARCHITECTURE, 'ia32']], [
	
	        // PocketPC mistakenly identified as PowerPC
	        /windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i // PowerPC
	        ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [/(sun4\w)[;\)]/i // SPARC
	        ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
	        // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	        ], [[ARCHITECTURE, util.lowerize]]],
	
	        device: [[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i // iPad/PlayBook
	        ], [MODEL, VENDOR, [TYPE, TABLET]], [/applecoremedia\/[\w\.]+ \((ipad)/ // iPad
	        ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [/(apple\s{0,1}tv)/i // Apple TV
	        ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [/(archos)\s(gamepad2?)/i, // Archos
	        /(hp).+(touchpad)/i, // HP TouchPad
	        /(hp).+(tablet)/i, // HP Tablet
	        /(kindle)\/([\w\.]+)/i, // Kindle
	        /\s(nook)[\w\s]+build\/(\w+)/i, // Nook
	        /(dell)\s(strea[kpr\s\d]*[\dko])/i // Dell Streak
	        ], [VENDOR, MODEL, [TYPE, TABLET]], [/(kf[A-z]+)\sbuild\/.+silk\//i // Kindle Fire HD
	        ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i // Fire Phone
	        ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [/android.+aft([bms])\sbuild/i // Fire TV
	        ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [/\((ip[honed|\s\w*]+);.+(apple)/i // iPod/iPhone
	        ], [MODEL, VENDOR, [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);/i // iPod/iPhone
	        ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [/(blackberry)[\s-]?(\w+)/i, // BlackBerry
	        /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
	        // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
	        /(hp)\s([\w\s]+\w)/i, // HP iPAQ
	        /(asus)-?(\w+)/i // Asus
	        ], [VENDOR, MODEL, [TYPE, MOBILE]], [/\(bb10;\s(\w+)/i // BlackBerry 10
	        ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
	        // Asus Tablets
	        /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [/(sony)\s(tablet\s[ps])\sbuild\//i, // Sony
	        /(sony)?(?:sgp.+)\sbuild\//i], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [/\s(ouya)\s/i, // Ouya
	        /(nintendo)\s([wids3u]+)/i // Nintendo
	        ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/android.+;\s(shield)\sbuild/i // Nvidia
	        ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation\s[34portablevi]+)/i // Playstation
	        ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [/(sprint\s(\w+))/i // Sprint Phones
	        ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i // Lenovo tablets
	        ], [VENDOR, MODEL, [TYPE, TABLET]], [/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, // HTC
	        /(zte)-(\w*)/i, // ZTE
	        /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
	        // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
	        ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [/(nexus\s9)/i // HTC Nexus 9
	        ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i // Huawei
	        ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [/(microsoft);\s(lumia[\s\w]+)/i // Microsoft Lumia
	        ], [VENDOR, MODEL, [TYPE, MOBILE]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i // Microsoft Xbox
	        ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
	        ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
	
	        // Motorola
	        /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i // HbbTV devices
	        ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
	        ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [// Samsung
	        /smart-tv.+(samsung)/i], [VENDOR, [TYPE, SMARTTV], MODEL], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [/sie-(\w*)/i // Siemens
	        ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, // Nokia
	        /(nokia)[\s_-]?([\w-]*)/i], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [/android\s3\.[\s\w;-]{10}(a\d{3})/i // Acer
	        ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [/android.+([vl]k\-?\d{3})\s+build/i // LG Tablet
	        ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i // LG Tablet
	        ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [/(lg) netcast\.tv/i // LG SmartTV
	        ], [VENDOR, MODEL, [TYPE, SMARTTV]], [/(nexus\s[45])/i, // LG
	        /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [/android.+(ideatab[a-z0-9\-\s]+)/i // Lenovo
	        ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [/linux;.+((jolla));/i // Jolla
	        ], [VENDOR, MODEL, [TYPE, MOBILE]], [/((pebble))app\/[\d\.]+\s/i // Pebble
	        ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i // OPPO
	        ], [VENDOR, MODEL, [TYPE, MOBILE]], [/crkey/i // Google Chromecast
	        ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [/android.+;\s(glass)\s\d/i // Google Glass
	        ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [/android.+;\s(pixel c)[\s)]/i // Google Pixel C
	        ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [/android.+;\s(pixel( [23])?( xl)?)\s/i // Google Pixel
	        ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [/android.+;\s(\w+)\s+build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
	        /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, // Xiaomi Hongmi
	        /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, // Xiaomi Mi
	        /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i // Redmi Phones
	        ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i // Mi Pad tablets
	        ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [/android.+;\s(m[1-5]\snote)\sbuild/i // Meizu Tablet
	        ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [/(mz)-([\w-]{2,})/i // Meizu Phone
	        ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [/android.+a000(1)\s+build/i, // OnePlus
	        /android.+oneplus\s(a\d{4})\s+build/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i // RCA Tablets
	        ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i // Dell Venue Tablets
	        ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i // Verizon Tablet
	        ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i // Barnes & Noble Tablet
	        ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i // Barnes & Noble Tablet
	        ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/android.+;\s(k88)\sbuild/i // ZTE K Series Tablet
	        ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i // Swiss GEN Mobile
	        ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/android.+[;\/]\s*(zur\d{3})\s+build/i // Swiss ZUR Tablet
	        ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i // Zeki Tablets
	        ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i // Dragon Touch Tablet
	        ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i // Insignia Tablets
	        ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i // NextBook Tablets
	        ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [// Voice Xtreme Phones
	
	        /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i // LvTel Phones
	        ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/android.+;\s(PH-1)\s/i], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [// Essential PH-1
	
	        /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i // Envizen Tablets
	        ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i // Le Pan Tablets
	        ], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i // MachSpeed Tablets
	        ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i // Trinity Tablets
	        ], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*TU_(1491)\s+build/i // Rotor Tablets
	        ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/android.+(KS(.+))\s+build/i // Amazon Kindle Tablets
	        ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i // Gigaset Tablets
	        ], [VENDOR, MODEL, [TYPE, TABLET]], [/\s(tablet|tab)[;\/]/i, // Unidentifiable Tablet
	        /\s(mobile)(?:[;\/]|\ssafari)/i // Unidentifiable Mobile
	        ], [[TYPE, util.lowerize], VENDOR, MODEL], [/(android[\w\.\s\-]{0,9});.+build/i // Generic Android Device
	        ], [MODEL, [VENDOR, 'Generic']]
	
	        /*//////////////////////////
	            // TODO: move to string map
	            ////////////////////////////
	             /(C6603)/i                                                          // Sony Xperia Z C6603
	            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	            /(C6903)/i                                                          // Sony Xperia Z 1
	            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	             /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
	            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
	            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
	            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
	            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
	            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
	            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
	            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	             /(T3C)/i                                                            // Advan Vandroid T3C
	            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
	            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
	            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
	             /(V972M)/i                                                          // ZTE V972M
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	             /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
	            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
	            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	             /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
	            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
	             /////////////
	            // END TODO
	            ///////////*/
	
	        ],
	
	        engine: [[/windows.+\sedge\/([\w\.]+)/i // EdgeHTML
	        ], [VERSION, [NAME, 'EdgeHTML']], [/(presto)\/([\w\.]+)/i, // Presto
	        /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
	        /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, // KHTML/Tasman/Links
	        /(icab)[\/\s]([23]\.[\d\.]+)/i // iCab
	        ], [NAME, VERSION], [/rv\:([\w\.]{1,9}).+(gecko)/i // Gecko
	        ], [VERSION, NAME]],
	
	        os: [[
	
	        // Windows based
	        /microsoft\s(windows)\s(vista|xp)/i // Windows (iTunes)
	        ], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, // Windows RT
	        /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, // Windows Phone
	        /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [
	
	        // Mobile/Embedded OS
	        /\((bb)(10);/i // BlackBerry 10
	        ], [[NAME, 'BlackBerry'], VERSION], [/(blackberry)\w*\/?([\w\.]*)/i, // Blackberry
	        /(tizen)[\/\s]([\w\.]+)/i, // Tizen
	        /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,
	        // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
	        /linux;.+(sailfish);/i // Sailfish OS
	        ], [NAME, VERSION], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i // Symbian
	        ], [[NAME, 'Symbian'], VERSION], [/\((series40);/i // Series 40
	        ], [NAME], [/mozilla.+\(mobile;.+gecko.+firefox/i // Firefox OS
	        ], [[NAME, 'Firefox OS'], VERSION], [
	
	        // Console
	        /(nintendo|playstation)\s([wids34portablevu]+)/i, // Nintendo/Playstation
	
	        // GNU/Linux based
	        /(mint)[\/\s\(]?(\w*)/i, // Mint
	        /(mageia|vectorlinux)[;\s]/i, // Mageia/VectorLinux
	        /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
	        // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	        // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	        /(hurd|linux)\s?([\w\.]*)/i, // Hurd/Linux
	        /(gnu)\s?([\w\.]*)/i // GNU
	        ], [NAME, VERSION], [/(cros)\s[\w]+\s([\w\.]+\w)/i // Chromium OS
	        ], [[NAME, 'Chromium OS'], VERSION], [
	
	        // Solaris
	        /(sunos)\s?([\w\.\d]*)/i // Solaris
	        ], [[NAME, 'Solaris'], VERSION], [
	
	        // BSD based
	        /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	        ], [NAME, VERSION], [/(haiku)\s(\w+)/i // Haiku
	        ], [NAME, VERSION], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i // iOS
	        ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i // Mac OS
	        ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
	
	        // Other
	        /((?:open)?solaris)[\/\s-]?([\w\.]*)/i, // Solaris
	        /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, // AIX
	        /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
	        // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
	        /(unix)\s?([\w\.]*)/i // UNIX
	        ], [NAME, VERSION]]
	    };
	
	    /////////////////
	    // Constructor
	    ////////////////
	    /*
	    var Browser = function (name, version) {
	        this[NAME] = name;
	        this[VERSION] = version;
	    };
	    var CPU = function (arch) {
	        this[ARCHITECTURE] = arch;
	    };
	    var Device = function (vendor, model, type) {
	        this[VENDOR] = vendor;
	        this[MODEL] = model;
	        this[TYPE] = type;
	    };
	    var Engine = Browser;
	    var OS = Browser;
	    */
	    var UAParser = function UAParser(uastring, extensions) {
	
	        if ((typeof uastring === 'undefined' ? 'undefined' : _typeof(uastring)) === 'object') {
	            extensions = uastring;
	            uastring = undefined;
	        }
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(uastring, extensions).getResult();
	        }
	
	        var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
	        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
	        //var browser = new Browser();
	        //var cpu = new CPU();
	        //var device = new Device();
	        //var engine = new Engine();
	        //var os = new OS();
	
	        this.getBrowser = function () {
	            var browser = { name: undefined, version: undefined };
	            mapper.rgx.call(browser, ua, rgxmap.browser);
	            browser.major = util.major(browser.version); // deprecated
	            return browser;
	        };
	        this.getCPU = function () {
	            var cpu = { architecture: undefined };
	            mapper.rgx.call(cpu, ua, rgxmap.cpu);
	            return cpu;
	        };
	        this.getDevice = function () {
	            var device = { vendor: undefined, model: undefined, type: undefined };
	            mapper.rgx.call(device, ua, rgxmap.device);
	            return device;
	        };
	        this.getEngine = function () {
	            var engine = { name: undefined, version: undefined };
	            mapper.rgx.call(engine, ua, rgxmap.engine);
	            return engine;
	        };
	        this.getOS = function () {
	            var os = { name: undefined, version: undefined };
	            mapper.rgx.call(os, ua, rgxmap.os);
	            return os;
	        };
	        this.getResult = function () {
	            return {
	                ua: this.getUA(),
	                browser: this.getBrowser(),
	                engine: this.getEngine(),
	                os: this.getOS(),
	                device: this.getDevice(),
	                cpu: this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return ua;
	        };
	        this.setUA = function (uastring) {
	            ua = uastring;
	            //browser = new Browser();
	            //cpu = new CPU();
	            //device = new Device();
	            //engine = new Engine();
	            //os = new OS();
	            return this;
	        };
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME: NAME,
	        MAJOR: MAJOR, // deprecated
	        VERSION: VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE: ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL: MODEL,
	        VENDOR: VENDOR,
	        TYPE: TYPE,
	        CONSOLE: CONSOLE,
	        MOBILE: MOBILE,
	        SMARTTV: SMARTTV,
	        TABLET: TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME: NAME,
	        VERSION: VERSION
	    };
	    UAParser.OS = {
	        NAME: NAME,
	        VERSION: VERSION
	    };
	    //UAParser.Utils = util;
	
	    ///////////
	    // Export
	    //////////
	
	
	    // check js environment
	    if (( false ? 'undefined' : _typeof(exports)) !== UNDEF_TYPE) {
	        // nodejs env
	        if (( false ? 'undefined' : _typeof(module)) !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        // TODO: test!!!!!!!!
	        /*
	        if (require && require.main === module && process) {
	            // cli
	            var jsonize = function (arr) {
	                var res = [];
	                for (var i in arr) {
	                    res.push(new UAParser(arr[i]).getResult());
	                }
	                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
	            };
	            if (process.stdin.isTTY) {
	                // via args
	                jsonize(process.argv.slice(2));
	            } else {
	                // via pipe
	                var str = '';
	                process.stdin.on('readable', function() {
	                    var read = process.stdin.read();
	                    if (read !== null) {
	                        str += read;
	                    }
	                });
	                process.stdin.on('end', function () {
	                    jsonize(str.replace(/\n$/, '').split('\n'));
	                });
	            }
	        }
	        */
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if (( false ? 'undefined' : _typeof(__webpack_require__(93))) === FUNC_TYPE && __webpack_require__(94)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (window) {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = window && (window.jQuery || window.Zepto);
	    if ((typeof $ === 'undefined' ? 'undefined' : _typeof($)) !== UNDEF_TYPE && !$.ua) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function () {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	})((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' ? window : undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(92)(module)))

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _SocketDownload = __webpack_require__(96);
	
	var _SocketDownload2 = _interopRequireDefault(_SocketDownload);
	
	var _SocketUpload = __webpack_require__(98);
	
	var _SocketUpload2 = _interopRequireDefault(_SocketUpload);
	
	var _ConfigStepMscore = __webpack_require__(74);
	
	var ConfigStepMscore = _interopRequireWildcard(_ConfigStepMscore);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _DateUtil = __webpack_require__(8);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _EQmScoreStepProgress = __webpack_require__(99);
	
	var _EQmScoreStepProgress2 = _interopRequireDefault(_EQmScoreStepProgress);
	
	var _KpiMapper = __webpack_require__(100);
	
	var KpiMapper = _interopRequireWildcard(_KpiMapper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RAW_DATA_PERIOD_MS = 500;
	
	/**
	 * Manage all sockets
	 */
	
	var SocketManager = function () {
	
	    /**
	     * Default constructor
	     * @param {GpsManager} gpsManager to get location with raw data
	     * @param {UrlBuilder} urlBuilder builder to format URL
	     * @param {number} nbSockets the count of sockets to run
	     * @param {string} direction the direction of the socket (dl/ul)
	     * @param {number} timeout the timeout in ms
	     * @param {GatewayService} gatewayService the gateway service
	     */
	    function SocketManager(gpsManager, urlBuilder, nbSockets, direction, timeout, gatewayService) {
	        _classCallCheck(this, SocketManager);
	
	        this.gpsManager = gpsManager;
	        this.urlBuilder = urlBuilder;
	        this.socketCount = nbSockets;
	        this.direction = direction;
	        this.timeout = timeout;
	        this.sockets = [];
	        this.raw = [];
	        this.isTimeout = false;
	        this.gatewayService = gatewayService;
	        this.gatewayInfos = null;
	    }
	
	    /**
	     * Start all sockets
	     * @param {function} progress progress callback
	     * @param {string} url to start test
	     * @param {number} volume the volume to exchange (only for UL)
	     * @param {string} mScoreServerUrl the mscore url server
	     * @return {Promise}
	     */
	
	
	    _createClass(SocketManager, [{
	        key: "start",
	        value: function start(progress, url, volume, mScoreServerUrl) {
	            var _this = this;
	
	            _Logger2.default.log("Start test");
	            var data = null;
	            // If upload, generate data for all sockets
	            if (this.direction == ConfigStepMscore.STEP_DIRECTION_UP) {
	                var start = _DateUtil2.default.getCurrentTimestampMs();
	                data = new Uint8Array(new ArrayBuffer(volume));
	                _Logger2.default.log("Generate the file of " + volume + " bytes in " + (_DateUtil2.default.getCurrentTimestampMs() - start));
	            }
	            var startDate = _DateUtil2.default.getCurrentTimestampMs();
	            var collector = this.startCollectRaw(progress, startDate, volume);
	
	            var socketInError = 0;
	            return new Promise(function (resolve, reject) {
	                _Logger2.default.log("Call " + url);
	                setTimeout(function (self) {
	                    _Logger2.default.log("Timeout reached!");
	                    self.stop();
	                }, _this.timeout, _this);
	                Promise.all(_this.initSockets(url, data)).then(function () {
	                    _Logger2.default.log("All sockets are done");
	                    resolve({ results: _this.stopCollectorRaw(progress, collector, startDate), mScoreServerUrl: mScoreServerUrl });
	                }).catch(function (error) {
	                    socketInError++;
	                    _Logger2.default.log("Socket in error: " + socketInError);
	                    reject(error);
	                });
	            });
	        }
	
	        /**
	         * Abort all sockets
	         * @return {boolean} always true
	         */
	
	    }, {
	        key: "stop",
	        value: function stop() {
	            this.sockets.forEach(function (socket) {
	                socket.stop();
	            });
	            return true;
	        }
	
	        /**
	         * Initialize a pool of Socket
	         * @param {string} url the url to call
	         * @param {Uint8Array | null} data
	         * @return {Array.<Socket>}
	         */
	
	    }, {
	        key: "initSockets",
	        value: function initSockets(url) {
	            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            var promises = [];
	            for (var i = 0; i < this.socketCount; i++) {
	                var randomUrl = url + '&random=' + Math.random();
	                var socket = null;
	                if (this.direction === ConfigStepMscore.STEP_DIRECTION_DL) {
	                    socket = new _SocketDownload2.default(randomUrl);
	                } else {
	                    socket = new _SocketUpload2.default(randomUrl, data);
	                }
	                this.sockets.push(socket);
	                promises.push(socket.run());
	            }
	
	            return promises;
	        }
	
	        /**
	         * @return {number} the bytes exchanged by all sockets
	         */
	
	    }, {
	        key: "getTotalBytesExchanged",
	        value: function getTotalBytesExchanged() {
	            var volume = 0;
	            this.sockets.forEach(function (socket) {
	                volume += socket.volume;
	            });
	            return volume;
	        }
	
	        /**
	         *
	         * Start the raw data collect
	         *
	         * @param {function} progress the progress callback to alert each time we collect raw data
	         * @param {number} startTime the timestamp when test started
	         * @param {number} targetVolume the volume to download/upload kill socket if volume raised
	         * @return {setInterval}
	         */
	
	    }, {
	        key: "startCollectRaw",
	        value: function startCollectRaw(progress, startTime, targetVolume) {
	            var _this2 = this;
	
	            this.lastDate = _DateUtil2.default.getCurrentTimestampMs();
	            this.lastBytes = 0;
	            // Init a first raw data value
	            var rawData = this.collectRaw(this.getTotalBytesExchanged(), startTime, this.lastDate);
	            this.gatewayService.startCollect(function (err, kpi) {
	                if (!err) {
	                    _this2.gatewayInfos = kpi;
	                } else {
	                    _Logger2.default.log(err.message);
	                    if (_this2.gatewayService.getCacheInfos()) {
	                        _this2.gatewayInfos = _this2.gatewayService.getCacheInfos()[KpiMapper.RAW];
	                    } else {
	                        _this2.gatewayInfos = null;
	                    }
	                }
	            }, RAW_DATA_PERIOD_MS);
	            this.raw.push(rawData);
	            // Collect raw data at interval
	            return setInterval(function () {
	                var currentTime = _DateUtil2.default.getCurrentTimestampMs();
	                var rawData = _this2.collectRaw(_this2.getTotalBytesExchanged(), startTime, currentTime);
	                progress(rawData);
	                _this2.raw.push(rawData);
	                if (rawData.totalBytes > targetVolume) {
	                    _this2.stop();
	                }
	            }, RAW_DATA_PERIOD_MS);
	        }
	
	        /**
	         *
	         * @param {function} progress
	         * @param {setInterval} collector
	         * @param {number} startTime start time
	         * @return {Array.<EQmScoreStepProgress>}
	         */
	
	    }, {
	        key: "stopCollectorRaw",
	        value: function stopCollectorRaw(progress, collector, startTime) {
	            clearInterval(collector);
	            var rawData = this.collectRaw(this.getTotalBytesExchanged(), startTime, _DateUtil2.default.getCurrentTimestampMs());
	            this.gatewayService.stopCollect();
	            this.gatewayInfos = null;
	            progress(rawData);
	            this.raw.push(rawData);
	            return this.raw;
	        }
	
	        /**
	         * Collect a raw data
	         *
	         * @param {number} totalBytes total bytes exchanged since the beginning
	         * @param {number} startTime the timestamp when test started
	         * @param {number} currentTime the current timestamp
	         * @return {EQmScoreStepProgress} the raw data collected
	         */
	
	    }, {
	        key: "collectRaw",
	        value: function collectRaw(totalBytes, startTime, currentTime) {
	            var lastBytes = this.lastBytes;
	            this.lastBytes = totalBytes;
	            var lastDate = this.lastDate;
	            this.lastDate = currentTime;
	
	            return new _EQmScoreStepProgress2.default(this.direction, currentTime, totalBytes - lastBytes, currentTime - lastDate, totalBytes, currentTime - startTime, this.gpsManager.get(), this.timeout, this.gatewayInfos);
	        }
	    }]);
	
	    return SocketManager;
	}();
	
	exports.default = SocketManager;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Socket2 = __webpack_require__(97);
	
	var _Socket3 = _interopRequireDefault(_Socket2);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import * as SocketConstants from "./Socket";
	//import streamSaver from "streamsaver";
	//streamSaver.mitm = window.location.protocol  + "//" + window.location.hostname + "/mitm.html?version=" + streamSaver.version.full
	
	
	/**
	 * Socket for download task
	 */
	var SocketDownload = function (_Socket) {
	    _inherits(SocketDownload, _Socket);
	
	    function SocketDownload(url) {
	        _classCallCheck(this, SocketDownload);
	
	        return _possibleConstructorReturn(this, (SocketDownload.__proto__ || Object.getPrototypeOf(SocketDownload)).call(this, url));
	    }
	
	    _createClass(SocketDownload, [{
	        key: "runInternal",
	        value: function runInternal(httpRequest, resolve) {
	            var _this2 = this;
	
	            _Logger2.default.log("GET " + this.url);
	            _Logger2.default.log("Mode : " + this.mode);
	            /*if (this.mode === SocketConstants.MODE_FETCH_STREAM && !process.env.NODE_ENV) {
	                const fileStream = streamSaver.createWriteStream("download" + Math.random());
	                this.writer = fileStream.getWriter();
	                this.controller = new window["AbortController"]();
	                this.signal = this.controller.signal;
	                 const options = {
	                    method: "GET",
	                    // headers: new Headers({"Access-Control-Request-Method": "GET"}),
	                    signal : this.signal
	                };
	                 fetch(this.url, options).then(res => {
	                    const reader = res.body.getReader();
	                    this.httpStatus  = res.status;
	                    const pump = () => reader.read()
	                        .then(({ value, done }) => {
	                            if (done) {
	                                this.writer.close();
	                                resolve();
	                            } else {
	                                if (value) {
	                                    this.volume += value.length;
	                                }
	                                this.writer.write(value)
	                                    .then(pump)
	                                    .catch((e) => {
	                                        Logger.log(e);
	                                        this.hasFailed = true;
	                                        resolve();
	                                    });
	                            }
	                        }).catch(() => {
	                            //this.writer.close();
	                            resolve();
	                        });
	                     pump().then(() => {
	                        //resolve();
	                    });
	                }).then(() => {
	                 }).catch(() => {
	                    this.hasFailed = true;
	                    resolve();
	                });
	             } else if (this.mode === SocketConstants.MODE_XML_HTTP_REQUEST) {*/
	            httpRequest.open("GET", this.url, true);
	
	            //httpRequest.setRequestHeader('Access-Control-Request-Method', 'GET');
	
	            httpRequest.addEventListener("progress", function (evt) {
	                _this2.volume = evt.loaded;
	            }, false);
	            httpRequest.addEventListener("load", function () {
	                _this2.httpStatus = _this2.httpRequest.status;
	                resolve();
	            }, false);
	            httpRequest.addEventListener("error", function () {
	                _Logger2.default.log("=> Socket error");
	                _this2.httpStatus = _this2.httpRequest.status;
	                _this2.hasFailed = true;
	                resolve();
	            }, false);
	            httpRequest.addEventListener("abort", function () {
	                _Logger2.default.log("=> Stopping abort");
	                resolve();
	            }, false);
	            httpRequest.send();
	            //}
	        }
	    }]);
	
	    return SocketDownload;
	}(_Socket3.default);
	
	exports.default = SocketDownload;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MODE_FETCH_STREAM = exports.MODE_XML_HTTP_REQUEST = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MODE_XML_HTTP_REQUEST = exports.MODE_XML_HTTP_REQUEST = 0;
	var MODE_FETCH_STREAM = exports.MODE_FETCH_STREAM = 1;
	
	/**
	 * Socket parent class
	 */
	
	var Socket = function () {
	
	    /**
	     * @param {string} url to call
	     */
	    function Socket(url) {
	        _classCallCheck(this, Socket);
	
	        this.url = url;
	        this.httpRequest = new XMLHttpRequest();
	        this.writer = null;
	        this.signal = null;
	        this.controller = null;
	        this.volume = 0;
	        this.httpStatus = -1;
	        this.hasFailed = false;
	        this.mode = MODE_XML_HTTP_REQUEST;
	
	        if (window["fetch"] && window["AbortController"] && window["WritableStream"] && window["ReadableStream"]) {
	            // Pre requistes
	            var ua = navigator.userAgent.toLowerCase();
	            var versionArray = ua.substring(ua.indexOf("chrome") + 7).split(".");
	            if (ua.indexOf("chrome") > 0 && versionArray.length > 0 && parseInt(versionArray[0]) >= 42) {// README EWA-124 : Only supports Chrome 42+ currently
	                //Logger.log("Using fetch stream socket mode (supported browser)");
	                //this.mode = MODE_FETCH_STREAM;
	            }
	        }
	    }
	
	    /**
	     * Call to start the socket transfer
	     * /!\ DONT OVERRIDE THIS METHOD
	     * @return {Promise}
	     */
	
	
	    _createClass(Socket, [{
	        key: "run",
	        value: function run() {
	            var _this = this;
	
	            return new Promise(function (resolve) {
	                _this.runInternal(_this.httpRequest, resolve);
	            });
	        }
	
	        /**
	         * Call when socket should start its transfer
	         * /!\ SHOULD BE OVERRIDEN BY SUBCLASS
	         *
	         * @param httpRequest
	         * @param resolve
	         */
	        /*eslint-disable no-unused-vars*/
	
	    }, {
	        key: "runInternal",
	        value: function runInternal(httpRequest, resolve) {}
	    }, {
	        key: "stop",
	        value: function stop() {
	            _Logger2.default.log("Aborting socket");
	            if (this.mode === MODE_FETCH_STREAM) {
	                this.writer.abort();
	                this.controller.abort();
	            } else if (this.mode === MODE_XML_HTTP_REQUEST) {
	                this.httpRequest.abort();
	            }
	        }
	    }]);
	
	    return Socket;
	}();
	
	exports.default = Socket;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Socket2 = __webpack_require__(97);
	
	var _Socket3 = _interopRequireDefault(_Socket2);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Socket for upload task
	 */
	var SocketUpload = function (_Socket) {
	    _inherits(SocketUpload, _Socket);
	
	    /**
	     *
	     * @param {string} url full to call mScore post
	     * @param {Uint8Array | null} data to send
	     */
	    function SocketUpload(url, data) {
	        _classCallCheck(this, SocketUpload);
	
	        var _this = _possibleConstructorReturn(this, (SocketUpload.__proto__ || Object.getPrototypeOf(SocketUpload)).call(this, url));
	
	        _this.data = data;
	        return _this;
	    }
	
	    _createClass(SocketUpload, [{
	        key: "stop",
	        value: function stop() {
	            _Logger2.default.log("Aborting socket");
	            this.httpRequest.abort();
	        }
	    }, {
	        key: "runInternal",
	        value: function runInternal(httpRequest, resolve) {
	            var _this2 = this;
	
	            _Logger2.default.log("POST " + this.url);
	
	            httpRequest.open("POST", this.url, true);
	
	            //httpRequest.setRequestHeader('Access-Control-Request-Method', 'POST');
	            //httpRequest.setRequestHeader('Access-Control-Request-Headers', 'X-Requested-With');
	
	            var data = new Blob([this.data], { type: 'text/plain' });
	            _Logger2.default.log('Blob length : ' + data.size);
	
	            httpRequest.addEventListener("load", function (load) {
	                _Logger2.default.log(load);
	                _this2.httpStatus = _this2.httpRequest.status;
	                resolve();
	            }, false);
	            httpRequest.addEventListener("error", function () {
	                _Logger2.default.log('error');
	                _this2.httpStatus = _this2.httpRequest.status;
	                _this2.hasFailed = true;
	                resolve();
	            }, false);
	            httpRequest.addEventListener("abort", function () {
	                _Logger2.default.log('abort');
	                resolve();
	            }, false);
	            httpRequest.addEventListener("onabort", function () {
	                _Logger2.default.log('onabort');
	                resolve();
	            }, false);
	            httpRequest.addEventListener("loadend", function () {
	                _Logger2.default.log('loadend');
	                _this2.httpStatus = _this2.httpRequest.status;
	                resolve();
	            }, false);
	            httpRequest.addEventListener("readystatechange", function () {
	                _Logger2.default.log('onreadystatechange');
	                _Logger2.default.log(httpRequest);
	            }, false);
	            httpRequest.upload.addEventListener("progress", function (evt) {
	                _this2.volume = evt.loaded;
	            }, false);
	            httpRequest.send(data);
	        }
	    }]);
	
	    return SocketUpload;
	}(_Socket3.default);
	
	exports.default = SocketUpload;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StepExecutor = __webpack_require__(82);
	
	var Step = _interopRequireWildcard(_StepExecutor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Class used to alert UI
	 */
	var EQmScoreStepProgress = function () {
	
	    /**
	     *
	     * @param {string} direction
	     * @param {number} timestamp of the measure in ms
	     * @param {number} instantBytes
	     * @param {number} instantTime
	     * @param {number} totalBytes
	     * @param {number} sessionTime
	     * @param {GpsInfos} gpsInfos
	     * @param {number} timeout
	     * @param {object} gatewayInfos
	     */
	    function EQmScoreStepProgress(direction, timestamp, instantBytes, instantTime, totalBytes, sessionTime, gpsInfos, timeout, gatewayInfos) {
	        _classCallCheck(this, EQmScoreStepProgress);
	
	        this.type = Step.STEP_MSCORE;
	        this.timestamp = timestamp;
	        this.direction = direction;
	        this.instantBytes = instantBytes;
	        this.instantTime = instantTime;
	        this.totalBytes = totalBytes;
	        this.sessionTime = sessionTime;
	        this.gpsInfos = gpsInfos;
	        this.timeout = timeout;
	        this.routerInfos = gatewayInfos; // Gateway is called router in APIs
	    }
	
	    _createClass(EQmScoreStepProgress, [{
	        key: "instantThroughput",
	        value: function instantThroughput() {
	            if (this.sessionTime == 0) {
	                return 0;
	            }
	            return this.totalBytes / 1000 / (this.sessionTime / 1000) * 8;
	        }
	    }]);
	
	    return EQmScoreStepProgress;
	}();
	
	exports.default = EQmScoreStepProgress;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RAW = exports.END = exports.BEGIN = exports.COMMON = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RawKpiConstants = __webpack_require__(101);
	
	var RawKpiConstants = _interopRequireWildcard(_RawKpiConstants);
	
	var _BearerEnum = __webpack_require__(102);
	
	var Bearer = _interopRequireWildcard(_BearerEnum);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var COMMON = exports.COMMON = "GLOBAL";
	var BEGIN = exports.BEGIN = "BEGIN";
	var END = exports.END = "END";
	var RAW = exports.RAW = "RAW";
	
	var KpiMapper = function () {
	    /**
	     * Constructor
	     *
	     */
	    function KpiMapper() {
	        _classCallCheck(this, KpiMapper);
	    }
	
	    /**
	     * Map a key value if value is not null
	     *
	     * @param kpi
	     * @param key
	     * @param value
	     */
	
	
	    _createClass(KpiMapper, [{
	        key: "mapValue",
	        value: function mapValue(kpi, key, value) {
	            if (value !== null && value !== "undefined" && typeof value != "undefined") {
	                if (typeof value.code != "undefined") {
	                    kpi[key] = value.code;
	                } else {
	                    kpi[key] = value;
	                }
	            } else {
	                _Logger2.default.log("Invalid kpi for key " + key + " / " + value);
	            }
	        }
	
	        /**
	         * Map common kpi part
	         *
	         * @param rawKpi
	         * @param kpi
	         */
	
	    }, {
	        key: "mapCommon",
	        value: function mapCommon(rawKpi, kpi) {
	            kpi[COMMON] = {};
	
	            this.mapValue(kpi[COMMON], "firmware", rawKpi[RawKpiConstants.HARDWARE_VERSION]);
	            this.mapValue(kpi[COMMON], "iccid", rawKpi[RawKpiConstants.ICCID]);
	            this.mapValue(kpi[COMMON], "imei", rawKpi[RawKpiConstants.IMEI]);
	            this.mapValue(kpi[COMMON], "model", rawKpi[RawKpiConstants.MODEL]);
	            this.mapValue(kpi[COMMON], "uid", rawKpi[RawKpiConstants.SERIAL_NUMBER]);
	            this.mapValue(kpi[COMMON], "manufacturer", rawKpi[RawKpiConstants.BRAND]);
	            this.mapValue(kpi[COMMON], "os_version", rawKpi[RawKpiConstants.SOFTWARE_VERSION]);
	
	            this.mapValue(kpi[COMMON], "sim_imsi", rawKpi[RawKpiConstants.IMSI]);
	            this.mapValue(kpi[COMMON], "sim_msisdn", rawKpi[RawKpiConstants.MSISDN]);
	            this.mapValue(kpi[COMMON], "sim_state", rawKpi[RawKpiConstants.SIM_STATUS]);
	            this.mapValue(kpi[COMMON], "private_ip", rawKpi[RawKpiConstants.LOCAL_IP]);
	            this.mapValue(kpi[COMMON], "private_ip_protocol", rawKpi[RawKpiConstants.LOCAL_IP_PROTOCOL]);
	            this.mapValue(kpi[COMMON], "public_ip", rawKpi[RawKpiConstants.WAN_IP]);
	            this.mapValue(kpi[COMMON], "public_ip_protocol", rawKpi[RawKpiConstants.WAN_IP_PROTOCOL]);
	            // TODO: Set those fields in specific proto fields - temporary fix
	            this.mapValue(kpi[COMMON], "agt_custom_int_1", rawKpi[RawKpiConstants.WIFI_USERS]);
	            this.mapValue(kpi[COMMON], "agt_custom_string_1", rawKpi[RawKpiConstants.HARDWARE_VERSION]);
	            this.mapValue(kpi[COMMON], "agt_custom_string_2", rawKpi[RawKpiConstants.MODEL]);
	        }
	
	        /**
	         * Map begin informations
	         *
	         * @param rawKpi
	         * @param kpi
	         */
	
	    }, {
	        key: "mapBegin",
	        value: function mapBegin(rawKpi, kpi) {
	            kpi[BEGIN] = {};
	
	            this.mapValue(kpi[BEGIN], "rad_bearer", rawKpi[RawKpiConstants.BEARER]);
	            this.mapValue(kpi[BEGIN], "rad_ci", rawKpi[RawKpiConstants.CELL_ID]);
	            this.mapValue(kpi[BEGIN], "lte_ci_start", rawKpi[RawKpiConstants.CELL_ID_4G]);
	            this.mapValue(kpi[BEGIN], "rad_lac", rawKpi[RawKpiConstants.LAC]);
	            this.mapValue(kpi[BEGIN], "rad_mcc", rawKpi[RawKpiConstants.MCC]);
	            this.mapValue(kpi[BEGIN], "rad_mnc", rawKpi[RawKpiConstants.MNC]);
	            this.mapValue(kpi[BEGIN], "rad_net_state", rawKpi[RawKpiConstants.NETSTAT]);
	            this.mapValue(kpi[BEGIN], "pci_start", rawKpi[RawKpiConstants.PCI]);
	            this.mapValue(kpi[BEGIN], "psc_start", rawKpi[RawKpiConstants.PSC]);
	            this.mapValue(kpi[BEGIN], "rad_rssi", rawKpi[RawKpiConstants.RSCP]);
	            if (rawKpi[RawKpiConstants.BEARER]) {
	                switch (rawKpi[RawKpiConstants.BEARER].code) {
	                    case Bearer.GPRS.code:
	                    case Bearer.EDGE.code:
	                    case Bearer.GSM.code:
	                    case Bearer.GSM_RAT.code:
	                    case Bearer.TYPE_2G.code:
	                        break;
	                    case Bearer.UMTS.code:
	                    case Bearer.CDMA.code:
	                    case Bearer.EVDO_0.code:
	                    case Bearer.EVDO_A.code:
	                    case Bearer.EVDO_B.code:
	                    case Bearer.C1XRTT.code:
	                    case Bearer.HSDPA.code:
	                    case Bearer.HSUPA.code:
	                    case Bearer.HSPA.code:
	                    case Bearer.IDEN.code:
	                    case Bearer.EHRPD.code:
	                    case Bearer.HSPAP.code:
	                    case Bearer.DUAL_CARRIER.code:
	                    case Bearer.TYPE_3G.code:
	                        this.mapValue(kpi[BEGIN], "signal_quality_start", rawKpi[RawKpiConstants.ECNO]);
	                        this.mapValue(kpi[BEGIN], "served_signal_start", rawKpi[RawKpiConstants.RSCP]);
	                        break;
	                    case Bearer.LTE.code:
	                    case Bearer.TYPE_4G.code:
	                    case Bearer.LTE_A.code:
	                        this.mapValue(kpi[BEGIN], "signal_quality_start", rawKpi[RawKpiConstants.RSRQ]);
	                        this.mapValue(kpi[BEGIN], "served_signal_start", rawKpi[RawKpiConstants.RSRP]);
	                        this.mapValue(kpi[BEGIN], "lte_bandwidth", rawKpi[RawKpiConstants.DL_BANDWIDTH]);
	                        break;
	                }
	            }
	
	            if (rawKpi[RawKpiConstants.RSSI]) {
	                this.mapValue(kpi[BEGIN], "rad_rssi", rawKpi[RawKpiConstants.RSSI]);
	            } else {
	                this.mapValue(kpi[BEGIN], "rad_rssi", kpi[BEGIN]["served_signal_start"]);
	            }
	
	            this.mapValue(kpi[BEGIN], "snr_start", rawKpi[RawKpiConstants.SNR]);
	            this.mapValue(kpi[BEGIN], "wifi_ssid", rawKpi[RawKpiConstants.WIFI_SSID]);
	            this.mapValue(kpi[BEGIN], "wifi_state", rawKpi[RawKpiConstants.WIFI_STATUS]);
	            this.mapValue(kpi[BEGIN], "earfcn", rawKpi[RawKpiConstants.EARFCN]);
	            this.mapValue(kpi[BEGIN], "rad_band", rawKpi[RawKpiConstants.RAD_BAND]);
	        }
	
	        /**
	         * Map end informations
	         *
	         * @param rawKpi
	         * @param kpi
	         */
	
	    }, {
	        key: "mapEnd",
	        value: function mapEnd(rawKpi, kpi) {
	            kpi[END] = {};
	
	            this.mapValue(kpi[END], "rad_bearer_end", rawKpi[RawKpiConstants.BEARER]);
	            this.mapValue(kpi[END], "rad_ci_end", rawKpi[RawKpiConstants.CELL_ID]);
	            this.mapValue(kpi[END], "lte_ci_end", rawKpi[RawKpiConstants.CELL_ID_4G]);
	            this.mapValue(kpi[END], "signal_quality_end", rawKpi[RawKpiConstants.ECNO]);
	            this.mapValue(kpi[END], "rad_lac_end", rawKpi[RawKpiConstants.LAC]);
	            this.mapValue(kpi[END], "rad_mcc_end", rawKpi[RawKpiConstants.MCC]);
	            this.mapValue(kpi[END], "rad_mnc_end", rawKpi[RawKpiConstants.MNC]);
	            this.mapValue(kpi[END], "rad_net_state_end", rawKpi[RawKpiConstants.NETSTAT]);
	            this.mapValue(kpi[END], "pci_end", rawKpi[RawKpiConstants.PCI]);
	            this.mapValue(kpi[END], "psc_end", rawKpi[RawKpiConstants.PSC]);
	            if (rawKpi[RawKpiConstants.BEARER]) {
	                switch (rawKpi[RawKpiConstants.BEARER].code) {
	                    case Bearer.GPRS.code:
	                    case Bearer.EDGE.code:
	                    case Bearer.GSM.code:
	                    case Bearer.GSM_RAT.code:
	                    case Bearer.TYPE_2G.code:
	                        break;
	                    case Bearer.UMTS.code:
	                    case Bearer.CDMA.code:
	                    case Bearer.EVDO_0.code:
	                    case Bearer.EVDO_A.code:
	                    case Bearer.EVDO_B.code:
	                    case Bearer.C1XRTT.code:
	                    case Bearer.HSDPA.code:
	                    case Bearer.HSUPA.code:
	                    case Bearer.HSPA.code:
	                    case Bearer.IDEN.code:
	                    case Bearer.EHRPD.code:
	                    case Bearer.HSPAP.code:
	                    case Bearer.DUAL_CARRIER.code:
	                    case Bearer.TYPE_3G.code:
	                        this.mapValue(kpi[END], "signal_quality_end", rawKpi[RawKpiConstants.ECNO]);
	                        this.mapValue(kpi[END], "served_signal_end", rawKpi[RawKpiConstants.RSCP]);
	                        break;
	                    case Bearer.LTE.code:
	                    case Bearer.TYPE_4G.code:
	                    case Bearer.LTE_A.code:
	                        this.mapValue(kpi[END], "signal_quality_end", rawKpi[RawKpiConstants.RSRQ]);
	                        this.mapValue(kpi[END], "served_signal_end", rawKpi[RawKpiConstants.RSRP]);
	                        this.mapValue(kpi[END], "lte_bandwidth_end", rawKpi[RawKpiConstants.DL_BANDWIDTH]);
	                        break;
	                }
	            }
	
	            if (rawKpi[RawKpiConstants.RSSI]) {
	                this.mapValue(kpi[END], "rad_rssi_end", rawKpi[RawKpiConstants.RSSI]);
	            } else {
	                this.mapValue(kpi[END], "rad_rssi_end", kpi[END]["served_signal_end"]);
	            }
	            this.mapValue(kpi[END], "snr_end", rawKpi[RawKpiConstants.SNR]);
	            this.mapValue(kpi[END], "wifi_ssid_end", rawKpi[RawKpiConstants.WIFI_SSID]);
	            this.mapValue(kpi[END], "wifi_state_end", rawKpi[RawKpiConstants.WIFI_STATUS]);
	            this.mapValue(kpi[END], "earfcn_end", rawKpi[RawKpiConstants.EARFCN]);
	            this.mapValue(kpi[END], "rad_band_end", rawKpi[RawKpiConstants.RAD_BAND]);
	        }
	
	        /**
	         * Do the mapping for protocol buffer from a raw kpi
	         *
	         * @param rawKpi
	         * @returns {Promise}
	         */
	
	    }, {
	        key: "map",
	        value: function map(rawKpi) {
	            var _this = this;
	
	            return new Promise(function (resolve) {
	                var kpi = {};
	                kpi[RAW] = rawKpi;
	                _this.mapCommon(rawKpi, kpi);
	                _this.mapBegin(rawKpi, kpi);
	                _this.mapEnd(rawKpi, kpi);
	
	                resolve(kpi);
	            });
	        }
	    }]);
	
	    return KpiMapper;
	}();
	
	/*
	
	mapCommon(rawKpi, kpi) {
	    kpi[COMMON] = {};
	
	    this.mapValue(kpi[COMMON], "boot.os_build", rawKpi[RawKpiConstants.HARDWARE_VERSION]);
	    this.mapValue(kpi[COMMON], "boot.iccid", rawKpi[RawKpiConstants.ICCID]);
	    this.mapValue(kpi[COMMON], "boot.imei", rawKpi[RawKpiConstants.IMEI]);
	    this.mapValue(kpi[COMMON], "boot.model", rawKpi[RawKpiConstants.MODEL]);
	    this.mapValue(kpi[COMMON], "boot.uid", rawKpi[RawKpiConstants.SERIAL_NUMBER]);
	    this.mapValue(kpi[COMMON], "boot.manufacturer", rawKpi[RawKpiConstants.BRAND]);
	    this.mapValue(kpi[COMMON], "boot.os_version", rawKpi[RawKpiConstants.SOFTWARE_VERSION]);
	
	    this.mapValue(kpi[COMMON], "sim.imsi", rawKpi[RawKpiConstants.IMSI]);
	    this.mapValue(kpi[COMMON], "sim.msisdn", rawKpi[RawKpiConstants.MSISDN]);
	    this.mapValue(kpi[COMMON], "sim.sim_state", rawKpi[RawKpiConstants.SIM_STATUS]);
	    this.mapValue(kpi[COMMON], "ipAddress.private_ip", rawKpi[RawKpiConstants.LOCAL_IP]);
	    this.mapValue(kpi[COMMON], "ipAddress.private_ip_protocol", rawKpi[RawKpiConstants.LOCAL_IP_PROTOCOL]);
	    this.mapValue(kpi[COMMON], "ipAddress.public_ip", rawKpi[RawKpiConstants.WAN_IP]);
	    this.mapValue(kpi[COMMON], "ipAddress.public_ip_protocol", rawKpi[RawKpiConstants.WAN_IP_PROTOCOL]);
	}
	
	mapBegin(rawKpi, kpi) {
	    kpi[BEGIN] = {};
	
	    this.mapValue(kpi[BEGIN], "radio_begin.rad_bearer", rawKpi[RawKpiConstants.BEARER]);
	    this.mapValue(kpi[BEGIN], "radio_begin.rad_ci", rawKpi[RawKpiConstants.CELL_ID]);
	    this.mapValue(kpi[BEGIN], "radio_begin.lte_ci_start", rawKpi[RawKpiConstants.CELL_ID_4G]);
	    this.mapValue(kpi[BEGIN], "radio_begin.signal_quality_start", rawKpi[RawKpiConstants.ECNO]);
	    this.mapValue(kpi[BEGIN], "radio_begin.rad_lac", rawKpi[RawKpiConstants.LAC]);
	    this.mapValue(kpi[BEGIN], "radio_begin.rad_mcc", rawKpi[RawKpiConstants.MCC]);
	    this.mapValue(kpi[BEGIN], "radio_begin.rad_mnc", rawKpi[RawKpiConstants.MNC]);
	    this.mapValue(kpi[BEGIN], "radio_begin.rad_net_state", rawKpi[RawKpiConstants.NETSTAT]);
	    this.mapValue(kpi[BEGIN], "radio_begin.pci_start", rawKpi[RawKpiConstants.PCI]);
	    this.mapValue(kpi[BEGIN], "radio_begin.psc_start", rawKpi[RawKpiConstants.PSC]);
	    this.mapValue(kpi[BEGIN], "radio_begin.served_signal_start", rawKpi[RawKpiConstants.RSCP]);
	    this.mapValue(kpi[BEGIN], "radio_begin.rad_rssi", rawKpi[RawKpiConstants.RSCP]);
	    this.mapValue(kpi[BEGIN], "radio_begin.served_signal_start", rawKpi[RawKpiConstants.RSRP]);
	    this.mapValue(kpi[BEGIN], "radio_begin.signal_quality_start", rawKpi[RawKpiConstants.RSRQ]);
	    this.mapValue(kpi[BEGIN], "radio_begin.rad_rssi", rawKpi[RawKpiConstants.RSSI]);
	    switch(rawKpi[RawKpiConstants.BEARER]) {
	        case Bearer.GPRS:
	        case Bearer.EDGE:
	        case Bearer.GSM:
	        case Bearer.GSM_RAT:
	        case Bearer.TYPE_2G:
	            this.mapValue(kpi[BEGIN], "radio_begin.served_signal_start", rawKpi[RawKpiConstants.RSSI]);
	            break;
	    }
	    this.mapValue(kpi[BEGIN], "radio_begin.snr_start", rawKpi[RawKpiConstants.SNR]);
	    this.mapValue(kpi[BEGIN], "wifi_begin.wifi_ssid", rawKpi[RawKpiConstants.WIFI_SSID]);
	    this.mapValue(kpi[BEGIN], "wifi_begin.wifi_state", rawKpi[RawKpiConstants.WIFI_STATUS]);
	}
	
	mapEnd(rawKpi, kpi) {
	    kpi[END] = {};
	
	    this.mapValue(kpi[END], "radio_end.rad_bearer", rawKpi[RawKpiConstants.BEARER]);
	    this.mapValue(kpi[END], "radio_end.rad_ci", rawKpi[RawKpiConstants.CELL_ID]);
	    this.mapValue(kpi[END], "radio_end.lte_ci_end", rawKpi[RawKpiConstants.CELL_ID_4G]);
	    this.mapValue(kpi[END], "radio_end.signal_quality_end", rawKpi[RawKpiConstants.ECNO]);
	    this.mapValue(kpi[END], "radio_end.rad_lac", rawKpi[RawKpiConstants.LAC]);
	    this.mapValue(kpi[END], "radio_end.rad_mcc", rawKpi[RawKpiConstants.MCC]);
	    this.mapValue(kpi[END], "radio_end.rad_mnc", rawKpi[RawKpiConstants.MNC]);
	    this.mapValue(kpi[END], "radio_end.rad_net_state", rawKpi[RawKpiConstants.NETSTAT]);
	    this.mapValue(kpi[END], "radio_end.pci_end", rawKpi[RawKpiConstants.PCI]);
	    this.mapValue(kpi[END], "radio_end.psc_end", rawKpi[RawKpiConstants.PSC]);
	    this.mapValue(kpi[END], "radio_end.served_signal_end", rawKpi[RawKpiConstants.RSCP]);
	    this.mapValue(kpi[END], "radio_end.rad_rssi", rawKpi[RawKpiConstants.RSCP]);
	    this.mapValue(kpi[END], "radio_end.served_signal_end", rawKpi[RawKpiConstants.RSRP]);
	    this.mapValue(kpi[END], "radio_end.signal_quality_end", rawKpi[RawKpiConstants.RSRQ]);
	    this.mapValue(kpi[END], "radio_end.rad_rssi", rawKpi[RawKpiConstants.RSSI]);
	    switch(rawKpi[RawKpiConstants.BEARER]) {
	        case Bearer.GPRS:
	        case Bearer.EDGE:
	        case Bearer.GSM:
	        case Bearer.GSM_RAT:
	        case Bearer.TYPE_2G:
	            this.mapValue(kpi[END], "radio_end.served_signal_end", rawKpi[RawKpiConstants.RSSI]);
	            break;
	    }
	    this.mapValue(kpi[END], "radio_end.snr_end", rawKpi[RawKpiConstants.SNR]);
	    this.mapValue(kpi[END], "wifi_end.wifi_ssid", rawKpi[RawKpiConstants.WIFI_SSID]);
	    this.mapValue(kpi[END], "wifi_end.wifi_state", rawKpi[RawKpiConstants.WIFI_STATUS]);
	}
	
	 */
	
	
	exports.default = KpiMapper;

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API_RETRIEVAL_TIME = exports.API_RETRIEVAL_TIME = "API_RETRIEVAL_TIME";
	var API_TIMESTAMP = exports.API_TIMESTAMP = "API_TIMESTAMP";
	var LOCAL_IP = exports.LOCAL_IP = "LOCAL_IP";
	var LOCAL_IP_PROTOCOL = exports.LOCAL_IP_PROTOCOL = "LOCAL_IP_PROTOCOL";
	var WAN_IP = exports.WAN_IP = "WAN_IP";
	var WAN_IP_PROTOCOL = exports.WAN_IP_PROTOCOL = "WAN_IP_PROTOCOL";
	var MODEL = exports.MODEL = "MODEL";
	var SERIAL_NUMBER = exports.SERIAL_NUMBER = "SERIAL_NUMBER";
	var IMEI = exports.IMEI = "IMEI";
	var IMSI = exports.IMSI = "IMSI";
	var ICCID = exports.ICCID = "ICCID";
	var MSISDN = exports.MSISDN = "MSISDN";
	var HARDWARE_VERSION = exports.HARDWARE_VERSION = "HARDWARE_VERSION";
	var SOFTWARE_VERSION = exports.SOFTWARE_VERSION = "SOFTWARE_VERSION";
	var BEARER = exports.BEARER = "BEARER";
	var NETSTAT = exports.NETSTAT = "NETSTAT";
	var SIM_STATUS = exports.SIM_STATUS = "SIM_STATUS";
	var WIFI_USERS = exports.WIFI_USERS = "WIFI_USERS";
	var WIFI_STATUS = exports.WIFI_STATUS = "WIFI_STATUS";
	var WIFI_SSID = exports.WIFI_SSID = "WIFI_SSID";
	var WIFI_CHANNEL = exports.WIFI_CHANNEL = "WIFI_CHANNEL";
	var WIFI_BANDWIDTH = exports.WIFI_BANDWIDTH = "WIFI_BANDWIDTH";
	var PCI = exports.PCI = "PCI";
	var PSC = exports.PSC = "PSC";
	var CELL_ID = exports.CELL_ID = "CELL_ID";
	var CELL_ID_4G = exports.CELL_ID_4G = "CELL_ID_4G";
	var LAC = exports.LAC = "LAC";
	var RSRQ = exports.RSRQ = "RSRQ";
	var RSRP = exports.RSRP = "RSRP";
	var RSSI = exports.RSSI = "RSSI";
	var SNR = exports.SNR = "SNR";
	var RSCP = exports.RSCP = "RSCP";
	var ECNO = exports.ECNO = "ECNO";
	var MNC = exports.MNC = "MNC";
	var MCC = exports.MCC = "MCC";
	var BRAND = exports.BRAND = "BRAND";
	var TIMESTAMP = exports.TIMESTAMP = "TIMESTAMP";
	var DL_BANDWIDTH = exports.DL_BANDWIDTH = "DL_BANDWIDTH";
	var EARFCN = exports.EARFCN = "EARFCN";
	var RAD_BAND = exports.RAD_BAND = "RAD_BAND";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UNSUPPORTED = exports.UNSUPPORTED = { code: -1, label: "UNSUPPORTED" };
	var UNKNOWN = exports.UNKNOWN = { code: 0, label: "UNKNOWN" };
	var GPRS = exports.GPRS = { code: 1, label: "GPRS" };
	var EDGE = exports.EDGE = { code: 2, label: "EDGE" };
	var UMTS = exports.UMTS = { code: 3, label: "UMTS" };
	var CDMA = exports.CDMA = { code: 4, label: "CDMA" };
	var EVDO_0 = exports.EVDO_0 = { code: 5, label: "EVDO 0" };
	var EVDO_A = exports.EVDO_A = { code: 6, label: "EVDO A" };
	var C1XRTT = exports.C1XRTT = { code: 7, label: "1XRTT" };
	var HSDPA = exports.HSDPA = { code: 8, label: "HSDPA" };
	var HSUPA = exports.HSUPA = { code: 9, label: "HSUPA" };
	var HSPA = exports.HSPA = { code: 10, label: "HSPA" };
	var IDEN = exports.IDEN = { code: 11, label: "IDEN" };
	var EVDO_B = exports.EVDO_B = { code: 12, label: "EVDO B" };
	var LTE = exports.LTE = { code: 13, label: "LTE" };
	var EHRPD = exports.EHRPD = { code: 14, label: "EHRPD" };
	var HSPAP = exports.HSPAP = { code: 15, label: "HSPAP" };
	var GSM = exports.GSM = { code: 16, label: "GSM" };
	var DUAL_CARRIER = exports.DUAL_CARRIER = { code: 30, label: "DUAL_CARRIER" };
	var WIFI = exports.WIFI = { code: 100, label: "WIFI" };
	var GSM_RAT = exports.GSM_RAT = { code: 101, label: "GSM_RAT" };
	var TYPE_2G = exports.TYPE_2G = { code: 103, label: "2G" };
	var TYPE_3G = exports.TYPE_3G = { code: 104, label: "3G" };
	var TYPE_4G = exports.TYPE_4G = { code: 105, label: "4G" };
	var IWLAN = exports.IWLAN = { code: 18, label: "IWLAN" };
	var LTE_A = exports.LTE_A = { code: 31, label: "LTE A" };

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _ResultWebService = __webpack_require__(104);
	
	var _ResultWebService2 = _interopRequireDefault(_ResultWebService);
	
	var _ResultParser = __webpack_require__(106);
	
	var _ResultParser2 = _interopRequireDefault(_ResultParser);
	
	var _MscoreStepExecutor = __webpack_require__(85);
	
	var MscoreConst = _interopRequireWildcard(_MscoreStepExecutor);
	
	var _EQmScoreStepDone = __webpack_require__(107);
	
	var _EQmScoreStepDone2 = _interopRequireDefault(_EQmScoreStepDone);
	
	var _ConfigWebService = __webpack_require__(12);
	
	var ConfigWebServicesConst = _interopRequireWildcard(_ConfigWebService);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MINIMUM_RETURNED_MEAN_OPINION_SCORE = 1.0;
	var MINIMUM_MEAN_OPINION_SCORE = 1.0;
	var MAXIMUM_RETURNED_MEAN_OPINION_SCORE = 4.4;
	var MAXIMUM_MEAN_OPINION_SCORE = 5.0;
	var DEFAULT_GET_RESULTS_TIMEOUT = 5000;
	
	/**
	 * Retrieve the result of the mScore test
	 */
	
	var ResultManager = function () {
	
	    /**
	     * Default constructor
	     * @param {UrlBuilder} urlBuilder builder to format URL
	     */
	    function ResultManager(urlBuilder) {
	        _classCallCheck(this, ResultManager);
	
	        this.urlBuilder = urlBuilder;
	        this.resultWebService = new _ResultWebService2.default();
	        this.resultParser = new _ResultParser2.default();
	        this.timeout = false;
	    }
	
	    /**
	     * @param {string} url to get results
	     * @param {Array.<EQmScoreStepProgress>} rawData
	     * @param {string} The best mScore server url
	     * @param {ConfigStepMscore} configuration server
	     * @return {Promise}
	     */
	
	
	    _createClass(ResultManager, [{
	        key: "getResult",
	        value: function getResult(url, rawData, mScoreServerUrl, configuration) {
	            var _this = this;
	
	            var self = this;
	            self.timeout = false;
	            var timeoutTimer = null;
	
	            return new Promise(function (resolve) {
	                var randomUrl = url + '&random=' + Math.random();
	                _Logger2.default.log("Get results from " + randomUrl);
	
	                timeoutTimer = setTimeout(function () {
	                    self.timeout = true;
	                    _Logger2.default.log("Timeout on get resbaseUrlults");
	                    resolve(self.computeResult(configuration, rawData, mScoreServerUrl));
	                }, configuration && configuration.params && configuration.params.posttimeout ? parseInt(configuration.params.posttimeout) * 1000 : DEFAULT_GET_RESULTS_TIMEOUT);
	
	                _this.resultWebService.getResult(randomUrl, rawData).then(function (result) {
	                    if (!self.timeout) {
	                        var mScoreResult = _this.resultParser.parse(result);
	                        if (timeoutTimer) {
	                            clearTimeout(timeoutTimer);
	                        }
	                        resolve(_this.computeResult(configuration, rawData, mScoreServerUrl, mScoreResult));
	                    }
	                }).catch(function (error) {
	                    if (!self.timeout) {
	                        _Logger2.default.log(error);
	                        if (timeoutTimer) {
	                            clearTimeout(timeoutTimer);
	                        }
	                        resolve(_this.computeResult(configuration, rawData, mScoreServerUrl));
	                    }
	                });
	            });
	        }
	
	        /**
	         * Straighten Mean opinion score to value between 1 and 5
	         *
	         * @param mos
	         * @returns {*} Null if no mos or out of bounds, otherwise straighten mos
	         */
	
	    }, {
	        key: "straightenMos",
	        value: function straightenMos(mos) {
	            if (mos) {
	                var mosFloat = parseFloat(mos);
	
	                if (MINIMUM_RETURNED_MEAN_OPINION_SCORE <= mosFloat && mosFloat <= MAXIMUM_RETURNED_MEAN_OPINION_SCORE) {
	                    var returnedRange = MAXIMUM_RETURNED_MEAN_OPINION_SCORE - MINIMUM_RETURNED_MEAN_OPINION_SCORE;
	                    var range = MAXIMUM_MEAN_OPINION_SCORE - MINIMUM_MEAN_OPINION_SCORE;
	
	                    return Math.round(((mosFloat - MINIMUM_RETURNED_MEAN_OPINION_SCORE) * range / returnedRange + MINIMUM_MEAN_OPINION_SCORE) * 100) / 100;
	                }
	            }
	
	            return null;
	        }
	
	        /**
	         * Compute the test result from mScore if available
	         *
	         * @param {ConfigStepMscore} configuration server
	         * @param {Array.<EQmScoreStepProgress>} rawData direction the direction of the test (dl/ul)
	         * @param {string} The best mScore server url
	         * @param {MscoreResult} result the result from mScore if available
	         * @return {EQmScoreStepDone} the result
	         */
	
	    }, {
	        key: "computeResult",
	        value: function computeResult(configuration, rawData, mScoreServerUrl) {
	            var result = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	            var lastRaw = rawData[rawData.length - 1];
	            var maxThroughput = void 0;
	            var avgThroughput = void 0;
	            var minLatency = void 0;
	            var time = void 0;
	            var volume = void 0;
	            var extras = null;
	            var baseUrl = this.urlBuilder.buildBaseUrl(mScoreServerUrl);
	            var mos = null;
	            var rootCauseAnalysis1 = null;
	            // EWA-39 Add flag to indicate if failed to get results from mScore server
	            var computeFailed = false;
	            if (result) {
	                maxThroughput = result.maxThroughput;
	                avgThroughput = result.avgThroughput;
	                minLatency = result.minLatency;
	                time = result.sessionTime;
	                volume = result.volume;
	                extras = result.extras;
	                rootCauseAnalysis1 = result.rootCauseAnalysis1;
	                mos = this.straightenMos(result.mos);
	            } else {
	                computeFailed = true;
	                maxThroughput = this.getMaxThroughput(rawData);
	                avgThroughput = lastRaw.totalBytes / 1000 / (lastRaw.sessionTime / 1000) * 8;
	                minLatency = -1;
	                time = lastRaw.sessionTime;
	                volume = lastRaw.totalBytes;
	            }
	
	            var chartUrl = null;
	            if (result) {
	                chartUrl = configuration.portalUrl + ConfigWebServicesConst.WEBSERVICE_EXT + "/mScoreChart/" + (result && result.extras && result.extras.TEST ? result.extras.TEST : "shooter") + "/" + (result && result.extras && result.extras.DA_SID ? result.extras.DA_SID : "unknown") + "?server=" + encodeURIComponent(baseUrl);
	            }
	            return new _EQmScoreStepDone2.default(MscoreConst.STATUS_SUCCESS, lastRaw.direction, configuration.getService(), configuration.getModule(), computeFailed, volume, time, maxThroughput, avgThroughput, minLatency, extras, baseUrl, mos, rootCauseAnalysis1, chartUrl);
	        }
	
	        /**
	         * Compute the max throughput from raw data
	         *
	         * @param {Array.<EQmScoreStepProgress>} rawData direction the direction of the test (dl/ul)
	         */
	
	    }, {
	        key: "getMaxThroughput",
	        value: function getMaxThroughput(rawData) {
	            var maxThroughput = 0;
	            rawData.forEach(function (data) {
	                if (maxThroughput < data.instantThroughput()) {
	                    maxThroughput = data.instantThroughput();
	                }
	            });
	
	            return maxThroughput;
	        }
	    }]);
	
	    return ResultManager;
	}();
	
	exports.default = ResultManager;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _WebService2 = __webpack_require__(13);
	
	var _WebService3 = _interopRequireDefault(_WebService2);
	
	var _RawDataParser = __webpack_require__(105);
	
	var _RawDataParser2 = _interopRequireDefault(_RawDataParser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Post the request to mScore to get results
	 */
	var ResultWebService = function (_WebService) {
	    _inherits(ResultWebService, _WebService);
	
	    function ResultWebService() {
	        _classCallCheck(this, ResultWebService);
	
	        var _this = _possibleConstructorReturn(this, (ResultWebService.__proto__ || Object.getPrototypeOf(ResultWebService)).call(this));
	
	        _this.rawDataParser = new _RawDataParser2.default();
	        return _this;
	    }
	
	    /**
	     *
	     * @param {string} url
	     * @param {Array.<EQmScoreStepProgress>} rawData the raw data
	     * @return {Promise}
	     */
	
	
	    _createClass(ResultWebService, [{
	        key: "getResult",
	        value: function getResult(url) {
	            var rawData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (rawData != null) {
	                return this.postRaw(url, this.rawDataParser.formatLogs(rawData));
	            }
	            return this.get(url);
	        }
	    }]);
	
	    return ResultWebService;
	}(_WebService3.default);
	
	exports.default = ResultWebService;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Constants = __webpack_require__(88);
	
	var Constants = _interopRequireWildcard(_Constants);
	
	var _RawKpiConstants = __webpack_require__(101);
	
	var RawKpiConstants = _interopRequireWildcard(_RawKpiConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DATA_SEPARATOR = ';';
	var LINE_SEPARATOR = ';\n';
	var EMPTY = '';
	
	var HEADER = "IFS;TIME_ELAPSED_MS;THROUGHPUT_KBPS;GPS_LAT;GPS_LONG;GPS_RADIUS;VERSION;NETSTAT;DATASTATE;MCC;MNC;CID;LAC;BEARER;PSC;RSSI;RSSI_RAW;CQI;RSRP;RSRP_RAW;RSRQ;RSRQ_RAW;SNR;SNR_RAW;IP;IMSI;WIFI_STATE;WIFI_SSID;WIFI_BSSID;WIFI_FREQ;WIFI_SPEED;WIFI_RSSI;IMEI;GPS_LAT;GPS_LONG;GPS_RADIUS;GPS_TIMESTAMP;DATE_ISO;RESERVED;";
	/**
	 * Parse the raw data generate by Web Agent to mScore format
	 */
	
	var RawDataParser = function () {
	
	    /**
	     * Empty constructor
	     */
	    function RawDataParser() {
	        _classCallCheck(this, RawDataParser);
	    }
	
	    /**
	     * Format raw data to mScore data
	     *
	     * @param {Array.<EQmScoreStepProgress>} rawData collected by agent
	     * @return {string} data to post to mScore
	     */
	
	
	    _createClass(RawDataParser, [{
	        key: "formatLogs",
	        value: function formatLogs() {
	            var _this = this;
	
	            var rawData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (!rawData) {
	                return '';
	            }
	            var lines = [];
	            rawData.forEach(function (data) {
	                lines.push(_this.formatLine(data));
	            });
	            return HEADER + '\n' + lines.join(LINE_SEPARATOR) + 'ENDOFPOST;';
	        }
	    }, {
	        key: "getGatewayInfos",
	        value: function getGatewayInfos(log, key) {
	            if (log.routerInfos && log.routerInfos[key]) {
	                if (typeof log.routerInfos[key].code != "undefined") {
	                    return log.routerInfos[key].code;
	                } else {
	                    return log.routerInfos[key];
	                }
	            } else {
	                return EMPTY;
	            }
	        }
	
	        /**
	         *
	         * @param {EQmScoreStepProgress} log
	         */
	
	    }, {
	        key: "formatLine",
	        value: function formatLine(log) {
	            var data = [];
	
	            data.push("IFS");
	            data.push(log.sessionTime);
	            data.push(log.instantThroughput());
	            data.push(log.gpsInfos.lat);
	            data.push(log.gpsInfos.long);
	            data.push(log.gpsInfos.radius);
	
	            data.push(Constants.AGENT_VERSION);
	            // data.push("2.1");
	
	            // Radio netstat
	            data.push(this.getGatewayInfos(log, RawKpiConstants.NETSTAT));
	            // Radio datastate
	            data.push(EMPTY);
	            // Radio mcc
	            data.push(this.getGatewayInfos(log, RawKpiConstants.MCC));
	            // Radio mnc
	            data.push(this.getGatewayInfos(log, RawKpiConstants.MNC));
	
	            // Radio cid
	            data.push(this.getGatewayInfos(log, RawKpiConstants.CELL_ID));
	            // Radio lac
	            data.push(EMPTY);
	            // Radio bearer
	            data.push(this.getGatewayInfos(log, RawKpiConstants.BEARER));
	            // Radio PSC/PCI
	            if (this.getGatewayInfos(log, RawKpiConstants.PSC) != EMPTY) {
	                data.push(this.getGatewayInfos(log, RawKpiConstants.PSC));
	            } else if (this.getGatewayInfos(log, RawKpiConstants.PCI) != EMPTY) {
	                data.push(this.getGatewayInfos(log, RawKpiConstants.PCI));
	            } else {
	                data.push(EMPTY);
	            }
	            // Radio RSSI
	            data.push(this.getGatewayInfos(log, RawKpiConstants.RSSI));
	            data.push(EMPTY);
	            // Radio CQI
	            data.push(EMPTY);
	            // Radio RSRP/RSCP
	            if (this.getGatewayInfos(log, RawKpiConstants.RSRP) != EMPTY) {
	                data.push(this.getGatewayInfos(log, RawKpiConstants.RSRP));
	            } else if (this.getGatewayInfos(log, RawKpiConstants.RSCP) != EMPTY) {
	                data.push(this.getGatewayInfos(log, RawKpiConstants.RSCP));
	            } else {
	                data.push(EMPTY);
	            }
	            data.push(EMPTY);
	            // Radio RSRQ/ECNO
	            if (this.getGatewayInfos(log, RawKpiConstants.RSRQ) != EMPTY) {
	                data.push(this.getGatewayInfos(log, RawKpiConstants.RSRQ));
	            } else if (this.getGatewayInfos(log, RawKpiConstants.ECNO) != EMPTY) {
	                data.push(this.getGatewayInfos(log, RawKpiConstants.ECNO));
	            } else {
	                data.push(EMPTY);
	            }
	            data.push(EMPTY);
	            // Radio SNR
	            data.push(this.getGatewayInfos(log, RawKpiConstants.SNR) == EMPTY ? 0 : this.getGatewayInfos(log, RawKpiConstants.SNR));
	            data.push(EMPTY);
	            // LOCAL IP
	            data.push(this.getGatewayInfos(log, RawKpiConstants.LOCAL_IP));
	            // SIM IMSI
	            data.push(this.getGatewayInfos(log, RawKpiConstants.IMSI));
	            // WIFI state
	            data.push(EMPTY);
	            // WIFI ssid
	            data.push(EMPTY);
	            // WIFI bssid
	            data.push(EMPTY);
	            // WIFI freq
	            data.push(EMPTY);
	            // WIFI speed
	            data.push(EMPTY);
	            // WIFI RSSI
	            data.push(EMPTY);
	            // IMEI
	            data.push(this.getGatewayInfos(log, RawKpiConstants.IMEI));
	            data.push(log.gpsInfos.lat);
	            data.push(log.gpsInfos.long);
	            data.push(log.gpsInfos.radius);
	            data.push(log.gpsInfos.timestamp);
	            // Date in ISO format of the raw data
	            data.push(new Date(log.timestamp).toISOString());
	
	            // Add a separator at the end of the line
	            return data.join(DATA_SEPARATOR) + DATA_SEPARATOR;
	        }
	    }]);
	
	    return RawDataParser;
	}();
	
	exports.default = RawDataParser;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MscoreResult = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MSCORE_HEADER = "ILS,PID,DATE,DA_SID,TEST,VOLUME_B,IP_SRC:PORT_SRC,IP_DST:PORT_DST,TCP_CONG,TIME_ELAPSED_MS,THROUGHPUT_KBPS,#SEG,#ACK,#RETRANS,#RETRANS_SACK,#RETRANS_RTO,GEOIP_AS,GEOIP_COUNTRY,GEOIP_CITY,USER_AGENT,HOST,TCP_OPTIONS,INIT_RWIN_B,MAX_RWIN_B,NB_RTT,RTT_MIN_MS,RTT_AVG_MS,RTT_MAX_MS,JITTER_MIN_MS,JITTER_AVG_MS,JITTER_MAX_MS,NB_SYN,NB_SYNACK,DA_UID,DA_GROUP_ID,DA_CELL,RCA_RWIN_PERCENT,RCA_CONGESTION_PERCENT,RCA_STALL_PERCENT,RCA_RETRANS_PERCENT,RCA_CWND_PERCENT,TARGET_RTT_MS,ACHIEVABLE_THROUGHPUT_KBPS,PERCENTILE10_THROUGHPUT_KBPS,PERCENTILE50_THROUGHPUT_KBPS,PERCENTILE90_THROUGHPUT_KBPS,PERCENTILE10_RTT_MS,PERCENTILE50_RTT_MS,PERCENTILE90_RTT_MS,PERCENTILE10_RWIN_B,PERCENTILE50_RWIN_B,PERCENTILE90_RWIN_B,PERCENTILE10_BIF_B,PERCENTILE50_BIF_B,PERCENTILE90_BIF_B,PERCENTILE10_INTERACK_MS,PERCENTILE50_INTERACK_MS,PERCENTILE90_INTERACK_MS,SCORE,#JITTER_BUFFER_UNDERRUN,#JITTER_BUFFER_OVERFLOW,#THREADS,TID,MEM_PERCENT,CPU_PERCENT,NET_THROUGHPUT_RX_KBPS,NET_THROUGHPUT_TX_KBPS,#TESTS,WD_PERCENT,VAR_PERCENT,TCP_STATE,TCP_CA_STATE,RCA_CAUSE_1,RCA_CAUSE_2,RCA_CAUSE_3,RETRANS_PERCENT,PERCENTILE10_BURSTUL_SNT_B,PERCENTILE50_BURSTUL_SNT_B,PERCENTILE90_BURSTUL_SNT_B,PERCENTILE10_BURSTUL_RCV_B,PERCENTILE50_BURSTUL_RCV_B,PERCENTILE90_BURSTUL_RCV_B,PERCENTILE10_BURSTDL_SNT_B,PERCENTILE50_BURSTDL_SNT_B,PERCENTILE90_BURSTDL_SNT_B,PERCENTILE10_SCORE,PERCENTILE50_SCORE,PERCENTILE90_SCORE,LISTEN_BACKLOG,RTT_SYNACK_MS,SSL_DELAY_MS,TIME_TO_SERVICE_MS,SYN_SOCKETS,SOCKETS,CLOSE_SOCKETS,STATUS,STATUS_CAUSE,DA_FIELDS,MSCORE_VERSION,";
	
	var AVERAGE_THROUGHPUT_KEY = "THROUGHPUT_KBPS";
	var MAX_THROUGHPUT_KEY = "PERCENTILE90_THROUGHPUT_KBPS";
	var MIN_RTT = "RTT_MIN_MS";
	var SESSION_TIME_KEY = "TIME_ELAPSED_MS";
	var VOLUME_KEY = "VOLUME_B";
	var MOS = "SCORE";
	var RCA1 = "RCA_CAUSE_1";
	
	/**
	 * Parse the result provided by mScore
	 */
	
	var ResultParser = function () {
	    function ResultParser() {
	        _classCallCheck(this, ResultParser);
	    }
	
	    /**
	     * Parse the IFS from mScore
	     * @param {string} result IFS returned by mScore
	     * @return {MscoreResult | null}
	     */
	
	
	    _createClass(ResultParser, [{
	        key: "parse",
	        value: function parse(result) {
	            _Logger2.default.log("Result: " + result);
	            var headers = MSCORE_HEADER.split(",");
	            var results = result.split(",");
	            if (headers.length > results.length) {
	                _Logger2.default.log("Failed to parse the mScore ILS (missing fields [" + headers.length + "," + results.length + "])");
	                return null;
	            } else {
	                var data = new Map();
	                for (var i = 0; i < headers.length; i++) {
	                    data.set(headers[i], results[i].trim());
	                }
	
	                // Create Object for extras data (don't use Map for < ES6)
	                var map = {};
	                data.forEach(function (value, key) {
	                    map[key] = value;
	                });
	
	                return new MscoreResult(data.get(MAX_THROUGHPUT_KEY).trim(), data.get(AVERAGE_THROUGHPUT_KEY).trim(), data.get(SESSION_TIME_KEY).trim(), data.get(VOLUME_KEY).trim(), data.get(MIN_RTT).trim(), data.get(MOS).trim(), data.get(RCA1).trim(), map);
	            }
	        }
	    }]);
	
	    return ResultParser;
	}();
	
	/**
	 * mScore results
	 */
	
	
	exports.default = ResultParser;
	
	var MscoreResult =
	
	/**
	 *
	 * @param {number} maxThroughput
	 * @param {number} avgThroughput
	 * @param {number} sessionTime
	 * @param {number} volume
	 * @param {number} minLatency
	 * @param {number} mos
	 * @param {string} rca1
	 * @param {Object} extras
	 */
	exports.MscoreResult = function MscoreResult(maxThroughput, avgThroughput, sessionTime, volume, minLatency, mos, rca1) {
	    var extras = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
	
	    _classCallCheck(this, MscoreResult);
	
	    this.maxThroughput = parseInt(maxThroughput);
	    this.avgThroughput = parseInt(avgThroughput);
	    this.sessionTime = parseInt(sessionTime);
	    this.volume = parseInt(volume);
	    this.minLatency = parseInt(minLatency);
	    this.mos = mos;
	    this.rootCauseAnalysis1 = rca1;
	    this.extras = extras;
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StepExecutor = __webpack_require__(82);
	
	var Step = _interopRequireWildcard(_StepExecutor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Class used to alert UI when test is done
	 */
	var EQmScoreStepDone =
	
	/**
	 *
	 * @param {string} status
	 * @param {string} direction
	 * @param {number} service
	 * @param {number} module
	 * @param {boolean} computeFailed
	 * @param {number} totalBytes
	 * @param {number} sessionTime
	 * @param {number} maxThroughput
	 * @param {number} averageThroughput
	 * @param {number} minLatency
	 * @param {Object} extras
	 * @param {string} baseUrl
	 * @param {number} mos
	 * @param {string} rootCauseAnalysis1
	 * @param {string} chartUrl
	 */
	function EQmScoreStepDone(status, direction, service) {
	  var module = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	  var computeFailed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	  var totalBytes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	  var sessionTime = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	  var maxThroughput = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
	  var averageThroughput = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
	  var minLatency = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
	  var extras = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
	  var baseUrl = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : '';
	  var mos = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
	  var rootCauseAnalysis1 = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : null;
	  var chartUrl = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : null;
	
	  _classCallCheck(this, EQmScoreStepDone);
	
	  this.type = Step.STEP_MSCORE;
	  this.computeFailed = computeFailed;
	  this.status = status;
	  this.direction = direction;
	  this.service = service;
	  this.module = module;
	  this.totalBytes = totalBytes;
	  this.sessionTime = sessionTime;
	  this.maxThroughput = maxThroughput;
	  this.averageThroughput = averageThroughput;
	  this.minLatency = minLatency;
	  this.extras = extras;
	  this.baseUrl = baseUrl;
	  this.mos = mos;
	  this.rootCauseAnalysis1 = rootCauseAnalysis1;
	  this.chartUrl = chartUrl;
	};
	
	exports.default = EQmScoreStepDone;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BEST_MSCORE_SERVER_COUNT = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _WebService = __webpack_require__(13);
	
	var _WebService2 = _interopRequireDefault(_WebService);
	
	var _MscoreStepPersist = __webpack_require__(9);
	
	var _MscoreStepPersist2 = _interopRequireDefault(_MscoreStepPersist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BEST_MSCORE_SERVER_COUNT = exports.BEST_MSCORE_SERVER_COUNT = 5;
	
	/**
	 * Represent a mScore step
	 */
	
	var MscoreBestServer = function () {
	
	    /**
	     * @param {ConfigStepMscore} configuration server
	     * @param {UrlBuilder} url builder
	     */
	    function MscoreBestServer(configuration, urlBuilder) {
	        _classCallCheck(this, MscoreBestServer);
	
	        this.configuration = configuration;
	        this.urlBuilder = urlBuilder;
	        this.webService = new _WebService2.default();
	        this.persistence = new _MscoreStepPersist2.default();
	    }
	
	    /**
	     * Select random mScore servers
	     * @returns {Array} The list of servers
	     */
	
	
	    _createClass(MscoreBestServer, [{
	        key: "selectBestMScoreServerRandomly",
	        value: function selectBestMScoreServerRandomly() {
	            var selectedServers = [];
	            var configurationServers = Array.from(this.configuration.servers);
	
	            // Select previous server URL
	            var previousBestMScoreServerUrl = this.persistence.getBestMscoreServer(this.configuration);
	            if (previousBestMScoreServerUrl) {
	                selectedServers.push(previousBestMScoreServerUrl);
	                var i = configurationServers.indexOf(previousBestMScoreServerUrl);
	                if (i > -1) {
	                    configurationServers.splice(i, 1);
	                }
	            }
	
	            _Logger2.default.log("Server list count for step : " + configurationServers.length);
	            while (selectedServers.length < BEST_MSCORE_SERVER_COUNT && configurationServers.length > 0) {
	                var serverIndex = Math.floor(Math.random() * configurationServers.length);
	                selectedServers.push(configurationServers[serverIndex]);
	                configurationServers.splice(serverIndex, 1);
	            }
	
	            return selectedServers;
	        }
	
	        /**
	         * Return a promise which select best mScore server
	         * @returns {Promise}
	         */
	
	    }, {
	        key: "bestServer",
	        value: function bestServer() {
	            var webService = this.webService;
	            var persist = this.persistence;
	            var stepConfig = this.configuration;
	
	            // For backward compliancy and avoid useless calls, return directly the server without doing anything if there is only one server set
	            if (stepConfig.servers.length == 1) {
	                return new Promise(function (resolve) {
	                    resolve(stepConfig.servers[0]);
	                });
	            }
	
	            var selectedServers = this.selectBestMScoreServerRandomly();
	
	            _Logger2.default.log("Server random list : ");
	            _Logger2.default.log(selectedServers);
	
	            // Build promises array
	            var checkUrlPromises = [];
	            var urlBuilder = this.urlBuilder;
	            var errorCount = 0;
	
	            // Create promises for each URL
	            selectedServers.forEach(function (mScoreSelectedServer) {
	                var checkUrl = urlBuilder.buildCheckServerUrl(mScoreSelectedServer);
	                checkUrlPromises.push(new Promise(function (resolve, reject) {
	                    webService.get(checkUrl).then(function (content) {
	                        _Logger2.default.log(content);
	                        resolve(mScoreSelectedServer);
	                    }).catch(function (error) {
	                        errorCount++;
	                        if (errorCount == selectedServers.length) {
	                            reject(error);
	                        }
	                    });
	                }));
	            });
	
	            // Return the promise.race
	            return new Promise(function (resolve, reject) {
	                Promise.race(checkUrlPromises).then(function (mScoreServerUrl) {
	                    _Logger2.default.log("Best mScore server picked URL : " + mScoreServerUrl);
	                    persist.saveBestMscoreServer(mScoreServerUrl, stepConfig);
	                    resolve(mScoreServerUrl);
	                }).catch(function (error) {
	                    _Logger2.default.log("Best mScore server pick failed");
	                    _Logger2.default.log(error);
	                    reject(error);
	                });
	            });
	        }
	    }]);
	
	    return MscoreBestServer;
	}();
	
	exports.default = MscoreBestServer;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfigStepPause = __webpack_require__(73);
	
	var _ConfigStepPause2 = _interopRequireDefault(_ConfigStepPause);
	
	var _ConfigStepMscore = __webpack_require__(74);
	
	var _ConfigStepMscore2 = _interopRequireDefault(_ConfigStepMscore);
	
	var _EQPauseStepConfig = __webpack_require__(110);
	
	var _EQPauseStepConfig2 = _interopRequireDefault(_EQPauseStepConfig);
	
	var _EQmScoreStepConfig = __webpack_require__(111);
	
	var _EQmScoreStepConfig2 = _interopRequireDefault(_EQmScoreStepConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Create step executor from config
	 */
	var StepConfigFactory = function () {
	    function StepConfigFactory() {
	        _classCallCheck(this, StepConfigFactory);
	    }
	
	    _createClass(StepConfigFactory, null, [{
	        key: "getStepPublicConfig",
	
	
	        /**
	         * Transform an internal config to public config
	         * @param {ConfigStepPause | ConfigStepMscore} stepConfig to transform
	         * @return {EQPauseStepConfig | EQmScoreStepConfig | null} null if config type not supported
	         */
	        value: function getStepPublicConfig(stepConfig) {
	            if (stepConfig instanceof _ConfigStepPause2.default) {
	                return new _EQPauseStepConfig2.default(stepConfig.pause);
	            } else if (stepConfig instanceof _ConfigStepMscore2.default) {
	                return new _EQmScoreStepConfig2.default(stepConfig.getDirection(), stepConfig.getSocketCount(), stepConfig.getService(), stepConfig.getModule(), stepConfig.getTimeout(), stepConfig.getParams());
	            }
	
	            return null;
	        }
	    }]);
	
	    return StepConfigFactory;
	}();
	
	exports.default = StepConfigFactory;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var STEP_PAUSE_TYPE = exports.STEP_PAUSE_TYPE = 'pause';
	
	/**
	 * Pause step detail
	 */
	
	var EQPauseStepConfig =
	
	/**
	 * @param {number} pause duration
	 */
	function EQPauseStepConfig(pause) {
	  _classCallCheck(this, EQPauseStepConfig);
	
	  this.type = STEP_PAUSE_TYPE;
	  this.pause = parseInt(pause);
	  Object.freeze(this);
	};
	
	exports.default = EQPauseStepConfig;

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var STEP_MSCORE_TYPE = exports.STEP_MSCORE_TYPE = 'mscore';
	
	/**
	 * mScore step detail
	 */
	
	var EQmScoreStepConfig =
	
	/**
	 * Default constructor
	 *
	 * @param {string} direction
	 * @param {number} socketCount
	 * @param {number} service
	 * @param {number} module
	 * @param {number} timeout
	 * @param {object} params
	 */
	function EQmScoreStepConfig(direction, socketCount, service, module, timeout, params) {
	  _classCallCheck(this, EQmScoreStepConfig);
	
	  this.type = STEP_MSCORE_TYPE;
	  this.direction = direction;
	  this.socketCount = socketCount;
	  this.service = service;
	  this.module = module;
	  this.timeout = timeout;
	  this.params = params;
	  Object.freeze(this);
	};
	
	exports.default = EQmScoreStepConfig;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Wrapper manager who provide user location
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _GpsInfos = __webpack_require__(113);
	
	var GpsInfosEnum = _interopRequireWildcard(_GpsInfos);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GpsManagerWrapper = function () {
	  /**
	   * Constructor
	   *
	   * @param {GpsManager} gpsManager The Gps manager
	   * @param {ConfigGps} gpsConfiguration The configuration
	   */
	  function GpsManagerWrapper(gpsManager, gpsConfiguration) {
	    _classCallCheck(this, GpsManagerWrapper);
	
	    /**
	     * @type {GpsManager}
	     */
	    this.gpsManager = gpsManager;
	    /**
	     * @type {ConfigGps}
	     */
	    this.gpsConfiguration = gpsConfiguration;
	  }
	
	  /**
	   * Return the last gps informations if not disabled by configuration
	   *
	   * @returns {GpsInfos} The GPS informations
	   */
	
	
	  _createClass(GpsManagerWrapper, [{
	    key: "get",
	    value: function get() {
	      if (!this.gpsConfiguration || this.gpsConfiguration && this.gpsConfiguration.enabled) {
	        return this.gpsManager.lastGpsInfos;
	      } else {
	        _Logger2.default.log("GPS coordinates disbale in scenario");
	        return new GpsInfosEnum.default(GpsInfosEnum.GPS_STATE_CAMPAIGN_DISABLED);
	      }
	    }
	  }]);
	
	  return GpsManagerWrapper;
	}();
	
	exports.default = GpsManagerWrapper;

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GPS_STATE_NOT_SUPPORTED = exports.GPS_STATE_NOT_SUPPORTED = -1;
	var GPS_STATE_UNKNOWN = exports.GPS_STATE_UNKNOWN = 0;
	var GPS_STATE_USER_DISABLED = exports.GPS_STATE_USER_DISABLED = 1;
	var GPS_STATE_CAMPAIGN_DISABLED = exports.GPS_STATE_CAMPAIGN_DISABLED = 3;
	var GPS_STATE_BOTH = exports.GPS_STATE_BOTH = 10;
	
	/**
	 * Contains all information about a GPS collect
	 */
	
	var GpsInfos =
	
	/**
	 * @param {int} status
	 * @param {number|null} lat
	 * @param {number|null} long
	 * @param {number|null} timestamp
	 * @param {number|null} radius
	 * @param {string|null} city
	 * @param {string|null} country
	 * @param {string|null} countryCode
	 * @param {string|null} postalCode
	 * @param {string|null} streetNumber
	 * @param {string|null} streetName
	 */
	function GpsInfos() {
	  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : GPS_STATE_UNKNOWN;
	  var lat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var long = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var timestamp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	  var radius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	  var city = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	  var country = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
	  var countryCode = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
	  var postalCode = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
	  var streetNumber = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
	  var streetName = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
	
	  _classCallCheck(this, GpsInfos);
	
	  this.status = status;
	  this.lat = lat;
	  this.long = long;
	  this.timestamp = timestamp;
	  this.radius = radius;
	  this.city = city;
	  this.country = country;
	  this.countryCode = countryCode;
	  this.postalCode = postalCode;
	  this.streetNumber = streetNumber;
	  this.streetName = streetName;
	  Object.freeze(this);
	};
	
	exports.default = GpsInfos;

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Contains public information about a script
	 */
	var EQScript =
	
	/**
	 *
	 * @param {number} key the script ID
	 * @param {string} label the script label from configuration
	 */
	function EQScript(key, label, iterations, steps, gpsEnabled) {
	  _classCallCheck(this, EQScript);
	
	  this.key = key;
	  this.label = label;
	  this.iterations = iterations;
	  this.steps = steps;
	  this.gpsEnabled = gpsEnabled;
	};
	
	exports.default = EQScript;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _Service2 = __webpack_require__(4);
	
	var _Service3 = _interopRequireDefault(_Service2);
	
	var _ConfigGps = __webpack_require__(72);
	
	var _ConfigGps2 = _interopRequireDefault(_ConfigGps);
	
	var _GpsManager = __webpack_require__(116);
	
	var _GpsManager2 = _interopRequireDefault(_GpsManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Manager who provide user location
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var GpsService = function (_Service) {
	    _inherits(GpsService, _Service);
	
	    function GpsService(gpsConfiguration) {
	        _classCallCheck(this, GpsService);
	
	        _Logger2.default.log('GPS init');
	
	        var _this = _possibleConstructorReturn(this, (GpsService.__proto__ || Object.getPrototypeOf(GpsService)).call(this));
	
	        _this.configuration = gpsConfiguration;
	        _this.reverseGeocodingFunction = null;
	        return _this;
	    }
	
	    /**
	     * Start GPS Manager
	     */
	
	
	    _createClass(GpsService, [{
	        key: 'start',
	        value: function start() {
	            this.gpsManager = new _GpsManager2.default(this.configuration, this.reverseGeocodingFunction);
	            this.gpsManager.start();
	        }
	
	        /**
	         * Stop GPSManager
	         */
	
	    }, {
	        key: 'stop',
	        value: function stop() {
	            this.gpsManager.stop();
	        }
	
	        /**
	         * Restart GPS Manager
	         */
	
	    }, {
	        key: 'restart',
	        value: function restart() {
	            this.stop();
	            this.start();
	        }
	
	        /**
	         * Merge global GPS configuration and scenario GPS configuration
	         *
	         * @param scenarioGpsconfiguration A ConfigGps object
	         * @returns {ConfigGps}
	         */
	
	    }, {
	        key: 'mergeConfig',
	        value: function mergeConfig(scenarioGpsconfiguration) {
	            if (scenarioGpsconfiguration) {
	                return new _ConfigGps2.default(scenarioGpsconfiguration.enabled, this.configuration.geocodingEnabled, scenarioGpsconfiguration.searchTime, scenarioGpsconfiguration.accuracy);
	            } else {
	                return this.configuration;
	            }
	        }
	
	        /**
	         * Set a reverse geocoding function to enrich GPS data from client side
	         * The callback should get 3 parameters
	         *
	         * @param reverseGeocodingFunction A function with 3 parameters (latitude, longitude, another callback to alert SDK when enrichment is successfully done)
	         */
	
	    }, {
	        key: 'setReverseGeocodingFunction',
	        value: function setReverseGeocodingFunction(reverseGeocodingFunction) {
	            this.reverseGeocodingFunction = reverseGeocodingFunction;
	        }
	
	        /**
	         * Provides a GpsManager where start / stop methods can be called
	         *
	         * @param scenarioGpsconfiguration Optional
	         * @returns {GpsManager}
	         */
	
	    }, {
	        key: 'provide',
	        value: function provide(scenarioGpsconfiguration) {
	            return new _GpsManager2.default(this.mergeConfig(scenarioGpsconfiguration), this.reverseGeocodingFunction);
	        }
	    }]);
	
	    return GpsService;
	}(_Service3.default);
	
	exports.default = GpsService;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Manager2 = __webpack_require__(117);
	
	var _Manager3 = _interopRequireDefault(_Manager2);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _GpsInfos = __webpack_require__(113);
	
	var GpsInfosEnum = _interopRequireWildcard(_GpsInfos);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Manager who provide user location
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var GpsManager = function (_Manager) {
	    _inherits(GpsManager, _Manager);
	
	    /**
	     * Default constructor
	     * @param {ConfigGps} gpsConfiguration
	     * @param {function} reverseGeocodingFunction
	     */
	    function GpsManager(gpsConfiguration) {
	        var reverseGeocodingFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	        _classCallCheck(this, GpsManager);
	
	        var _this = _possibleConstructorReturn(this, (GpsManager.__proto__ || Object.getPrototypeOf(GpsManager)).call(this));
	
	        _this.configuration = gpsConfiguration;
	        _this.currentWatcher = null;
	        _this.reverseGeocodingFunction = reverseGeocodingFunction;
	        /**
	         * @type {GpsInfos}
	         */
	        _this.lastGpsInfos = new GpsInfosEnum.default(GpsInfosEnum.GPS_STATE_UNKNOWN);
	        return _this;
	    }
	
	    /**
	     * Start monitoring GPS for infinite duration, until stop() is called
	     */
	
	
	    _createClass(GpsManager, [{
	        key: "start",
	        value: function start() {
	            _Logger2.default.log('Starting GPSManager');
	            if (!this.configuration || !this.configuration.enabled) {
	                // Configuration is disabled
	                var gpsInfos = new GpsInfosEnum.default(GpsInfosEnum.GPS_STATE_CAMPAIGN_DISABLED);
	                this.setLocation(gpsInfos);
	            } else if (!navigator.geolocation) {
	                // No geolocation engine available
	                var _gpsInfos = new GpsInfosEnum.default(GpsInfosEnum.GPS_STATE_NOT_SUPPORTED);
	                this.setLocation(_gpsInfos);
	            } else {
	                // Start the geolocation
	                var self = this;
	                this.currentWatcher = navigator.geolocation.watchPosition(function (location) {
	                    _Logger2.default.log("Received coordinates : ");
	                    _Logger2.default.log(location);
	                    self.processLocation(location);
	                });
	            }
	        }
	
	        /**
	         * Stop the current started GPS instance
	         */
	
	    }, {
	        key: "stop",
	        value: function stop() {
	            _Logger2.default.log('Stopping GPSManager');
	            if (navigator.geolocation && this.currentWatcher) {
	                navigator.geolocation.clearWatch(this.currentWatcher);
	                this.currentWatcher = null;
	            } else {
	                if (!this.currentWatcher) {
	                    _Logger2.default.log('No GPSManager instance running');
	                }
	            }
	        }
	
	        /**
	         * Private method
	         * Used to generate a GpsInfos object, with reverse geocoding enrichment if provided.
	         *
	         * @param location The HTML5 location object
	         */
	
	    }, {
	        key: "processLocation",
	        value: function processLocation(location) {
	            var _this2 = this;
	
	            if (this.configuration.geocodingEnabled && this.reverseGeocodingFunction) {
	                // A reverse geocoding function has been set
	                return this.reverseGeocodingFunction(location.coords.latitude, location.coords.longitude, function (reverseGeocodingData) {
	                    _this2.setLocation(new GpsInfosEnum.default(GpsInfosEnum.GPS_STATE_BOTH, location.coords.latitude, location.coords.longitude, location.timestamp, location.coords.accuracy, reverseGeocodingData.city, reverseGeocodingData.country, reverseGeocodingData.countryCode, reverseGeocodingData.postalCode, reverseGeocodingData.streetNumber, reverseGeocodingData.streetName));
	                });
	            } else {
	                // Reverse geocoding disabled by configuration
	                this.setLocation(new GpsInfosEnum.default(GpsInfosEnum.GPS_STATE_BOTH, location.coords.latitude, location.coords.longitude, location.timestamp, location.coords.accuracy));
	            }
	        }
	
	        /**
	         * Use this setter to avoid conflicts with 'this'
	         * @param {GpsInfos} gpsLocation
	         */
	
	    }, {
	        key: "setLocation",
	        value: function setLocation(gpsLocation) {
	            this.lastGpsInfos = gpsLocation;
	        }
	
	        /**
	         * Provide the last GpsInfos retrieved. Need to call start and collect data before.
	         *
	         * @returns {GpsInfos}
	         */
	
	    }, {
	        key: "get",
	        value: function get() {
	            return this.lastGpsInfos;
	        }
	    }]);
	
	    return GpsManager;
	}(_Manager3.default);
	
	exports.default = GpsManager;

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by smizrahi on 8/18/16.
	 */
	
	var Manager = function Manager() {
	  _classCallCheck(this, Manager);
	};
	
	exports.default = Manager;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _Service2 = __webpack_require__(4);
	
	var _Service3 = _interopRequireDefault(_Service2);
	
	var _DeviceManager = __webpack_require__(119);
	
	var _DeviceManager2 = _interopRequireDefault(_DeviceManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Service who provide device informations
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var DeviceService = function (_Service) {
	  _inherits(DeviceService, _Service);
	
	  /**
	   * Constructor
	   */
	  function DeviceService() {
	    _classCallCheck(this, DeviceService);
	
	    _Logger2.default.log('Device init');
	
	    /**
	     * @type {DeviceManager}
	     */
	    var _this = _possibleConstructorReturn(this, (DeviceService.__proto__ || Object.getPrototypeOf(DeviceService)).call(this));
	
	    _this.manager = new _DeviceManager2.default();
	    _this.manager.retrievePrivateIpAddress();
	    return _this;
	  }
	
	  return DeviceService;
	}(_Service3.default);
	
	exports.default = DeviceService;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NAVIGATOR_CONNECTION_TYPE_WIFI = exports.NAVIGATOR_CONNECTION_TYPE_ETH = exports.NAVIGATOR_CONNECTION_TYPE_CELL = exports.TECHNOLOGY_UNKNOWN = exports.TECHNOLOGY_ETHERNET = exports.TECHNOLOGY_GSM = exports.TECHNOLOGY_WIFI = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Manager2 = __webpack_require__(117);
	
	var _Manager3 = _interopRequireDefault(_Manager2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Manager who provides device informations
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var TECHNOLOGY_WIFI = exports.TECHNOLOGY_WIFI = 100;
	var TECHNOLOGY_GSM = exports.TECHNOLOGY_GSM = 101;
	var TECHNOLOGY_ETHERNET = exports.TECHNOLOGY_ETHERNET = 102;
	var TECHNOLOGY_UNKNOWN = exports.TECHNOLOGY_UNKNOWN = 0;
	
	var NAVIGATOR_CONNECTION_TYPE_CELL = exports.NAVIGATOR_CONNECTION_TYPE_CELL = "cellular";
	var NAVIGATOR_CONNECTION_TYPE_ETH = exports.NAVIGATOR_CONNECTION_TYPE_ETH = "ethernet";
	var NAVIGATOR_CONNECTION_TYPE_WIFI = exports.NAVIGATOR_CONNECTION_TYPE_WIFI = "wifi";
	
	var DeviceManager = function (_Manager) {
	    _inherits(DeviceManager, _Manager);
	
	    /**
	     * Constructor
	     */
	    function DeviceManager() {
	        _classCallCheck(this, DeviceManager);
	
	        /**
	         * @type {string}
	         */
	        var _this = _possibleConstructorReturn(this, (DeviceManager.__proto__ || Object.getPrototypeOf(DeviceManager)).call(this));
	
	        _this.privateIp = null;
	        return _this;
	    }
	
	    /**
	     * Retrieve private ip adress and set into property privateIp
	     */
	
	
	    _createClass(DeviceManager, [{
	        key: "retrievePrivateIpAddress",
	        value: function retrievePrivateIpAddress() {
	            window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection; //compatibility for firefox and chrome
	            if (window.RTCPeerConnection) {
	                var self = this;
	                var pc = new RTCPeerConnection({ iceServers: [] }),
	                    noop = function noop() {};
	                pc.createDataChannel(""); //create a bogus data channel
	                pc.createOffer(pc.setLocalDescription.bind(pc), noop); // create offer and set local description
	                pc.onicecandidate = function (ice) {
	                    //listen for candidate events
	                    if (!ice || !ice.candidate || !ice.candidate.candidate) return null;
	                    self.privateIp = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
	                    pc.onicecandidate = noop;
	                };
	            } else {
	                this.privateIp = null;
	            }
	        }
	
	        /**
	         * Returns the private ip in cache
	         *
	         * @returns {string} private ip address
	         */
	
	    }, {
	        key: "getPrivateIpAddress",
	        value: function getPrivateIpAddress() {
	            return this.privateIp;
	        }
	
	        /**
	         * Returns the technology id
	         *
	         * @returns {number} technology
	         */
	
	    }, {
	        key: "getTechnology",
	        value: function getTechnology() {
	            if (typeof navigator !== 'undefined' && navigator && navigator.connection && (navigator.connection.type || navigator.connection.effectiveType)) {
	                var connectionType = navigator.connection.type ? navigator.connection.type : navigator.connection.effectiveType;
	                if (connectionType === NAVIGATOR_CONNECTION_TYPE_CELL) {
	                    return TECHNOLOGY_GSM;
	                } else if (connectionType === NAVIGATOR_CONNECTION_TYPE_ETH) {
	                    return TECHNOLOGY_ETHERNET;
	                } else if (connectionType === NAVIGATOR_CONNECTION_TYPE_WIFI) {
	                    return TECHNOLOGY_WIFI;
	                }
	            }
	
	            return TECHNOLOGY_UNKNOWN;
	        }
	    }]);
	
	    return DeviceManager;
	}(_Manager3.default);
	
	exports.default = DeviceManager;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Manager2 = __webpack_require__(117);
	
	var _Manager3 = _interopRequireDefault(_Manager2);
	
	var _EQError = __webpack_require__(6);
	
	var _EQError2 = _interopRequireDefault(_EQError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Manager who provide custom fields
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var AUTHORIZED_CUSTOM_FIELDS = ['mscore_custom_string_1', 'mscore_custom_string_2', 'mscore_custom_string_3', 'mscore_custom_string_4', 'mscore_custom_string_5', 'mscore_custom_string_6', 'mscore_custom_string_7', 'mscore_custom_string_8', 'mscore_custom_string_9', 'mscore_custom_string_10', 'mscore_custom_string_11', 'mscore_custom_string_12', 'mscore_custom_string_13', 'mscore_custom_string_14', 'mscore_custom_string_15'];
	
	var CustomFieldsManager = function (_Manager) {
	    _inherits(CustomFieldsManager, _Manager);
	
	    function CustomFieldsManager() {
	        _classCallCheck(this, CustomFieldsManager);
	
	        var _this = _possibleConstructorReturn(this, (CustomFieldsManager.__proto__ || Object.getPrototypeOf(CustomFieldsManager)).call(this));
	
	        _this.customFields = new Map();
	        return _this;
	    }
	
	    /**
	     * Set a new custom field
	     *
	     * @param key
	     * @param value
	     */
	
	
	    _createClass(CustomFieldsManager, [{
	        key: 'add',
	        value: function add(key, value) {
	            if (AUTHORIZED_CUSTOM_FIELDS.indexOf(key) >= 0) {
	                this.customFields.set(key, value);
	            } else {
	                throw new _EQError2.default('Custom fields key unauthorized, use one of them: ' + AUTHORIZED_CUSTOM_FIELDS, 1900);
	            }
	        }
	
	        /**
	         * Delete a custom field
	         *
	         * @param key
	         */
	
	    }, {
	        key: 'delete',
	        value: function _delete(key) {
	            if (AUTHORIZED_CUSTOM_FIELDS.indexOf(key) >= 0) {
	                this.customFields.delete(key);
	            } else {
	                throw new _EQError2.default('Custom fields key unauthorized, use one of them: ' + AUTHORIZED_CUSTOM_FIELDS, 1901);
	            }
	        }
	
	        /**
	         * Returns a custom field for a specific key
	         *
	         * @param key
	         * @returns {V}
	         */
	
	    }, {
	        key: 'get',
	        value: function get(key) {
	            return this.customFields.get(key);
	        }
	
	        /**
	         * Returns all custom fields
	         *
	         * @returns {Map}
	         */
	
	    }, {
	        key: 'getAll',
	        value: function getAll() {
	            return this.customFields;
	        }
	    }]);
	
	    return CustomFieldsManager;
	}(_Manager3.default);
	
	exports.default = CustomFieldsManager;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AUTH_FAILED_MAX_ATTEMPT_REACHED = exports.AUTH_FAILED_INVALID_USERNAME_PASSWORD = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Service2 = __webpack_require__(4);
	
	var _Service3 = _interopRequireDefault(_Service2);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _EQError = __webpack_require__(6);
	
	var _EQError2 = _interopRequireDefault(_EQError);
	
	var _HuaweiGatewayModule = __webpack_require__(122);
	
	var _HuaweiGatewayModule2 = _interopRequireDefault(_HuaweiGatewayModule);
	
	var _KpiMapper = __webpack_require__(100);
	
	var KpiMapper = _interopRequireWildcard(_KpiMapper);
	
	var _RawKpiConstants = __webpack_require__(101);
	
	var RawKpiConstants = _interopRequireWildcard(_RawKpiConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_GATEWAY_EXTENSIONS = ["1", "254"];
	var PING_TIMEOUT = 5000; // In ms
	var MODULES = [_HuaweiGatewayModule2.default];
	var COLLECT_VALIDITY_TIME = 120000; // In ms
	var MAX_LOGIN_ATTEMPT = 3;
	var NB_LOGIN_ATTEMPT_TIMER = 2; // In seconds
	
	var AUTH_FAILED_INVALID_USERNAME_PASSWORD = exports.AUTH_FAILED_INVALID_USERNAME_PASSWORD = 108006;
	var AUTH_FAILED_MAX_ATTEMPT_REACHED = exports.AUTH_FAILED_MAX_ATTEMPT_REACHED = 108007;
	
	var GatewayService = function (_Service) {
	    _inherits(GatewayService, _Service);
	
	    /**
	     * Constructor
	     */
	    function GatewayService() {
	        _classCallCheck(this, GatewayService);
	
	        var _this = _possibleConstructorReturn(this, (GatewayService.__proto__ || Object.getPrototypeOf(GatewayService)).call(this));
	
	        _Logger2.default.log('Ip lookup');
	        _this.ip = null;
	        _this.username = null;
	        _this.password = null;
	        _this.module = null;
	        _this.collectTimer = null;
	        _this.isCollecting = false;
	        _this.nbLoginAttempt = 0;
	        _this.cacheInfos = null;
	        return _this;
	    }
	
	    /**
	     * Init
	     *
	     * @param callback
	     * @param ip
	     * @param username
	     * @param password
	     */
	
	
	    _createClass(GatewayService, [{
	        key: "init",
	        value: function init() {
	            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var ip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var username = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	            var password = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	            this.ip = ip;
	            this.username = username;
	            this.password = password;
	            this.module = null; // Reset module
	
	            // Ip is forced and set
	            var self = this;
	            self.nbLoginAttempt++;
	            if (this.ip) {
	                this.pingIps({ self: this, ips: [this.ip] }).then(this.authenticate).then(function (module) {
	                    self.module = module;
	                    if (callback) callback(self.module.brand, self.module.model, null);
	                }).catch(function (e) {
	                    _Logger2.default.log(e);
	                    if (self.nbLoginAttempt < MAX_LOGIN_ATTEMPT && e.code != AUTH_FAILED_INVALID_USERNAME_PASSWORD && e.code != AUTH_FAILED_MAX_ATTEMPT_REACHED) {
	                        setTimeout(function () {
	                            self.init(callback, ip, username, password);
	                        }, NB_LOGIN_ATTEMPT_TIMER * 1000);
	                    } else {
	                        if (callback) callback(null, null, e);
	                    }
	                });
	            } else {
	                this.getIps({ self: this }).then(this.lookForDefaultIps).then(this.pingIps).then(this.authenticate).then(function (module) {
	                    self.module = module;
	                    if (callback) callback(self.module.brand, self.module.model, null);
	                }).catch(function (e) {
	                    _Logger2.default.log(e);
	                    if (self.nbLoginAttempt < MAX_LOGIN_ATTEMPT && e.code != AUTH_FAILED_INVALID_USERNAME_PASSWORD && e.code != AUTH_FAILED_MAX_ATTEMPT_REACHED) {
	                        setTimeout(function () {
	                            self.init(callback, ip, username, password);
	                        }, NB_LOGIN_ATTEMPT_TIMER * 1000);
	                    } else {
	                        if (callback) callback(null, null, e);
	                    }
	                });
	            }
	        }
	
	        /**
	         * Get a list of local ips through RTC (for all interfaces)
	         *
	         * @returns {Promise} A promise with the current class instance (self) and an array of ip addresses (ips)
	         */
	
	    }, {
	        key: "getIps",
	        value: function getIps() {
	            var _this2 = this;
	
	            return new Promise(function (resolve) {
	                var ips = [];
	                window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection || false;
	
	                if (window.RTCPeerConnection) {
	                    var pc = new RTCPeerConnection({ iceServers: [] }),
	                        noop = function noop() {};
	                    pc.createDataChannel('');
	                    pc.createOffer(pc.setLocalDescription.bind(pc), noop);
	
	                    pc.onicecandidate = function (event) {
	                        if (event && event.candidate && event.candidate.candidate) {
	                            var s = event.candidate.candidate.split('\n');
	                            ips.push(s[0].split(' ')[4]);
	                        } else if (event && !event.candidate) {
	                            resolve({ self: _this2, ips: ips });
	                        }
	                    };
	                }
	            });
	        }
	
	        /**
	         * Generate an ip with default extensions specified in constants above
	         * Can throw an error
	         *
	         * @param ip
	         * @param extension
	         * @returns {*}
	         */
	
	    }, {
	        key: "lookForDefaultIps",
	
	
	        /**
	         * Generate a list of ips based on local ip interfaces detected and default extensions.
	         * For example, if current local ip is 192.168.0.3 and default extensions are ["1", "254"], this method will return ["192.168.0.1", "192.168.0.254"]
	         *
	         * @returns {Promise} A promise with the current class instance (self) and an array of ip addresses (ips)
	         */
	        value: function lookForDefaultIps(result) {
	            return new Promise(function (resolve) {
	                var ips = result.ips;
	                var self = result.self;
	                var defaultGatewayExtensions = result.defaultGatewayExtensions ? result.defaultGatewayExtensions : DEFAULT_GATEWAY_EXTENSIONS;
	                var potentialDefaultGatewayIpList = [];
	                if (ips.length > 0) {
	                    ips.forEach(function (ip) {
	                        defaultGatewayExtensions.forEach(function (defaultGatewaysExtension) {
	                            try {
	                                var potentialDefaultGatewayIp = GatewayService.generateIpWithExtension(ip, defaultGatewaysExtension);
	                                if (potentialDefaultGatewayIpList.indexOf(potentialDefaultGatewayIp) === -1) {
	                                    potentialDefaultGatewayIpList.push(potentialDefaultGatewayIp);
	                                }
	                            } catch (e) {
	                                _Logger2.default.log("Error : " + e.message + " for gateway " + ip);
	                            }
	                        });
	                    });
	                }
	
	                resolve({ self: self, ips: potentialDefaultGatewayIpList });
	            });
	        }
	
	        /**
	         * Ping a module to check if it is responding
	         *
	         * @param module
	         * @returns {Promise} A promise with the module, the error, the headers and the delta (time to respond)
	         */
	
	    }, {
	        key: "pingIpAsPromise",
	        value: function pingIpAsPromise(module) {
	            return new Promise(function (resolve) {
	                var oReq = new XMLHttpRequest();
	                var startTimestamp = Date.now();
	                var success = false;
	                oReq.open("get", module.getPingUrl(), true);
	
	                oReq.onreadystatechange = function () {
	                    if (this.readyState === XMLHttpRequest.DONE) {
	                        if (this.status >= 200 && this.status < 300) {
	                            resolve({ module: module, error: null, delta: Date.now() - startTimestamp, headers: this.getAllResponseHeaders() });
	                        } else {
	                            // Comment : Due to Promise.race, we should not call resolve (or reject) to try others IP addresses
	                            setTimeout(function () {
	                                resolve({ module: module, error: new _EQError2.default("HTTP status : " + oReq.status, 8967), delta: Date.now() - startTimestamp, headers: null });
	                            }, PING_TIMEOUT - (Date.now() - startTimestamp));
	                        }
	                    }
	                };
	                oReq.addEventListener("abort", function () {
	                    resolve({ module: module, error: new _EQError2.default("Timeout", 8968), delta: Date.now() - startTimestamp, headers: null });
	                }, false);
	                setTimeout(function () {
	                    if (!success) {
	                        oReq.abort();
	                    }
	                }, PING_TIMEOUT);
	
	                oReq.send();
	            });
	        }
	
	        /**
	         * Ping a list of ips and detect what module is behind.
	         *
	         * @param result An object with two parameters : self (current instance) and ips (a list of ip addresses)
	         * @returns {Promise}
	         */
	
	    }, {
	        key: "pingIps",
	        value: function pingIps(result) {
	            return new Promise(function (resolve, reject) {
	                var ipsToPingPromises = [];
	                var self = result.self;
	                result.ips.forEach(function (ip) {
	                    MODULES.forEach(function (Module) {
	                        ipsToPingPromises.push(self.pingIpAsPromise(new Module(ip, self.username, self.password)));
	                    });
	                });
	
	                Promise.race(ipsToPingPromises).then(function (pingResult) {
	                    _Logger2.default.log("Detected module " + pingResult.module.brand + " " + pingResult.module.model + " on IP " + pingResult.module.ip + ". Time to detect : " + pingResult.delta + "ms");
	                    resolve(pingResult.module);
	                }).catch(function (e) {
	                    reject(new _EQError2.default("Module not detected : " + e.message, 8969));
	                });
	            });
	        }
	
	        /**
	         * Call the authentication of the module
	         * @param module
	         * @returns {*|Promise}
	         */
	
	    }, {
	        key: "authenticate",
	        value: function authenticate(module) {
	            return module.authenticate();
	        }
	
	        /**
	         * Retrieve gateway informations
	         *
	         * @returns {Promise}
	         */
	
	    }, {
	        key: "getInfos",
	        value: function getInfos() {
	            var _this3 = this;
	
	            var self = this;
	            return new Promise(function (resolve, reject) {
	                if (self.module) {
	                    self.module.getApiInfo().then(function (infos) {
	                        if (infos[KpiMapper.RAW]) {
	                            infos[KpiMapper.RAW][RawKpiConstants.API_TIMESTAMP] = Date.now();
	                        }
	
	                        _this3.cacheInfos = infos;
	                        resolve(infos);
	                    }).catch(function (e) {
	                        reject(e);
	                    });
	                } else {
	                    reject(new _EQError2.default("No module set !", 21298));
	                }
	            });
	        }
	
	        /**
	         * Collect data
	         *
	         * @param cb
	         * @param minTimer
	         * @param lastTimestamp
	         * @param self
	         */
	
	    }, {
	        key: "collect",
	        value: function collect(cb, minTimer, lastTimestamp) {
	            var self = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	            if (!self) {
	                self = this;
	            }
	
	            if (self.collectTimer && self.isCollecting) {
	                self.getInfos().then(function (infos) {
	                    var now = Date.now();
	                    var nextTick = Math.max(minTimer, now - lastTimestamp);
	                    self.collectTimer = setTimeout(function () {
	                        self.collect(cb, minTimer, now + nextTick, self);
	                    }, nextTick);
	                    if (nextTick < COLLECT_VALIDITY_TIME) {
	                        cb(null, infos[KpiMapper.RAW]);
	                    } else {
	                        cb(new _EQError2.default("Gateway infos too old : " + nextTick, 872586));
	                    }
	                }).catch(function (e) {
	                    var now = Date.now();
	                    var nextTick = Math.max(minTimer, now - lastTimestamp);
	                    self.collectTimer = setTimeout(function () {
	                        self.collect(cb, minTimer, now + nextTick, self);
	                    }, nextTick);
	                    cb(e);
	                });
	            }
	        }
	
	        /**
	         * Start collect until stop is called
	         *
	         * @param cb
	         * @param minTimer
	         */
	
	    }, {
	        key: "startCollect",
	        value: function startCollect(cb) {
	            var minTimer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	
	            var self = this;
	            if (cb && this.module) {
	                if (!this.collectTimer && !this.isCollecting) {
	                    this.isCollecting = true;
	                    this.collectTimer = setTimeout(function () {
	                        self.collect(cb, minTimer, Date.now(), self);
	                    }, 0);
	                } else {
	                    cb(new _EQError2.default("Gateway infos already collecting", 872538));
	                }
	            } else {
	                cb(new _EQError2.default("No callback or module detected", 872537));
	            }
	        }
	
	        /**
	         * Stop a running collect
	         */
	
	    }, {
	        key: "stopCollect",
	        value: function stopCollect() {
	            if (this.collectTimer) {
	                clearTimeout(this.collectTimer);
	                this.collectTimer = null;
	            }
	            this.isCollecting = false;
	        }
	
	        /**
	         * Get cache informations
	         */
	
	    }, {
	        key: "getCacheInfos",
	        value: function getCacheInfos() {
	            var now = Date.now();
	            if (this.cacheInfos && now - this.cacheInfos[KpiMapper.RAW][RawKpiConstants.API_TIMESTAMP] < COLLECT_VALIDITY_TIME) {
	                return this.cacheInfos;
	            } else {
	                return null;
	            }
	        }
	    }], [{
	        key: "generateIpWithExtension",
	        value: function generateIpWithExtension(ip, extension) {
	            var splitIp = ip.split(".");
	            var result = ip;
	            if (splitIp.length === 4) {
	                splitIp[3] = extension;
	                result = splitIp.join(".");
	            } else {
	                throw new _EQError2.default("Invalid IP", 8965);
	            }
	
	            return result;
	        }
	    }]);
	
	    return GatewayService;
	}(_Service3.default);
	
	exports.default = GatewayService;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GatewayModule2 = __webpack_require__(123);
	
	var _GatewayModule3 = _interopRequireDefault(_GatewayModule2);
	
	var _EQError = __webpack_require__(6);
	
	var _EQError2 = _interopRequireDefault(_EQError);
	
	var _sha = __webpack_require__(127);
	
	var _sha2 = _interopRequireDefault(_sha);
	
	var _HuaweiKpiConverter = __webpack_require__(136);
	
	var _HuaweiKpiConverter2 = _interopRequireDefault(_HuaweiKpiConverter);
	
	var _GatewayService = __webpack_require__(121);
	
	var GatewayServiceConstants = _interopRequireWildcard(_GatewayService);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_USERNAME = "admin";
	var DEFAULT_PASSWORD = "admin";
	
	var RESPONSE = "response";
	var SES_INFO = "SesInfo";
	var TOK_INFO = "TokInfo";
	var TOKEN_KEY = "__RequestVerificationToken";
	var TOKEN_ONE_KEY = "__RequestVerificationTokenone";
	var TOKEN_TWO_KEY = "__RequestVerificationTokentwo";
	
	var LOGOUT_ENDPOINT = "/api/user/logout";
	var TOKEN_ENDPOINT = "/api/webserver/SesTokInfo";
	var LOGIN_ENDPOINT = "/api/user/login";
	
	var API_INFO_ENDPOINT = "/api/device/information"; // First call only
	var API_STATUS_ENDPOINT = "/api/monitoring/status";
	var API_WLAN_SETTINGS_ENDPOINT = "/api/wlan/basic-settings"; // First call only
	var API_DEVICE_SIGNAL_ENDPOINT = "/api/device/signal";
	var API_NET_PLMN_ENDPOINT = "/api/net/current-plmn";
	var endpoints = ["/", LOGIN_ENDPOINT, API_INFO_ENDPOINT, API_STATUS_ENDPOINT, API_WLAN_SETTINGS_ENDPOINT, API_DEVICE_SIGNAL_ENDPOINT, API_NET_PLMN_ENDPOINT];
	var sessionIDCookie = "SessionID";
	var API_TIMEOUT = 3000; // in ms
	
	// Properties
	var API_RETRIEVAL_TIME = "retrievalTime";
	
	/*eslint-disable no-undef*/
	var HuaweiE580 = function (_GatewayModule) {
	    _inherits(HuaweiE580, _GatewayModule);
	
	    /**
	     * Constructor
	     *
	     * @param ip
	     * @param username
	     * @param password
	     */
	    function HuaweiE580(ip) {
	        var username = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	        var password = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	        _classCallCheck(this, HuaweiE580);
	
	        var _this = _possibleConstructorReturn(this, (HuaweiE580.__proto__ || Object.getPrototypeOf(HuaweiE580)).call(this, "Huawei", "E5180 / B525", _HuaweiKpiConverter2.default, null, null, ip, username, password));
	
	        _this.username = username ? username : DEFAULT_USERNAME;
	        _this.password = password ? password : DEFAULT_PASSWORD;
	        _this.sesInfo = null;
	        _this.tokInfo = null;
	        _this.authenticationToken = null;
	        _this.authenticationTokenOne = null;
	        _this.authenticationTokenTwo = null;
	        _this.apiCache = {};
	        return _this;
	    }
	
	    _createClass(HuaweiE580, [{
	        key: "SHA256andBase64",
	        value: function SHA256andBase64(text) {
	            return new Buffer((0, _sha2.default)("sha256").update(text).digest("hex"), 'utf-8').toString('base64');
	        }
	
	        /**
	         * Returns the URL to ping
	         *
	         * @returns {string} The ping URL
	         */
	
	    }, {
	        key: "getPingUrl",
	        value: function getPingUrl() {
	            return "http://" + this.ip + TOKEN_ENDPOINT;
	        }
	
	        /**
	         * Clean cookies environment
	         */
	
	    }, {
	        key: "cleanCookies",
	        value: function cleanCookies() {
	            var _this2 = this;
	
	            // Clean cookies
	            if (window["chrome"]) {
	                endpoints.forEach(function (endpoint) {
	                    window["chrome"].cookies.remove({ url: "http://" + _this2.ip + endpoint, name: "sid" });
	                    window["chrome"].cookies.remove({ url: "http://" + _this2.ip + endpoint, name: sessionIDCookie });
	                });
	
	                window["chrome"].cookies.set({ url: "http://" + this.ip, name: sessionIDCookie, value: this.sesInfo });
	            }
	        }
	
	        /**
	         * Set the request headers with authentication tokens
	         *
	         * @param req An XMLHttpRequest object
	         */
	
	    }, {
	        key: "setRequestHeaders",
	        value: function setRequestHeaders(req) {
	            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
	            req.setRequestHeader("Accept", "*/*");
	            req.withCredentials = true;
	            if (this.tokInfo && !this.authenticationToken) {
	                req.setRequestHeader(TOKEN_KEY, this.tokInfo);
	            }
	            if (this.authenticationToken) {
	                req.setRequestHeader(TOKEN_KEY, this.authenticationToken);
	            }
	            if (this.authenticationTokenOne) {
	                req.setRequestHeader(TOKEN_ONE_KEY, this.authenticationTokenOne);
	            }
	            if (this.authenticationTokenTwo) {
	                req.setRequestHeader(TOKEN_TWO_KEY, this.authenticationTokenTwo);
	            }
	        }
	
	        /**
	         * Authenticate action to the gateway (override if needed)
	         *
	         * @returns {Promise} A promise with the module as return, or en EQError
	         */
	
	    }, {
	        key: "authenticate",
	        value: function authenticate() {
	            var _this3 = this;
	
	            return new Promise(function (resolve, reject) {
	                // Clean
	                _this3.sesInfo = null;
	                _this3.tokInfo = null;
	                _this3.authenticationToken = null;
	                _this3.authenticationTokenOne = null;
	                _this3.authenticationTokenTwo = null;
	                var self = _this3;
	
	                var oReqLogout = new XMLHttpRequest();
	                oReqLogout.open("post", "http://" + self.ip + LOGOUT_ENDPOINT, true);
	                oReqLogout.onreadystatechange = function () {
	                    if (this.readyState === XMLHttpRequest.DONE) {
	                        // Login
	                        var oReqAuthenticationFirstRequest = new XMLHttpRequest();
	
	                        oReqAuthenticationFirstRequest.open("get", "http://" + self.ip + TOKEN_ENDPOINT, true);
	                        oReqAuthenticationFirstRequest.onreadystatechange = function () {
	                            if (this.readyState === XMLHttpRequest.DONE) {
	                                if (this.status === 200) {
	                                    var parseString = __webpack_require__(14).parseString;
	                                    // The option explicitChildren is used to avoid merging sub properties
	                                    // Take a tour on https://github.com/Leonidas-from-XIV/node-xml2js documentation
	                                    parseString(this.responseText, { explicitArray: false }, function (err, result) {
	                                        if (!err && result) {
	                                            if (result && result[RESPONSE] && result[RESPONSE][SES_INFO] && result[RESPONSE][TOK_INFO]) {
	                                                var sesInfoArray = result[RESPONSE][SES_INFO].split("=");
	                                                if (sesInfoArray.length === 1 || sesInfoArray.length === 2) {
	                                                    if (sesInfoArray.length === 2) {
	                                                        self.sesInfo = sesInfoArray[1]; //result[RESPONSE][SES_INFO];
	                                                    } else {
	                                                        self.sesInfo = result[RESPONSE][SES_INFO];
	                                                    }
	
	                                                    self.tokInfo = result[RESPONSE][TOK_INFO];
	
	                                                    // Step 1 finished, starting step 2 ...
	                                                    var encodedPassword = self.SHA256andBase64(self.username + self.SHA256andBase64(self.password) + self.tokInfo);
	
	                                                    //const postDataForSecondRequest =
	
	                                                    var obj = { Username: self.username, password_type: 4, Password: encodedPassword };
	
	                                                    var Xml2jsBuilder = __webpack_require__(14).Builder;
	                                                    var postDataForSecondRequestBuilder = new Xml2jsBuilder({
	                                                        rootName: "request"
	                                                    });
	
	                                                    self.cleanCookies();
	
	                                                    // Let's do the second authentication request
	                                                    var oReqAuthenticationSecondRequest = new XMLHttpRequest();
	                                                    oReqAuthenticationSecondRequest.open("post", "http://" + self.ip + LOGIN_ENDPOINT, true);
	                                                    self.setRequestHeaders(oReqAuthenticationSecondRequest);
	                                                    oReqAuthenticationSecondRequest.onreadystatechange = function () {
	                                                        if (this.readyState === XMLHttpRequest.DONE) {
	                                                            if (this.status === 200) {
	                                                                parseString(this.responseText, { explicitArray: false }, function (err, result) {
	                                                                    if (!err && result) {
	                                                                        if (!result.error) {
	                                                                            if (result && result.response && result.response && result.response === "OK" && oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_KEY) && oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_ONE_KEY) && oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_TWO_KEY)) {
	                                                                                // Authentication succeed !
	
	                                                                                if (window["chrome"]) {
	                                                                                    window["chrome"].cookies.getAll({
	                                                                                        domain: self.ip,
	                                                                                        path: "/",
	                                                                                        name: sessionIDCookie
	                                                                                    }, function (cookies) {
	                                                                                        if (cookies.length === 1) {
	                                                                                            self.sesInfo = cookies[0].value;
	                                                                                            self.authenticationToken = oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_KEY);
	                                                                                            self.authenticationTokenOne = oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_ONE_KEY);
	                                                                                            self.authenticationTokenTwo = oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_TWO_KEY);
	                                                                                            self.cleanCookies();
	                                                                                            // Get some apis and set in cache for later
	
	                                                                                            setTimeout(function () {
	                                                                                                self.getApiInfo().then(function () {
	                                                                                                    resolve(self);
	                                                                                                }).catch(function () {
	                                                                                                    resolve(self);
	                                                                                                });
	                                                                                            }, 500);
	                                                                                        } else {
	                                                                                            reject(new _EQError2.default("Authentication failed. No session id found.", 792812));
	                                                                                        }
	                                                                                    });
	                                                                                } else {
	                                                                                    reject(new _EQError2.default("No access to cookies.", 792813));
	                                                                                }
	                                                                            } else {
	                                                                                reject(new _EQError2.default("Error - unexpected OK response while second authentication execution", 45219));
	                                                                            }
	                                                                        } else {
	                                                                            // Error in authentication (XML parsing OK, bad response)
	                                                                            /*
	                                                                             <?xml version="1.0" encoding="UTF-8"?>
	                                                                             <error>
	                                                                             <code>125002</code>
	                                                                             <message></message>
	                                                                             </error>
	                                                                             */
	                                                                            if (result.error && result.error.code && parseInt(result.error.code) === GatewayServiceConstants.AUTH_FAILED_MAX_ATTEMPT_REACHED) {
	                                                                                reject(new _EQError2.default("Max login attempt reached. Please try again in " + result.error.waittime + " minute" + (parseInt(result.error.waittime) > 1 ? "s" : ""), GatewayServiceConstants.AUTH_FAILED_MAX_ATTEMPT_REACHED));
	                                                                            } else if (result.error && result.error.code && parseInt(result.error.code) === GatewayServiceConstants.AUTH_FAILED_INVALID_USERNAME_PASSWORD) {
	                                                                                reject(new _EQError2.default("Invalid username or password (" + result.error.count + "/3)", GatewayServiceConstants.AUTH_FAILED_INVALID_USERNAME_PASSWORD));
	                                                                            } else {
	                                                                                reject(new _EQError2.default("Error (" + result.error.code[0] + ") while second authentication execution", 45218));
	                                                                            }
	                                                                        }
	                                                                    } else {
	                                                                        reject(new _EQError2.default("Error (" + err.message + ") while second authentication request parsing XML : " + this.responseText, 45217));
	                                                                    }
	                                                                });
	                                                            } else {
	                                                                reject(new _EQError2.default("Invalid response for second authentication request. Received code " + this.status + ".", 45216));
	                                                            }
	                                                        }
	                                                    };
	                                                    oReqAuthenticationSecondRequest.send(postDataForSecondRequestBuilder.buildObject(obj));
	                                                } else {
	                                                    reject(new _EQError2.default("Invalid sesInfo length after split", 45215));
	                                                }
	                                            } else {
	                                                reject(new _EQError2.default("Unexpected gateway result", 45214));
	                                            }
	                                        } else {
	                                            reject(new _EQError2.default("Error (" + err.message + ") while first authentication request parsing XML : " + this.responseText, 45213));
	                                        }
	                                    });
	                                } else {
	                                    reject(new _EQError2.default("Invalid response for first authentication request. Received code " + this.status + ".", 45212));
	                                }
	                            }
	                        };
	                        oReqAuthenticationFirstRequest.send();
	                    }
	                };
	
	                oReqLogout.send('<?xml version: "1.0" encoding="UTF-8"?><request><Logout>1</Logout></request>');
	            });
	        }
	
	        /**
	         * Get an API
	         * Note that authentication should be ran before
	         *
	         * @param endpoint An endpoint
	         * @returns {Promise} A promise with an Object of API result as return, or an EQError
	         */
	
	    }, {
	        key: "getAPI",
	        value: function getAPI(endpoint) {
	            var self = this;
	            return new Promise(function (resolve, reject) {
	                var success = false;
	
	                var oReq = new XMLHttpRequest();
	                oReq.open("get", "http://" + self.ip + endpoint, true);
	                self.setRequestHeaders(oReq);
	                oReq.onreadystatechange = function () {
	                    if (this.readyState === XMLHttpRequest.DONE) {
	                        if (this.status === 200) {
	                            success = true;
	                            var parseString = __webpack_require__(14).parseString;
	                            parseString(this.responseText, { explicitArray: false }, function (err, result) {
	                                if (!err && result) {
	                                    if (!result.error && result.response) {
	                                        resolve(result.response);
	                                    } else {
	                                        reject(new _EQError2.default("Invalid response for API request " + endpoint + ". XML contains functional error : " + (result.error && result.error.code && result.error.code.length > 0 ? result.error.code[0] : "unknown") + ".", 45918));
	                                    }
	                                } else {
	                                    reject(new _EQError2.default("Invalid response for API request " + endpoint + ". XML parsing error : " + err.message + ".", 45917));
	                                }
	                            });
	                        } else {
	                            reject(new _EQError2.default("Invalid response for API request " + endpoint + ". Received code " + this.status + ".", 45916));
	                        }
	                    }
	                };
	
	                setTimeout(function () {
	                    if (!success) {
	                        oReq.abort();
	                    }
	                }, API_TIMEOUT);
	
	                oReq.send();
	            });
	        }
	
	        /**
	         * Call all APIs available for the Huawei
	         * Note that authentication should be ran before
	         *
	         * @returns {Promise} A promise with an Object with API results as return, or an EQError
	         */
	
	    }, {
	        key: "getApiInfo",
	        value: function getApiInfo() {
	            var _this4 = this;
	
	            return new Promise(function (resolve, reject) {
	                var self = _this4;
	                //self.cleanCookies();
	
	                var pStatus = self.getAPI(API_STATUS_ENDPOINT);
	                var pSignal = self.getAPI(API_DEVICE_SIGNAL_ENDPOINT);
	                var pPlmn = self.getAPI(API_NET_PLMN_ENDPOINT);
	                var pInfo = self.getAPI(API_INFO_ENDPOINT);
	                var pWlanSettings = self.getAPI(API_WLAN_SETTINGS_ENDPOINT);
	                var apis = [pStatus, pSignal, pPlmn, pInfo, pWlanSettings];
	
	                var startTimestamp = Date.now();
	                _this4.executeChainedPromises(apis, function (results, errors) {
	                    if (errors.length === apis.length) {
	                        // Failed
	                        reject(errors[0]);
	                    } else {
	                        // Merge all results in a single object
	                        var rawData = self.apiCache;
	                        rawData[API_RETRIEVAL_TIME] = Date.now() - startTimestamp;
	
	                        results.forEach(function (result) {
	                            rawData = Object.assign(rawData, result);
	                        });
	
	                        // Clean values (set "" to null values)
	                        Object.keys(rawData).forEach(function (rawDataKey) {
	                            if (rawData[rawDataKey] === "") {
	                                rawData[rawDataKey] = null;
	                            }
	                        });
	
	                        // Processing KPI : convert, validate ...
	                        self.processKpi(rawData).then(function (rawKpi) {
	                            resolve(rawKpi);
	                        }).catch(function (e) {
	                            reject(e);
	                        });
	                    }
	                });
	            });
	        }
	
	        /**
	         * Execute an array of promises sequencially
	         *
	         * @param promises
	         * @param cb
	         * @param stopOnFailed
	         */
	
	    }, {
	        key: "executeChainedPromises",
	        value: function executeChainedPromises(promises, cb) {
	            var stopOnFailed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	            var success = [];
	            var failed = [];
	            var hasFailed = false;
	            promises.reduce(function (accumulatorPromise, nextPromise) {
	                return accumulatorPromise.then(function () {
	                    if (!hasFailed || !stopOnFailed) {
	                        return nextPromise;
	                    } else {
	                        return null;
	                    }
	                }).then(function (r) {
	                    if (!stopOnFailed || stopOnFailed && !hasFailed) {
	                        success.push(r);
	                        if (success.length + failed.length === promises.length && cb) {
	                            cb(success, failed);
	                        }
	                    }
	                }).catch(function (e) {
	                    hasFailed = true;
	                    failed.push(e);
	                    if (cb && !stopOnFailed && success.length + failed.length === promises.length || stopOnFailed) {
	                        cb(success, failed);
	                    }
	                });
	            }, Promise.resolve());
	        }
	    }]);
	
	    return HuaweiE580;
	}(_GatewayModule3.default);
	
	exports.default = HuaweiE580;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41).Buffer))

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _KpiConverter = __webpack_require__(124);
	
	var _KpiConverter2 = _interopRequireDefault(_KpiConverter);
	
	var _KpiValidator = __webpack_require__(126);
	
	var _KpiValidator2 = _interopRequireDefault(_KpiValidator);
	
	var _KpiMapper = __webpack_require__(100);
	
	var _KpiMapper2 = _interopRequireDefault(_KpiMapper);
	
	var _EQError = __webpack_require__(6);
	
	var _EQError2 = _interopRequireDefault(_EQError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GatewayModule = function () {
	    /**
	     * Constructor
	     *
	     * @param brand
	     * @param model
	     * @param Converter
	     * @param Validator
	     * @param ip
	     * @param username
	     * @param password
	     */
	    function GatewayModule(brand, model) {
	        var Converter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	        var Validator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	        var Mapper = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	        var ip = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	        var username = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
	        var password = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
	
	        _classCallCheck(this, GatewayModule);
	
	        this.brand = brand;
	        this.model = model;
	        this.ip = ip;
	        this.converter = Converter ? new Converter(this.brand, this.ip) : new _KpiConverter2.default(this.brand, this.ip);
	        this.validator = Validator ? new Validator() : new _KpiValidator2.default();
	        this.mapper = Mapper ? new Mapper() : new _KpiMapper2.default();
	        this.username = username;
	        this.password = password;
	    }
	
	    /**
	     * Returns the URL to ping (override if needed)
	     *
	     * @returns {string} The ping URL
	     */
	
	
	    _createClass(GatewayModule, [{
	        key: "getPingUrl",
	        value: function getPingUrl() {
	            return "http://" + this.ip;
	        }
	
	        /**
	         * Validate the headers to confirm the ping (override if needed)
	         *
	         * @param headers The HTTP headers
	         * @returns {boolean} True if headers are valid, false otherwise
	         */
	
	    }, {
	        key: "validateHeaders",
	        value: function validateHeaders() {
	            return true;
	        }
	
	        /**
	         * Authenticate action to the gateway (override if needed)
	         *
	         * @returns {Promise} A promise with the module as return, or en EQError
	         */
	
	    }, {
	        key: "authenticate",
	        value: function authenticate() {
	            var _this = this;
	
	            return new Promise(function (resolve) {
	                resolve(_this);
	            });
	        }
	
	        /**
	         * Call all APIs available
	         * Note that authentication should be ran before
	         *
	         * @returns {Promise} A promise with an Object with API results as return, or an EQError
	         */
	
	    }, {
	        key: "getApiInfo",
	        value: function getApiInfo() {
	            throw new _EQError2.default("getApiInfo must be overriden", 624411);
	        }
	
	        /**
	         * Process the rawData kpi
	         *
	         * @param rawData
	         * @param converters
	         * @returns {Promise}
	         */
	
	    }, {
	        key: "processKpi",
	        value: function processKpi(rawData, converters) {
	            var self = this;
	            return new Promise(function (resolve, reject) {
	                if (self.converter && self.validator) {
	                    self.converter.convert(rawData, converters).then(function (rawKpi) {
	                        self.validator.validate(rawKpi).then(function (rawKpi) {
	                            self.mapper.map(rawKpi).then(function (kpi) {
	                                resolve(kpi);
	                            }).catch(function (e) {
	                                reject(new _EQError2.default(e.message, 624430));
	                            });
	                        }).catch(function (e) {
	                            reject(new _EQError2.default(e.message, 624420));
	                        });
	                    }).catch(function (e) {
	                        reject(new _EQError2.default(e.message, 624410));
	                    });
	                } else {
	                    reject(new _EQError2.default("No converter or validator set for this module", 624409));
	                }
	            });
	        }
	    }]);
	
	    return GatewayModule;
	}();
	
	exports.default = GatewayModule;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //import EQError from "../../../../../utils/EQError";
	
	
	var _RawKpiConstants = __webpack_require__(101);
	
	var RawKpiConstants = _interopRequireWildcard(_RawKpiConstants);
	
	var _BearerEnum = __webpack_require__(102);
	
	var Bearer = _interopRequireWildcard(_BearerEnum);
	
	var _IpProtocolEnum = __webpack_require__(125);
	
	var IpProtocol = _interopRequireWildcard(_IpProtocolEnum);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KpiConverter = function () {
	    /**
	     * Constructor
	     *
	     * @param brand
	     * @param ip
	     */
	    function KpiConverter(brand, ip) {
	        _classCallCheck(this, KpiConverter);
	
	        this.brand = brand;
	        this.ip = ip;
	    }
	
	    /**
	     * Return a raw kpi object
	     *
	     * @returns {Object}
	     */
	
	
	    _createClass(KpiConverter, [{
	        key: "getRawKpi",
	        value: function getRawKpi() {
	            var rawKpi = {};
	            Object.keys(RawKpiConstants).forEach(function (kpiKey) {
	                rawKpi[kpiKey] = null;
	            });
	            rawKpi[RawKpiConstants.BRAND] = this.brand;
	            rawKpi[RawKpiConstants.LOCAL_IP] = this.ip;
	            rawKpi[RawKpiConstants.LOCAL_IP_PROTOCOL] = IpProtocol.VERSION_4;
	            rawKpi[RawKpiConstants.TIMESTAMP] = Date.now();
	
	            return rawKpi;
	        }
	
	        /**
	         * Access to the raw kpi constants without import
	         */
	
	    }, {
	        key: "getRawKpiConstants",
	        value: function getRawKpiConstants() {
	            return RawKpiConstants;
	        }
	
	        /**
	         * Set api cell id
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "cellId",
	        value: function cellId(rawData, rawKpi) {
	            if (rawKpi[RawKpiConstants.CELL_ID] && rawKpi[RawKpiConstants.BEARER]) {
	                switch (rawKpi[RawKpiConstants.BEARER].code) {
	                    case Bearer.GPRS.code:
	                    case Bearer.EDGE.code:
	                    case Bearer.GSM.code:
	                    case Bearer.GSM_RAT.code:
	                    case Bearer.TYPE_2G.code:
	                        rawKpi[RawKpiConstants.CELL_ID] = rawKpi[RawKpiConstants.CELL_ID] & 0xFFFF;
	                        break;
	                    case Bearer.UMTS.code:
	                    case Bearer.CDMA.code:
	                    case Bearer.EVDO_0.code:
	                    case Bearer.EVDO_A.code:
	                    case Bearer.EVDO_B.code:
	                    case Bearer.C1XRTT.code:
	                    case Bearer.HSDPA.code:
	                    case Bearer.HSUPA.code:
	                    case Bearer.HSPA.code:
	                    case Bearer.IDEN.code:
	                    case Bearer.EHRPD.code:
	                    case Bearer.HSPAP.code:
	                    case Bearer.DUAL_CARRIER.code:
	                    case Bearer.TYPE_3G.code:
	                        rawKpi[RawKpiConstants.CELL_ID] = rawKpi[RawKpiConstants.CELL_ID] & 0xFFFF;
	                        break;
	                    case Bearer.LTE.code:
	                    case Bearer.TYPE_4G.code:
	                    case Bearer.LTE_A.code:
	                        // padStart function definition if unexisting (string prototype)
	                        // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
	                        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
	                        if (!String.prototype.padStart) {
	                            String.prototype.padStart = function padStart(targetLength, padString) {
	                                targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
	                                padString = String(typeof padString !== 'undefined' ? padString : ' ');
	                                if (this.length > targetLength) {
	                                    return String(this);
	                                } else {
	                                    targetLength = targetLength - this.length;
	                                    if (targetLength > padString.length) {
	                                        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
	                                    }
	                                    return padString.slice(0, targetLength) + String(this);
	                                }
	                            };
	                        }
	                        rawKpi[RawKpiConstants.CELL_ID_4G] = parseInt(parseInt(rawKpi[RawKpiConstants.CELL_ID], 10).toString(2).padStart(28, "0").substr(20), 2);
	                        break;
	                }
	            }
	        }
	
	        /**
	         * Set api rad band
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "radBand",
	        value: function radBand(rawData, rawKpi) {
	            var bands = [];
	            var createBandObject = function createBandObject(band, label, lowRange, highRange) {
	                return { band: band, label: label, lowRange: lowRange, highRange: highRange };
	            };
	
	            bands.push(createBandObject(1, "2100", 0, 600));
	            bands.push(createBandObject(2, "1900", 600, 1200));
	            bands.push(createBandObject(3, "1800", 1200, 1950));
	            bands.push(createBandObject(4, "1700", 1950, 2400));
	            bands.push(createBandObject(5, "850", 2400, 2650));
	            bands.push(createBandObject(6, "UMTS only", 2650, 2750));
	            bands.push(createBandObject(7, "2600", 2750, 3450));
	            bands.push(createBandObject(8, "900 GSM", 3450, 3800));
	            bands.push(createBandObject(9, "1800", 3800, 4150));
	            bands.push(createBandObject(10, "AWS-1+", 4150, 4750));
	            bands.push(createBandObject(11, "1500 Lower", 4750, 4950));
	            bands.push(createBandObject(12, "700 a", 5010, 5180));
	            bands.push(createBandObject(13, "700 c", 5180, 5280));
	            bands.push(createBandObject(14, "700 PS", 5280, 5380));
	            bands.push(createBandObject(17, "700 b", 5730, 5850));
	            bands.push(createBandObject(18, "800 Lower", 5850, 6000));
	            bands.push(createBandObject(19, "800 Upper", 6000, 6150));
	            bands.push(createBandObject(20, "800 DD", 6150, 6450));
	            bands.push(createBandObject(21, "1500 Upper", 6450, 6600));
	            bands.push(createBandObject(22, "3500", 6600, 7400));
	            bands.push(createBandObject(23, "2000 S-band", 7500, 7700));
	            bands.push(createBandObject(24, "1600 L-band", 7700, 8040));
	            bands.push(createBandObject(25, "1900+", 8040, 8690));
	            bands.push(createBandObject(26, "850+", 8690, 9040));
	            bands.push(createBandObject(27, "800 SMR", 9040, 9210));
	            bands.push(createBandObject(28, "700 APT", 9210, 9660));
	            bands.push(createBandObject(29, "700 d", 9660, 9770));
	            bands.push(createBandObject(30, "2300 WCS", 9770, 9870));
	            bands.push(createBandObject(31, "450", 9870, 9920));
	            bands.push(createBandObject(32, "1500 L-band", 9920, 10360));
	            bands.push(createBandObject(33, "TD 1900", 36000, 36200));
	            bands.push(createBandObject(34, "TD 2000", 36200, 36350));
	            bands.push(createBandObject(35, "TD PCS Lower", 36350, 36950));
	            bands.push(createBandObject(36, "TD PCS Upper", 36950, 37550));
	            bands.push(createBandObject(37, "TD PCS Center gap", 37550, 37750));
	            bands.push(createBandObject(38, "TD 2600", 37750, 38250));
	            bands.push(createBandObject(39, "TD 1900+", 38250, 38650));
	            bands.push(createBandObject(40, "TD 2300", 38650, 39650));
	            bands.push(createBandObject(41, "TD 2500", 39650, 41590));
	            bands.push(createBandObject(42, "TD 3500", 41590, 43590));
	            bands.push(createBandObject(43, "TD 3700", 43590, 45590));
	            bands.push(createBandObject(44, "TD 700", 45590, 46590));
	            bands.push(createBandObject(45, "TD 1500", 46590, 46790));
	            bands.push(createBandObject(46, "TD Unlicensed", 46790, 54540));
	            bands.push(createBandObject(47, "TD V2X", 54540, 55240));
	            bands.push(createBandObject(48, "TD 3600", 55240, 56740));
	            bands.push(createBandObject(49, "TD 3600r", 56740, 58240));
	            bands.push(createBandObject(50, "TD 1500+", 58240, 59090));
	            bands.push(createBandObject(51, "TD 1500-", 59090, 59140));
	            bands.push(createBandObject(52, "TD 3300", 59140, 60140));
	            bands.push(createBandObject(65, "2100", 65536, 66436));
	            bands.push(createBandObject(66, "1700", 66436, 67336));
	            bands.push(createBandObject(67, "700", 67336, 67536));
	            bands.push(createBandObject(68, "700", 67536, 67836));
	            bands.push(createBandObject(69, "2600", 67836, 68336));
	            bands.push(createBandObject(70, "2000", 68336, 68586));
	            bands.push(createBandObject(71, "600", 68586, 68936));
	            bands.push(createBandObject(72, "450", 68936, 68986));
	            bands.push(createBandObject(73, "450", 68986, 69036));
	            bands.push(createBandObject(74, "1500", 69036, 69466));
	            bands.push(createBandObject(75, "1500", 69466, 70316));
	            bands.push(createBandObject(76, "1500", 70316, 70366));
	            bands.push(createBandObject(85, "700", 70366, 70546));
	            bands.push(createBandObject(252, "Unlicensed NII-1", 255144, 256144));
	            bands.push(createBandObject(255, "Unlicensed NII-3", 260894, 262144));
	
	            var fBand = null;
	            if (rawKpi[RawKpiConstants.EARFCN]) {
	                bands.forEach(function (band) {
	                    if (rawKpi[RawKpiConstants.EARFCN] >= band.lowRange && rawKpi[RawKpiConstants.EARFCN] < band.highRange) {
	                        fBand = band;
	                    }
	                });
	            }
	
	            if (fBand) {
	                rawKpi[RawKpiConstants.RAD_BAND] = fBand.band;
	            }
	        }
	
	        /**
	         * Convert a raw data to a raw kpi
	         *
	         * @param rawData
	         * @param converters
	         * @returns {Promise}
	         */
	
	    }, {
	        key: "convert",
	        value: function convert(rawData, converters) {
	            var rawKpi = this.getRawKpi();
	            return new Promise(function (resolve) {
	                converters.forEach(function (cMethod) {
	                    cMethod(rawData, rawKpi);
	                });
	
	                resolve(rawKpi);
	            });
	        }
	    }]);
	
	    return KpiConverter;
	}();
	
	exports.default = KpiConverter;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UNSUPPORTED = exports.UNSUPPORTED = { code: -1, label: "UNSUPPORTED" };
	var UNKNOWN = exports.UNKNOWN = { code: 0, label: "UNKNOWN" };
	var VERSION_4 = exports.VERSION_4 = { code: 1, label: "VERSION 4" };
	var VERSION_6 = exports.VERSION_6 = { code: 2, label: "VERSION 6" };

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _EQError = __webpack_require__(6);
	
	var _EQError2 = _interopRequireDefault(_EQError);
	
	var _RawKpiConstants = __webpack_require__(101);
	
	var RawKpiConstants = _interopRequireWildcard(_RawKpiConstants);
	
	var _BearerEnum = __webpack_require__(102);
	
	var Bearer = _interopRequireWildcard(_BearerEnum);
	
	var _Logger = __webpack_require__(5);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KpiValidator = function () {
	    /**
	     * Constructor
	     *
	     */
	    function KpiValidator() {
	        _classCallCheck(this, KpiValidator);
	    }
	
	    /**
	     * Display an error and set kpi to NULL value
	     *
	     * @param rawKpi
	     * @param kpiConstant
	     */
	
	
	    _createClass(KpiValidator, [{
	        key: "mcc",
	
	
	        /**
	         * Validate mcc value
	         *
	         * @param rawKpi
	         */
	        value: function mcc(rawKpi) {
	            if (rawKpi[RawKpiConstants.MCC]) {
	                if (parseInt(rawKpi[RawKpiConstants.MCC]) < 100 || parseInt(rawKpi[RawKpiConstants.MCC]) > 999) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.MCC);
	                }
	            }
	        }
	
	        /**
	         * Validate mnc value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "mnc",
	        value: function mnc(rawKpi) {
	            if (rawKpi[RawKpiConstants.MNC]) {
	                if (parseInt(rawKpi[RawKpiConstants.MNC]) < 1 || parseInt(rawKpi[RawKpiConstants.MNC]) > 999) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.MNC);
	                }
	            }
	        }
	
	        /**
	         * Validate cell id value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "cellId",
	        value: function cellId(rawKpi) {
	            if (rawKpi[RawKpiConstants.CELL_ID]) {
	                if ((parseInt(rawKpi[RawKpiConstants.CELL_ID]) < 1 || parseInt(rawKpi[RawKpiConstants.CELL_ID]) > 65535) && rawKpi[RawKpiConstants.BEARER].code != Bearer.LTE_A.code && rawKpi[RawKpiConstants.BEARER].code != Bearer.LTE.code && rawKpi[RawKpiConstants.BEARER].code != Bearer.TYPE_4G.code) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.CELL_ID);
	                }
	            }
	        }
	
	        /**
	         * Validate rssi value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "rssi",
	        value: function rssi(rawKpi) {
	            if (rawKpi[RawKpiConstants.RSSI]) {
	                if (rawKpi[RawKpiConstants.RSSI] < -113 || rawKpi[RawKpiConstants.RSSI] > -51) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.RSSI);
	                }
	            }
	        }
	
	        /**
	         * Validate rscp value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "rscp",
	        value: function rscp(rawKpi) {
	            if (rawKpi[RawKpiConstants.RSCP]) {
	                if (rawKpi[RawKpiConstants.RSCP] < -113 || rawKpi[RawKpiConstants.RSCP] > -51) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.RSCP);
	                }
	            }
	        }
	
	        /**
	         * Validate rsrp value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "rsrp",
	        value: function rsrp(rawKpi) {
	            if (rawKpi[RawKpiConstants.RSRP]) {
	                if (rawKpi[RawKpiConstants.RSRP] < -140 || rawKpi[RawKpiConstants.RSRP] > -44) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.RSRP);
	                }
	            }
	        }
	
	        /**
	         * Validate psc value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "psc",
	        value: function psc(rawKpi) {
	            if (rawKpi[RawKpiConstants.PSC]) {
	                if (rawKpi[RawKpiConstants.PSC] < 0 || rawKpi[RawKpiConstants.PSC] > 512) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.PSC);
	                }
	            }
	        }
	
	        /**
	         * Validate ecno value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "ecno",
	        value: function ecno(rawKpi) {
	            if (rawKpi[RawKpiConstants.ECNO]) {
	                if (rawKpi[RawKpiConstants.ECNO] < -10 || rawKpi[RawKpiConstants.ECNO] > 0) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.ECNO);
	                }
	            }
	        }
	
	        /**
	         * Validate rsrq value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "rsrq",
	        value: function rsrq(rawKpi) {
	            if (rawKpi[RawKpiConstants.RSRQ]) {
	                if (rawKpi[RawKpiConstants.RSRQ] < -20 || rawKpi[RawKpiConstants.RSRQ] > 3) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.RSRQ);
	                }
	            }
	        }
	
	        /**
	         * Validate snr value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "snr",
	        value: function snr(rawKpi) {
	            if (rawKpi[RawKpiConstants.SNR]) {
	                if (rawKpi[RawKpiConstants.SNR] < -20 || rawKpi[RawKpiConstants.SNR] > 30) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.SNR);
	                }
	            }
	        }
	
	        /**
	         * Validate pci value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "pci",
	        value: function pci(rawKpi) {
	            if (rawKpi[RawKpiConstants.PCI]) {
	                if (rawKpi[RawKpiConstants.PCI] < 0 || rawKpi[RawKpiConstants.PCI] > 503) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.PCI);
	                }
	            }
	        }
	
	        /**
	         * Validate cellId4g value
	         *
	         * @param rawKpi
	         */
	
	    }, {
	        key: "cellId4g",
	        value: function cellId4g(rawKpi) {
	            if (rawKpi[RawKpiConstants.CELL_ID_4G]) {
	                if (rawKpi[RawKpiConstants.CELL_ID_4G] < 0 || rawKpi[RawKpiConstants.CELL_ID_4G] > 255) {
	                    KpiValidator.displayErrorAndSetNull(rawKpi, RawKpiConstants.CELL_ID_4G);
	                }
	            }
	        }
	
	        /**
	         * Validate the raw kpi object
	         *
	         * @param rawKpi
	         * @returns {Promise}
	         */
	
	    }, {
	        key: "validate",
	        value: function validate(rawKpi) {
	            var self = this;
	            return new Promise(function (resolve) {
	                var validators = [self.mnc, self.mcc, self.cellId, self.rssi, self.rscp, self.rsrp, self.psc, self.ecno, self.rsrq, self.snr, self.pci, self.cellId4g];
	
	                validators.forEach(function (cMethod) {
	                    cMethod(rawKpi);
	                });
	
	                resolve(rawKpi);
	            });
	        }
	    }], [{
	        key: "displayErrorAndSetNull",
	        value: function displayErrorAndSetNull(rawKpi, kpiConstant) {
	            _Logger2.default.log(new _EQError2.default("Validator error. Invalid " + kpiConstant + " : " + rawKpi[kpiConstant]));
	            rawKpi[kpiConstant] = null;
	        }
	    }]);
	
	    return KpiValidator;
	}();
	
	exports.default = KpiValidator;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _exports = module.exports = function SHA(algorithm) {
	  algorithm = algorithm.toLowerCase();
	
	  var Algorithm = _exports[algorithm];
	  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
	
	  return new Algorithm();
	};
	
	_exports.sha = __webpack_require__(128);
	_exports.sha1 = __webpack_require__(131);
	_exports.sha224 = __webpack_require__(132);
	_exports.sha256 = __webpack_require__(133);
	_exports.sha384 = __webpack_require__(134);
	_exports.sha512 = __webpack_require__(135);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
	 * in FIPS PUB 180-1
	 * This source code is derived from sha1.js of the same repository.
	 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
	 * operation was added.
	 */
	
	var inherits = __webpack_require__(47);
	var Hash = __webpack_require__(129);
	var Buffer = __webpack_require__(130).Buffer;
	
	var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0];
	
	var W = new Array(80);
	
	function Sha() {
	  this.init();
	  this._w = W;
	
	  Hash.call(this, 64, 56);
	}
	
	inherits(Sha, Hash);
	
	Sha.prototype.init = function () {
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	  this._e = 0xc3d2e1f0;
	
	  return this;
	};
	
	function rotl5(num) {
	  return num << 5 | num >>> 27;
	}
	
	function rotl30(num) {
	  return num << 30 | num >>> 2;
	}
	
	function ft(s, b, c, d) {
	  if (s === 0) return b & c | ~b & d;
	  if (s === 2) return b & c | b & d | c & d;
	  return b ^ c ^ d;
	}
	
	Sha.prototype._update = function (M) {
	  var W = this._w;
	
	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;
	
	  for (var i = 0; i < 16; ++i) {
	    W[i] = M.readInt32BE(i * 4);
	  }for (; i < 80; ++i) {
	    W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	  }for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20);
	    var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
	
	    e = d;
	    d = c;
	    c = rotl30(b);
	    b = a;
	    a = t;
	  }
	
	  this._a = a + this._a | 0;
	  this._b = b + this._b | 0;
	  this._c = c + this._c | 0;
	  this._d = d + this._d | 0;
	  this._e = e + this._e | 0;
	};
	
	Sha.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(20);
	
	  H.writeInt32BE(this._a | 0, 0);
	  H.writeInt32BE(this._b | 0, 4);
	  H.writeInt32BE(this._c | 0, 8);
	  H.writeInt32BE(this._d | 0, 12);
	  H.writeInt32BE(this._e | 0, 16);
	
	  return H;
	};
	
	module.exports = Sha;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(130).Buffer;
	
	// prototype class for hash functions
	function Hash(blockSize, finalSize) {
	  this._block = Buffer.alloc(blockSize);
	  this._finalSize = finalSize;
	  this._blockSize = blockSize;
	  this._len = 0;
	}
	
	Hash.prototype.update = function (data, enc) {
	  if (typeof data === 'string') {
	    enc = enc || 'utf8';
	    data = Buffer.from(data, enc);
	  }
	
	  var block = this._block;
	  var blockSize = this._blockSize;
	  var length = data.length;
	  var accum = this._len;
	
	  for (var offset = 0; offset < length;) {
	    var assigned = accum % blockSize;
	    var remainder = Math.min(length - offset, blockSize - assigned);
	
	    for (var i = 0; i < remainder; i++) {
	      block[assigned + i] = data[offset + i];
	    }
	
	    accum += remainder;
	    offset += remainder;
	
	    if (accum % blockSize === 0) {
	      this._update(block);
	    }
	  }
	
	  this._len += length;
	  return this;
	};
	
	Hash.prototype.digest = function (enc) {
	  var rem = this._len % this._blockSize;
	
	  this._block[rem] = 0x80;
	
	  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	  this._block.fill(0, rem + 1);
	
	  if (rem >= this._finalSize) {
	    this._update(this._block);
	    this._block.fill(0);
	  }
	
	  var bits = this._len * 8;
	
	  // uint32
	  if (bits <= 0xffffffff) {
	    this._block.writeUInt32BE(bits, this._blockSize - 4);
	
	    // uint64
	  } else {
	    var lowBits = (bits & 0xffffffff) >>> 0;
	    var highBits = (bits - lowBits) / 0x100000000;
	
	    this._block.writeUInt32BE(highBits, this._blockSize - 8);
	    this._block.writeUInt32BE(lowBits, this._blockSize - 4);
	  }
	
	  this._update(this._block);
	  var hash = this._hash();
	
	  return enc ? hash.toString(enc) : hash;
	};
	
	Hash.prototype._update = function () {
	  throw new Error('_update must be implemented by subclass');
	};
	
	module.exports = Hash;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(41);
	var Buffer = buffer.Buffer;
	
	// alternative to using Object.keys for old browsers
	function copyProps(src, dst) {
	  for (var key in src) {
	    dst[key] = src[key];
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer;
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports);
	  exports.Buffer = SafeBuffer;
	}
	
	function SafeBuffer(arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length);
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer);
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number');
	  }
	  return Buffer(arg, encodingOrOffset, length);
	};
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number');
	  }
	  var buf = Buffer(size);
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding);
	    } else {
	      buf.fill(fill);
	    }
	  } else {
	    buf.fill(0);
	  }
	  return buf;
	};
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number');
	  }
	  return Buffer(size);
	};
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number');
	  }
	  return buffer.SlowBuffer(size);
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(47);
	var Hash = __webpack_require__(129);
	var Buffer = __webpack_require__(130).Buffer;
	
	var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0];
	
	var W = new Array(80);
	
	function Sha1() {
	  this.init();
	  this._w = W;
	
	  Hash.call(this, 64, 56);
	}
	
	inherits(Sha1, Hash);
	
	Sha1.prototype.init = function () {
	  this._a = 0x67452301;
	  this._b = 0xefcdab89;
	  this._c = 0x98badcfe;
	  this._d = 0x10325476;
	  this._e = 0xc3d2e1f0;
	
	  return this;
	};
	
	function rotl1(num) {
	  return num << 1 | num >>> 31;
	}
	
	function rotl5(num) {
	  return num << 5 | num >>> 27;
	}
	
	function rotl30(num) {
	  return num << 30 | num >>> 2;
	}
	
	function ft(s, b, c, d) {
	  if (s === 0) return b & c | ~b & d;
	  if (s === 2) return b & c | b & d | c & d;
	  return b ^ c ^ d;
	}
	
	Sha1.prototype._update = function (M) {
	  var W = this._w;
	
	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;
	
	  for (var i = 0; i < 16; ++i) {
	    W[i] = M.readInt32BE(i * 4);
	  }for (; i < 80; ++i) {
	    W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
	  }for (var j = 0; j < 80; ++j) {
	    var s = ~~(j / 20);
	    var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
	
	    e = d;
	    d = c;
	    c = rotl30(b);
	    b = a;
	    a = t;
	  }
	
	  this._a = a + this._a | 0;
	  this._b = b + this._b | 0;
	  this._c = c + this._c | 0;
	  this._d = d + this._d | 0;
	  this._e = e + this._e | 0;
	};
	
	Sha1.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(20);
	
	  H.writeInt32BE(this._a | 0, 0);
	  H.writeInt32BE(this._b | 0, 4);
	  H.writeInt32BE(this._c | 0, 8);
	  H.writeInt32BE(this._d | 0, 12);
	  H.writeInt32BE(this._e | 0, 16);
	
	  return H;
	};
	
	module.exports = Sha1;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(47);
	var Sha256 = __webpack_require__(133);
	var Hash = __webpack_require__(129);
	var Buffer = __webpack_require__(130).Buffer;
	
	var W = new Array(64);
	
	function Sha224() {
	  this.init();
	
	  this._w = W; // new Array(64)
	
	  Hash.call(this, 64, 56);
	}
	
	inherits(Sha224, Sha256);
	
	Sha224.prototype.init = function () {
	  this._a = 0xc1059ed8;
	  this._b = 0x367cd507;
	  this._c = 0x3070dd17;
	  this._d = 0xf70e5939;
	  this._e = 0xffc00b31;
	  this._f = 0x68581511;
	  this._g = 0x64f98fa7;
	  this._h = 0xbefa4fa4;
	
	  return this;
	};
	
	Sha224.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(28);
	
	  H.writeInt32BE(this._a, 0);
	  H.writeInt32BE(this._b, 4);
	  H.writeInt32BE(this._c, 8);
	  H.writeInt32BE(this._d, 12);
	  H.writeInt32BE(this._e, 16);
	  H.writeInt32BE(this._f, 20);
	  H.writeInt32BE(this._g, 24);
	
	  return H;
	};
	
	module.exports = Sha224;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(47);
	var Hash = __webpack_require__(129);
	var Buffer = __webpack_require__(130).Buffer;
	
	var K = [0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5, 0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5, 0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3, 0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174, 0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC, 0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA, 0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7, 0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967, 0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13, 0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85, 0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3, 0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070, 0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5, 0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3, 0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208, 0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2];
	
	var W = new Array(64);
	
	function Sha256() {
	  this.init();
	
	  this._w = W; // new Array(64)
	
	  Hash.call(this, 64, 56);
	}
	
	inherits(Sha256, Hash);
	
	Sha256.prototype.init = function () {
	  this._a = 0x6a09e667;
	  this._b = 0xbb67ae85;
	  this._c = 0x3c6ef372;
	  this._d = 0xa54ff53a;
	  this._e = 0x510e527f;
	  this._f = 0x9b05688c;
	  this._g = 0x1f83d9ab;
	  this._h = 0x5be0cd19;
	
	  return this;
	};
	
	function ch(x, y, z) {
	  return z ^ x & (y ^ z);
	}
	
	function maj(x, y, z) {
	  return x & y | z & (x | y);
	}
	
	function sigma0(x) {
	  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
	}
	
	function sigma1(x) {
	  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
	}
	
	function gamma0(x) {
	  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
	}
	
	function gamma1(x) {
	  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
	}
	
	Sha256.prototype._update = function (M) {
	  var W = this._w;
	
	  var a = this._a | 0;
	  var b = this._b | 0;
	  var c = this._c | 0;
	  var d = this._d | 0;
	  var e = this._e | 0;
	  var f = this._f | 0;
	  var g = this._g | 0;
	  var h = this._h | 0;
	
	  for (var i = 0; i < 16; ++i) {
	    W[i] = M.readInt32BE(i * 4);
	  }for (; i < 64; ++i) {
	    W[i] = gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16] | 0;
	  }for (var j = 0; j < 64; ++j) {
	    var T1 = h + sigma1(e) + ch(e, f, g) + K[j] + W[j] | 0;
	    var T2 = sigma0(a) + maj(a, b, c) | 0;
	
	    h = g;
	    g = f;
	    f = e;
	    e = d + T1 | 0;
	    d = c;
	    c = b;
	    b = a;
	    a = T1 + T2 | 0;
	  }
	
	  this._a = a + this._a | 0;
	  this._b = b + this._b | 0;
	  this._c = c + this._c | 0;
	  this._d = d + this._d | 0;
	  this._e = e + this._e | 0;
	  this._f = f + this._f | 0;
	  this._g = g + this._g | 0;
	  this._h = h + this._h | 0;
	};
	
	Sha256.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(32);
	
	  H.writeInt32BE(this._a, 0);
	  H.writeInt32BE(this._b, 4);
	  H.writeInt32BE(this._c, 8);
	  H.writeInt32BE(this._d, 12);
	  H.writeInt32BE(this._e, 16);
	  H.writeInt32BE(this._f, 20);
	  H.writeInt32BE(this._g, 24);
	  H.writeInt32BE(this._h, 28);
	
	  return H;
	};
	
	module.exports = Sha256;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherits = __webpack_require__(47);
	var SHA512 = __webpack_require__(135);
	var Hash = __webpack_require__(129);
	var Buffer = __webpack_require__(130).Buffer;
	
	var W = new Array(160);
	
	function Sha384() {
	  this.init();
	  this._w = W;
	
	  Hash.call(this, 128, 112);
	}
	
	inherits(Sha384, SHA512);
	
	Sha384.prototype.init = function () {
	  this._ah = 0xcbbb9d5d;
	  this._bh = 0x629a292a;
	  this._ch = 0x9159015a;
	  this._dh = 0x152fecd8;
	  this._eh = 0x67332667;
	  this._fh = 0x8eb44a87;
	  this._gh = 0xdb0c2e0d;
	  this._hh = 0x47b5481d;
	
	  this._al = 0xc1059ed8;
	  this._bl = 0x367cd507;
	  this._cl = 0x3070dd17;
	  this._dl = 0xf70e5939;
	  this._el = 0xffc00b31;
	  this._fl = 0x68581511;
	  this._gl = 0x64f98fa7;
	  this._hl = 0xbefa4fa4;
	
	  return this;
	};
	
	Sha384.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(48);
	
	  function writeInt64BE(h, l, offset) {
	    H.writeInt32BE(h, offset);
	    H.writeInt32BE(l, offset + 4);
	  }
	
	  writeInt64BE(this._ah, this._al, 0);
	  writeInt64BE(this._bh, this._bl, 8);
	  writeInt64BE(this._ch, this._cl, 16);
	  writeInt64BE(this._dh, this._dl, 24);
	  writeInt64BE(this._eh, this._el, 32);
	  writeInt64BE(this._fh, this._fl, 40);
	
	  return H;
	};
	
	module.exports = Sha384;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inherits = __webpack_require__(47);
	var Hash = __webpack_require__(129);
	var Buffer = __webpack_require__(130).Buffer;
	
	var K = [0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd, 0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc, 0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019, 0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118, 0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe, 0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2, 0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1, 0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694, 0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3, 0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65, 0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483, 0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5, 0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210, 0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4, 0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725, 0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70, 0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926, 0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df, 0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8, 0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b, 0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001, 0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30, 0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910, 0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8, 0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53, 0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8, 0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb, 0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3, 0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60, 0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec, 0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9, 0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b, 0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207, 0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178, 0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6, 0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b, 0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493, 0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c, 0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a, 0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817];
	
	var W = new Array(160);
	
	function Sha512() {
	  this.init();
	  this._w = W;
	
	  Hash.call(this, 128, 112);
	}
	
	inherits(Sha512, Hash);
	
	Sha512.prototype.init = function () {
	  this._ah = 0x6a09e667;
	  this._bh = 0xbb67ae85;
	  this._ch = 0x3c6ef372;
	  this._dh = 0xa54ff53a;
	  this._eh = 0x510e527f;
	  this._fh = 0x9b05688c;
	  this._gh = 0x1f83d9ab;
	  this._hh = 0x5be0cd19;
	
	  this._al = 0xf3bcc908;
	  this._bl = 0x84caa73b;
	  this._cl = 0xfe94f82b;
	  this._dl = 0x5f1d36f1;
	  this._el = 0xade682d1;
	  this._fl = 0x2b3e6c1f;
	  this._gl = 0xfb41bd6b;
	  this._hl = 0x137e2179;
	
	  return this;
	};
	
	function Ch(x, y, z) {
	  return z ^ x & (y ^ z);
	}
	
	function maj(x, y, z) {
	  return x & y | z & (x | y);
	}
	
	function sigma0(x, xl) {
	  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
	}
	
	function sigma1(x, xl) {
	  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
	}
	
	function Gamma0(x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
	}
	
	function Gamma0l(x, xl) {
	  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
	}
	
	function Gamma1(x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
	}
	
	function Gamma1l(x, xl) {
	  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
	}
	
	function getCarry(a, b) {
	  return a >>> 0 < b >>> 0 ? 1 : 0;
	}
	
	Sha512.prototype._update = function (M) {
	  var W = this._w;
	
	  var ah = this._ah | 0;
	  var bh = this._bh | 0;
	  var ch = this._ch | 0;
	  var dh = this._dh | 0;
	  var eh = this._eh | 0;
	  var fh = this._fh | 0;
	  var gh = this._gh | 0;
	  var hh = this._hh | 0;
	
	  var al = this._al | 0;
	  var bl = this._bl | 0;
	  var cl = this._cl | 0;
	  var dl = this._dl | 0;
	  var el = this._el | 0;
	  var fl = this._fl | 0;
	  var gl = this._gl | 0;
	  var hl = this._hl | 0;
	
	  for (var i = 0; i < 32; i += 2) {
	    W[i] = M.readInt32BE(i * 4);
	    W[i + 1] = M.readInt32BE(i * 4 + 4);
	  }
	  for (; i < 160; i += 2) {
	    var xh = W[i - 15 * 2];
	    var xl = W[i - 15 * 2 + 1];
	    var gamma0 = Gamma0(xh, xl);
	    var gamma0l = Gamma0l(xl, xh);
	
	    xh = W[i - 2 * 2];
	    xl = W[i - 2 * 2 + 1];
	    var gamma1 = Gamma1(xh, xl);
	    var gamma1l = Gamma1l(xl, xh);
	
	    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	    var Wi7h = W[i - 7 * 2];
	    var Wi7l = W[i - 7 * 2 + 1];
	
	    var Wi16h = W[i - 16 * 2];
	    var Wi16l = W[i - 16 * 2 + 1];
	
	    var Wil = gamma0l + Wi7l | 0;
	    var Wih = gamma0 + Wi7h + getCarry(Wil, gamma0l) | 0;
	    Wil = Wil + gamma1l | 0;
	    Wih = Wih + gamma1 + getCarry(Wil, gamma1l) | 0;
	    Wil = Wil + Wi16l | 0;
	    Wih = Wih + Wi16h + getCarry(Wil, Wi16l) | 0;
	
	    W[i] = Wih;
	    W[i + 1] = Wil;
	  }
	
	  for (var j = 0; j < 160; j += 2) {
	    Wih = W[j];
	    Wil = W[j + 1];
	
	    var majh = maj(ah, bh, ch);
	    var majl = maj(al, bl, cl);
	
	    var sigma0h = sigma0(ah, al);
	    var sigma0l = sigma0(al, ah);
	    var sigma1h = sigma1(eh, el);
	    var sigma1l = sigma1(el, eh);
	
	    // t1 = h + sigma1 + ch + K[j] + W[j]
	    var Kih = K[j];
	    var Kil = K[j + 1];
	
	    var chh = Ch(eh, fh, gh);
	    var chl = Ch(el, fl, gl);
	
	    var t1l = hl + sigma1l | 0;
	    var t1h = hh + sigma1h + getCarry(t1l, hl) | 0;
	    t1l = t1l + chl | 0;
	    t1h = t1h + chh + getCarry(t1l, chl) | 0;
	    t1l = t1l + Kil | 0;
	    t1h = t1h + Kih + getCarry(t1l, Kil) | 0;
	    t1l = t1l + Wil | 0;
	    t1h = t1h + Wih + getCarry(t1l, Wil) | 0;
	
	    // t2 = sigma0 + maj
	    var t2l = sigma0l + majl | 0;
	    var t2h = sigma0h + majh + getCarry(t2l, sigma0l) | 0;
	
	    hh = gh;
	    hl = gl;
	    gh = fh;
	    gl = fl;
	    fh = eh;
	    fl = el;
	    el = dl + t1l | 0;
	    eh = dh + t1h + getCarry(el, dl) | 0;
	    dh = ch;
	    dl = cl;
	    ch = bh;
	    cl = bl;
	    bh = ah;
	    bl = al;
	    al = t1l + t2l | 0;
	    ah = t1h + t2h + getCarry(al, t1l) | 0;
	  }
	
	  this._al = this._al + al | 0;
	  this._bl = this._bl + bl | 0;
	  this._cl = this._cl + cl | 0;
	  this._dl = this._dl + dl | 0;
	  this._el = this._el + el | 0;
	  this._fl = this._fl + fl | 0;
	  this._gl = this._gl + gl | 0;
	  this._hl = this._hl + hl | 0;
	
	  this._ah = this._ah + ah + getCarry(this._al, al) | 0;
	  this._bh = this._bh + bh + getCarry(this._bl, bl) | 0;
	  this._ch = this._ch + ch + getCarry(this._cl, cl) | 0;
	  this._dh = this._dh + dh + getCarry(this._dl, dl) | 0;
	  this._eh = this._eh + eh + getCarry(this._el, el) | 0;
	  this._fh = this._fh + fh + getCarry(this._fl, fl) | 0;
	  this._gh = this._gh + gh + getCarry(this._gl, gl) | 0;
	  this._hh = this._hh + hh + getCarry(this._hl, hl) | 0;
	};
	
	Sha512.prototype._hash = function () {
	  var H = Buffer.allocUnsafe(64);
	
	  function writeInt64BE(h, l, offset) {
	    H.writeInt32BE(h, offset);
	    H.writeInt32BE(l, offset + 4);
	  }
	
	  writeInt64BE(this._ah, this._al, 0);
	  writeInt64BE(this._bh, this._bl, 8);
	  writeInt64BE(this._ch, this._cl, 16);
	  writeInt64BE(this._dh, this._dl, 24);
	  writeInt64BE(this._eh, this._el, 32);
	  writeInt64BE(this._fh, this._fl, 40);
	  writeInt64BE(this._gh, this._gl, 48);
	  writeInt64BE(this._hh, this._hl, 56);
	
	  return H;
	};
	
	module.exports = Sha512;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _KpiConverter2 = __webpack_require__(124);
	
	var _KpiConverter3 = _interopRequireDefault(_KpiConverter2);
	
	var _IpProtocolEnum = __webpack_require__(125);
	
	var IpProtocol = _interopRequireWildcard(_IpProtocolEnum);
	
	var _BearerEnum = __webpack_require__(102);
	
	var Bearer = _interopRequireWildcard(_BearerEnum);
	
	var _NetstatEnum = __webpack_require__(137);
	
	var Netstat = _interopRequireWildcard(_NetstatEnum);
	
	var _SimStateEnum = __webpack_require__(138);
	
	var SimState = _interopRequireWildcard(_SimStateEnum);
	
	var _WifiStatusEnum = __webpack_require__(139);
	
	var WifiStatus = _interopRequireWildcard(_WifiStatusEnum);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HuaweiE580KpiConverter = function (_KpiConverter) {
	    _inherits(HuaweiE580KpiConverter, _KpiConverter);
	
	    /**
	     * Constructor
	     *
	     * @param brand
	     * @param ip
	     */
	    function HuaweiE580KpiConverter(brand, ip) {
	        _classCallCheck(this, HuaweiE580KpiConverter);
	
	        return _possibleConstructorReturn(this, (HuaweiE580KpiConverter.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter)).call(this, brand, ip));
	    }
	
	    /**
	     * Removed special XML characters
	     *
	     * @param inputString
	     * @returns {string|XML}
	     */
	
	
	    _createClass(HuaweiE580KpiConverter, [{
	        key: "apiRetrievalTime",
	
	
	        /**
	         * Set api retrieval time
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	        value: function apiRetrievalTime(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.retrievalTime)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).API_RETRIEVAL_TIME] = parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.retrievalTime));
	            }
	        }
	
	        /**
	         * Set api local IP
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "localIp",
	        value: function localIp(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.localIp)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).LOCAL_IP] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.localIp);
	            }
	        }
	
	        /**
	         * Set api local ip protocol
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "localIpProtocol",
	        value: function localIpProtocol(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.localIp)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).LOCAL_IP_PROTOCOL] = IpProtocol.VERSION_4;
	            }
	        }
	
	        /**
	         * Set api WAN ip
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "wanIp",
	        value: function wanIp(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.WanIPv6Address)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WAN_IP] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WanIPv6Address);
	            } else if (HuaweiE580KpiConverter.isNotNull(rawData.WanIPAddress)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WAN_IP] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WanIPAddress);
	            }
	        }
	
	        /**
	         * Set api WAN ip protocol
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "wanIpProtocol",
	        value: function wanIpProtocol(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.WanIPv6Address)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WAN_IP_PROTOCOL] = IpProtocol.VERSION_6;
	            } else if (HuaweiE580KpiConverter.isNotNull(rawData.WanIPAddress)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WAN_IP_PROTOCOL] = IpProtocol.VERSION_4;
	            } else {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WAN_IP_PROTOCOL] = IpProtocol.UNSUPPORTED;
	            }
	        }
	
	        /**
	         * Set api model
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "model",
	        value: function model(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.DeviceName)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).MODEL] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.DeviceName);
	            }
	        }
	
	        /**
	         * Set api serial number
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "serialNumber",
	        value: function serialNumber(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.SerialNumber)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).SERIAL_NUMBER] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.SerialNumber);
	            }
	        }
	
	        /**
	         * Set api IMEI
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "imei",
	        value: function imei(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.Imei)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).IMEI] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Imei);
	            }
	        }
	
	        /**
	         * Set api IMSI
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "imsi",
	        value: function imsi(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.Imsi)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).IMSI] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Imsi);
	            }
	        }
	
	        /**
	         * Set api ICCID
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "iccid",
	        value: function iccid(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.Iccid)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).ICCID] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Iccid);
	            }
	        }
	
	        /**
	         * Set api MSISDN
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "msisdn",
	        value: function msisdn(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.Msisdn)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).MSISDN] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Msisdn);
	            }
	        }
	
	        /**
	         * Set api hardware version
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "hardwareVersion",
	        value: function hardwareVersion(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.HardwareVersion)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).HARDWARE_VERSION] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.HardwareVersion);
	            }
	        }
	
	        /**
	         * Set api software version
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "softwareVersion",
	        value: function softwareVersion(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.SoftwareVersion)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).SOFTWARE_VERSION] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.SoftwareVersion);
	            }
	        }
	
	        /**
	         * Set api bearer
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "bearer",
	        value: function bearer(rawData, rawKpi) {
	            // Mapping
	            var HUAWEI_NETWORK_TYPES = {
	                "0": Bearer.UNKNOWN,
	                "1": Bearer.TYPE_2G,
	                "2": Bearer.TYPE_2G,
	                "3": Bearer.TYPE_2G,
	                "4": Bearer.TYPE_3G,
	                "5": Bearer.TYPE_3G,
	                "6": Bearer.TYPE_3G,
	                "7": Bearer.TYPE_3G,
	                "8": Bearer.TYPE_3G,
	                "9": Bearer.HSDPA, // 3G+
	                "10": Bearer.TYPE_3G,
	                "11": Bearer.TYPE_3G,
	                "12": Bearer.TYPE_3G,
	                "13": Bearer.TYPE_3G,
	                "14": Bearer.TYPE_3G,
	                "15": Bearer.TYPE_3G,
	                "16": Bearer.TYPE_3G,
	                "17": Bearer.HSDPA, // 3G+
	                "18": Bearer.HSDPA, // 3G+
	                "19": Bearer.TYPE_4G,
	                "21": Bearer.CDMA,
	                "22": Bearer.CDMA,
	                "23": Bearer.CDMA,
	                "24": Bearer.CDMA,
	                "25": Bearer.CDMA,
	                "26": Bearer.CDMA,
	                "27": Bearer.CDMA,
	                "28": Bearer.CDMA,
	                "29": Bearer.CDMA,
	                "30": Bearer.CDMA,
	                "31": Bearer.EHRPD,
	                "32": Bearer.EHRPD,
	                "33": Bearer.EHRPD,
	                "34": Bearer.EHRPD,
	                "35": Bearer.EHRPD,
	                "36": Bearer.EHRPD,
	                "41": Bearer.TYPE_3G, //WDCDMA
	                "42": Bearer.TYPE_3G,
	                "43": Bearer.TYPE_3G,
	                "44": Bearer.TYPE_3G,
	                "45": Bearer.HSDPA, // 3G+
	                "46": Bearer.HSDPA, // 3G+
	                "61": Bearer.CDMA,
	                "62": Bearer.TYPE_3G,
	                "63": Bearer.TYPE_3G,
	                "64": Bearer.TYPE_3G,
	                "65": Bearer.HSDPA, // 3G+
	                "81": Bearer.IWLAN, // WIMAX
	                "101": Bearer.TYPE_4G
	            };
	
	            if (HuaweiE580KpiConverter.isNotNull(rawData.CurrentNetworkType)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).BEARER] = HUAWEI_NETWORK_TYPES[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.CurrentNetworkType)] ? HUAWEI_NETWORK_TYPES[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.CurrentNetworkType)] : Bearer.UNSUPPORTED;
	            } else {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).BEARER] = Bearer.UNKNOWN;
	            }
	        }
	
	        /**
	         * Set api netstat
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "netstat",
	        value: function netstat(rawData, rawKpi) {
	            // Mapping
	            var HUAWEI_NETSTAT = {
	                "900": Netstat.SEARCHING,
	                "901": Netstat.HOME_NETWORK,
	                "902": Netstat.NO_SERVICE,
	                "903": Netstat.NO_SERVICE
	            };
	
	            /*var MACRO_CONNECTION_CONNECTING = '900';
	             var MACRO_CONNECTION_CONNECTED = '901';
	             var MACRO_CONNECTION_DISCONNECTED = '902';
	             var MACRO_CONNECTION_DISCONNECTING = '903';*/
	
	            if (HuaweiE580KpiConverter.isNotNull(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.workmode)) && HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.workmode) === "NO SERVICE") {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).NETSTAT] = Netstat.NO_SERVICE;
	            } else if (HuaweiE580KpiConverter.isNotNull(rawData.RoamingStatus) && parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.RoamingStatus)) > 0) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).NETSTAT] = Netstat.ROAMING_NATIONAL;
	            } else if (HuaweiE580KpiConverter.isNotNull(rawData.ConnectionStatus) && parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.ConnectionStatus)) === 105) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).NETSTAT] = Netstat.AIRPLANE;
	            } else if (HuaweiE580KpiConverter.isNotNull(rawData.ConnectionStatus)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).NETSTAT] = HUAWEI_NETSTAT[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.ConnectionStatus)] ? HUAWEI_NETSTAT[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.ConnectionStatus)] : Netstat.UNKNOWN;
	            } else {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).NETSTAT] = Netstat.UNKNOWN;
	            }
	        }
	
	        /**
	         * Set api sim status
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "simStatus",
	        value: function simStatus(rawData, rawKpi) {
	            // Mapping
	            var HUAWEI_SIM_STATUS = {
	                "0": SimState.PIN_REQUIRE,
	                "1": SimState.READY,
	                "255": SimState.ABSENT,
	                "256": SimState.NETWORK_LOCKED,
	                "257": SimState.READY,
	                "258": SimState.READY,
	                "259": SimState.PIN_REQUIRE,
	                "260": SimState.PIN_REQUIRE,
	                "261": SimState.PUK_REQUIRE
	            };
	
	            /*var MACRO_NO_SIM_CARD = '255';
	             var MACRO_CPIN_FAIL = '256';
	             var MACRO_PIN_READY = '257';
	             var MACRO_PIN_DISABLE = '258';
	             var MACRO_PIN_VALIDATE = '259';
	             var MACRO_PIN_REQUIRED = '260';
	             var MACRO_PUK_REQUIRED = '261';*/
	
	            if (HuaweiE580KpiConverter.isNotNull(rawData.SimStatus)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).SIM_STATUS] = HUAWEI_SIM_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.SimStatus)] ? HUAWEI_SIM_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.SimStatus)] : SimState.UNKNOWN;
	            } else {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).SIM_STATUS] = SimState.UNKNOWN;
	            }
	        }
	
	        /**
	         * Set api wifi users
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "wifiUsers",
	        value: function wifiUsers(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.CurrentWifiUser)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WIFI_USERS] = parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.CurrentWifiUser));
	            }
	        }
	
	        /**
	         * Set api wifi status
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "wifiStatus",
	        value: function wifiStatus(rawData, rawKpi) {
	            // Mapping
	            var HUAWEI_WIFI_STATUS = {
	                "0": WifiStatus.DISCONNECTED,
	                "1": WifiStatus.CONNECTED,
	                "2": WifiStatus.CONNECTED,
	                "3": WifiStatus.DISCONNECTED,
	                "900": WifiStatus.SEARCHING,
	                "901": WifiStatus.CONNECTED,
	                "902": WifiStatus.DISCONNECTED,
	                "903": WifiStatus.DISCONNECTED
	            };
	
	            /*
	             var WIFI_CONNECTING = '900';
	             var WIFI_CONNECTED= '901';
	             var WIFI_DISCONNECTED = '902';
	             var WIFI_DISCONNECTING = '903';
	             */
	
	            if (HuaweiE580KpiConverter.isNotNull(rawData.WifiConnectionStatus)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WIFI_STATUS] = HUAWEI_WIFI_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiConnectionStatus)] ? HUAWEI_WIFI_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiConnectionStatus)] : WifiStatus.UNKNOWN;
	            } else if (HuaweiE580KpiConverter.isNotNull(rawData.WifiStatus)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WIFI_STATUS] = HUAWEI_WIFI_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiStatus)] ? HUAWEI_WIFI_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiStatus)] : WifiStatus.UNKNOWN;
	            } else {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WIFI_STATUS] = WifiStatus.UNKNOWN;
	            }
	        }
	
	        /**
	         * Set api wifi ssid
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "wifiSsid",
	        value: function wifiSsid(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.WifiSsid)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WIFI_SSID] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiSsid);
	            }
	        }
	
	        /**
	         * Set api wifi channel
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "wifiChannel",
	        value: function wifiChannel(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.WifiChannel)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WIFI_CHANNEL] = parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiChannel));
	            }
	        }
	
	        /**
	         * Set api wifi bandwidth
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "wifiBandwidth",
	        value: function wifiBandwidth(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.wifibandwidth)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).WIFI_BANDWIDTH] = parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.wifibandwidth));
	            }
	        }
	
	        /**
	         * Set api pci
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "pci",
	        value: function pci(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.pci)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).PCI] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.pci));
	            }
	        }
	
	        /**
	         * Set api psc
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "psc",
	        value: function psc(rawData, rawKpi) {
	
	            if (HuaweiE580KpiConverter.isNotNull(rawData.psc)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).PSC] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.psc));
	            }
	        }
	
	        /**
	         * Set api cell id
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "cellId",
	        value: function cellId(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.cell_id)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).CELL_ID] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.cell_id));
	                _get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "cellId", this).call(this, rawData, rawKpi);
	            }
	        }
	
	        /**
	         * Set api LAC / TAC
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "lac",
	        value: function lac(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.lac)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).LAC] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(rawData.lac);
	            } else if (HuaweiE580KpiConverter.isNotNull(rawData.tac)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).LAC] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(rawData.tac);
	            }
	        }
	
	        /**
	         * Set api rsrq
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "rsrq",
	        value: function rsrq(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.rsrq)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).RSRQ] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.rsrq));
	            }
	        }
	
	        /**
	         * Set api rsrp
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "rsrp",
	        value: function rsrp(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.rsrp)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).RSRP] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.rsrp));
	            }
	        }
	
	        /**
	         * Set api rssi
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "rssi",
	        value: function rssi(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.rssi)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).RSSI] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.rssi));
	            }
	        }
	
	        /**
	         * Set api snr
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "snr",
	        value: function snr(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.sinr)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).SNR] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.sinr));
	            }
	        }
	
	        /**
	         * Set api rscp
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "rscp",
	        value: function rscp(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.rscp)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).RSCP] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.rscp));
	            }
	        }
	
	        /**
	         * Set api ecno
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "ecno",
	        value: function ecno(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.ecio)) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).ECNO] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.ecio));
	            }
	        }
	
	        /**
	         * Set api mcc
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "mcc",
	        value: function mcc(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.Numeric) && rawData.Numeric.length > 2) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).MCC] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Numeric).substr(0, 3);
	            }
	        }
	
	        /**
	         * Set api mnc
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "mnc",
	        value: function mnc(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.Numeric) && rawData.Numeric.length > 3) {
	                rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).MNC] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Numeric).substr(3, HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Numeric).length - 3);
	            }
	        }
	
	        /**
	         * Set earfcn
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "earfcn",
	        value: function earfcn(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.earfcn)) {
	                var regex = /DL:([0-9]*) /gmi;
	                var res = regex.exec(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.earfcn));
	                if (res && res.length === 2) {
	                    rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).EARFCN] = parseInt(res[1]);
	                }
	            }
	        }
	
	        /**
	         * Set DL bandwidth
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "dlbandwidth",
	        value: function dlbandwidth(rawData, rawKpi) {
	            if (HuaweiE580KpiConverter.isNotNull(rawData.dlbandwidth)) {
	                var regex = /([0-9]*)Mhz/gmi;
	                var res = regex.exec(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.dlbandwidth));
	                if (res && res.length === 2) {
	                    rawKpi[_get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "getRawKpiConstants", this).call(this).DL_BANDWIDTH] = parseInt(res[1]);
	                }
	            }
	        }
	
	        /**
	         * Set api rad band
	         *
	         * @param rawData Input
	         * @param rawKpi Output
	         */
	
	    }, {
	        key: "radBand",
	        value: function radBand(rawData, rawKpi) {
	            _get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "radBand", this).call(this, rawData, rawKpi);
	        }
	
	        /**
	         * Convert a raw data to a raw kpi
	         *
	         * @param rawData
	         * @returns {Promise}
	         */
	
	    }, {
	        key: "convert",
	        value: function convert(rawData) {
	            return _get(HuaweiE580KpiConverter.prototype.__proto__ || Object.getPrototypeOf(HuaweiE580KpiConverter.prototype), "convert", this).call(this, rawData, [this.localIp, this.apiRetrievalTime, this.localIpProtocol, this.wanIp, this.wanIpProtocol, this.model, this.serialNumber, this.imei, this.imsi, this.iccid, this.msisdn, this.hardwareVersion, this.softwareVersion, this.bearer, this.netstat, this.simStatus, this.wifiUsers, this.wifiStatus, this.wifiSsid, this.wifiChannel, this.wifiBandwidth, this.pci, this.cellId, this.rsrq, this.rsrp, this.rssi, this.snr, this.rscp, this.mcc, this.mnc, this.lac, this.earfcn, this.dlbandwidth, this.radBand]);
	        }
	    }], [{
	        key: "removeParasaticalCharacters",
	        value: function removeParasaticalCharacters(inputString) {
	            //case seen on real router: value returned for RSSI is '&amp;gt;=-51dBm' => clean this value
	            return inputString ? inputString.toString().replace('&gt;=', '').replace('&lt;=', '').replace('&amp;', '').replace('&gt;', '').replace('=', '').replace(';', '').replace('>', '').replace('<', '') : '';
	        }
	
	        /**
	         * Remove all characters ([azAZ]) from string and convert to int
	         *
	         * @param inputString An input string
	         */
	
	    }, {
	        key: "removeAllCharsAndConvertToInt",
	        value: function removeAllCharsAndConvertToInt(inputString) {
	            return inputString ? parseInt(inputString.toString().toLowerCase().replace(/[a-zA-Z]+/g, '')) : '';
	        }
	
	        /**
	         * Check if value exists
	         * @param value
	         * @returns {boolean}
	         */
	
	    }, {
	        key: "isNotNull",
	        value: function isNotNull(value) {
	            return value !== undefined && value !== null;
	        }
	    }]);
	
	    return HuaweiE580KpiConverter;
	}(_KpiConverter3.default);
	
	exports.default = HuaweiE580KpiConverter;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NOT_AVAILABLE = exports.NOT_AVAILABLE = { code: -1, label: "NOT AVAILABLE" };
	var UNKNOWN = exports.UNKNOWN = { code: 0, label: "UNKNOWN" };
	var NO_SERVICE = exports.NO_SERVICE = { code: 1, label: "NO SERVICE" };
	var EMERGENCY_ONLY = exports.EMERGENCY_ONLY = { code: 2, label: "EMERGENCY ONLY" };
	var SEARCHING = exports.SEARCHING = { code: 3, label: "SEARCHING" };
	var BUSY = exports.BUSY = { code: 4, label: "BUSY" };
	var HOME_NETWORK = exports.HOME_NETWORK = { code: 5, label: "HOME NETWORK" };
	var DENIED = exports.DENIED = { code: 6, label: "DENIED" };
	var ROAMING_INTERNATIONAL = exports.ROAMING_INTERNATIONAL = { code: 7, label: "ROAMING INTERNATIONAL" };
	var AIRPLANE = exports.AIRPLANE = { code: 8, label: "AIRPLANE" };
	var ROAMING_NATIONAL = exports.ROAMING_NATIONAL = { code: 9, label: "ROAMING NATIONAL" };
	var ROAMING = exports.ROAMING = { code: 10, label: "ROAMING" };

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NOT_AVAILABLE = exports.NOT_AVAILABLE = { code: -1, label: "NOT AVAILABLE" };
	var UNKNOWN = exports.UNKNOWN = { code: 0, label: "UNKNOWN" };
	var ABSENT = exports.ABSENT = { code: 1, label: "ABSENT" };
	var NETWORK_LOCKED = exports.NETWORK_LOCKED = { code: 2, label: "NETWORK LOCKED" };
	var PIN_REQUIRE = exports.PIN_REQUIRE = { code: 3, label: "PIN REQUIRE" };
	var PUK_REQUIRE = exports.PUK_REQUIRE = { code: 4, label: "PUK REQUIRE" };
	var READY = exports.READY = { code: 5, label: "READY" };

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UNKNOWN = exports.UNKNOWN = { code: 0, label: "UNKNOWN" };
	var DISABLED = exports.DISABLED = { code: 1, label: "DISABLED" };
	var SEARCHING = exports.SEARCHING = { code: 2, label: "SEARCHING" };
	var CONNECTED = exports.CONNECTED = { code: 3, label: "CONNECTED" };
	var DISCONNECTED = exports.DISCONNECTED = { code: 4, label: "DISCONNECTED" };

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   v4.2.6+9869a4bc
	 */
	
	(function (global, factory) {
	  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.ES6Promise = factory();
	})(undefined, function () {
	  'use strict';
	
	  function objectOrFunction(x) {
	    var type = typeof x === 'undefined' ? 'undefined' : _typeof(x);
	    return x !== null && (type === 'object' || type === 'function');
	  }
	
	  function isFunction(x) {
	    return typeof x === 'function';
	  }
	
	  var _isArray = void 0;
	  if (Array.isArray) {
	    _isArray = Array.isArray;
	  } else {
	    _isArray = function _isArray(x) {
	      return Object.prototype.toString.call(x) === '[object Array]';
	    };
	  }
	
	  var isArray = _isArray;
	
	  var len = 0;
	  var vertxNext = void 0;
	  var customSchedulerFn = void 0;
	
	  var asap = function asap(callback, arg) {
	    queue[len] = callback;
	    queue[len + 1] = arg;
	    len += 2;
	    if (len === 2) {
	      // If len is 2, that means that we need to schedule an async flush.
	      // If additional callbacks are queued before the queue is flushed, they
	      // will be processed by this flush that we are scheduling.
	      if (customSchedulerFn) {
	        customSchedulerFn(flush);
	      } else {
	        scheduleFlush();
	      }
	    }
	  };
	
	  function setScheduler(scheduleFn) {
	    customSchedulerFn = scheduleFn;
	  }
	
	  function setAsap(asapFn) {
	    asap = asapFn;
	  }
	
	  var browserWindow = typeof window !== 'undefined' ? window : undefined;
	  var browserGlobal = browserWindow || {};
	  var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	  var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	  // test for web worker but not in IE10
	  var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	  // node
	  function useNextTick() {
	    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	    // see https://github.com/cujojs/when/issues/410 for details
	    return function () {
	      return process.nextTick(flush);
	    };
	  }
	
	  // vertx
	  function useVertxTimer() {
	    if (typeof vertxNext !== 'undefined') {
	      return function () {
	        vertxNext(flush);
	      };
	    }
	
	    return useSetTimeout();
	  }
	
	  function useMutationObserver() {
	    var iterations = 0;
	    var observer = new BrowserMutationObserver(flush);
	    var node = document.createTextNode('');
	    observer.observe(node, { characterData: true });
	
	    return function () {
	      node.data = iterations = ++iterations % 2;
	    };
	  }
	
	  // web worker
	  function useMessageChannel() {
	    var channel = new MessageChannel();
	    channel.port1.onmessage = flush;
	    return function () {
	      return channel.port2.postMessage(0);
	    };
	  }
	
	  function useSetTimeout() {
	    // Store setTimeout reference so es6-promise will be unaffected by
	    // other code modifying setTimeout (like sinon.useFakeTimers())
	    var globalSetTimeout = setTimeout;
	    return function () {
	      return globalSetTimeout(flush, 1);
	    };
	  }
	
	  var queue = new Array(1000);
	  function flush() {
	    for (var i = 0; i < len; i += 2) {
	      var callback = queue[i];
	      var arg = queue[i + 1];
	
	      callback(arg);
	
	      queue[i] = undefined;
	      queue[i + 1] = undefined;
	    }
	
	    len = 0;
	  }
	
	  function attemptVertx() {
	    try {
	      var vertx = Function('return this')().require('vertx');
	      vertxNext = vertx.runOnLoop || vertx.runOnContext;
	      return useVertxTimer();
	    } catch (e) {
	      return useSetTimeout();
	    }
	  }
	
	  var scheduleFlush = void 0;
	  // Decide what async method to use to triggering processing of queued callbacks:
	  if (isNode) {
	    scheduleFlush = useNextTick();
	  } else if (BrowserMutationObserver) {
	    scheduleFlush = useMutationObserver();
	  } else if (isWorker) {
	    scheduleFlush = useMessageChannel();
	  } else if (browserWindow === undefined && "function" === 'function') {
	    scheduleFlush = attemptVertx();
	  } else {
	    scheduleFlush = useSetTimeout();
	  }
	
	  function then(onFulfillment, onRejection) {
	    var parent = this;
	
	    var child = new this.constructor(noop);
	
	    if (child[PROMISE_ID] === undefined) {
	      makePromise(child);
	    }
	
	    var _state = parent._state;
	
	    if (_state) {
	      var callback = arguments[_state - 1];
	      asap(function () {
	        return invokeCallback(_state, child, callback, parent._result);
	      });
	    } else {
	      subscribe(parent, child, onFulfillment, onRejection);
	    }
	
	    return child;
	  }
	
	  /**
	    `Promise.resolve` returns a promise that will become resolved with the
	    passed `value`. It is shorthand for the following:
	  
	    ```javascript
	    let promise = new Promise(function(resolve, reject){
	      resolve(1);
	    });
	  
	    promise.then(function(value){
	      // value === 1
	    });
	    ```
	  
	    Instead of writing the above, your code now simply becomes the following:
	  
	    ```javascript
	    let promise = Promise.resolve(1);
	  
	    promise.then(function(value){
	      // value === 1
	    });
	    ```
	  
	    @method resolve
	    @static
	    @param {Any} value value that the returned promise will be resolved with
	    Useful for tooling.
	    @return {Promise} a promise that will become fulfilled with the given
	    `value`
	  */
	  function resolve$1(object) {
	    /*jshint validthis:true */
	    var Constructor = this;
	
	    if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.constructor === Constructor) {
	      return object;
	    }
	
	    var promise = new Constructor(noop);
	    resolve(promise, object);
	    return promise;
	  }
	
	  var PROMISE_ID = Math.random().toString(36).substring(2);
	
	  function noop() {}
	
	  var PENDING = void 0;
	  var FULFILLED = 1;
	  var REJECTED = 2;
	
	  var TRY_CATCH_ERROR = { error: null };
	
	  function selfFulfillment() {
	    return new TypeError("You cannot resolve a promise with itself");
	  }
	
	  function cannotReturnOwn() {
	    return new TypeError('A promises callback cannot return that same promise.');
	  }
	
	  function getThen(promise) {
	    try {
	      return promise.then;
	    } catch (error) {
	      TRY_CATCH_ERROR.error = error;
	      return TRY_CATCH_ERROR;
	    }
	  }
	
	  function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	    try {
	      then$$1.call(value, fulfillmentHandler, rejectionHandler);
	    } catch (e) {
	      return e;
	    }
	  }
	
	  function handleForeignThenable(promise, thenable, then$$1) {
	    asap(function (promise) {
	      var sealed = false;
	      var error = tryThen(then$$1, thenable, function (value) {
	        if (sealed) {
	          return;
	        }
	        sealed = true;
	        if (thenable !== value) {
	          resolve(promise, value);
	        } else {
	          fulfill(promise, value);
	        }
	      }, function (reason) {
	        if (sealed) {
	          return;
	        }
	        sealed = true;
	
	        reject(promise, reason);
	      }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	      if (!sealed && error) {
	        sealed = true;
	        reject(promise, error);
	      }
	    }, promise);
	  }
	
	  function handleOwnThenable(promise, thenable) {
	    if (thenable._state === FULFILLED) {
	      fulfill(promise, thenable._result);
	    } else if (thenable._state === REJECTED) {
	      reject(promise, thenable._result);
	    } else {
	      subscribe(thenable, undefined, function (value) {
	        return resolve(promise, value);
	      }, function (reason) {
	        return reject(promise, reason);
	      });
	    }
	  }
	
	  function handleMaybeThenable(promise, maybeThenable, then$$1) {
	    if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	      handleOwnThenable(promise, maybeThenable);
	    } else {
	      if (then$$1 === TRY_CATCH_ERROR) {
	        reject(promise, TRY_CATCH_ERROR.error);
	        TRY_CATCH_ERROR.error = null;
	      } else if (then$$1 === undefined) {
	        fulfill(promise, maybeThenable);
	      } else if (isFunction(then$$1)) {
	        handleForeignThenable(promise, maybeThenable, then$$1);
	      } else {
	        fulfill(promise, maybeThenable);
	      }
	    }
	  }
	
	  function resolve(promise, value) {
	    if (promise === value) {
	      reject(promise, selfFulfillment());
	    } else if (objectOrFunction(value)) {
	      handleMaybeThenable(promise, value, getThen(value));
	    } else {
	      fulfill(promise, value);
	    }
	  }
	
	  function publishRejection(promise) {
	    if (promise._onerror) {
	      promise._onerror(promise._result);
	    }
	
	    publish(promise);
	  }
	
	  function fulfill(promise, value) {
	    if (promise._state !== PENDING) {
	      return;
	    }
	
	    promise._result = value;
	    promise._state = FULFILLED;
	
	    if (promise._subscribers.length !== 0) {
	      asap(publish, promise);
	    }
	  }
	
	  function reject(promise, reason) {
	    if (promise._state !== PENDING) {
	      return;
	    }
	    promise._state = REJECTED;
	    promise._result = reason;
	
	    asap(publishRejection, promise);
	  }
	
	  function subscribe(parent, child, onFulfillment, onRejection) {
	    var _subscribers = parent._subscribers;
	    var length = _subscribers.length;
	
	    parent._onerror = null;
	
	    _subscribers[length] = child;
	    _subscribers[length + FULFILLED] = onFulfillment;
	    _subscribers[length + REJECTED] = onRejection;
	
	    if (length === 0 && parent._state) {
	      asap(publish, parent);
	    }
	  }
	
	  function publish(promise) {
	    var subscribers = promise._subscribers;
	    var settled = promise._state;
	
	    if (subscribers.length === 0) {
	      return;
	    }
	
	    var child = void 0,
	        callback = void 0,
	        detail = promise._result;
	
	    for (var i = 0; i < subscribers.length; i += 3) {
	      child = subscribers[i];
	      callback = subscribers[i + settled];
	
	      if (child) {
	        invokeCallback(settled, child, callback, detail);
	      } else {
	        callback(detail);
	      }
	    }
	
	    promise._subscribers.length = 0;
	  }
	
	  function tryCatch(callback, detail) {
	    try {
	      return callback(detail);
	    } catch (e) {
	      TRY_CATCH_ERROR.error = e;
	      return TRY_CATCH_ERROR;
	    }
	  }
	
	  function invokeCallback(settled, promise, callback, detail) {
	    var hasCallback = isFunction(callback),
	        value = void 0,
	        error = void 0,
	        succeeded = void 0,
	        failed = void 0;
	
	    if (hasCallback) {
	      value = tryCatch(callback, detail);
	
	      if (value === TRY_CATCH_ERROR) {
	        failed = true;
	        error = value.error;
	        value.error = null;
	      } else {
	        succeeded = true;
	      }
	
	      if (promise === value) {
	        reject(promise, cannotReturnOwn());
	        return;
	      }
	    } else {
	      value = detail;
	      succeeded = true;
	    }
	
	    if (promise._state !== PENDING) {
	      // noop
	    } else if (hasCallback && succeeded) {
	      resolve(promise, value);
	    } else if (failed) {
	      reject(promise, error);
	    } else if (settled === FULFILLED) {
	      fulfill(promise, value);
	    } else if (settled === REJECTED) {
	      reject(promise, value);
	    }
	  }
	
	  function initializePromise(promise, resolver) {
	    try {
	      resolver(function resolvePromise(value) {
	        resolve(promise, value);
	      }, function rejectPromise(reason) {
	        reject(promise, reason);
	      });
	    } catch (e) {
	      reject(promise, e);
	    }
	  }
	
	  var id = 0;
	  function nextId() {
	    return id++;
	  }
	
	  function makePromise(promise) {
	    promise[PROMISE_ID] = id++;
	    promise._state = undefined;
	    promise._result = undefined;
	    promise._subscribers = [];
	  }
	
	  function validationError() {
	    return new Error('Array Methods must be provided an Array');
	  }
	
	  var Enumerator = function () {
	    function Enumerator(Constructor, input) {
	      this._instanceConstructor = Constructor;
	      this.promise = new Constructor(noop);
	
	      if (!this.promise[PROMISE_ID]) {
	        makePromise(this.promise);
	      }
	
	      if (isArray(input)) {
	        this.length = input.length;
	        this._remaining = input.length;
	
	        this._result = new Array(this.length);
	
	        if (this.length === 0) {
	          fulfill(this.promise, this._result);
	        } else {
	          this.length = this.length || 0;
	          this._enumerate(input);
	          if (this._remaining === 0) {
	            fulfill(this.promise, this._result);
	          }
	        }
	      } else {
	        reject(this.promise, validationError());
	      }
	    }
	
	    Enumerator.prototype._enumerate = function _enumerate(input) {
	      for (var i = 0; this._state === PENDING && i < input.length; i++) {
	        this._eachEntry(input[i], i);
	      }
	    };
	
	    Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	      var c = this._instanceConstructor;
	      var resolve$$1 = c.resolve;
	
	      if (resolve$$1 === resolve$1) {
	        var _then = getThen(entry);
	
	        if (_then === then && entry._state !== PENDING) {
	          this._settledAt(entry._state, i, entry._result);
	        } else if (typeof _then !== 'function') {
	          this._remaining--;
	          this._result[i] = entry;
	        } else if (c === Promise$1) {
	          var promise = new c(noop);
	          handleMaybeThenable(promise, entry, _then);
	          this._willSettleAt(promise, i);
	        } else {
	          this._willSettleAt(new c(function (resolve$$1) {
	            return resolve$$1(entry);
	          }), i);
	        }
	      } else {
	        this._willSettleAt(resolve$$1(entry), i);
	      }
	    };
	
	    Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	      var promise = this.promise;
	
	      if (promise._state === PENDING) {
	        this._remaining--;
	
	        if (state === REJECTED) {
	          reject(promise, value);
	        } else {
	          this._result[i] = value;
	        }
	      }
	
	      if (this._remaining === 0) {
	        fulfill(promise, this._result);
	      }
	    };
	
	    Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	      var enumerator = this;
	
	      subscribe(promise, undefined, function (value) {
	        return enumerator._settledAt(FULFILLED, i, value);
	      }, function (reason) {
	        return enumerator._settledAt(REJECTED, i, reason);
	      });
	    };
	
	    return Enumerator;
	  }();
	
	  /**
	    `Promise.all` accepts an array of promises, and returns a new promise which
	    is fulfilled with an array of fulfillment values for the passed promises, or
	    rejected with the reason of the first passed promise to be rejected. It casts all
	    elements of the passed iterable to promises as it runs this algorithm.
	  
	    Example:
	  
	    ```javascript
	    let promise1 = resolve(1);
	    let promise2 = resolve(2);
	    let promise3 = resolve(3);
	    let promises = [ promise1, promise2, promise3 ];
	  
	    Promise.all(promises).then(function(array){
	      // The array here would be [ 1, 2, 3 ];
	    });
	    ```
	  
	    If any of the `promises` given to `all` are rejected, the first promise
	    that is rejected will be given as an argument to the returned promises's
	    rejection handler. For example:
	  
	    Example:
	  
	    ```javascript
	    let promise1 = resolve(1);
	    let promise2 = reject(new Error("2"));
	    let promise3 = reject(new Error("3"));
	    let promises = [ promise1, promise2, promise3 ];
	  
	    Promise.all(promises).then(function(array){
	      // Code here never runs because there are rejected promises!
	    }, function(error) {
	      // error.message === "2"
	    });
	    ```
	  
	    @method all
	    @static
	    @param {Array} entries array of promises
	    @param {String} label optional string for labeling the promise.
	    Useful for tooling.
	    @return {Promise} promise that is fulfilled when all `promises` have been
	    fulfilled, or rejected if any of them become rejected.
	    @static
	  */
	  function all(entries) {
	    return new Enumerator(this, entries).promise;
	  }
	
	  /**
	    `Promise.race` returns a new promise which is settled in the same way as the
	    first passed promise to settle.
	  
	    Example:
	  
	    ```javascript
	    let promise1 = new Promise(function(resolve, reject){
	      setTimeout(function(){
	        resolve('promise 1');
	      }, 200);
	    });
	  
	    let promise2 = new Promise(function(resolve, reject){
	      setTimeout(function(){
	        resolve('promise 2');
	      }, 100);
	    });
	  
	    Promise.race([promise1, promise2]).then(function(result){
	      // result === 'promise 2' because it was resolved before promise1
	      // was resolved.
	    });
	    ```
	  
	    `Promise.race` is deterministic in that only the state of the first
	    settled promise matters. For example, even if other promises given to the
	    `promises` array argument are resolved, but the first settled promise has
	    become rejected before the other promises became fulfilled, the returned
	    promise will become rejected:
	  
	    ```javascript
	    let promise1 = new Promise(function(resolve, reject){
	      setTimeout(function(){
	        resolve('promise 1');
	      }, 200);
	    });
	  
	    let promise2 = new Promise(function(resolve, reject){
	      setTimeout(function(){
	        reject(new Error('promise 2'));
	      }, 100);
	    });
	  
	    Promise.race([promise1, promise2]).then(function(result){
	      // Code here never runs
	    }, function(reason){
	      // reason.message === 'promise 2' because promise 2 became rejected before
	      // promise 1 became fulfilled
	    });
	    ```
	  
	    An example real-world use case is implementing timeouts:
	  
	    ```javascript
	    Promise.race([ajax('foo.json'), timeout(5000)])
	    ```
	  
	    @method race
	    @static
	    @param {Array} promises array of promises to observe
	    Useful for tooling.
	    @return {Promise} a promise which settles in the same way as the first passed
	    promise to settle.
	  */
	  function race(entries) {
	    /*jshint validthis:true */
	    var Constructor = this;
	
	    if (!isArray(entries)) {
	      return new Constructor(function (_, reject) {
	        return reject(new TypeError('You must pass an array to race.'));
	      });
	    } else {
	      return new Constructor(function (resolve, reject) {
	        var length = entries.length;
	        for (var i = 0; i < length; i++) {
	          Constructor.resolve(entries[i]).then(resolve, reject);
	        }
	      });
	    }
	  }
	
	  /**
	    `Promise.reject` returns a promise rejected with the passed `reason`.
	    It is shorthand for the following:
	  
	    ```javascript
	    let promise = new Promise(function(resolve, reject){
	      reject(new Error('WHOOPS'));
	    });
	  
	    promise.then(function(value){
	      // Code here doesn't run because the promise is rejected!
	    }, function(reason){
	      // reason.message === 'WHOOPS'
	    });
	    ```
	  
	    Instead of writing the above, your code now simply becomes the following:
	  
	    ```javascript
	    let promise = Promise.reject(new Error('WHOOPS'));
	  
	    promise.then(function(value){
	      // Code here doesn't run because the promise is rejected!
	    }, function(reason){
	      // reason.message === 'WHOOPS'
	    });
	    ```
	  
	    @method reject
	    @static
	    @param {Any} reason value that the returned promise will be rejected with.
	    Useful for tooling.
	    @return {Promise} a promise rejected with the given `reason`.
	  */
	  function reject$1(reason) {
	    /*jshint validthis:true */
	    var Constructor = this;
	    var promise = new Constructor(noop);
	    reject(promise, reason);
	    return promise;
	  }
	
	  function needsResolver() {
	    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	  }
	
	  function needsNew() {
	    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	  }
	
	  /**
	    Promise objects represent the eventual result of an asynchronous operation. The
	    primary way of interacting with a promise is through its `then` method, which
	    registers callbacks to receive either a promise's eventual value or the reason
	    why the promise cannot be fulfilled.
	  
	    Terminology
	    -----------
	  
	    - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	    - `thenable` is an object or function that defines a `then` method.
	    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	    - `exception` is a value that is thrown using the throw statement.
	    - `reason` is a value that indicates why a promise was rejected.
	    - `settled` the final resting state of a promise, fulfilled or rejected.
	  
	    A promise can be in one of three states: pending, fulfilled, or rejected.
	  
	    Promises that are fulfilled have a fulfillment value and are in the fulfilled
	    state.  Promises that are rejected have a rejection reason and are in the
	    rejected state.  A fulfillment value is never a thenable.
	  
	    Promises can also be said to *resolve* a value.  If this value is also a
	    promise, then the original promise's settled state will match the value's
	    settled state.  So a promise that *resolves* a promise that rejects will
	    itself reject, and a promise that *resolves* a promise that fulfills will
	    itself fulfill.
	  
	  
	    Basic Usage:
	    ------------
	  
	    ```js
	    let promise = new Promise(function(resolve, reject) {
	      // on success
	      resolve(value);
	  
	      // on failure
	      reject(reason);
	    });
	  
	    promise.then(function(value) {
	      // on fulfillment
	    }, function(reason) {
	      // on rejection
	    });
	    ```
	  
	    Advanced Usage:
	    ---------------
	  
	    Promises shine when abstracting away asynchronous interactions such as
	    `XMLHttpRequest`s.
	  
	    ```js
	    function getJSON(url) {
	      return new Promise(function(resolve, reject){
	        let xhr = new XMLHttpRequest();
	  
	        xhr.open('GET', url);
	        xhr.onreadystatechange = handler;
	        xhr.responseType = 'json';
	        xhr.setRequestHeader('Accept', 'application/json');
	        xhr.send();
	  
	        function handler() {
	          if (this.readyState === this.DONE) {
	            if (this.status === 200) {
	              resolve(this.response);
	            } else {
	              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	            }
	          }
	        };
	      });
	    }
	  
	    getJSON('/posts.json').then(function(json) {
	      // on fulfillment
	    }, function(reason) {
	      // on rejection
	    });
	    ```
	  
	    Unlike callbacks, promises are great composable primitives.
	  
	    ```js
	    Promise.all([
	      getJSON('/posts'),
	      getJSON('/comments')
	    ]).then(function(values){
	      values[0] // => postsJSON
	      values[1] // => commentsJSON
	  
	      return values;
	    });
	    ```
	  
	    @class Promise
	    @param {Function} resolver
	    Useful for tooling.
	    @constructor
	  */
	
	  var Promise$1 = function () {
	    function Promise(resolver) {
	      this[PROMISE_ID] = nextId();
	      this._result = this._state = undefined;
	      this._subscribers = [];
	
	      if (noop !== resolver) {
	        typeof resolver !== 'function' && needsResolver();
	        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	      }
	    }
	
	    /**
	    The primary way of interacting with a promise is through its `then` method,
	    which registers callbacks to receive either a promise's eventual value or the
	    reason why the promise cannot be fulfilled.
	     ```js
	    findUser().then(function(user){
	      // user is available
	    }, function(reason){
	      // user is unavailable, and you are given the reason why
	    });
	    ```
	     Chaining
	    --------
	     The return value of `then` is itself a promise.  This second, 'downstream'
	    promise is resolved with the return value of the first promise's fulfillment
	    or rejection handler, or rejected if the handler throws an exception.
	     ```js
	    findUser().then(function (user) {
	      return user.name;
	    }, function (reason) {
	      return 'default name';
	    }).then(function (userName) {
	      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	      // will be `'default name'`
	    });
	     findUser().then(function (user) {
	      throw new Error('Found user, but still unhappy');
	    }, function (reason) {
	      throw new Error('`findUser` rejected and we're unhappy');
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	    });
	    ```
	    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	     ```js
	    findUser().then(function (user) {
	      throw new PedagogicalException('Upstream error');
	    }).then(function (value) {
	      // never reached
	    }).then(function (value) {
	      // never reached
	    }, function (reason) {
	      // The `PedgagocialException` is propagated all the way down to here
	    });
	    ```
	     Assimilation
	    ------------
	     Sometimes the value you want to propagate to a downstream promise can only be
	    retrieved asynchronously. This can be achieved by returning a promise in the
	    fulfillment or rejection handler. The downstream promise will then be pending
	    until the returned promise is settled. This is called *assimilation*.
	     ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // The user's comments are now available
	    });
	    ```
	     If the assimliated promise rejects, then the downstream promise will also reject.
	     ```js
	    findUser().then(function (user) {
	      return findCommentsByAuthor(user);
	    }).then(function (comments) {
	      // If `findCommentsByAuthor` fulfills, we'll have the value here
	    }, function (reason) {
	      // If `findCommentsByAuthor` rejects, we'll have the reason here
	    });
	    ```
	     Simple Example
	    --------------
	     Synchronous Example
	     ```javascript
	    let result;
	     try {
	      result = findResult();
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	     Errback Example
	     ```js
	    findResult(function(result, err){
	      if (err) {
	        // failure
	      } else {
	        // success
	      }
	    });
	    ```
	     Promise Example;
	     ```javascript
	    findResult().then(function(result){
	      // success
	    }, function(reason){
	      // failure
	    });
	    ```
	     Advanced Example
	    --------------
	     Synchronous Example
	     ```javascript
	    let author, books;
	     try {
	      author = findAuthor();
	      books  = findBooksByAuthor(author);
	      // success
	    } catch(reason) {
	      // failure
	    }
	    ```
	     Errback Example
	     ```js
	     function foundBooks(books) {
	     }
	     function failure(reason) {
	     }
	     findAuthor(function(author, err){
	      if (err) {
	        failure(err);
	        // failure
	      } else {
	        try {
	          findBoooksByAuthor(author, function(books, err) {
	            if (err) {
	              failure(err);
	            } else {
	              try {
	                foundBooks(books);
	              } catch(reason) {
	                failure(reason);
	              }
	            }
	          });
	        } catch(error) {
	          failure(err);
	        }
	        // success
	      }
	    });
	    ```
	     Promise Example;
	     ```javascript
	    findAuthor().
	      then(findBooksByAuthor).
	      then(function(books){
	        // found books
	    }).catch(function(reason){
	      // something went wrong
	    });
	    ```
	     @method then
	    @param {Function} onFulfilled
	    @param {Function} onRejected
	    Useful for tooling.
	    @return {Promise}
	    */
	
	    /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	    ```js
	    function findAuthor(){
	    throw new Error('couldn't find that author');
	    }
	    // synchronous
	    try {
	    findAuthor();
	    } catch(reason) {
	    // something went wrong
	    }
	    // async with promises
	    findAuthor().catch(function(reason){
	    // something went wrong
	    });
	    ```
	    @method catch
	    @param {Function} onRejection
	    Useful for tooling.
	    @return {Promise}
	    */
	
	    Promise.prototype.catch = function _catch(onRejection) {
	      return this.then(null, onRejection);
	    };
	
	    /**
	      `finally` will be invoked regardless of the promise's fate just as native
	      try/catch/finally behaves
	    
	      Synchronous example:
	    
	      ```js
	      findAuthor() {
	        if (Math.random() > 0.5) {
	          throw new Error();
	        }
	        return new Author();
	      }
	    
	      try {
	        return findAuthor(); // succeed or fail
	      } catch(error) {
	        return findOtherAuther();
	      } finally {
	        // always runs
	        // doesn't affect the return value
	      }
	      ```
	    
	      Asynchronous example:
	    
	      ```js
	      findAuthor().catch(function(reason){
	        return findOtherAuther();
	      }).finally(function(){
	        // author was either found, or not
	      });
	      ```
	    
	      @method finally
	      @param {Function} callback
	      @return {Promise}
	    */
	
	    Promise.prototype.finally = function _finally(callback) {
	      var promise = this;
	      var constructor = promise.constructor;
	
	      if (isFunction(callback)) {
	        return promise.then(function (value) {
	          return constructor.resolve(callback()).then(function () {
	            return value;
	          });
	        }, function (reason) {
	          return constructor.resolve(callback()).then(function () {
	            throw reason;
	          });
	        });
	      }
	
	      return promise.then(callback, callback);
	    };
	
	    return Promise;
	  }();
	
	  Promise$1.prototype.then = then;
	  Promise$1.all = all;
	  Promise$1.race = race;
	  Promise$1.resolve = resolve$1;
	  Promise$1.reject = reject$1;
	  Promise$1._setScheduler = setScheduler;
	  Promise$1._setAsap = setAsap;
	  Promise$1._asap = asap;
	
	  /*global self*/
	  function polyfill() {
	    var local = void 0;
	
	    if (typeof global !== 'undefined') {
	      local = global;
	    } else if (typeof self !== 'undefined') {
	      local = self;
	    } else {
	      try {
	        local = Function('return this')();
	      } catch (e) {
	        throw new Error('polyfill failed because global object is unavailable in this environment');
	      }
	    }
	
	    var P = local.Promise;
	
	    if (P) {
	      var promiseToString = null;
	      try {
	        promiseToString = Object.prototype.toString.call(P.resolve());
	      } catch (e) {
	        // silently ignored
	      }
	
	      if (promiseToString === '[object Promise]' && !P.cast) {
	        return;
	      }
	    }
	
	    local.Promise = Promise$1;
	  }
	
	  // Strange compat..
	  Promise$1.polyfill = polyfill;
	  Promise$1.Promise = Promise$1;
	
	  return Promise$1;
	});
	
	//# sourceMappingURL=es6-promise.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), (function() { return this; }())))

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*eslint-disable no-underscore-dangle*/
	
	// WeakMap method
	var privateState = new WeakMap();
	function createPrivateState(o) {
	    privateState.set(o, {});
	}
	function _private(o) {
	    // "private" is a reserved keyword
	    return privateState.get(o);
	}
	
	/**
	 * EQualOne SDK OnClickManager public APIs
	 */
	
	var EQOnClickManager = function () {
	    function EQOnClickManager(core) {
	        _classCallCheck(this, EQOnClickManager);
	
	        createPrivateState(this);
	        _private(this).core = core;
	    }
	
	    _createClass(EQOnClickManager, [{
	        key: "getScripts",
	        value: function getScripts() {
	            return _private(this).core.scriptService.getScripts();
	        }
	    }, {
	        key: "startScript",
	        value: function startScript(key, callback) {
	            _private(this).core.scriptService.startScript(parseInt(key), callback, _private(this).core.customFieldsManager.getAll());
	        }
	    }, {
	        key: "stopScript",
	        value: function stopScript(key) {
	            _private(this).core.scriptService.stopScript(parseInt(key));
	        }
	    }]);
	
	    return EQOnClickManager;
	}();
	
	exports.default = EQOnClickManager;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// equalone-sdk.js